import { DAILY_RITUAL_DE, DAILY_RITUAL_EN } from './dailyRitual';
import { PENDING_SOURCE_TEXTS } from './pendingSourceKeys';
import type { SupportedLanguage } from './languages';
import type { TranslationMap } from './translate';

export const M5_DE_OVERRIDES: TranslationMap = {
  "a5.unlimited_short": "Züge unbegrenzt",
  "publish.usk_required_hint": "Wähle noch eine Altersstufe aus.",
  "publish.status_error": "Der Stand der Veröffentlichung konnte nicht geladen werden. Bitte versuche es erneut.",
  "character_chat.menu_section_settings": "Guthaben, Hilfe und Antwortmodus",
  "chat.menu_notes_section": "Notizen, Guthaben und Hilfe",
  "dashboard.pinned_badge": "Angepinnt",
  "chats.menu_unpin": "Anpinnen aufheben",
  "chats.conversation_aria": "{name}, {conversation}",
  "chats.conversation_n_date": "Gespräch {number} vom {date}",
  "chats.conversation_n": "Gespräch {number}",
  "chats.menu_profile_hint": "Bilder, Stimme und Aktionen dieser Figur.",
  "chat.open_world_hint": "Öffnet die Weltübersicht und macht diese Welt zu deiner aktiven Welt.",
  "chat.open_world": "Welt dieses Abenteuers erkunden",
  "chat.adventure_actions_hint": "Hier findest du die wichtigsten Funktionen für dein Abenteuer. Notizen und Guthaben stehen weiter unten.",
  "chat.adventure_actions": "Aktionen für dein Abenteuer",
  "chat.memories_book_hint": "Lies die gespeicherten Erlebnisse aus diesem Abenteuer nach.",
  "chat.change_narrator_hint": "Aktuell erzählt {name}; wähle hier einen anderen Erzählstil.",
  "chat.change_narrator": "Erzähler wechseln",
  "publish.consent.required_hint": "Zum Absenden: Lies die Punkte im Formular und setze die Zustimmung hier.",
  "character_chat.persona_create": "Spielerfigur anlegen",
  "character_chat.persona_player_hint": "Wähle eine eigene Spielerfigur für deine Rolle im Gespräch. Die Begleiterfigur bleibt dein Gegenüber.",
  "companion.publish_hint": "Teile deine Figur mit anderen und prüfe vorher die Hinweise zur Veröffentlichung.",
  "companion.pin_hint": "Halte dieses Gespräch oben in deiner Chatliste griffbereit.",
  "companion.image_hint": "Öffne die Bildauswahl im Profil und bestätige dort die angezeigten Kosten.",
  "companion.image_title": "Bild erzeugen",
  "companion.voice_saved": "Stimme gespeichert. Sie gilt ab der nächsten neuen Sprachausgabe.",
  "companion.voice_hint": "Wähle die Stimme für Anrufe und vorgelesene Nachrichten dieser Figur.",
  "companion.voice_title": "Stimme ändern",
  "companion.actions_title": "Begleiter-Aktionen",
  "tier.zdr.description": "Schreibt Textantworten mit einer anderen KI-Modellfamilie, also mit einem anderen Schreibstil. Dein Nachrichtenpreis und deine übrigen Einstellungen bleiben gleich.",
  "pwa.game_settings": "Erzähler, Welten und Spielregeln",
  "settings.experience_title": "Lesen und Chat-Hilfen",
  "settings.section.experience": "Lesen & Chat",
  "settings.section.media": "Antworten & Audio",
  "settings.section_hint.legal": "Datenschutz, Nutzungsbedingungen und weitere Rechtstexte lesen.",
  "settings.section_hint.privacy": "Produktverbesserung und Werbe-Herkunft steuern.",
  "settings.section_hint.help": "Hilfe erhalten und lokale App-Daten verwalten.",
  "settings.section_hint.notifications": "Push-Mitteilungen und E-Mails auswählen.",
  "settings.section_hint.experience": "Lesetempo, Antwortlänge, Chat-Hilfen und Kostenkontrolle einstellen.",
  "settings.section_hint.media": "Antwortqualität, Kosten, Vorlesen und Stimmen einstellen.",
  "settings.section_hint.appearance": "Farben und Chat-Hintergründe anpassen.",
  "settings.section_hint.account": "Profil, Rufname, Geburtsdatum, Altersstufe und Anmeldung verwalten.",
  "settings.danger_title": "Konto endgültig löschen",
  "settings.logout_hint": "Du meldest dich auf diesem Gerät ab. Dein Konto und deine gespeicherten Inhalte bleiben erhalten.",
  "settings.session_title": "Anmeldung",
  "profile.display_name_invalid": "Bitte gib einen Anzeigenamen mit höchstens 80 Zeichen ein.",
  "profile.display_name_hint": "So heißt du in Lorath. Hier steht auch dein Rufname aus dem Onboarding; du kannst ihn jederzeit ändern.",
  "profile.display_name": "Rufname / Anzeigename",
  "chats.delete_title": "Gespräch löschen",
  "chats.delete_confirm": "„{name}“ und der gesamte Gesprächsverlauf werden endgültig gelöscht.",
  "chats.delete_error": "Das Gespräch konnte nicht gelöscht werden. Bitte versuche es erneut.",
  "chat.adventure_menu_title": "Abenteuer-Menü",
  "measurement.report.heading": "Messung: {from} bis {to} (Ende exklusiv)",
  "measurement.report.full": "Abdeckung: vollständige Erfassungswoche.",
  "measurement.report.partial": "Abdeckung: unvollständig; vor Messbeginn keine Rekonstruktion.",
  "measurement.report.scope": "Nur registrierte Volljährige mit Messschlüssel. Kleine Gruppen zusammengelegt, kleine Einzelkennzahlen zurückgehalten.",
  "measurement.report.cohort": "Kohorte {week}: Registrierung {registered} → erste Nachricht {first} → fünfte Nachricht {fifth} → Kaufansicht {view} → Kauf {purchase}.",
  "measurement.report.wait": "Wartezeit {group}: Median {median} ms ({accounts} Konten, {samples} Antworten).",
  "measurement.report.anonymous": "Gäste/Minderjährige: nur nicht verknüpfbare Summen; ohne belegbare Kontenzahl keine Gruppenausgabe.",

  "measurement.title": "Messung",
  "measurement.scope": "Nur registrierte Volljährige ab Messbeginn. Gäste und Minderjährige zählen ohne Kennung in Summen; diese werden ohne belegbare Kontenzahl nicht veröffentlicht. Gruppen unter fünf Konten werden zusammengelegt oder zurückgehalten. Der Trichter zählt verschiedene Konten je Stufe innerhalb des Zeitraums.",
  "measurement.period": "Zeitraum",
  "measurement.previous_week": "Vorwoche",
  "measurement.twelve_weeks": "Zwölf abgeschlossene Wochen",
  "measurement.refresh": "Aktualisieren",
  "measurement.suppressed": "Zurückgehalten (< 5)",
  "measurement.failed": "Die Messung konnte nicht geladen werden.",
  "measurement.enabled": "Erfassung eingeschaltet.",
  "measurement.disabled": "Erfassung ausgeschaltet; Aktivierung erst nach L1.",
  "measurement.incomplete": "Der Zeitraum ist noch nicht vollständig erfasst. Vor Messbeginn, nach Widerspruch oder Kontolöschung fehlen zu Recht Ereignisse.",
  "measurement.cohorts": "Trichter je Registrierungswoche",
  "measurement.week": "Registrierungswoche",
  "measurement.accounts": "Gemessene Konten",
  "measurement.account_registered": "Registriert / gesichert",
  "measurement.first_own_message": "1. eigene Nachricht",
  "measurement.fifth_own_message": "5. eigene Nachricht",
  "measurement.purchase_view": "Kaufansicht",
  "measurement.purchase_completed": "Kauf",
  "measurement.combined": "Zusammengelegte Gruppen",
  "measurement.empty": "Keine ausreichend große Kohorte im Zeitraum.",
  "measurement.latency": "Wartezeit bis zum ersten gestreamten Abschnitt",
  "measurement.platform_language": "Plattform / Sprache",
  "measurement.samples": "Antworten",
  "measurement.median": "Median",
  "measurement.a3_unavailable": "A3: Der Anteil erster eigener Nachrichten bei Vorlagenstarts ist derzeit nicht belastbar messbar. Die vorhandenen Kampagnen speichern die Vorlagenherkunft nicht eindeutig. Prüftor: mindestens 55 % bei mindestens 40 Starts.",
  "measurement.weekly_report": "Wochenbericht",
  "measurement.report_enabled": "Automatische Ablage des Vorwochenberichts eingeschaltet.",
  "measurement.report_disabled": "Automatische Ablage ausgeschaltet. Die Vorschau ist jederzeit lesbar.",
  "attribution.title": "Dürfen wir die Werbe-Herkunft abfragen?",
  "attribution.body.ios": "Wir möchten wissen, ob du über eine unserer Anzeigen im App Store zu Lorath gekommen bist. Dafür fragen wir einmal bei Apple nach. Wir erfahren dann nur die Kennungen unseres Werbekontos, der Kampagne, Anzeigengruppe, Suchbegriff und Anzeige, dein Land oder deine Region und ob es ein erster oder ein erneuter Download war. Keine Werbe-ID, nichts über andere Apps. Wir speichern das 13 Monate an deinem Konto, um unser kleines Werbebudget sinnvoll einzusetzen. Du kannst das jederzeit in den Einstellungen ändern. Mehr in der Datenschutzerklärung § 2a i.",
  "attribution.body.android": "Wir möchten wissen, über welchen Link oder welche Anzeige du zu Lorath gekommen bist. Dafür liest die App einmal die Angabe aus, die Google Play bei der Installation hinterlegt hat: Quelle, Medium, Kampagne, Inhalt und Suchbegriff des Links sowie die Zeitpunkte von Klick und Installationsbeginn. Keine Werbe-ID, nichts über andere Apps. Wir speichern das 13 Monate an deinem Konto, um unser kleines Werbebudget sinnvoll einzusetzen. Du kannst das jederzeit in den Einstellungen ändern. Mehr in der Datenschutzerklärung § 2a i.",
  "attribution.privacy": "Datenschutzerklärung § 2a i",
  "attribution.allow": "Erlauben",
  "attribution.deny": "Nicht erlauben",
  "attribution.failed": "Die Werbe-Herkunft konnte nicht aktualisiert werden. Deine Einwilligung kannst du unter Einstellungen › Datenschutz prüfen und jederzeit widerrufen.",
  "attribution.settings.title": "Werbe-Herkunft",
  "attribution.settings.description": "Mit deiner Einwilligung fragen wir einmal ab, woher deine Installation stammt, und speichern die Herkunft 13 Monate an deinem Konto. Wenn du ausschaltest, widerrufst du die Einwilligung und wir löschen die Herkunft von Apple oder Google.",
  "attribution.settings.privacy": "Datenschutz",

  "entry.continue_apple": "Mit Apple weiterspielen",
  "entry.continue_google": "Mit Google weiterspielen",
  "entry.register_email": "Mit E-Mail registrieren",
  "entry.try_guest": "Erst mal ohne Konto ausprobieren",
  "entry.have_account": "Ich habe ein Konto",
  "entry.tap_to_start": "Tippe, es beginnt sofort",
  "entry.build_own": "Eigenes Abenteuer bauen",
  "entry.secure_title": "Konto sichern",
  "entry.secure_body": "Sichere deine Geschichte, damit du sie auf jedem Gerät wiederfindest.",
  "entry.secure_apple": "Mit Apple sichern",
  "entry.secure_google": "Mit Google sichern",
  "entry.secure_email": "Mit E-Mail sichern",
  "entry.later": "Später",
  "entry.expiry_body": "Dein Gastzugang läuft in den nächsten fünf Tagen ab. Sichere dein Konto, damit du deine Geschichte danach weiterführen kannst.",
  "entry.oauth_already_linked": "Dieses Apple- oder Google-Konto gehört bereits zu einem anderen Lorath-Konto. Die Konten werden nicht zusammengeführt. Sichere diese Geschichte mit einem anderen Zugang oder mit E-Mail.",
  "entry.secure_error": "Das Sichern hat nicht geklappt. Du kannst es erneut versuchen oder deine Geschichte mit E-Mail sichern.",
  "entry.walkthrough": "Rundgang",
  "entry.walkthrough_error": "Der Rundgang konnte nicht geöffnet werden. Bitte versuche es erneut.",
  "entry.what_do_you_do": "Was tust du?",
  "iap.status.verified": "Dein Kauf ist bestätigt.",
  "iap.billing_issue.apple_store": "App Store",
  "iap.billing_issue.google_store": "Play Store",
  "iap.error.payment_declined": "Zahlung wurde abgelehnt.",
  "iap.error.store_unavailable": "Store gerade nicht erreichbar – bitte später erneut versuchen.",
  "iap.plan_change_at_period_end": "Ein Wechsel zu einer kürzeren Laufzeit ist erst nach Ablauf deines aktuellen Abos möglich. Deaktiviere dafür die Verlängerung bei Google Play und schließe danach das gewünschte Abo neu ab.",
  "iap.status.already_owned": "Du hast dieses Abo bereits – wird wiederhergestellt.",
  "iap.status.confirming": "Kauf wird bestätigt …",
  "iap.status.delayed": "Bestätigung dauert länger – du bekommst Bescheid, sobald sie da ist.",
  "iap.status.owner_conflict": "Dieses Abo gehört zu einem anderen Lorath-Konto.",
  "iap.billing_issue.title": "Zahlungsmethode prüfen",
  "iap.billing_issue.text": "Deine Zahlung im {store} ist fehlgeschlagen. Aktualisiere deine Zahlungsmethode, damit deine Mitgliedschaft weiterläuft.",
  "iap.billing_issue.manage": "Zahlungsmethode aktualisieren",
  "audio.error_stt_language": "Diktieren ist in deiner Kontosprache derzeit nicht verfügbar. Du kannst deinen Text eintippen.",
  "tr_session.tab_transcript": "Transkript",
  "tr_session.price_free_remaining": "Noch {time} einmalige Freiminuten verfügbar. Der geschätzte Preis berücksichtigt sie.",
  "tr_session.transcript_empty": "Noch kein Transkript",
  "tr_session.transcript_empty_hint": "Nach dem Kauf und der Verarbeitung erscheint hier der gesprochene Text.",
  "tr_session.transcript_speaker": "Sprecher {number}",
  "legal_reaccept.changes.heading": "Was ist neu?",
  "legal_reaccept.changes.terms": "Neu: Regeln für Geschenk-Codes (einlösbar mindestens drei Jahre, Coins aus gekauften Codes verfallen nie, Widerruf, soweit angeboten Kauf auch ohne Konto), eine klare Kaufregel für Minderjährige (nur mit vorheriger Zustimmung der Eltern) und Regeln für einmalige Erstkaufangebote. Vorkasse wird nicht mehr angeboten.",
  "legal_reaccept.changes.use_terms": "Neu: Alle Textwege laufen mit Zero Data Retention, außer im 18+-Bereich, und MiniMax wird nicht mehr genutzt; Standard-Bilder erzeugen ByteDance oder Google. Der Aufpreis für die ZDR-Option entfällt. Neu sind Regeln für einmalige Erstkaufangebote, für die Einladungsprämie (§ 4d) samt Übergang für frühere Einladungen und eine klare Kaufregel für Minderjährige.",
  "legal_reaccept.changes.privacy": "Neu: MiniMax wird nicht mehr genutzt. Texte gehen über OpenRouter an Anthropic-Modelle, manche Hintergrundaufgaben an ein DeepSeek-Modell; alle Text- und Bildwege laufen mit Zero Data Retention (ZDR), außer im 18+-Bereich. Standard-Bilder schicken wir nur dann an ByteDance mit möglicher Verarbeitung in China, wenn du dem vorher in einem eigenen Dialog zustimmst; sonst erzeugt sie Google zum selben Preis. Neu beschrieben sind außerdem die Messung mit einem pseudonymen Messschlüssel, die Herkunft deines Kontos, Geschenk-Codes mit Angaben zur beschenkten Person, Einladungen, Kaufhinweise in der App und die Beta-Umgebung. Um Einwilligungen, etwa zur Werbe-Herkunft in den Apps, bitten wir dich gesondert; diese Zustimmung ist keine solche Einwilligung.",
  "paywall.legal_contract": "Mit dem Kauf einer Mitgliedschaft kommt ein Vertrag mit Julius Berger (Lorath.eu) zustande. Die Zahlung wird über den App Store bzw. Google Play Store abgewickelt. Es gelten unsere AGB und die Datenschutzerklärung. Mit der Bestellung bestätigst du, dass du volljährig bist oder dass ein Elternteil dem Kauf vorher zugestimmt hat (AGB § 4.3).",
  "iap.restore.nothing_found": "Es wurde keine aktive Mitgliedschaft zum Wiederherstellen gefunden.",
  "live_talk.included_minutes_used": "Deine Minuten sind aufgebraucht, weiter für {rate} Coins/Minute",
  "membership.title": "Mitgliedschaft",
  "membership.teaser": "Mehr Geschichten, Stimmen und Gestaltungsmöglichkeiten mit Lorath Plus, Ultra oder Founders.",
  "membership.view_plans": "Mitgliedschaften ansehen",
  "membership.settings_title": "Mitgliedschaft",
  "membership.no_next_date": "Kein nächstes Datum",
  "membership.free_description": "Du nutzt Lorath ohne Mitgliedschaft.",
  "membership.plan": "Tarif",
  "membership.status": "Status",
  "membership.duration": "Laufzeit",
  "membership.next_date": "Nächstes Datum",
  "membership.status.trial": "Probezeit",
  "membership.status.active": "Aktiv",
  "membership.status.grace": "Zahlung wird geprüft",
  "membership.status.cancelled": "Gekündigt",
  "membership.status.expired": "Abgelaufen",
  "membership.unlimited_messages": "Unbegrenzte Standard-Nachrichten",
  "membership.messages_quota": "{left} von {total} Gratis-Nachrichten heute übrig",
  "membership.daily_counter": "{used} von {total} Gratis-Nachrichten heute",
  "membership.live_quota": "{left} von {total} Lagerfeuer-Minuten je 28 Tage übrig",
  "membership.background_quota": "{left} von {total} Hintergründen im Monat übrig",
  "membership.manage": "Verwalten",
  "membership.overview.title": "Dein Abo",
  "membership.overview.subtitle": "Alle Leistungen, Gutschriften und Verbräuche auf einen Blick.",
  "membership.overview.renews_at": "Verlängert sich am {date}",
  "membership.overview.usable_until": "Nutzbar bis {date}",
  "membership.overview.auto_renew": "Verlängert sich automatisch",
  "membership.overview.auto_renew_off": "Verlängert sich nicht automatisch",
  "membership.overview.this_week": "Diese Woche",
  "membership.overview.messages_today": "Nachrichten heute",
  "membership.overview.messages_unlimited": "Unbegrenzte Standard-Nachrichten",
  "membership.overview.messages_resets": "Setzt sich zurück am {datetime}",
  "membership.overview.live_minutes": "Lagerfeuer-Minuten",
  "membership.overview.live_minutes_label": "{left} von {total} Live-Minuten im Zyklus übrig",
  "membership.overview.cycle_end": "Zyklus endet am {date}",
  "membership.overview.backgrounds": "Hintergründe",
  "membership.overview.backgrounds_label": "{left} von {total} Hintergründen im Zyklus übrig",
  "membership.overview.status_characters": "Tagesstatus",
  "membership.overview.status_characters_label": "{used} von {total} Tagesstatus-Läufen heute",
  "membership.overview.coins_title": "Deine Coins",
  "membership.overview.coins_balance": "{coins} Coins auf dem Konto",
  "membership.overview.coins_subscription_title": "Abo-Tranchen",
  "membership.overview.coins_tranche": "{amount} Coins, gültig bis {date}",
  "membership.overview.coins_tranche_no_expiry": "{amount} Coins",
  "membership.coins_help.title": "Welche Coins werden zuerst verbraucht?",
  "membership.coins_help.body": "Lorath nutzt deine Coins in dieser Reihenfolge, damit nichts liegen bleibt: 1) Abo-Coins — immer die Tranche, die als nächstes abläuft (21 Tage nach Gutschrift). 2) Bonus-Coins, zum Beispiel aus Aktionen oder Entschuldigungen. 3) Gekaufte Coins. So verfällt nichts und du behältst den Überblick.",
  "membership.only_included.label": "Nur Inklusivleistungen verwenden",
  "membership.only_included.desc": "Blockiert alles, was Coins kosten würde — auch wenn noch Inklusiv-Minuten übrig sind. Sobald die Inklusiv-Minuten verbraucht sind, endet das Lagerfeuer ohne in den Coin-Modus zu wechseln. Vorlesen, KI-Hintergründe, Tagesstatus und kostenpflichtige Chat-Antworten werden ebenfalls geblockt.",
  "membership.only_included.help_title": "Was bedeutet ‘nur Inklusivleistungen’?",
  "tts.only_included": "In deinem Plan sind nur Inklusivleistungen freigeschaltet. Das Vorlesen würde Coins kosten, deshalb ist es gerade nicht verfügbar.",
  "chat.only_included": "In deinem Plan sind nur Inklusivleistungen freigeschaltet. Diese Nachricht würde Coins kosten, deshalb ist sie gerade nicht verfügbar.",
  "chat_bg.only_included": "In deinem Plan sind nur Inklusivleistungen freigeschaltet. KI-Hintergründe würden Coins kosten, deshalb ist die Funktion gerade nicht verfügbar.",
  "live.budget.label": "Höchstens {limit} Coins in dieser Sitzung",
  "live.budget.unit_coins": "Coins",
  "live.budget.hint": "0 = kein Limit. Sobald das Limit erreicht ist, beendet sich das Lagerfeuer sauber und du kannst weiter entscheiden.",
  "live.transition.limit_reached.title": "Sitzungslimit erreicht",
  "live.transition.limit_reached.body": "Du hast dein selbst gesetztes Coin-Limit für diese Sitzung erreicht. Du kannst jetzt weiter für Coins fortfahren oder das Lagerfeuer beenden.",
  "live.transition.limit_reached.continue": "Weiter für Coins",
  "live.transition.limit_reached.end": "Beenden",
  "live.transition.only_included.title": "Inklusiv-Modus aktiv",
  "live.transition.only_included.body": "Deine Inklusiv-Minuten sind aufgebraucht. In deinem Plan sind nur Inklusivleistungen freigeschaltet — das Lagerfeuer endet hier.",
  "live.transition.only_included.continue": "Verstanden",
  "live.transition.only_included.end": "Beenden",
  "membership.overview.coins_next_grant": "Nächste {amount} Coins am {date}",
  "membership.overview.coins_expiring_soon": "{amount} Coins verfallen am {date}",
  "membership.overview.coins_purchased_title": "Gekaufte Coins",
  "membership.overview.coins_purchased": "{coins} Coins (verfallen nicht)",
  "membership.overview.coins_bonus_title": "Bonus-Coins",
  "membership.overview.coins_bonus": "{coins} Coins aus Bonus und Aktionen",
  "membership.overview.ledger_title": "Verlauf",
  "membership.overview.ledger_empty": "Noch keine Buchungen.",
  "membership.overview.ledger_coins_granted": "{amount} Coins gutgeschrieben",
  "membership.overview.ledger_coins_spent": "{amount} Coins verbraucht",
  "membership.overview.ledger_coins_expired": "{amount} Coins verfallen",
  "membership.overview.ledger_message_free": "Gratis-Nachricht",
  "membership.overview.ledger_live_minutes": "Lagerfeuer-Minuten verbraucht",
  "membership.overview.ledger_background": "Hintergrund verbraucht",
  "membership.overview.ledger_status": "Tagesstatus ausgelöst",
  "membership.overview.manage_subscription": "Abo verwalten",
  "membership.overview.manage_subscription_web": "Abos werden in der Lorath-App verwaltet.",
  "membership.overview.restore": "Käufe wiederherstellen",
  "membership.overview.upgrade": "Tarife ansehen",
  "membership.overview.open_overview": "Dein Abo",
  "membership.overview.day_group": "{date}",
  "membership.app_icon_title": "App-Icon",
  "membership.app_icon_description": "Wechsle das Icon auf deinem Homescreen. Gesperrte Icons benötigen eine Mitgliedschaft.",
  // M6b Kosmetik: Alternate-App-Icons (Parchment/Obsidian/Founders).
  // Werte stehen in frontend/src/native/appIcon.ts als APP_ICON_LABELS.
  "appearance.icon.standard": "Standard",
  "appearance.icon.night": "Nacht",
  "appearance.icon.gold": "Gold",
  "appearance.icon.crimson": "Purpur",
  "appearance.icon.parchment": "Pergament",
  "appearance.icon.obsidian": "Obsidian",
  "appearance.icon.founders": "Gründer",
  // M6 Kosmetik: Membership-Badge-Tooltips. Wird vom MembershipBadge
  // angezeigt, sobald die Tier-Abzeichen ohne erweiterte Inhalte auskommen.
  "membership.badge.plus": "Plus-Mitglied",
  "membership.badge.ultra": "Ultra-Mitglied",
  "membership.badge.founders": "Founders-Mitglied",
  "membership.badge.torchbearer": "Fackelträger",
  "membership.bestandsschutz.title": "Danke für deine frühe Unterstützung",
  // F2 (Review-2): App-Icon-Tier-Gate (Fix 4). Wird vom profile-PUT-Endpunkt
  // zurueckgegeben, wenn ein Free-User ein gesperrtes Icon setzt.
  "auth.icon_membership_required": "Dieses App-Icon ist Teil einer Mitgliedschaft.",
  "membership.bestandsschutz.body": "Du erhältst einen Monat Plus gratis, aktiv bis {date}. Außerdem kannst du einmalig ein Jahresabo deiner Wahl mit 25 % Rabatt sichern.",
  "membership.bestandsschutz.continue": "Danke, weiter",
  "membership.bestandsschutz.claim": "Jahresabo mit 25 % sichern",
  "bestandsschutz_end.title": "Dein Bestandsschutz endet",
  "bestandsschutz_end.body": "Dein Plus aus dem Bestandsschutz endet am {date}. Danach spielst du mit deinen Coins und der Tageskiste weiter – deine gekauften Coins behältst du natürlich.",
  "bestandsschutz_end.cta_view": "Mitgliedschaft ansehen",
  "bestandsschutz_end.ack": "Verstanden",
  "settings.notifications.email_marketing.label": "Wöchentlicher Rückblick per E-Mail",
  "settings.notifications.email_marketing.desc": "Einmal pro Woche ein kurzer Rückblick auf deine Abenteuer und neue Ideen. Jederzeit abbestellbar. Zum Einschalten schicken wir dir eine Bestätigungsmail.",
  "settings.notifications.email_marketing.pending": "Wir haben dir eine Bestätigungsmail geschickt. Bitte bestätige dort mit einem Klick.",
  "settings.notifications.email_marketing.status_pending": "Status: wartet auf Bestätigung",
  "settings.notifications.email_marketing.status_confirmed": "Status: bestätigt",
  "settings.notifications.email_marketing.no_email": "Hinterlege zuerst eine E-Mail-Adresse in deinem Profil, um E-Mails zu erhalten.",
  "settings.notifications.email_marketing.age_restricted": "E-Mails dieser Art kannst du ab 16 Jahren erhalten.",
  "settings.notifications.email_marketing.throttled": "Wir haben dir erst vor Kurzem eine Bestätigungsmail geschickt. Schau bitte in dein Postfach, auch im Spam-Ordner, und versuche es sonst später noch einmal.",
  "settings.notifications.email_marketing.unavailable": "Die Bestätigungsmail konnte gerade nicht gesendet werden. Bitte versuche es später noch einmal.",
  "settings.notifications.email_marketing.resend": "Bestätigungsmail erneut senden",
  "email_prompt.label": "E-Mail-Rückblick",
  "email_prompt.text": "Möchtest du einmal pro Woche einen kurzen Rückblick auf deine Abenteuer und neue Ideen per E-Mail? Jederzeit abbestellbar.",
  "email_prompt.yes": "Ja, gerne",
  "email_prompt.no": "Nein danke",
  "email_prompt.sent": "Danke! Wir haben dir eine Bestätigungsmail geschickt. Bitte bestätige dort mit einem Klick.",
  "email_prompt.failed": "Das hat gerade nicht geklappt. Du kannst die E-Mails jederzeit in den Einstellungen unter Benachrichtigungen einschalten.",
  "email.doi_subject": "Bitte bestätigen: wöchentlicher E-Mail-Rückblick von Lorath",
  "email.doi_greeting": "Hallo {username},",
  "email.doi_p1": "du hast in Lorath eingestellt, dass wir dir einmal pro Woche einen kurzen Rückblick auf deine Abenteuer und neue Ideen per E-Mail schicken dürfen.",
  "email.doi_p2": "Damit wir sicher sind, dass diese Adresse dir gehört und du das wirklich möchtest, bestätige es bitte mit einem Klick. Erst danach schicken wir dir diese E-Mails.",
  "email.doi_cta": "Ja, E-Mails erhalten",
  "email.doi_link_hint": "Falls der Knopf nicht funktioniert, kopiere diesen Link in die Adresszeile deines Browsers:",
  "email.doi_valid": "Der Link ist 7 Tage gültig.",
  "email.doi_ignore": "Wenn du das nicht warst, ignoriere diese Nachricht einfach. Dann passiert nichts.",
  "email.doi_page_confirmed_title": "Bestätigt",
  "email.doi_page_confirmed_body": "Danke! Du bekommst ab jetzt einmal pro Woche einen kurzen Rückblick auf deine Abenteuer und neue Ideen per E-Mail. Du kannst das jederzeit über den Abmeldelink in jeder E-Mail oder in der App unter Einstellungen, Benachrichtigungen beenden.",
  "email.doi_page_already_title": "Schon bestätigt",
  "email.doi_page_already_body": "Deine Bestätigung liegt bereits vor. Du musst nichts weiter tun.",
  "email.doi_page_expired_title": "Link abgelaufen",
  "email.doi_page_expired_body": "Dieser Bestätigungslink ist nicht mehr gültig. Schalte die E-Mails in der App unter Einstellungen, Benachrichtigungen noch einmal ein, dann schicken wir dir einen neuen.",
  "email.doi_page_invalid_title": "Link ungültig",
  "email.doi_page_invalid_body": "Dieser Bestätigungslink ist ungültig oder wurde durch einen neueren ersetzt. Schalte die E-Mails in der App unter Einstellungen, Benachrichtigungen noch einmal ein.",
  "email.doi_page_open_app": "Lorath öffnen",
  "email.doi_withdraw": "Du kannst deine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, über den Abmeldelink in jeder E-Mail oder in der App unter Einstellungen, Benachrichtigungen. Wie wir deine Daten dafür verarbeiten, steht in der Datenschutzerklärung (Link unten).",
  "email.doi_page_ready_title": "E-Mails bestätigen",
  "email.doi_page_ready_body": "Möchtest du einmal pro Woche einen kurzen Rückblick auf deine Abenteuer und neue Ideen per E-Mail erhalten? Mit dem Klick auf den Knopf bestätigst du das. Du kannst deine Einwilligung jederzeit widerrufen.",
  "email.doi_page_privacy": "Hinweise zum Datenschutz",
  "settings.notifications.email_marketing.birthdate_missing": "Bitte hinterlege zuerst dein Geburtsdatum in deinem Profil. Wir brauchen es, um sicherzustellen, dass du diese E-Mails erhalten darfst (ab 16 Jahren).",
  "settings.notifications.email_marketing.language_unsupported": "Der wöchentliche Rückblick ist für deine Sprache noch nicht verfügbar. Sobald die Texte übersetzt sind, kannst du ihn hier einschalten.",
  "settings.notifications.email_marketing.privacy_link": "Hinweise zum Datenschutz",
  "auth.marketing_recap_checkbox": "Wöchentlichen Rückblick per E-Mail erhalten (Bestätigung per E-Mail nötig)",
  "tier.plus": "Plus", "tier.ultra": "Ultra", "tier.founders": "Founders",
  "tier.settings_title": "Antwortqualität und Kosten",
  "tier.blitz.label": "Blitzschnell",
  "tier.blitz.description": "Antwortet besonders zügig und hält den Spielfluss lebendig.",
  "tier.creative.label": "Kreativ",
  "tier.creative.description": "Schreibt ausführlicher, atmosphärischer und ideenreicher.",
  "tier.price_line": "Abenteuer {adventure} Coins · Chat {chat} Coins",
  "tier.zdr.label": "Andere Modellfamilie",
  "tier.zdr.surcharge": "Ohne Aufpreis für alle Konten.",
  "tier.zdr.included": "Ohne Aufpreis für alle Konten.",
  "tier.zdr.audio_note": "Zero Data Retention (ZDR, keine Speicherung bei den Anbietern) gilt unabhängig von dieser Wahl für Textanfragen und Bilder. Audiofunktionen und der 18+-Bereich sind ausgenommen.",
  "lock.feature.tts": "Vorlesen – ab {tier}",
  "lock.feature.live": "Lagerfeuer – ab {tier}",
  "lock.feature.background": "Chat-Hintergrund – ab {tier}",
  "lock.feature.theme": "Theme – ab {tier}",
  "lock.feature.icon": "App-Icon – ab {tier}",
  "lock.feature.zdr": "Andere Modellfamilie ohne Aufpreis – auch ohne {tier}",
  "lock.feature.model": "KI-Modell – ab {tier}",
  "lock.feature.live_minutes": "Live-Minuten – ab {tier}",
  "paywall.title": "Wähle deine Mitgliedschaft",
  "paywall.subtitle": "Mehr Raum für Geschichten – mit klaren Kontingenten und jederzeit kündbar.",
  "paywall.duration_label": "Laufzeit wählen",
  "paywall.duration.week": "Woche", "paywall.duration.month": "Monat", "paywall.duration.year": "Jahr", "paywall.duration.custom": "Individuell",
  "paywall.year_saving": "2 Monate geschenkt",
  "paywall.discount_bestand25": "Dein einmaliger Bestandsschutz-Rabatt von 25 % ist vorgemerkt.",
  "paywall.app_only": "Abos sind derzeit über die Lorath-App erhältlich.",
  "paywall.error_unavailable": "Der Kauf ist gerade nicht verfügbar. Bitte versuche es später erneut.",
  "paywall.popular": "Beliebteste Wahl",
  "paywall.recommended": "Unsere Empfehlung",
  "paywall.week_note": "Wochenabos enthalten keine Lagerfeuer-Minuten",
  "paywall.per.week": "pro Woche", "paywall.per.month": "pro Monat", "paywall.per.year": "pro Jahr",
  "paywall.cta.trial": "7 Tage gratis starten", "paywall.cta.subscribe": "Jetzt abonnieren", "paywall.cta.support": "Entwicklung unterstützen",
  "paywall.plus.benefit1": "20 Standard-Nachrichten pro Tag", "paywall.plus.benefit2": "40 Coins pro Woche (160 im Monat)", "paywall.plus.benefit2_week": "40 Coins pro Woche", "paywall.plus.benefit3": "Zusätzliche Designs und App-Symbole", "paywall.plus.benefit4": "Erzählerstimme freigeschaltet", "paywall.plus.benefit5": "Lagerfeuer freigeschaltet · 15 Coins pro Minute", "paywall.plus.benefit6": "4 individuelle Hintergründe pro Monat",
  "paywall.legal_zdr": "Zero Data Retention gilt für alle Textwege und für Standard- und Premium-Bilder, außer im 18+-Bereich (Datenschutzerklärung § 6 h). Tonmodelle (Vorlesen, Spracheingabe, Lagerfeuer, Anrufe) sind davon ausgenommen.",
  "paywall.ultra.benefit1": "60 Standard-Nachrichten pro Tag", "paywall.ultra.benefit2": "125 Coins pro Woche (500 im Monat)", "paywall.ultra.benefit2_week": "125 Coins pro Woche", "paywall.ultra.benefit3": "Blitzschnelle Stufe inklusive", "paywall.ultra.benefit4": "15 Lagerfeuer-Minuten je 4 Wochen, danach 12 Coins pro Minute", "paywall.ultra.benefit5": "10 individuelle Hintergründe pro Monat", "paywall.ultra.benefit6": "Alle regulären App-Icons",
  "paywall.founders.benefit1": "Alles aus Ultra und 100 Nachrichten pro Tag", "paywall.founders.benefit2": "250 Coins pro Woche (1.000 im Monat)", "paywall.founders.benefit2_week": "250 Coins pro Woche", "paywall.founders.benefit3": "30 Minuten je 4 Wochen, danach 10 Coins pro Minute", "paywall.founders.benefit4": "20 individuelle Hintergründe pro Monat", "paywall.founders.benefit5": "Founders-Siegel und Name in den Credits", "paywall.founders.benefit6": "Beta-Zugang und Feature-Abstimmungen",
  "paywall.legal_price": "Der angezeigte Preis gilt für die gewählte Laufzeit, inkl. gesetzl. MwSt.",
  "paywall.legal_renewal": "Das Abo verlängert sich automatisch und kann jederzeit in den Store-Einstellungen gekündigt werden.",
  "paywall.legal_trial": "Die Gratis-Woche gilt einmal je Apple- oder Google-Konto; danach wird das Abo kostenpflichtig verlängert.",
  // P1 Promotion-Design: 60_PROMOTION.md §5 — Texte für PromoHero, PromoCta,
  // MembershipHeroCard und die Paywall-Markierung. Variante-Texte (intro.*,
  // start.*, quota.*) liefert P2; hier nur die statischen Bausteine.
  "paywall.ribbon_trial": "7 Tage gratis",
  "paywall.current_plan": "Dein Tarif",
  "paywall.cta.current": "Aktiv",
  "paywall.cta.upgrade": "Auf {tier} wechseln",
  "paywall.cta.downgrade": "Wechsel zum Laufzeitende",
  "paywall.cta.upgrade.success": "Upgrade aktiv: Lorath {tier}",
  "paywall.cta.downgrade.success": "Wechsel vorgemerkt ab {date}",
  "paywall.cta.none.success": "Willkommen bei Lorath {tier}",
  "paywall.error_replace_token": "Bitte zuerst „Käufe wiederherstellen“ in den Einstellungen ausführen und den Wechsel danach erneut starten.",
  "paywall.note.upgrade": "Die Verrechnung der Restlaufzeit zeigt dir der Store vor dem Kauf.",
  "paywall.note.downgrade": "Der Wechsel wird zum Ende deiner aktuellen Laufzeit am {date} wirksam. Bis dahin bleiben alle Vorteile aktiv.",
  "paywall.summary.trial": "Heute fällig: {today} · Erste Abbuchung am {date}: {price}",
  "paywall.summary.trial_renewal": "Verlängert sich automatisch, jederzeit in den Store-Einstellungen kündbar.",
  "paywall.summary.paid": "Heute fällig: {today} · Danach {price} {duration}",
  "paywall.summary.renewal": "Verlängert sich automatisch, jederzeit in den Store-Einstellungen kündbar.",
  "paywall.summary.includes": "Enthalten: {value}",
  "paywall.summary.unlocks": "Freigeschaltet gegen Coins: {value}",
  "paywall.summary.after": "Danach: {value}",
  "paywall.summary.upgrade": "Die Verrechnung der Restlaufzeit zeigt dir der Store vor dem Kauf.",
  "paywall.summary.downgrade": "Wechsel zum Ende der laufenden Laufzeit am {date}",
  "paywall.summary.trial_pending": "Kauf wird geprüft …",
  "paywall.matrix.toggle": "Alle Leistungen vergleichen",
  "paywall.matrix.row.messages": "Nachrichten pro Tag",
  "paywall.matrix.row.coins": "Coins pro Woche",
  "paywall.matrix.row.live": "Lagerfeuer je 4 Wochen",
  "paywall.matrix.row.live_after": "danach pro Minute",
  "paywall.matrix.row.tts": "Vorlesen",
  "paywall.matrix.row.backgrounds": "Hintergründe je 4 Wochen",
  "paywall.matrix.row.status": "Tagesstatus",
  "paywall.matrix.row.themes_icons": "Themes und App-Icons",
  "paywall.matrix.row.zdr": "Andere Modellfamilie (für alle ohne Aufpreis)",
  "paywall.matrix.row.trial": "Gratiswoche",
  "paywall.matrix.cell.included": "enthalten",
  "paywall.matrix.cell.coins": "gegen Coins",
  "paywall.matrix.cell.yes": "ja",
  "paywall.matrix.cell.no": "nein",
  "paywall.matrix.cell.premium": "Premium-Stimme",
  "paywall.matrix.cell.beta": "1 Charakter",
  "paywall.matrix.cell.founders_status": "2 Charaktere",
  "paywall.matrix.cell.standard": "Standard",
  "paywall.matrix.cell.trial_only": "nur Neukunden",
  "paywall.matrix.cell.unlock": "freigeschaltet",
  "paywall.founders_title": "Lorath unterstützen",
  "paywall.founders_body": "Founders ist eine eigene Stufe: Du trägst Lorath mit, erhältst ein exklusives Icon und Theme und bekommst 100 Nachrichten pro Tag, 250 Coins pro Woche sowie 30 Lagerfeuer-Minuten je 4 Wochen.",
  "paywall.legal_coins": "Coins werden wöchentlich gutgeschrieben und verfallen 21 Tage nach Gutschrift. Ein Monatsabo enthält 4 Wochengutschriften, ein Jahresabo 52 – unabhängig von der Länge des Store-Abrechnungsmonats.",
  "paywall.legal_minutes": "Lagerfeuer-Minuten gelten je 28 Tage ab Abo-Beginn und nur für Monats- und Jahresabos von Ultra und Founders, auch während einer Gratis-Woche dieser Laufzeiten. Wochenabos enthalten keine Minuten.",
  "paywall.web_continue": "In der App fortsetzen",
  "paywall.error_verifying": "Kauf wird geprüft …",
  "paywall.per_month": "entspricht {amount} pro Monat",
  "paywall.recommendation.based_on": "Für deine Nutzung in den letzten 28 Tagen passt {tier}",
  "paywall.recommendation.avg_messages": "durchschnittlich {value} Nachrichten am Tag",
  "paywall.recommendation.campfire_minutes": "{value} Lagerfeuer-Minuten",
  "paywall.recommendation.backgrounds": "{value} Hintergründe",
  "paywall.recommendation.tts": "{value} Mal Vorlesen",
  "paywall.recommendation.downgrade_hint": "Für deine Nutzung reicht {tier} – du kannst zum Ende deiner Laufzeit wechseln.",
  "paywall.preview.voice_title": "Hörprobe",
  "paywall.preview.voice_plus": "Standard-Stimme",
  "paywall.preview.voice_ultra": "Premium-Stimme",
  "paywall.preview.themes_title": "Themes",
  "paywall.preview.icons_title": "App-Icons",
  "paywall.preview.tier_plus": "Plus",
  "paywall.preview.tier_ultra": "Ultra",
  "paywall.preview.tier_founders": "Founders",
  "paywall.preview.tier_locked": "ab {tier}",
  "paywall.sticky_hint": "{tier} · {price} {per}",
  "promo.card.title": "Mehr Raum für deine Geschichten",
  "promo.card.text": "Tägliche Gratis-Nachrichten, Erzählerstimme, Lagerfeuer-Gespräche und eigene Gestaltung – mit Lorath Plus, Ultra oder Founders.",
  "promo.card.member_title": "Deine Mitgliedschaft",
  "promo.later": "Später",
  "promo.dismiss": "Ausblenden",
  "membership.quota_title": "Deine Kontingente",
  "upsell.coins_empty": "Mitgliedschaft ansehen", "upsell.view_membership": "Mitgliedschaft ansehen",
  "upsell.creative_scene": "Diese Szene in Kreativ, {coins} Coins",
  "upsell.free_messages_empty": "Mehr Gratis-Nachrichten mit Ultra", "upsell.live_minutes_empty": "Mehr Live-Minuten mit Ultra",
  "typing.writing": "Der Erzähler schreibt …", "typing.writing_named": "{name} schreibt …",
  "promo.intro.free.title": "Neu: Lorath Mitgliedschaft",
  "promo.intro.member.title": "Danke für deine Mitgliedschaft",
  "promo.start.free.title": "Mehr Raum für deine Geschichten",
  "promo.start.lapsed.title": "Willkommen zurück",
  "promo.start.plus.title": "Mehr Luft mit Ultra",
  "promo.start.ultra.title": "Trag die Fackel weiter",
  "promo.messages.free.title": "Du bist mittendrin",
  "promo.context.adventure.free.title": "Willst du den Erzähler hören?",
  "promo.context.character.free.title": "Willst du mit {name} sprechen?",
  "promo.context.group.free.title": "Mehr Runden am Tag",
  "promo.context.adventure.plus.title": "Mit dem Erzähler sprechen?",
  "promo.context.character.plus.title": "Mit {name} live sprechen?",
  "promo.quota.coins.free.title": "Deine Coins sind aufgebraucht",
  "promo.quota.messages.plus.title": "20 von 20 heute",
  "promo.quota.live.ultra.title": "Live-Minuten aufgebraucht",
  "promo.intro.free.text": "Plus, Ultra und Founders bringen dir tägliche Gratis-Nachrichten, Erzählerstimme, Lagerfeuer-Gespräche, Hintergründe und eigene Gestaltung. Teste 7 Tage gratis, jederzeit kündbar.",
  "promo.intro.member.text": "Deine Vorteile sind aktiv. {hint}",
  "promo.start.free.text": "Mit Plus hast du 20 Gratis-Nachrichten am Tag, 40 Coins pro Woche und die Erzählerstimme. Ultra legt Lagerfeuer-Gespräche und 60 Nachrichten drauf.",
  "promo.start.lapsed.text": "Dein Platz am Feuer ist frei: {tier} wartet auf dich – mit allen Vorteilen, die du kanntest.",
  "promo.start.plus.text": "60 Nachrichten am Tag, 125 Coins pro Woche, 15 Live-Minuten und alle App-Icons. Deine Restlaufzeit wird angerechnet.",
  "promo.start.ultra.text": "Founders: 100 Nachrichten am Tag, 30 Live-Minuten, 20 Hintergründe, Founders-Siegel und dein Name in den Credits.",
  "promo.messages.free.text": "Mit Plus schreibst du täglich 20 Nachrichten ohne Coins und bekommst 40 Coins pro Woche obendrauf.",
  "promo.context.adventure.free.text": "Mit Plus liest der Erzähler jede Szene vor. Mit Ultra sprichst du live mit ihm – 15 Minuten im Monat inklusive.",
  "promo.context.character.free.text": "Mit Ultra rufst du {name} an und sprichst live – 15 Minuten im Monat inklusive, dazu 60 Nachrichten am Tag.",
  "promo.context.group.free.text": "Mit Plus schreibst du 20 Nachrichten täglich, über alle Gespräche verteilt.",
  "promo.context.adventure.plus.text": "Ultra bringt 15 Live-Minuten im Monat und 60 Nachrichten am Tag.",
  "promo.context.character.plus.text": "Ultra bringt 15 Live-Minuten im Monat und die beste Stimme. Deine Restlaufzeit wird angerechnet.",
  "promo.quota.coins.free.text": "Mit Plus geht es täglich mit 20 Gratis-Nachrichten weiter – und 40 Coins pro Woche.",
  "promo.quota.messages.plus.text": "Mit Ultra wären es 60 Nachrichten am Tag – und 125 Coins pro Woche.",
  "promo.quota.live.ultra.text": "Founders bringt 30 Minuten im Monat und 20 Hintergründe.",
  "promo.intro.free.cta": "7 Tage gratis testen",
  "promo.intro.member.cta": "Vorteile ansehen",
  "promo.start.free.cta": "Mitgliedschaften ansehen",
  "promo.start.lapsed.cta": "Wieder einsteigen",
  "promo.start.plus.cta": "Upgrade ansehen",
  "promo.start.ultra.cta": "Founders ansehen",
  "promo.messages.free.cta": "7 Tage gratis testen",
  "promo.context.adventure.free.cta": "Stimmen freischalten",
  "promo.context.character.free.cta": "Anrufe freischalten",
  "promo.context.group.free.cta": "Mitgliedschaften ansehen",
  "promo.context.adventure.plus.cta": "Upgrade ansehen",
  "promo.context.character.plus.cta": "Upgrade ansehen",
  "promo.quota.coins.free.cta": "7 Tage gratis testen",
  "promo.quota.messages.plus.cta": "Upgrade ansehen",
  "promo.quota.live.ultra.cta": "Founders ansehen",
  "promo.intro.free.benefit1": "20 bis 100 Standard-Nachrichten pro Tag ohne Coins",
  "promo.intro.free.benefit2": "Erzählerstimme und Lagerfeuer-Gespräche",
  "promo.intro.free.benefit3": "Coins, Hintergründe, Themes und App-Icons inklusive",
  "promo.intro.member.benefit1": "Tägliche Gratis-Nachrichten und Monats-Coins laufen",
  "promo.intro.member.benefit2": "Stimmen, Hintergründe und Gestaltung sind freigeschaltet",
  "promo.intro.member.benefit3": "Jederzeit in den Einstellungen verwalten",
  "promo.start.free.benefit1": "20 Standard-Nachrichten pro Tag ohne Coins",
  "promo.start.free.benefit2": "40 Coins pro Woche inklusive",
  "promo.start.free.benefit3": "Zusätzliche Designs und App-Symbole",
  "promo.start.lapsed.benefit1": "Tägliche Gratis-Nachrichten ohne Coins",
  "promo.start.lapsed.benefit2": "Monats-Coins inklusive",
  "promo.start.lapsed.benefit3": "Stimmen, Hintergründe und Gestaltung",
  "promo.start.plus.benefit1": "60 Standard-Nachrichten pro Tag",
  "promo.start.plus.benefit2": "125 Coins pro Woche",
  "promo.start.plus.benefit3": "15 Live-Minuten pro Monat inklusive",
  "promo.start.ultra.benefit1": "100 Standard-Nachrichten pro Tag",
  "promo.start.ultra.benefit2": "30 Live-Minuten pro Monat inklusive",
  "promo.start.ultra.benefit3": "Founders-Siegel und Name in den Credits",
  "promo.messages.free.benefit1": "20 Standard-Nachrichten pro Tag ohne Coins",
  "promo.messages.free.benefit2": "40 Coins pro Woche inklusive",
  "promo.messages.free.benefit3": "4 individuelle Hintergründe pro Monat",
  "promo.context.adventure.free.benefit1": "Erzählerstimme freigeschaltet",
  "promo.context.adventure.free.benefit2": "Lagerfeuer-Gespräche freigeschaltet",
  "promo.context.adventure.free.benefit3": "20 Standard-Nachrichten pro Tag ohne Coins",
  "promo.context.character.free.benefit1": "15 Live-Minuten pro Monat inklusive",
  "promo.context.character.free.benefit2": "60 Standard-Nachrichten pro Tag",
  "promo.context.character.free.benefit3": "125 Coins pro Woche",
  "promo.context.group.free.benefit1": "20 Nachrichten täglich, über alle Gespräche verteilt",
  "promo.context.group.free.benefit2": "40 Coins pro Woche inklusive",
  "promo.context.group.free.benefit3": "Zusätzliche Designs und App-Symbole",
  "promo.context.adventure.plus.benefit1": "60 Standard-Nachrichten pro Tag",
  "promo.context.adventure.plus.benefit2": "125 Coins pro Woche",
  "promo.context.adventure.plus.benefit3": "15 Live-Minuten pro Monat inklusive",
  "promo.context.character.plus.benefit1": "60 Standard-Nachrichten pro Tag",
  "promo.context.character.plus.benefit2": "125 Coins pro Woche",
  "promo.context.character.plus.benefit3": "15 Live-Minuten pro Monat inklusive",
  "promo.quota.coins.free.benefit1": "20 Standard-Nachrichten pro Tag ohne Coins",
  "promo.quota.coins.free.benefit2": "40 Coins pro Woche inklusive",
  "promo.quota.coins.free.benefit3": "Jederzeit kündbar",
  "promo.quota.messages.plus.benefit1": "60 Standard-Nachrichten pro Tag",
  "promo.quota.messages.plus.benefit2": "125 Coins pro Woche",
  "promo.quota.messages.plus.benefit3": "15 Live-Minuten pro Monat inklusive",
  "promo.quota.live.ultra.benefit1": "100 Standard-Nachrichten pro Tag",
  "promo.quota.live.ultra.benefit2": "30 Live-Minuten pro Monat inklusive",
  "promo.quota.live.ultra.benefit3": "Founders-Siegel und Name in den Credits",
  "promo.intro.member.upgrade_hint.plus": "Ultra bringt 60 Nachrichten am Tag und Lagerfeuer-Gespräche.",
  "promo.intro.member.upgrade_hint.ultra": "Founders bringt 30 Live-Minuten, das Founders-Siegel und deinen Namen in den Credits.",
  "promo.intro.member.upgrade_hint.none": "Danke, dass du Lorath trägst.",
  "promo.preview.label": "Hinweis-Vorschau (Admin)",
  "promo.preview.off": "Aus",
  "promo.preview.show_intro": "Intro-Dialog zeigen",
  "promo.preview.show_bestandsschutz_end": "Bestandsschutz-Hinweis zeigen (ab 18)",
  "promo.preview.show_bestandsschutz_end_minor": "Bestandsschutz-Hinweis zeigen (unter 18)",
  // P3 §9 — Tarif-Change-CTAs aus dem Settings-Accordion
  "membership.settings.upgrade": "Tarif ändern",
  "membership.settings.restore": "Käufe wiederherstellen",
  "membership.settings.restore_success": "Käufe wiederhergestellt",
  "membership.settings.restore_error": "Wiederherstellung fehlgeschlagen ({code})",
  "membership.next_coins": "Nächste {coins} Coins am {date}",
  "membership.coins_weekly": "{coins} Coins pro Woche",

  "week.title": "Deine Woche",
  "week.subtitle": "{start} – {end}",
  "week.empty.title": "Diese Woche ist noch leer.",
  "week.empty.body": "Wenn du mit einem Abenteuer oder einer Figur schreibst, füllt sich dein Rückblick von allein.",
  "week.nav.prev": "Vorherige Woche",
  "week.nav.next": "Nächste Woche",
  "week.nav.today": "Heute",
  "week.counts.title": "Kennzahlen",
  "week.counts.messages": "Nachrichten",
  "week.counts.adventures_active": "Aktive Abenteuer",
  "week.counts.character_chats_active": "Aktive Begleiter",
  "week.counts.images": "Bilder",
  "week.counts.audiobook_minutes": "Hörbuch-Minuten",
  "week.counts.campfire_sessions": "Lagerfeuer-Sitzungen",
  "week.moments.title": "Momente",
  "week.moments.empty": "In dieser Woche hast du noch keinen Moment hinterlassen.",
  "week.moments.kind.adventure": "Abenteuer",
  "week.moments.kind.character": "Begleiter",
  "week.images.title": "Bilder der Woche",
  "week.images.empty": "Keine Bilder gespeichert.",
  "week.continue.button": "Hier weitermachen",
  "week.continue.last_active": "Zuletzt aktiv {when}",
  "week.locked.title": "Mehr in deinem Wochenrückblick",
  "week.locked.body": "Du siehst hier eine Vorschau. Mit Plus bekommst du alle Momente und Bilder der Woche.",
  "week.error.too_far_back": "Du kannst nur acht Wochen zurückblicken.",
  "week.error.future_week": "Diese Woche liegt in der Zukunft.",
  "week.error.invalid_week": "Ungültiges Wochenformat. Erwartet wird JJJJ-Www.",
  "memories_book.title": "Erinnerungsbuch",
  "memories_book.search_placeholder": "Erinnerung suchen",
  "memories_book.empty": "Noch keine Erinnerungen gespeichert.",
  "memories_book.empty_hint": "Schreib dir die ersten Gedanken auf — was soll dein Begleiter oder dein Abenteuer über dich wissen?",
  "memories_book.add_button": "Neue Erinnerung",
  "memories_book.add_placeholder": "Was möchtest du dir merken?",
  "memories_book.add_confirm": "Speichern",
  "memories_book.edit_button": "Bearbeiten",
  "memories_book.edit_confirm": "Änderung speichern",
  "memories_book.delete_title": "Erinnerung löschen?",
  "memories_book.delete_body": "Dieser Eintrag wird dauerhaft entfernt.",
  "memories_book.delete_confirm": "Löschen",
  "memories_book.cancel": "Abbrechen",
  "memories_book.saved": "Gespeichert.",
  "memories_book.deleted": "Gelöscht.",
  "memories_book.error_too_long": "Bitte halte den Eintrag unter 500 Zeichen.",
  "memories_book.pin_toggle": "Anpinnen",
  "memories_book.unpin_toggle": "Lösen",
  "memories_book.pinned_label": "Gepinnt",
  "memories_book.error_generic": "Das hat nicht geklappt. Versuch es nochmal.",
  "week.nav.card_label": "Wochenrückblick",
  "week.nav.card_desc": "Kennzahlen, Momente und Bilder deiner Woche",
  "memories_book.nav_label": "Erinnerungsbuch",
  "lock.feature.live_call": "Anruf – ab {tier}",
  "admin.funnel.title": "Conversion-Trichter (Mitgliedschaft)",
  "admin.funnel.window_label": "Zeitraum",
  "admin.funnel.window_days": "{days} Tage",
  "admin.funnel.total_promo_view": "Angezeigt",
  "admin.funnel.total_promo_click": "Angeklickt",
  "admin.funnel.total_paywall_view": "Paywall besucht",
  "admin.funnel.total_checkout_started": "Käufe gestartet",
  "admin.funnel.total_purchase_verified": "Käufe bestätigt",
  "admin.funnel.total_trial_started": "Gratiswochen gestartet",
  "admin.funnel.rate_promo": "Anzeige → Klick",
  "admin.funnel.rate_paywall": "Paywall → Kaufstart",
  "admin.funnel.rate_checkout": "Kaufstart → bestätigt",
  "admin.funnel.rate_trial": "Gratiswoche → bestätigt",
  "admin.funnel.note": "Daten dienen der Optimierung der Promo- und Paywall-Texte. Keine personenbezogenen Inhalte.",
  // S11 Founders-Bereich: alle Texte spiegeln 1:1 die DE-Quellen in
  // server/i18n/ui/de.json (siehe scripts/i18n-pending-sources.json).
  "founders.page_title": "Founders-Bereich",
  "founders.intro_thanks": "Danke, dass du Lorath von Anfang an trägst. Hier zählt deine Stimme wirklich.",
  "founders.intro_preview": "Stimm mit ab, gib uns Rückmeldung und tauche in den Credits auf – wenn du willst.",
  "founders.section_vote": "Abstimmen",
  "founders.vote_intro": "Eine offene Abstimmung. Du kannst deine Stimme jederzeit ändern.",
  "founders.vote_voted": "Du hast für „{option}\" gestimmt. Danke!",
  "founders.vote_change": "Stimme ändern",
  "founders.vote_results_count": "{count} Stimmen",
  "founders.vote_results_percent": "{percent} %",
  "founders.vote_closed": "Diese Abstimmung ist geschlossen.",
  "founders.vote_closed_at": "Geschlossen am {date}.",
  "founders.vote_none_open": "Aktuell ist keine Abstimmung offen. Schau bald wieder vorbei.",
  "founders.section_feedback": "Deine Rückmeldung",
  "founders.feedback_intro": "Was funktioniert gut, was nervt dich? Du kannst bis zu fünf Einträge pro Tag senden.",
  "founders.feedback_label": "Deine Nachricht an uns",
  "founders.feedback_placeholder": "Schreib uns, was dir auf dem Herzen liegt …",
  "founders.feedback_max": "Maximal 1000 Zeichen.",
  "founders.feedback_send": "Senden",
  "founders.feedback_empty": "Du hast uns noch nichts geschrieben.",
  "founders.feedback_status_new": "Neu",
  "founders.feedback_status_seen": "Gelesen",
  "founders.feedback_status_answered": "Beantwortet",
  "founders.feedback_reply_label": "Unsere Antwort",
  "founders.feedback_error_required": "Bitte schreib uns eine kurze Nachricht.",
  "founders.feedback_error_too_long": "Deine Nachricht ist zu lang (maximal 1000 Zeichen).",
  "founders.feedback_error_daily_limit": "Du hast dein Tageslimit von fünf Rückmeldungen erreicht.",
  "founders.feedback_success": "Danke! Wir haben deine Rückmeldung erhalten.",
  "founders.section_credits": "Credits",
  "founders.credits_intro": "Sollen wir deinen Namen in den Founders-Credits zeigen? Du kannst das jederzeit ändern oder leer lassen.",
  "founders.credits_opt_in": "Meinen Namen in den Credits nennen",
  "founders.credits_label": "Anzeigename",
  "founders.credits_placeholder": "z.B. Anna oder Anna Z.",
  "founders.credits_save": "Speichern",
  "founders.credits_saved": "Gespeichert.",
  "founders.credits_error_invalid_name": "Bitte nur Buchstaben, Zahlen, Leerzeichen, Bindestrich, Punkt und Apostroph.",
  "founders.credits_error_too_long": "Der Anzeigename darf maximal 40 Zeichen lang sein.",
  "founders.credits_list_title": "Unsere Founders",
  "founders.credits_list_empty": "Sobald die ersten Founders zustimmen, tauchen sie hier auf.",
  "founders.credits_list_intro": "Diese Menschen unterstützen Lorath von Anfang an.",
  "founders.section_roadmap": "Roadmap",
  "founders.roadmap_column_planned": "Geplant",
  "founders.roadmap_column_in_progress": "In Arbeit",
  "founders.roadmap_column_done": "Erledigt",
  "founders.preview_locked": "Der Founders-Bereich ist nur für Founders und Fackelträger sichtbar.",
  "founders.preview_cta": "Founders-Bereich freischalten",
  "founders.entry_link_paywall": "Founders-Bereich ansehen",
  "founders.entry_link_paywall_locked": "Nach der Anmeldung sichtbar",
  "founders.entry_link_settings": "Founders-Bereich",
  // S8 Onboarding: Einstiegswahl, Vorteilswoche, Trial-Erinnerung.
  // Texte spiegeln 1:1 die DE-Quellen in server/i18n/ui/de.json.
  "onboarding.choice.title": "Womit möchtest du anfangen?",
  "onboarding.choice.intro": "Du hast gerade Plus aktiviert. Such dir einen Vorteil aus, mit dem du direkt loslegen möchtest. Den Rest findest du jederzeit in den Einstellungen.",
  "onboarding.choice.writing_title": "Mehr schreiben",
  "onboarding.choice.writing_body": "Weiter im letzten Abenteuer oder Charakter-Chat — wo du zuletzt aktiv warst.",
  "onboarding.choice.listening_title": "Geschichten hören",
  "onboarding.choice.listening_body": "Erzählerstimme für dein letztes Abenteuer oder Lagerfeuer bei Ultra.",
  "onboarding.choice.design_title": "Gestalten",
  "onboarding.choice.design_body": "Themes, App-Icon und Hintergründe in den Erscheinungsbild-Einstellungen.",
  "onboarding.choice.opt_in": "Erinnere mich zwei Tage vor der ersten Abbuchung",
  "onboarding.choice.skip": "Später",
  "onboarding.banner.title": "Weiter mit {benefit}",
  "onboarding.banner.text": "Du nutzt Lorath Plus seit ein paar Tagen. Entdecke als Nächstes: {benefit}. Du kannst es jederzeit ablehnen.",
  "onboarding.banner.cta": "Ausprobieren",
  "onboarding.loading": "Bereite deine Vorteile vor …",
  "onboarding.trial_reminder.title": "Deine Gratiswoche endet bald",
  "onboarding.trial_reminder.body": "Deine Gratiswoche endet am {date}. Danach wird der Preis automatisch verlängert. Du kannst jederzeit in den Store-Einstellungen kündigen.",
  "onboarding.trial_reminder.ok": "Alles klar",
  "onboarding.trial_reminder.manage": "Abo verwalten",
  "paywall.trial_unverified": "Gratiswoche, sofern dein Store-Konto berechtigt ist",
  "paywall.summary.offer_pending": "Das verfügbare Angebot wird im Store geprüft.",
  "paywall.summary.downgrade_unknown": "Wechsel zum Ende der laufenden Laufzeit. Den Termin zeigt dir der Store.",
};

const M5_EN_OVERRIDES: TranslationMap = {
  "a5.unlimited_short": "Unlimited turns",
  "publish.usk_required_hint": "Please choose an age level.",
  "publish.status_error": "The publication status could not be loaded. Please try again.",
  "character_chat.menu_section_settings": "Balance, help and reply mode",
  "chat.menu_notes_section": "Notes, balance and help",
  "dashboard.pinned_badge": "Pinned",
  "chats.menu_unpin": "Unpin",
  "chats.conversation_aria": "{name}, {conversation}",
  "chats.conversation_n_date": "Conversation {number} from {date}",
  "chats.conversation_n": "Conversation {number}",
  "chats.menu_profile_hint": "This character’s images, voice and actions.",
  "chat.open_world_hint": "Opens the world overview and makes this world your active world.",
  "chat.open_world": "Explore this adventure’s world",
  "chat.adventure_actions_hint": "Here you find the main features for your adventure. Your notes and balance are further down.",
  "chat.adventure_actions": "Actions for your adventure",
  "chat.memories_book_hint": "Read the saved moments from this adventure.",
  "chat.change_narrator_hint": "{name} is narrating now; choose a different narrative style here.",
  "chat.change_narrator": "Change narrator",
  "publish.consent.required_hint": "To submit: read the points in the form and tick the consent box here.",
  "character_chat.persona_create": "Create player character",
  "character_chat.persona_player_hint": "Choose one of your player characters as your role in this conversation. Your companion remains the other participant.",
  "companion.publish_hint": "Share your character with others after reviewing the publication information.",
  "companion.pin_hint": "Keep this conversation at the top of your chat list.",
  "companion.image_hint": "Open the image controls in the profile and confirm the displayed cost there.",
  "companion.image_title": "Generate image",
  "companion.voice_saved": "Voice saved. It will apply to the next new audio output.",
  "companion.voice_hint": "Choose this character’s voice for calls and messages read aloud.",
  "companion.voice_title": "Change voice",
  "companion.actions_title": "Companion actions",
  "tier.zdr.description": "Writes text replies with a different AI model family, which gives them a different writing style. Your message price and other settings stay the same.",
  "pwa.game_settings": "Narrators, worlds and game rules",
  "settings.experience_title": "Reading and chat assistance",
  "settings.section.experience": "Reading & chat",
  "settings.section.media": "Replies & audio",
  "settings.section_hint.legal": "Read the privacy policy, terms of use and other legal information.",
  "settings.section_hint.privacy": "Control product improvement and advertising attribution.",
  "settings.section_hint.help": "Get help and manage local app data.",
  "settings.section_hint.notifications": "Choose push notifications and emails.",
  "settings.section_hint.experience": "Set reading speed, reply length, chat assistance and cost control.",
  "settings.section_hint.media": "Set reply quality, costs, reading aloud and voices.",
  "settings.section_hint.appearance": "Adjust colors and chat backgrounds.",
  "settings.section_hint.account": "Manage your profile, preferred name, date of birth, content age level and sign-in.",
  "settings.danger_title": "Permanently delete account",
  "settings.logout_hint": "Sign out on this device. Your account and saved content will remain available.",
  "settings.session_title": "Sign-in",
  "profile.display_name_invalid": "Please enter a display name of up to 80 characters.",
  "profile.display_name_hint": "This is your name in Lorath, including the preferred name from onboarding. You can change it any time.",
  "profile.display_name": "Preferred name / display name",
  "chats.delete_title": "Delete conversation",
  "chats.delete_confirm": "“{name}” and the entire conversation will be permanently deleted.",
  "chats.delete_error": "The conversation could not be deleted. Please try again.",
  "chat.adventure_menu_title": "Adventure menu",
  "measurement.report.heading": "Measurement: {from} to {to} (end exclusive)",
  "measurement.report.full": "Coverage: full collection week.",
  "measurement.report.partial": "Coverage: incomplete; events before collection began cannot be reconstructed.",
  "measurement.report.scope": "Registered adults with measurement keys only. Small groups are combined and small individual metrics withheld.",
  "measurement.report.cohort": "Cohort {week}: registration {registered} → first message {first} → fifth message {fifth} → purchase view {view} → purchase {purchase}.",
  "measurement.report.wait": "Wait time {group}: median {median} ms ({accounts} accounts, {samples} responses).",
  "measurement.report.anonymous": "Guests/minors: unlinked totals only; no group output without a provable account count.",

  "measurement.title": "Measurement",
  "measurement.scope": "Registered adults from the start of measurement only. Guests and minors contribute to unlinked totals, withheld without a provable account count. Groups below five accounts are combined or withheld. The funnel counts distinct accounts at each stage within the period.",
  "measurement.period": "Period",
  "measurement.previous_week": "Previous week",
  "measurement.twelve_weeks": "Twelve completed weeks",
  "measurement.refresh": "Refresh",
  "measurement.suppressed": "Withheld (< 5)",
  "measurement.failed": "Measurement could not be loaded.",
  "measurement.enabled": "Collection enabled.",
  "measurement.disabled": "Collection disabled; enable only after L1.",
  "measurement.incomplete": "This period has not been fully captured. Events before collection began or removed after objection or account deletion are intentionally unavailable.",
  "measurement.cohorts": "Funnel by registration week",
  "measurement.week": "Registration week",
  "measurement.accounts": "Measured accounts",
  "measurement.account_registered": "Registered / secured",
  "measurement.first_own_message": "1st own message",
  "measurement.fifth_own_message": "5th own message",
  "measurement.purchase_view": "Purchase view",
  "measurement.purchase_completed": "Purchase",
  "measurement.combined": "Combined groups",
  "measurement.empty": "No sufficiently large cohort in this period.",
  "measurement.latency": "Time to first streamed section",
  "measurement.platform_language": "Platform / language",
  "measurement.samples": "Responses",
  "measurement.median": "Median",
  "measurement.a3_unavailable": "A3: First own messages after template starts cannot currently be measured reliably. Existing campaigns do not unambiguously record template provenance. Gate: at least 55% across at least 40 starts.",
  "measurement.weekly_report": "Weekly report",
  "measurement.report_enabled": "Automatic storage of the previous week report enabled.",
  "measurement.report_disabled": "Automatic storage disabled. The preview remains available.",
  "attribution.title": "May we check how you found us?",
  "attribution.body.ios": "We would like to know whether you found Lorath through one of our ads in the App Store. To do this, we ask Apple once. We only receive the identifiers of our advertising account, campaign, ad group, keyword and ad, your country or region, and whether this was a first download or a redownload. No advertising ID, no information about other apps. We store this on your account for 13 months to make sensible use of our small advertising budget. You can change this at any time in Settings. Read more in the Privacy Policy, section 2a i.",
  "attribution.body.android": "We would like to know which link or ad brought you to Lorath. To do this, the app reads the information Google Play stored during installation once: the source, medium, campaign, content and keyword of the link, as well as the times of the click and the start of installation. No advertising ID, no information about other apps. We store this on your account for 13 months to make sensible use of our small advertising budget. You can change this at any time in Settings. Read more in the Privacy Policy, section 2a i.",
  "attribution.privacy": "Privacy Policy, section 2a i",
  "attribution.allow": "Allow",
  "attribution.deny": "Do not allow",
  "attribution.failed": "We could not update the installation source. You can check your consent under Settings › Privacy and withdraw it at any time.",
  "attribution.settings.title": "Installation source",
  "attribution.settings.description": "With your consent, we check once where your installation came from and store its source on your account for 13 months. Switching this off withdraws your consent and deletes the source information from Apple or Google.",
  "attribution.settings.privacy": "Privacy",

  "entry.continue_apple": "Continue with Apple",
  "entry.continue_google": "Continue with Google",
  "entry.register_email": "Register with email",
  "entry.try_guest": "Try it without an account first",
  "entry.have_account": "I have an account",
  "entry.tap_to_start": "Tap to start right away",
  "entry.build_own": "Create your own adventure",
  "entry.secure_title": "Save your account",
  "entry.secure_body": "Save your story so you can find it again on any device.",
  "entry.secure_apple": "Save with Apple",
  "entry.secure_google": "Save with Google",
  "entry.secure_email": "Save with email",
  "entry.later": "Later",
  "entry.expiry_body": "Your guest access expires within the next five days. Save your account to continue your story afterwards.",
  "entry.oauth_already_linked": "This Apple or Google account is already linked to another Lorath account. The accounts will not be merged. Save this story with another login or with email.",
  "entry.secure_error": "We couldn't save your account. You can try again or save your story with email.",
  "entry.walkthrough": "Walkthrough",
  "entry.walkthrough_error": "The walkthrough couldn't be opened. Please try again.",
  "entry.what_do_you_do": "What do you do?",
  "iap.status.verified": "Your purchase is confirmed.",
  "iap.billing_issue.apple_store": "App Store",
  "iap.billing_issue.google_store": "Play Store",
  "iap.error.payment_declined": "Payment was declined.",
  "iap.error.store_unavailable": "The store is currently unavailable. Please try again later.",
  "iap.plan_change_at_period_end": "You can switch to a shorter billing period after your current subscription expires. Turn off renewal in Google Play, then purchase the subscription you want after it expires.",
  "iap.status.already_owned": "You already own this subscription. Restoring it now.",
  "iap.status.confirming": "Confirming your purchase …",
  "iap.status.delayed": "Confirmation is taking longer. You will be notified once it arrives.",
  "iap.status.owner_conflict": "This subscription belongs to another Lorath account.",
  "iap.billing_issue.title": "Check your payment method",
  "iap.billing_issue.text": "Your payment in the {store} failed. Update your payment method to keep your membership running.",
  "iap.billing_issue.manage": "Update payment method",
  "audio.error_stt_language": "Dictation is not available in your account language yet. You can type your message instead.",
  "tr_session.tab_transcript": "Transcript",
  "tr_session.price_free_remaining": "You have {time} of one-time free minutes left. The estimate includes them.",
  "tr_session.transcript_empty": "No transcript yet",
  "tr_session.transcript_empty_hint": "The spoken text will appear here after purchase and processing.",
  "tr_session.transcript_speaker": "Speaker {number}",
  "legal_reaccept.changes.heading": "What has changed?",
  "legal_reaccept.changes.terms": "New: Rules for gift codes (redeemable for at least three years, Coins from purchased codes never expire, cancellation, purchases without an account where offered), a clear purchase rule for minors (only with prior parental consent) and rules for one-time first-purchase offers. Advance bank transfer is no longer offered.",
  "legal_reaccept.changes.use_terms": "New: All text routes use Zero Data Retention, except in the 18+ area, and MiniMax is no longer used; Standard images are generated by ByteDance or Google. The surcharge for the ZDR option is removed. New rules cover one-time first-purchase offers, the invitation reward (§ 4d) including the transition for earlier invitations, and a clear purchase rule for minors.",
  "legal_reaccept.changes.privacy": "New: MiniMax is no longer used. Texts go through OpenRouter to Anthropic models, and some background tasks to a DeepSeek model; all text and image routes use Zero Data Retention (ZDR), except in the 18+ area. We send Standard images to ByteDance with possible processing in China only if you agree beforehand in a separate dialog; otherwise, Google generates them at the same price. Newly described are also measurement using a pseudonymous measurement key, the origin of your account, gift codes with information about the recipient, invitations, purchase prompts in the app and the beta environment. We request consent, for example for advertising origin in the apps, separately; this acceptance is not such consent.",
  "paywall.legal_contract": "Purchasing a membership concludes a contract with Julius Berger (Lorath.eu). Payment is processed through the App Store or Google Play Store. Our General Terms and Conditions and Privacy Policy apply. By placing the order, you confirm that you are an adult or that a parent has consented to the purchase beforehand (General Terms and Conditions § 4.3).",
  "iap.restore.nothing_found": "No active membership was found to restore.",
  "live_talk.included_minutes_used": "Your included minutes are used up. Continue for {rate} Coins/minute",
  "membership.title": "Membership",
  "membership.teaser": "More stories, voices and ways to personalise Lorath with Plus, Ultra or Founders.",
  "membership.view_plans": "View memberships",
  "membership.settings_title": "Membership",
  "membership.no_next_date": "No next date",
  "membership.free_description": "You are using Lorath without a membership.",
  "membership.plan": "Plan", "membership.status": "Status", "membership.duration": "Duration", "membership.next_date": "Next date",
  "membership.status.trial": "Trial", "membership.status.active": "Active", "membership.status.grace": "Payment pending", "membership.status.cancelled": "Cancelled", "membership.status.expired": "Expired",
  "membership.unlimited_messages": "Unlimited standard messages",
  "membership.messages_quota": "{left} of {total} free messages left today",
  "membership.daily_counter": "{used} of {total} free messages today",
  "membership.live_quota": "{left} of {total} campfire minutes left per 28 days",
  "membership.background_quota": "{left} of {total} backgrounds left this month",
  "membership.manage": "Manage",
  "membership.overview.title": "Your subscription",
  "membership.overview.subtitle": "All benefits, credits and usage in one place.",
  "membership.overview.renews_at": "Renews on {date}",
  "membership.overview.usable_until": "Usable until {date}",
  "membership.overview.auto_renew": "Auto-renewal on",
  "membership.overview.auto_renew_off": "Auto-renewal off",
  "membership.overview.this_week": "This week",
  "membership.overview.messages_today": "Messages today",
  "membership.overview.messages_unlimited": "Unlimited standard messages",
  "membership.overview.messages_resets": "Resets at {datetime}",
  "membership.overview.live_minutes": "Campfire minutes",
  "membership.overview.live_minutes_label": "{left} of {total} live minutes left in this cycle",
  "membership.overview.cycle_end": "Cycle ends on {date}",
  "membership.overview.backgrounds": "Backgrounds",
  "membership.overview.backgrounds_label": "{left} of {total} backgrounds left in this cycle",
  "membership.overview.status_characters": "Daily status",
  "membership.overview.status_characters_label": "{used} of {total} daily status runs today",
  "membership.overview.coins_title": "Your coins",
  "membership.overview.coins_balance": "{coins} coins in your account",
  "membership.overview.coins_subscription_title": "Subscription tranches",
  "membership.overview.coins_tranche": "{amount} coins, valid until {date}",
  "membership.overview.coins_tranche_no_expiry": "{amount} coins",
  "membership.coins_help.title": "Which coins are spent first?",
  "membership.coins_help.body": "Lorath uses your coins in this order, so nothing goes to waste: 1) Subscription coins — always the tranche that expires next (21 days after it was granted). 2) Bonus coins, for example from promotions or apologies. 3) Purchased coins. That way nothing expires unnoticed and you keep a clear view.",
  "membership.only_included.label": "Only included benefits",
  "membership.only_included.desc": "Blocks anything that would cost coins — even while included minutes are still available. Once included minutes are used up, the campfire ends without switching to coin mode. Reading aloud, AI backgrounds, daily status and paid chat replies are also blocked.",
  "membership.only_included.help_title": "What does “only included benefits” mean?",
  "tts.only_included": "Your plan only allows included benefits. Reading aloud would cost coins, so it is unavailable right now.",
  "chat.only_included": "Your plan only allows included benefits. This message would cost coins, so it is unavailable right now.",
  "chat_bg.only_included": "Your plan only allows included benefits. AI backgrounds would cost coins, so the feature is unavailable right now.",
  "live.budget.label": "At most {limit} coins in this session",
  "live.budget.unit_coins": "coins",
  "live.budget.hint": "0 = no limit. When the limit is reached the campfire ends cleanly and you can decide what to do next.",
  "live.transition.limit_reached.title": "Session limit reached",
  "live.transition.limit_reached.body": "You have reached the coin limit you set for this session. You can continue paying per coin or end the campfire.",
  "live.transition.limit_reached.continue": "Continue with coins",
  "live.transition.limit_reached.end": "End session",
  "live.transition.only_included.title": "Included mode active",
  "live.transition.only_included.body": "Your included minutes are used up. Your plan only allows included benefits, so the campfire ends here.",
  "live.transition.only_included.continue": "Got it",
  "live.transition.only_included.end": "End session",
  "membership.overview.coins_next_grant": "Next {amount} coins on {date}",
  "membership.overview.coins_expiring_soon": "{amount} coins expire on {date}",
  "membership.overview.coins_purchased_title": "Purchased coins",
  "membership.overview.coins_purchased": "{coins} coins (never expire)",
  "membership.overview.coins_bonus_title": "Bonus coins",
  "membership.overview.coins_bonus": "{coins} coins from bonuses and promotions",
  "membership.overview.ledger_title": "History",
  "membership.overview.ledger_empty": "No transactions yet.",
  "membership.overview.ledger_coins_granted": "{amount} coins credited",
  "membership.overview.ledger_coins_spent": "{amount} coins spent",
  "membership.overview.ledger_coins_expired": "{amount} coins expired",
  "membership.overview.ledger_message_free": "Free message",
  "membership.overview.ledger_live_minutes": "Campfire minutes used",
  "membership.overview.ledger_background": "Background used",
  "membership.overview.ledger_status": "Daily status triggered",
  "membership.overview.manage_subscription": "Manage subscription",
  "membership.overview.manage_subscription_web": "Subscriptions are managed in the Lorath app.",
  "membership.overview.restore": "Restore purchases",
  "membership.overview.upgrade": "View plans",
  "membership.overview.open_overview": "Your subscription",
  "membership.overview.day_group": "{date}",
  "membership.app_icon_title": "App icon", "membership.app_icon_description": "Switch the icon on your home screen. Locked icons require a membership.",
  // M6b Kosmetik: Alternate-App-Icons (Parchment/Obsidian/Founders).
  "appearance.icon.standard": "Standard",
  "appearance.icon.night": "Night",
  "appearance.icon.gold": "Gold",
  "appearance.icon.crimson": "Crimson",
  "appearance.icon.parchment": "Parchment",
  "appearance.icon.obsidian": "Obsidian",
  "appearance.icon.founders": "Founders",
  // M6 Kosmetik: Membership-Badge-Tooltips.
  "membership.badge.plus": "Plus member",
  "membership.badge.ultra": "Ultra member",
  "membership.badge.founders": "Founders member",
  "membership.badge.torchbearer": "Torchbearer",
  "membership.bestandsschutz.title": "Thank you for supporting us early",
  // F2 (Review-2): App-Icon-Tier-Gate (Fix 4). English copy mirrors the German
  // source string so the localOverrides test stays in sync.
  "auth.icon_membership_required": "This app icon is part of a membership.",
  "membership.bestandsschutz.body": "You receive one month of Plus free, active until {date}. You can also secure a one-time 25% discount on an annual plan of your choice.",
  "membership.bestandsschutz.continue": "Thanks, continue", "membership.bestandsschutz.claim": "Secure annual plan with 25% off",
  "bestandsschutz_end.title": "Your early-supporter protection is ending",
  "bestandsschutz_end.body": "Your Plus from the early-supporter protection ends on {date}. After that you keep playing with your coins and the daily chest – the coins you bought are yours to keep, of course.",
  "bestandsschutz_end.cta_view": "View membership",
  "bestandsschutz_end.ack": "Got it",
  "settings.notifications.email_marketing.label": "Weekly recap by email",
  "settings.notifications.email_marketing.desc": "Once a week, a short look back at your adventures and new ideas. You can unsubscribe at any time. To turn it on, we send you a confirmation email.",
  "settings.notifications.email_marketing.pending": "We have sent you a confirmation email. Please confirm there with one click.",
  "settings.notifications.email_marketing.status_pending": "Status: waiting for confirmation",
  "settings.notifications.email_marketing.status_confirmed": "Status: confirmed",
  "settings.notifications.email_marketing.no_email": "Add an email address to your profile first to receive emails.",
  "settings.notifications.email_marketing.age_restricted": "You can receive emails of this kind from the age of 16.",
  "settings.notifications.email_marketing.throttled": "We sent you a confirmation email only a short while ago. Please check your inbox, including the spam folder, and try again later if needed.",
  "settings.notifications.email_marketing.unavailable": "The confirmation email could not be sent right now. Please try again later.",
  "settings.notifications.email_marketing.resend": "Send confirmation email again",
  "email_prompt.label": "Email recap",
  "email_prompt.text": "Would you like a short weekly recap of your adventures and new ideas by email? You can unsubscribe at any time.",
  "email_prompt.yes": "Yes, please",
  "email_prompt.no": "No thanks",
  "email_prompt.sent": "Thank you! We have sent you a confirmation email. Please confirm there with one click.",
  "email_prompt.failed": "That did not work just now. You can turn the emails on at any time under Settings, Notifications.",
  "email.doi_subject": "Please confirm: weekly email recap from Lorath",
  "email.doi_greeting": "Hi {username},",
  "email.doi_p1": "In Lorath you chose to receive a short weekly recap of your adventures and new ideas by email.",
  "email.doi_p2": "So that we can be sure this address is yours and that you really want this, please confirm with one click. We will only send these emails after that.",
  "email.doi_cta": "Yes, send me the emails",
  "email.doi_link_hint": "If the button does not work, copy this link into your browser's address bar:",
  "email.doi_valid": "The link is valid for 7 days.",
  "email.doi_ignore": "If this was not you, simply ignore this message. Nothing will happen.",
  "email.doi_page_confirmed_title": "Confirmed",
  "email.doi_page_confirmed_body": "Thank you! From now on you will get a short weekly recap of your adventures and new ideas by email. You can stop this at any time with the unsubscribe link in every email or in the app under Settings, Notifications.",
  "email.doi_page_already_title": "Already confirmed",
  "email.doi_page_already_body": "Your confirmation is already on file. There is nothing more to do.",
  "email.doi_page_expired_title": "Link expired",
  "email.doi_page_expired_body": "This confirmation link is no longer valid. Turn the emails on again in the app under Settings, Notifications, and we will send you a new one.",
  "email.doi_page_invalid_title": "Link invalid",
  "email.doi_page_invalid_body": "This confirmation link is invalid or has been replaced by a newer one. Turn the emails on again in the app under Settings, Notifications.",
  "email.doi_page_open_app": "Open Lorath",
  "email.doi_withdraw": "You can withdraw your consent at any time with effect for the future, using the unsubscribe link in every email or in the app under Settings, Notifications. How we process your data for this is described in our privacy policy (link below).",
  "email.doi_page_ready_title": "Confirm emails",
  "email.doi_page_ready_body": "Would you like a short weekly recap of your adventures and new ideas by email? One click on the button confirms it. You can withdraw your consent at any time.",
  "email.doi_page_privacy": "Privacy information",
  "settings.notifications.email_marketing.birthdate_missing": "Please add your date of birth to your profile first. We need it to make sure you may receive these emails (from the age of 16).",
  "settings.notifications.email_marketing.language_unsupported": "The weekly recap is not yet available in your language. As soon as the texts are translated, you can turn it on here.",
  "settings.notifications.email_marketing.privacy_link": "Privacy information",
  "auth.marketing_recap_checkbox": "Receive a weekly recap by email (confirmation by email required)",
  "tier.plus": "Plus", "tier.ultra": "Ultra", "tier.founders": "Founders",
  "tier.settings_title": "Reply quality and costs",
  "tier.blitz.label": "Lightning fast", "tier.blitz.description": "Responds especially quickly to keep the story moving.",
  "tier.creative.label": "Creative", "tier.creative.description": "Writes with more detail, atmosphere and original ideas.",
  "tier.price_line": "Adventure {adventure} coins · Chat {chat} coins",
  "tier.zdr.label": "Alternative model family", "tier.zdr.surcharge": "No surcharge for any account.", "tier.zdr.included": "No surcharge for any account.", "tier.zdr.audio_note": "Zero data retention (ZDR, providers do not store your content) applies to text requests and images regardless of this choice. Audio features and the 18+ area are excluded.",
  "lock.feature.tts": "Read aloud – from {tier}",
  "lock.feature.live": "Campfire – from {tier}",
  "lock.feature.background": "Chat background – from {tier}",
  "lock.feature.theme": "Theme – from {tier}",
  "lock.feature.icon": "App icon – from {tier}",
  "lock.feature.zdr": "Alternative model family at no surcharge – even without {tier}",
  "lock.feature.model": "AI model – from {tier}",
  "lock.feature.live_minutes": "Live minutes – from {tier}",
  "paywall.title": "Choose your membership",
  "paywall.subtitle": "More room for stories, with clear allowances and cancellation at any time.",
  "paywall.duration_label": "Choose duration",
  "paywall.duration.week": "Week", "paywall.duration.month": "Month", "paywall.duration.year": "Year", "paywall.duration.custom": "Custom",
  "paywall.year_saving": "2 months free",
  "paywall.discount_bestand25": "Your one-time 25% loyalty discount has been reserved.",
  "paywall.app_only": "Subscriptions are currently available through the Lorath app.",
  "paywall.error_unavailable": "Purchasing is currently unavailable. Please try again later.",
  "paywall.popular": "Most popular",
  "paywall.recommended": "Our recommendation",
  "paywall.week_note": "Weekly subscriptions do not include campfire minutes",
  "paywall.per.week": "per week", "paywall.per.month": "per month", "paywall.per.year": "per year",
  "paywall.cta.trial": "Start 7 days free", "paywall.cta.subscribe": "Subscribe now", "paywall.cta.support": "Support development",
  "paywall.plus.benefit1": "20 standard messages per day", "paywall.plus.benefit2": "40 coins per week (160 per month)", "paywall.plus.benefit2_week": "40 coins per week", "paywall.plus.benefit3": "Additional themes and app icons", "paywall.plus.benefit4": "Narrator voice unlocked", "paywall.plus.benefit5": "Campfire unlocked · 15 coins per minute", "paywall.plus.benefit6": "4 custom backgrounds per month",
  "paywall.legal_zdr": "Zero Data Retention applies to all text routes and to Standard and Premium images, except in the 18+ area (Privacy Policy § 6 h). Audio models (voice output, speech input, Campfire, calls) are excluded.",
  "paywall.ultra.benefit1": "60 standard messages per day", "paywall.ultra.benefit2": "125 coins per week (500 per month)", "paywall.ultra.benefit2_week": "125 coins per week", "paywall.ultra.benefit3": "Lightning-fast tier included", "paywall.ultra.benefit4": "15 campfire minutes per 4 weeks, then 12 coins per minute", "paywall.ultra.benefit5": "10 custom backgrounds per month", "paywall.ultra.benefit6": "All regular app icons",
  "paywall.founders.benefit1": "Everything in Ultra and 100 messages per day", "paywall.founders.benefit2": "250 coins per week (1,000 per month)", "paywall.founders.benefit2_week": "250 coins per week", "paywall.founders.benefit3": "30 minutes per 4 weeks, then 10 coins per minute", "paywall.founders.benefit4": "20 custom backgrounds per month", "paywall.founders.benefit5": "Founders seal and your name in the credits", "paywall.founders.benefit6": "Beta access and feature voting",
  "paywall.legal_price": "The displayed price applies to the selected term, including statutory VAT.",
  "paywall.legal_renewal": "The subscription renews automatically and can be cancelled at any time in the store settings.",
  "paywall.legal_trial": "The free week is available once per Apple or Google account; the paid subscription then renews automatically.",
  // P1 Promotion-Design (60_PROMOTION.md §5) — mirror of the German copy.
  "paywall.ribbon_trial": "7 days free",
  "paywall.current_plan": "Your plan",
  "paywall.cta.current": "Active",
  "paywall.cta.upgrade": "Switch to {tier}",
  "paywall.cta.downgrade": "Switch at end of term",
  "paywall.cta.upgrade.success": "Upgrade active: Lorath {tier}",
  "paywall.cta.downgrade.success": "Switch scheduled from {date}",
  "paywall.cta.none.success": "Welcome to Lorath {tier}",
  "paywall.error_replace_token": "Please run “Restore purchases” in the settings first, then start the switch again.",
  "paywall.note.upgrade": "The store will show you how any remaining term is credited before you confirm.",
  "paywall.note.downgrade": "The switch takes effect at the end of your current term on {date}. All benefits stay active until then.",
  "paywall.summary.trial": "Due today: {today} · First charge on {date}: {price}",
  "paywall.summary.trial_renewal": "Renews automatically, cancel anytime in your store settings.",
  "paywall.summary.paid": "Due today: {today} · Then {price} {duration}",
  "paywall.summary.renewal": "Renews automatically, cancel anytime in your store settings.",
  "paywall.summary.includes": "Included: {value}",
  "paywall.summary.unlocks": "Unlocked with coins: {value}",
  "paywall.summary.after": "Afterwards: {value}",
  "paywall.summary.upgrade": "Your store shows how the remaining term is credited before purchase.",
  "paywall.summary.downgrade": "Switch at the end of the current term on {date}",
  "paywall.summary.trial_pending": "Verifying purchase …",
  "paywall.matrix.toggle": "Compare all benefits",
  "paywall.matrix.row.messages": "Messages per day",
  "paywall.matrix.row.coins": "Coins per week",
  "paywall.matrix.row.live": "Campfire per 4 weeks",
  "paywall.matrix.row.live_after": "then per minute",
  "paywall.matrix.row.tts": "Read aloud",
  "paywall.matrix.row.backgrounds": "Backgrounds per 4 weeks",
  "paywall.matrix.row.status": "Daily character status",
  "paywall.matrix.row.themes_icons": "Themes and app icons",
  "paywall.matrix.row.zdr": "Alternative model family (no surcharge for anyone)",
  "paywall.matrix.row.trial": "Free trial",
  "paywall.matrix.cell.included": "included",
  "paywall.matrix.cell.coins": "with coins",
  "paywall.matrix.cell.yes": "yes",
  "paywall.matrix.cell.no": "no",
  "paywall.matrix.cell.premium": "Premium voice",
  "paywall.matrix.cell.beta": "1 character",
  "paywall.matrix.cell.founders_status": "2 characters",
  "paywall.matrix.cell.standard": "Standard",
  "paywall.matrix.cell.trial_only": "new customers only",
  "paywall.matrix.cell.unlock": "unlocked",
  "paywall.founders_title": "Support Lorath",
  "paywall.founders_body": "Founders is its own tier: you carry Lorath, get an exclusive icon and theme, and enjoy 100 messages per day, 250 coins per week, and 30 campfire minutes per 4 weeks.",
  "paywall.legal_coins": "Coins are granted weekly and expire 21 days after the grant. A monthly subscription includes 4 weekly grants, an annual subscription 52 – regardless of the length of the store billing month.",
  "paywall.legal_minutes": "Campfire minutes apply per 28 days from the start of the subscription and only to monthly and annual Ultra and Founders subscriptions, including a free trial week for those terms. Weekly subscriptions include no minutes.",
  "paywall.web_continue": "Continue in the app",
  "paywall.error_verifying": "Verifying purchase …",
  "paywall.per_month": "equivalent to {amount} per month",
  "paywall.recommendation.based_on": "Based on your use over the last 28 days, {tier} is a good fit",
  "paywall.recommendation.avg_messages": "an average of {value} messages per day",
  "paywall.recommendation.campfire_minutes": "{value} campfire minutes",
  "paywall.recommendation.backgrounds": "{value} backgrounds",
  "paywall.recommendation.tts": "{value} read-aloud sessions",
  "paywall.recommendation.downgrade_hint": "{tier} is enough for your use — you can switch at the end of your current term.",
  "paywall.preview.voice_title": "Listen",
  "paywall.preview.voice_plus": "Standard voice",
  "paywall.preview.voice_ultra": "Premium voice",
  "paywall.preview.themes_title": "Themes",
  "paywall.preview.icons_title": "App icons",
  "paywall.preview.tier_plus": "Plus",
  "paywall.preview.tier_ultra": "Ultra",
  "paywall.preview.tier_founders": "Founders",
  "paywall.preview.tier_locked": "from {tier}",
  "paywall.sticky_hint": "{tier} · {price} {per}",
  "promo.card.title": "More room for your stories",
  "promo.card.text": "Daily free messages, narrator voice, campfire talks and personal touches — with Lorath Plus, Ultra or Founders.",
  "promo.card.member_title": "Your membership",
  "promo.later": "Later",
  "promo.dismiss": "Hide",
  "membership.quota_title": "Your allowances",
  "upsell.coins_empty": "View membership", "upsell.view_membership": "View membership",
  "upsell.creative_scene": "This scene in Creative, {coins} coins",
  "upsell.free_messages_empty": "More free messages with Ultra", "upsell.live_minutes_empty": "More live minutes with Ultra",
  "typing.writing": "The narrator is writing …", "typing.writing_named": "{name} is writing …",
  "promo.intro.free.title": "New: Lorath membership",
  "promo.intro.member.title": "Thank you for your membership",
  "promo.start.free.title": "More room for your stories",
  "promo.start.lapsed.title": "Welcome back",
  "promo.start.plus.title": "More room with Ultra",
  "promo.start.ultra.title": "Carry the torch further",
  "promo.messages.free.title": "You are right in the middle of it",
  "promo.context.adventure.free.title": "Want to hear the narrator?",
  "promo.context.character.free.title": "Want to talk to {name}?",
  "promo.context.group.free.title": "More rounds a day",
  "promo.context.adventure.plus.title": "Talk to the narrator?",
  "promo.context.character.plus.title": "Talk to {name} live?",
  "promo.quota.coins.free.title": "Your coins are used up",
  "promo.quota.messages.plus.title": "20 of 20 today",
  "promo.quota.live.ultra.title": "Live minutes used up",
  "promo.intro.free.text": "Plus, Ultra and Founders bring you daily free messages, narrator voice, campfire talks, backgrounds and your own look. Try 7 days for free, cancel anytime.",
  "promo.intro.member.text": "Your benefits are active. {hint}",
  "promo.start.free.text": "With Plus you get 20 free messages a day, 40 coins per week and the narrator voice. Ultra adds campfire conversations and 60 messages.",
  "promo.start.lapsed.text": "Your place by the fire is free: {tier} is waiting for you – with all the benefits you knew.",
  "promo.start.plus.text": "60 messages a day, 125 coins per week, 15 live minutes and all app icons. Your remaining term is credited.",
  "promo.start.ultra.text": "Founders: 100 messages a day, 30 live minutes, 20 backgrounds, the Founders seal and your name in the credits.",
  "promo.messages.free.text": "With Plus you write 20 messages a day without coins and get 40 coins per week on top.",
  "promo.context.adventure.free.text": "With Plus the narrator reads every scene aloud. With Ultra you talk to him live – 15 minutes a month included.",
  "promo.context.character.free.text": "With Ultra you call {name} and talk live – 15 minutes a month included, plus 60 messages a day.",
  "promo.context.group.free.text": "With Plus you write 20 messages per day, spread across all conversations.",
  "promo.context.adventure.plus.text": "Ultra brings 15 live minutes a month and 60 messages a day.",
  "promo.context.character.plus.text": "Ultra brings 15 live minutes a month and the best voice. Your remaining term is credited.",
  "promo.quota.coins.free.text": "With Plus you continue every day with 20 free messages – and 40 coins per week.",
  "promo.quota.messages.plus.text": "With Ultra it would be 60 messages a day – and 125 coins per week.",
  "promo.quota.live.ultra.text": "Founders brings 30 minutes a month and 20 backgrounds.",
  "promo.intro.free.cta": "Try 7 days for free",
  "promo.intro.member.cta": "View benefits",
  "promo.start.free.cta": "View memberships",
  "promo.start.lapsed.cta": "Rejoin",
  "promo.start.plus.cta": "View upgrade",
  "promo.start.ultra.cta": "View Founders",
  "promo.messages.free.cta": "Try 7 days for free",
  "promo.context.adventure.free.cta": "Unlock voices",
  "promo.context.character.free.cta": "Unlock calls",
  "promo.context.group.free.cta": "View memberships",
  "promo.context.adventure.plus.cta": "View upgrade",
  "promo.context.character.plus.cta": "View upgrade",
  "promo.quota.coins.free.cta": "Try 7 days for free",
  "promo.quota.messages.plus.cta": "View upgrade",
  "promo.quota.live.ultra.cta": "View Founders",
  "promo.intro.free.benefit1": "20 to 100 standard messages per day without coins",
  "promo.intro.free.benefit2": "Narrator voice and campfire talks",
  "promo.intro.free.benefit3": "Coins, backgrounds, themes and app icons included",
  "promo.intro.member.benefit1": "Daily free messages and monthly coins are running",
  "promo.intro.member.benefit2": "Voices, backgrounds and styling are unlocked",
  "promo.intro.member.benefit3": "Manage anytime in the settings",
  "promo.start.free.benefit1": "20 standard messages per day without coins",
  "promo.start.free.benefit2": "40 coins per week included",
  "promo.start.free.benefit3": "Additional themes and app icons",
  "promo.start.lapsed.benefit1": "Daily free messages without coins",
  "promo.start.lapsed.benefit2": "Monthly coins included",
  "promo.start.lapsed.benefit3": "Voices, backgrounds and styling",
  "promo.start.plus.benefit1": "60 standard messages per day",
  "promo.start.plus.benefit2": "125 coins per week",
  "promo.start.plus.benefit3": "15 live minutes per month included",
  "promo.start.ultra.benefit1": "100 standard messages per day",
  "promo.start.ultra.benefit2": "30 live minutes per month included",
  "promo.start.ultra.benefit3": "Founders seal and your name in the credits",
  "promo.messages.free.benefit1": "20 standard messages per day without coins",
  "promo.messages.free.benefit2": "40 coins per week included",
  "promo.messages.free.benefit3": "4 custom backgrounds per month",
  "promo.context.adventure.free.benefit1": "Narrator voice unlocked",
  "promo.context.adventure.free.benefit2": "Campfire talks unlocked",
  "promo.context.adventure.free.benefit3": "20 standard messages per day without coins",
  "promo.context.character.free.benefit1": "15 live minutes per month included",
  "promo.context.character.free.benefit2": "60 standard messages per day",
  "promo.context.character.free.benefit3": "125 coins per week",
  "promo.context.group.free.benefit1": "20 messages per day, spread across all conversations",
  "promo.context.group.free.benefit2": "40 coins per week included",
  "promo.context.group.free.benefit3": "Additional themes and app icons",
  "promo.context.adventure.plus.benefit1": "60 standard messages per day",
  "promo.context.adventure.plus.benefit2": "125 coins per week",
  "promo.context.adventure.plus.benefit3": "15 live minutes per month included",
  "promo.context.character.plus.benefit1": "60 standard messages per day",
  "promo.context.character.plus.benefit2": "125 coins per week",
  "promo.context.character.plus.benefit3": "15 live minutes per month included",
  "promo.quota.coins.free.benefit1": "20 standard messages per day without coins",
  "promo.quota.coins.free.benefit2": "40 coins per week included",
  "promo.quota.coins.free.benefit3": "Cancel anytime",
  "promo.quota.messages.plus.benefit1": "60 standard messages per day",
  "promo.quota.messages.plus.benefit2": "125 coins per week",
  "promo.quota.messages.plus.benefit3": "15 live minutes per month included",
  "promo.quota.live.ultra.benefit1": "100 standard messages per day",
  "promo.quota.live.ultra.benefit2": "30 live minutes per month included",
  "promo.quota.live.ultra.benefit3": "Founders seal and your name in the credits",
  "promo.intro.member.upgrade_hint.plus": "Ultra brings 60 messages a day and campfire talks.",
  "promo.intro.member.upgrade_hint.ultra": "Founders brings 30 live minutes, the Founders seal and your name in the credits.",
  "promo.intro.member.upgrade_hint.none": "Thank you for carrying Lorath.",
  "promo.preview.label": "Promo preview (admin)",
  "promo.preview.off": "Off",
  "promo.preview.show_intro": "Show intro dialog",
  "promo.preview.show_bestandsschutz_end": "Show early-supporter notice (18+)",
  "promo.preview.show_bestandsschutz_end_minor": "Show early-supporter notice (under 18)",
  // P3 §9 — EN mirror of the DE settings CTAs
  "membership.settings.upgrade": "Change plan",
  "membership.settings.restore": "Restore purchases",
  "membership.settings.restore_success": "Purchases restored",
  "membership.settings.restore_error": "Restore failed ({code})",
  "membership.next_coins": "Next {coins} coins on {date}",
  "membership.coins_weekly": "{coins} coins per week",

  "week.title": "Your week",
  "week.subtitle": "{start} – {end}",
  "week.empty.title": "This week is still empty.",
  "week.empty.body": "Once you write with an adventure or a character, your review fills up on its own.",
  "week.nav.prev": "Previous week",
  "week.nav.next": "Next week",
  "week.nav.today": "Today",
  "week.counts.title": "Counts",
  "week.counts.messages": "Messages",
  "week.counts.adventures_active": "Active adventures",
  "week.counts.character_chats_active": "Active companions",
  "week.counts.images": "Images",
  "week.counts.audiobook_minutes": "Audiobook minutes",
  "week.counts.campfire_sessions": "Campfire sessions",
  "week.moments.title": "Moments",
  "week.moments.empty": "You haven't left any moment yet this week.",
  "week.moments.kind.adventure": "Adventure",
  "week.moments.kind.character": "Companion",
  "week.images.title": "Images of the week",
  "week.images.empty": "No saved images.",
  "week.continue.button": "Continue here",
  "week.continue.last_active": "Last active {when}",
  "week.locked.title": "More in your weekly review",
  "week.locked.body": "You see a preview here. With Plus, you get all moments and images of the week.",
  "week.error.too_far_back": "You can only look back eight weeks.",
  "week.error.future_week": "This week is in the future.",
  "week.error.invalid_week": "Invalid week format. Expected YYYY-Www.",
  "memories_book.title": "Memory book",
  "memories_book.search_placeholder": "Search a memory",
  "memories_book.empty": "No memories saved yet.",
  "memories_book.empty_hint": "Write down your first thoughts — what should your companion or your adventure know about you?",
  "memories_book.add_button": "New memory",
  "memories_book.add_placeholder": "What would you like to remember?",
  "memories_book.add_confirm": "Save",
  "memories_book.edit_button": "Edit",
  "memories_book.edit_confirm": "Save changes",
  "memories_book.delete_title": "Delete this memory?",
  "memories_book.delete_body": "This entry will be removed permanently.",
  "memories_book.delete_confirm": "Delete",
  "memories_book.cancel": "Cancel",
  "memories_book.saved": "Saved.",
  "memories_book.deleted": "Deleted.",
  "memories_book.error_too_long": "Please keep the entry under 500 characters.",
  "memories_book.pin_toggle": "Pin",
  "memories_book.unpin_toggle": "Unpin",
  "memories_book.pinned_label": "Pinned",
  "memories_book.error_generic": "Something went wrong. Try again.",
  "week.nav.card_label": "Weekly review",
  "week.nav.card_desc": "Counts, moments and images of your week",
  "memories_book.nav_label": "Memory book",
  "lock.feature.live_call": "Call – from {tier}",
  "admin.funnel.title": "Conversion funnel (membership)",
  "admin.funnel.window_label": "Time window",
  "admin.funnel.window_days": "{days} days",
  "admin.funnel.total_promo_view": "Viewed",
  "admin.funnel.total_promo_click": "Clicked",
  "admin.funnel.total_paywall_view": "Paywall visited",
  "admin.funnel.total_checkout_started": "Checkouts started",
  "admin.funnel.total_purchase_verified": "Purchases verified",
  "admin.funnel.total_trial_started": "Free trials started",
  "admin.funnel.rate_promo": "View → click",
  "admin.funnel.rate_paywall": "Paywall → checkout",
  "admin.funnel.rate_checkout": "Checkout → verified",
  "admin.funnel.rate_trial": "Free trial → verified",
  "admin.funnel.note": "Data is used to tune promo and paywall copy. No personal content is stored.",
  // S11 Founders-Bereich: EN spiegelt die DE-Quellen 1:1 (siehe Manifest).
  "founders.page_title": "Founders area",
  "founders.intro_thanks": "Thank you for carrying Lorath from the very start. Your voice truly counts here.",
  "founders.intro_preview": "Vote, send us feedback, and appear in the credits – if you want.",
  "founders.section_vote": "Vote",
  "founders.vote_intro": "One open poll. You can change your vote at any time.",
  "founders.vote_voted": "You voted for „{option}“. Thank you!",
  "founders.vote_change": "Change vote",
  "founders.vote_results_count": "{count} votes",
  "founders.vote_results_percent": "{percent} %",
  "founders.vote_closed": "This poll is closed.",
  "founders.vote_closed_at": "Closed on {date}.",
  "founders.vote_none_open": "No poll is open right now. Check back soon.",
  "founders.section_feedback": "Your feedback",
  "founders.feedback_intro": "What works well, what annoys you? You can send up to five entries per day.",
  "founders.feedback_label": "Your message to us",
  "founders.feedback_placeholder": "Tell us what's on your mind …",
  "founders.feedback_max": "Up to 1000 characters.",
  "founders.feedback_send": "Send",
  "founders.feedback_empty": "You haven't written to us yet.",
  "founders.feedback_status_new": "New",
  "founders.feedback_status_seen": "Read",
  "founders.feedback_status_answered": "Answered",
  "founders.feedback_reply_label": "Our reply",
  "founders.feedback_error_required": "Please write us a short message.",
  "founders.feedback_error_too_long": "Your message is too long (1000 characters max).",
  "founders.feedback_error_daily_limit": "You've reached your daily limit of five feedback messages.",
  "founders.feedback_success": "Thank you! We've received your feedback.",
  "founders.section_credits": "Credits",
  "founders.credits_intro": "Should we show your name in the Founders credits? You can change this any time or leave it blank.",
  "founders.credits_opt_in": "Include my name in the credits",
  "founders.credits_label": "Display name",
  "founders.credits_placeholder": "e.g. Anna or Anna Z.",
  "founders.credits_save": "Save",
  "founders.credits_saved": "Saved.",
  "founders.credits_error_invalid_name": "Please use only letters, numbers, spaces, dash, dot and apostrophe.",
  "founders.credits_error_too_long": "The display name must be at most 40 characters long.",
  "founders.credits_list_title": "Our founders",
  "founders.credits_list_empty": "As soon as the first founders opt in, they'll appear here.",
  "founders.credits_list_intro": "These people support Lorath from the very start.",
  "founders.section_roadmap": "Roadmap",
  "founders.roadmap_column_planned": "Planned",
  "founders.roadmap_column_in_progress": "In progress",
  "founders.roadmap_column_done": "Done",
  "founders.preview_locked": "The Founders area is only visible to Founders and Torchbearers.",
  "founders.preview_cta": "Unlock the Founders area",
  "founders.entry_link_paywall": "View Founders area",
  "founders.entry_link_paywall_locked": "Visible after sign in",
  "founders.entry_link_settings": "Founders area",
  // S8 Onboarding: English mirrors the DE source keys above.
  "onboarding.choice.title": "Where would you like to start?",
  "onboarding.choice.intro": "You just activated Plus. Pick one benefit to start with right away — you can find the others in settings any time.",
  "onboarding.choice.writing_title": "Keep writing",
  "onboarding.choice.writing_body": "Jump back into your last adventure or character chat where you left off.",
  "onboarding.choice.listening_title": "Listen to stories",
  "onboarding.choice.listening_body": "The narrator voice for your last adventure, or Campfire on Ultra.",
  "onboarding.choice.design_title": "Personalise",
  "onboarding.choice.design_body": "Themes, app icon and backgrounds in the appearance settings.",
  "onboarding.choice.opt_in": "Remind me two days before the first charge",
  "onboarding.choice.skip": "Later",
  "onboarding.banner.title": "Continue with {benefit}",
  "onboarding.banner.text": "You have been on Lorath Plus for a few days. Next up: {benefit}. You can dismiss this any time.",
  "onboarding.banner.cta": "Try it",
  "onboarding.loading": "Preparing your benefits …",
  "onboarding.trial_reminder.title": "Your free week is ending soon",
  "onboarding.trial_reminder.body": "Your free week ends on {date}. After that the price renews automatically. You can cancel any time in the store settings.",
  "onboarding.trial_reminder.ok": "Got it",
  "onboarding.trial_reminder.manage": "Manage subscription",
  "paywall.trial_unverified": "Free week if your store account is eligible",
  "paywall.summary.offer_pending": "Checking the available offer in the store.",
  "paywall.summary.downgrade_unknown": "Switch at the end of the current term. Your store will show the date.",
};

const LOCAL_I18N_OVERRIDES: Partial<Record<SupportedLanguage, TranslationMap>> = {
  de: {
    ...M5_DE_OVERRIDES,
    // Offline-Fallback für den Transparenzdialog; Quellen sind bereits übersetzt.
    "ai_transparency.moderation_deep_external": "Die gründliche Prüfung läuft bei {operator}.",
    // S-30 (Fix 7.3.3.2): Hinweis der Tindra-Nachpruefung; steht im Manifest
    // scripts/i18n-pending-sources.json, daher wortgleich mit server/i18n/ui/de.json.
    "helpbot.action_unverified": "Hinweis: Tindra konnte nicht bestätigen, dass diese Änderung wirklich ausgeführt wurde. Bitte prüfe das Ergebnis im Editor.",
    // FIX2-C/D-11: Intim-Video-Galerie, Zustaende pending/rendering/failed.
    // Steht im Manifest scripts/i18n-pending-sources.json, daher wortgleich
    // mit server/i18n/ui/de.json.
    "intimate_videos.status_processing": "Dein Video entsteht gerade. Das kann ein paar Minuten dauern.",
    "intimate_videos.status_failed": "Video-Erstellung fehlgeschlagen. Die Coins wurden erstattet.",
    // FIX2-C/N-17: dauerhafter Sync-Fehler (SyncErrorBanner). Steht im
    // Manifest scripts/i18n-pending-sources.json, daher wortgleich mit
    // server/i18n/ui/de.json.
    "sync.error_persistent": "Der Hintergrund-Abgleich hängt seit einer Weile. Deine Daten können veraltet sein.",
    // FIX2-C/N-19: Tindra-Verlauf-Sheet (Umbenennung + Archivieren-Aktion).
    // Steht im Manifest scripts/i18n-pending-sources.json, daher wortgleich
    // mit server/i18n/ui/de.json.
    "helpbot.history": "Verlauf",
    "helpbot.archive_action": "Archivieren",
    // W2-B (Erstkontakt, 7.4): neue und geaenderte Quelltexte fuer Sofortstart,
    // Leiste, Tour und Glossar. Stehen im Manifest scripts/i18n-pending-sources.json
    // und muessen wortgleich mit server/i18n/ui/<lang>.json sein (localOverrides.test.ts).
    "nav.more": "Mehr",
    "more.intro": "Alle Bereiche von Lorath auf einen Blick.",
    "more.unlock_hint": "Welt und Tafelrunde kommen in die Leiste, sobald du {count} eigene Nachrichten geschrieben hast — oder sofort mit „Ich leite eine Spielrunde“ in den Einstellungen.",
    "more.desc.world": "Dein Weltenbau: Orte, Völker und Figuren, auf die Abenteuer und Begleiter zurückgreifen.",
    "more.desc.table_rounds": "Für echte Spielrunden am Tisch: Lorath führt Protokoll, erinnert sich und spielt die NPCs.",
    "more.desc.tindra": "Tindra beantwortet deine Fragen rund um Lorath.",
    "more.desc.soundboard": "Klänge und Musik für deine Spielrunde.",
    "more.desc.milestones": "Deine Erfolge und Abzeichen.",
    "more.desc.memory_book": "Lies und verwalte die Erinnerungen, die Lorath für dich gespeichert hat.",
    "more.desc.spielbau": "Lege Ton, Setting und Regeln für deine Geschichten und Spielrunden fest.",
    "more.desc.coins": "Coins, Pakete und deine Mitgliedschaft.",
    "more.desc.settings": "Konto, Aussehen, Sprache und Hilfe.",
    "first_scene.adventure.title": "Wähle deine erste Geschichte",
    "first_scene.adventure.intro": "Tippe auf eine Geschichte — sie beginnt sofort und kostet nichts.",
    "first_scene.adventure.own": "Eigene Geschichte bauen",
    "first_scene.companion.title": "Wähle deinen ersten Begleiter",
    "first_scene.companion.intro": "Tippe auf eine Figur und schreib gleich los — kostenlos.",
    "first_scene.companion.own": "Eigenen Begleiter bauen",
    "first_scene.companion.cta": "Losschreiben",
    "first_scene.unavailable": "Gerade lassen sich keine Vorschläge laden. Du kannst trotzdem sofort loslegen:",
    "first_scene.empty": "Hier gibt es gerade keine Vorschläge für dich. Bau dir einfach selbst etwas:",
    "first_scene.retry": "Erneut versuchen",
    "dashboard.continue.starter_body": "Such dir eine Geschichte aus — ein Tipp, und du bist mittendrin.",
    "chats.starter_body": "Wähle einen Begleiter und schreib gleich los — euer Chat erscheint dann hier.",
    "settings.leads_round.title": "Spielrunde",
    "settings.leads_round.label": "Ich leite eine Spielrunde",
    "settings.leads_round.desc": "Holt Welt und Tafelrunde dauerhaft in die untere Leiste — für alle, die am Tisch eine Runde leiten.",
    "push_priming.reason.adventure_planning": "Dein Abenteuer wird gerade vorbereitet, das kann ein paar Minuten dauern. Sollen wir dir Bescheid geben, sobald es bereit ist? Als Nächstes fragt dein Gerät nach der Erlaubnis.",
    "world.overview_title": "Deine Welt",
    "world.area_places_time": "Orte & Zeiten",
    "world.area_beings_culture": "Figuren, Wesen & Kulturen",
    "world.area_custom": "Eigene Bereiche",
    "world.areas_back": "Alle Bereiche",
    "world.area_things_quests": "Dinge & Aufträge",
    "world.area_card_empty": "Noch nichts angelegt",
    "world.area_empty": "In diesem Bereich ist noch nichts angelegt. Wähle eine Kategorie und lege dein erstes Element an.",
    "world.cosmos_empty": "Dein Kosmos ist noch leer. Öffne einen Bereich und lege dein erstes Element an.",
    "world.areas_all_hidden": "Alle Kategorien sind ausgeblendet",
    "world.areas_all_hidden_body": "In diesem Kosmos ist gerade nichts zu sehen, weil alle Kategorien ausgeblendet sind.",
    "world.kosmos_create_hint": "Ein neuer Kosmos bringt die Systemvorlagen mit: Orte, Völker, Wesen und mehr. Du kannst sie nutzen oder eigene Elemente anlegen.",
    "world.kosmos_intro": "Ein Kosmos bündelt die Bausteine deiner Welt. Die Systemvorlagen sind von Anfang an dabei, darum ist ein neuer Kosmos nie ganz leer.",
    "tree.empty_tree_hint": "Noch keine Elemente in diesem Weltenbaum.",
    "tree.add_element": "Element hinzufügen",
    "tree.no_matching_elements": "Keine passenden Elemente.",
    "tr.no_rounds_hint": "Du leitest eine echte Runde am Tisch? Lorath führt Protokoll, erinnert sich und spielt die NPCs.",
    // D1 (Waechter v2.1): DSE-Nachtrag zum Waechter. Diese Keys stehen im
    // Manifest scripts/i18n-pending-sources.json und muessen deshalb hier
    // wortgleich mit server/i18n/ui/<lang>.json stehen (localOverrides.test.ts).

    // Nachtrag Schritt 2.7: diese Hoerbuch-Fehlertexte stehen im Manifest
    // (scripts/i18n-pending-sources.json), fehlten hier aber — dadurch war die
    // generierte Keyliste nicht mit den lokalen Quelltexten deckungsgleich.
    "waechter.restored.title": "Nachricht freigegeben",
    "waechter.restored.body": "Die Nachricht wurde von unserem automatisierten System als problematisch eingestuft, aber ein menschlicher Prüfer kam zu dem Ergebnis, dass sie unbedenklich ist. Bitte entschuldige das.",
    "audiobook.error_asset_missing": "Die Audiodatei ist nicht mehr verfügbar.",
    "audiobook.error_campaign_unavailable": "Diese Kampagne kann nicht für ein Hörbuch verwendet werden.",
    "audiobook.error_generic": "Die Hörbuch-Anfrage konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
    "audiobook.error_insufficient_coins": "Für diesen Abschnitt reichen dein Prepaid-Guthaben und deine Coins nicht.",
    "audiobook.error_invalid_request": "Die Anfrage enthält ungültige oder fehlende Felder.",
    "audiobook.error_not_found": "Dieses Hörbuch oder dieser Abschnitt wurde nicht gefunden.",
    "audiobook.error_planning": "Der Hörbuch-Plan konnte nicht erzeugt werden. Bitte versuche es mit einer kürzeren Anfrage erneut.",
    "audiobook.error_provider": "Der Sprachanbieter ist gerade nicht verfügbar. Bitte versuche es in einem Moment erneut.",
    "audiobook.error_state_conflict": "Das Hörbuch befindet sich in einem Zustand, der diese Aktion nicht erlaubt.",

    // Waechter-Eingabesperre und Fuehrung zum Fork (Schritt 2.7).
    "waechter.lock.hint": "Eine Antwort in diesem Verlauf wurde von unserer Moderation entzogen — ab dieser Stelle geht es nicht weiter. Schreib deine letzte eigene Nachricht neu, dann läuft die Geschichte von dort aus weiter.",
    "waechter.lock.button": "Ab hier neu schreiben",
    "waechter.lock.edit_intro": "Deine Nachricht steht schon da. Ändere sie und schick sie ab — die Geschichte geht von hier aus neu weiter, der entzogene Teil fällt weg.",
    "waechter.lock.edit_active": "Schick oben deine bearbeitete Nachricht ab — hier unten geht es erst danach weiter.",
    "waechter.lock.no_anchor": "Hier gibt es keine eigene Nachricht, an der es weitergehen könnte. Beginne bitte ein neues Gespräch.",
    "waechter.lock.degraded": "Die Prüfung ist gerade nicht erreichbar. Warte einen Moment und versuch es dann noch einmal.",
    "waechter.lock.retry": "Erneut versuchen",
    "waechter.lock.stale": "Der Verlauf hat sich geändert — die Stelle zum Weiterschreiben ist nicht mehr da. Lade den Verlauf neu, dann siehst du, wie es weitergeht.",
    // L1 (Landscape-Split, 18.09.2026) — Bedienelemente des breiten Splits.
    "split.resize_handle": "Spaltenbreite ändern",
    "split.maximize": "Detail maximieren",
    "split.restore": "Liste wieder einblenden",
    "waechter.lock.reload": "Verlauf neu laden",
    "waechter.lock.dead_branch": "Dieser Weg enthält eine entzogene Antwort und lässt sich nicht mehr öffnen.",

    "waechter.card.title": "Antwort entzogen",
    "waechter.card.body": "Unsere Moderations-KI hat diese Antwort entzogen.",
    "waechter.card.reason_label": "Kurzbegründung:",
    "waechter.card.coins_kept": "Die Coins für diese Antwort bleiben abgezogen.",
    "waechter.card.appeal_hint": "Du kannst diese Entscheidung von einem Menschen prüfen lassen.",
    "waechter.card.appeal_button": "Von einem Menschen prüfen lassen",
    "waechter.card.objection_open": "Dein Widerspruch wird geprüft.",
    "waechter.card.objection_upheld": "Ein Mensch hat die Entscheidung bestätigt.",
    "waechter.card.appeal_error_duplicate": "Für diese Antwort liegt bereits ein Widerspruch vor.",
    "waechter.card.appeal_error_limit": "Du kannst höchstens fünf Widersprüche innerhalb von 24 Stunden einreichen.",
    "waechter.card.wartung_title": "Prüfung vorübergehend nicht möglich",
    "waechter.card.wartung": "Unsere Inhaltsprüfung ist gerade nicht erreichbar. Deshalb haben wir keine Antwort erzeugt und dir keine Coins abgezogen. Bitte versuche es in Kürze erneut.",
    "waechter.card.retry": "Erneut versuchen",
    "moderation.sor.appeal": "Wenn du das für einen Fehler hältst, kannst du die Entscheidung direkt an der betroffenen Antwort von einem Menschen prüfen lassen.",
    "waechter.category.csam": "Sexuelle Inhalte mit Kindern",
    "waechter.category.tsam": "Sexuelle Inhalte mit Jugendlichen",
    "waechter.category.rape": "Sexuelle Gewalt",
    "waechter.category.porn": "Pornografische Inhalte",
    "waechter.category.bestiality": "Sexuelle Handlungen mit Tieren",
    "waechter.category.illegal_instructions": "Anleitungen zu illegalen Handlungen",
    "waechter.category.drugs": "Drogen",
    "waechter.category.hate": "Hass",
    "waechter.category.other": "Inhaltsprüfung",
    "moddesk.title": "Moderationsdashboard",
    "moddesk.no_access": "Diese Seite ist für Moderatorinnen und Moderatoren.",
    "moddesk.confidentiality_title": "Vertraulichkeitszusage",
    "moddesk.error": "Die Moderationsanfrage konnte nicht abgeschlossen werden.",
    "moddesk.already_decided": "Dieser Fall wurde bereits entschieden.",
    "moddesk.confidentiality_body": "Du siehst ausschließlich KI-Antworten aus Gesprächen fremder Menschen — Nutzernachrichten bleiben unsichtbar und stehen nur als Platzhalter in der Reihenfolge. Namen, die in einer KI-Antwort vorkommen, bleiben sichtbar; behandle sie vertraulich. Du entscheidest nur, ob der Wächter richtig lag. Nichts davon darf Lorath verlassen. Jeder Aufruf eines Wortlauts wird protokolliert.",
    "moddesk.confidentiality_accept": "Verstanden",
    "moddesk.list_empty": "Keine Fälle in dieser Auswahl.",
    "moddesk.auto_badge": "Automatischer Fall — ein Mensch muss entscheiden",
    "moddesk.source_objection": "Widerspruch",
    "moddesk.case_context": "Kontext vor der Nachricht",
    "moddesk.case_reason": "KI-Begründung",
    "moddesk.show_text": "Wortlaut anzeigen",
    "moddesk.show_text_logged": "Der Aufruf wird protokolliert.",
    "moddesk.text_unavailable": "Wortlaut nicht mehr verfügbar",
    "moddesk.text_expires_in": "Wortlaut noch {count} Tage verfügbar",
    "moddesk.text_expired_ab": "Nach Ablauf existiert gegebenenfalls nur noch der verschlüsselte Beweisspeicher. Das System kann ihn nicht lesen.",
    "moddesk.ab_retry_warning": "{count} a/b-Wiedervorlagen ohne gesicherten Dashboard-Fall. Nachlauf prüfen.",
    "moddesk.decision_reason": "Begründung",
    "moddesk.decision_reason_hint": "Bitte begründe die Entscheidung mit 10 bis 1000 Zeichen.",
    "moddesk.decide_overturn": "Freigeben",
    "moddesk.decide_uphold_keep": "Bestätigen (Beweis behalten)",
    "moddesk.decide_uphold_delete": "Bestätigen (Beweis löschen)",
    "moddesk.police_toggle": "Polizeimeldung",
    "moddesk.police_reference": "Aktenzeichen",
    "moddesk.decided": "Entschieden",
    "moddesk.settings_card_title": "Moderationsdashboard",
    "moddesk.settings_card_open": "Moderationsdashboard öffnen",
    "moddesk.back_settings": "Zu den Einstellungen",
    "moddesk.back_list": "Zur Fallliste",
    "moddesk.loading": "Wird geladen …",
    "moddesk.refresh": "Aktualisieren",
    "moddesk.filter_status": "Status",
    "moddesk.filter_category": "Kategorie",
    "moddesk.filter_source": "Quelle",
    "moddesk.status_open": "Offen",
    "moddesk.all": "Alle",
    "moddesk.previous": "Vorherige Seite",
    "moddesk.next": "Nächste Seite",
    "moddesk.open_case": "Fall {id} öffnen",
    "moddesk.role_assistant": "KI",
    "moddesk.evidence_warning": "Beweisschlüssel nicht verfügbar: Es werden keine Beweise gesichert. „Beweis behalten“ bestätigt nicht, dass eine Kopie vorhanden ist.",
    "moddesk.health": "Nicht auflösbare Prüfungen (24 h): {runs} · Offene Tier-A-Eskalationen: {tier}",
    "moddesk.evidence_status": "Beweis-Aktion",
    "moddesk.followup_status": "Nachlieferung und Entschädigung",
    "moddesk.history": "Audit-Verlauf (letzte 100 Ereignisse)",
    "moddesk.not_allowed": "Für diesen Fall nicht erlaubt.",
    "moddesk.police_reference_without_report": "Aktenzeichen erfordert eine Polizeimeldung.",
    "moddesk.invalid_police": "Bitte prüfe die Polizeifelder.",
    "moddesk.case_not_found": "Fall nicht gefunden.",
    "moddesk.category.csam": "Sexualisierung von Kindern",
    "moddesk.category.tsam": "Sexualisierung von Jugendlichen",
    "moddesk.category.rape": "Sexuelle Gewalt",
    "moddesk.category.porn": "Pornografie",
    "moddesk.category.bestiality": "Sexualisierung von Tieren",
    "moddesk.category.illegal_instructions": "Anleitungen zu Straftaten",
    "moddesk.category.drugs": "Drogen",
    "moddesk.category.hate": "Hass",
    "moddesk.category.unknown": "Andere Kategorie",
    "moddesk.surface.character_chat": "Figurenchat",
    "moddesk.surface.table_round": "Tafelrunde",
    "moddesk.surface.group_chat": "Gruppenchat",
    "moddesk.surface.tindra": "Tindra",
    "moddesk.surface.demo": "Probeszene",
    "moddesk.surface.campaign_planning": "Abenteuerplanung",
    "moddesk.evidence.unknown": "Keine Aktion vermerkt; Bestand unbestätigt",
    "moddesk.evidence.kept": "Behalten vermerkt; Bestand unbestätigt",
    "moddesk.evidence.deleted": "Gelöscht",
    "moddesk.evidence.delete_pending": "Löschung ausstehend",
    "moddesk.evidence.delete_failed": "Löschung fehlgeschlagen",
    "moddesk.followup.pending": "Ausstehend",
    "moddesk.followup.done": "Erledigt",
    "moddesk.followup.failed": "Fehlgeschlagen",
    "moddesk.event.moderation.case_text_viewed": "Wortlaut angefordert",
    "moddesk.event.moderation.case_decided": "Fall entschieden",
    "moddesk.event.moderation.evidence_deleted": "Beweis gelöscht",
    "moddesk.event.moderation.evidence_delete_failed": "Beweislöschung nicht abgeschlossen",
    "moddesk.category.real_person_sexual": "Sexualisierung einer realen Person",
    "moddesk.category.violence_glorification": "Gewaltverherrlichung",
    "moddesk.category.sexual_violence_glorification": "Verherrlichung sexueller Gewalt",
    "moddesk.category.dangerous_practice": "Gefährliche Anleitung",
    "moddesk.category.usk_violation": "Altersfreigabe verletzt",
    "moddesk.category.hate_speech": "Hass und Hetze",
    "moddesk.category.self_harm": "Selbstgefährdung",
    "moddesk.category.other_concern": "Sonstige Beanstandung",
    "moddesk.category.csam_review": "Missbrauchsdarstellung — Prüfung",
    "moddesk.category.real_person_defamation": "Verleumdung einer realen Person",
    "moddesk.category.real_world_violence": "Gefahr für reale Personen",
    "moddesk.category.user_distress": "Notlage der nutzenden Person",
    "moddesk.surface.campaign": "Abenteuer",
    "moddesk.context_user_hidden": "[Nutzerzug — nicht einsehbar]",
    "moddesk.evidence.not_found": "Keine Beweiszeile gefunden",
    "moddesk.invalid_decision": "Unbekannte Entscheidung.",
    "moddesk.event.moderation.case_decision_completed": "Nachlauf abgeschlossen",
    "moddesk.abandoned_warning": "{count} Wiedervorlage(n) in a/b konnten nicht aufgelöst werden und wurden aufgegeben. Die Nachrichten bleiben entzogen, es gibt aber keinen Dashboard-Fall dazu.",
    "moddesk.followup_warning": "{count} entschiedene(r) Fall/Fälle warten noch auf Beweislöschung oder Entschädigung. Die Wiederaufnahme läuft alle 15 Minuten.",
    "live_talk.settings.title": "Audio-Einstellungen",
    "live_talk.settings.music_label": "Musik",
    "live_talk.settings.music_hint": "KI-generiert und kostenlos nutzbar.",
    "live_talk.settings.music_volume": "Musiklautstärke",
    "live_talk.settings.speaker_volume": "Sprecherlautstärke",
    "live_talk.settings.show_costs": "Gesamtpreis anzeigen",
    "live_talk.settings.show_balance": "Restcoins anzeigen",
    "live_talk.settings.total_coins": "Bisherige Coins",
    "live_talk.settings.remaining_coins": "Restcoins",
    "live_talk.endless": "Endlos weitererzählen",
    "live_talk.endless_hint": "Erzählt und entscheidet automatisch weiter, bis du stoppst oder dein Guthaben aufgebraucht ist. Die üblichen Coins pro Minute fallen weiter an.",

    // Hörbuch im Frontend (Paket P4): Startdialog, Player, Sperrbildschirm.
    "audiobook.menu_label": "Hörbuch",
    "audiobook.menu_hint": "Hör dein Abenteuer als fortlaufende Erzählung.",
    "audiobook.dialog_title": "Hörbuch starten",
    "audiobook.start_title": "Hörbuch",
    "audiobook.start_price": "{startCoins} Coins starten dein Hörbuch, inklusive {includedCoins} Coins Audioguthaben.",
    "audiobook.start_price_hint": "Neue Abschnitte: {coinsPerThousand} Coins je 1.000 Zeichen, ungefähr eine Hörminute. Bezahlte Abschnitte kannst du kostenlos weiterhören.",
    "audiobook.start_balance": "Aktuelles Guthaben: {balance} Coins.",
    "audiobook.start_price_loading": "Preis wird geladen …",
    "audiobook.start_voice_show": "Sprecherstimme wählen",
    "audiobook.start_voice_hide": "Sprecherstimme ausblenden",
    "audiobook.start_voice_label": "Sprecherstimme",
    "audiobook.start_voice_auto": "Automatisch",
    "audiobook.start_begin": "Hörbuch starten",
    "audiobook.start_continue": "Hörbuch fortsetzen",
    "audiobook.player_title": "Hörbuch",
    "audiobook.player_playing": "Es wird erzählt",
    "audiobook.player_muted": "Mikro stumm",
    "audiobook.player_voice_summary": "Sprecher und Erzählung folgen dem Hörbuch-Plan.",
    "audiobook.planning": "Erzählung wird vorbereitet …",
    "audiobook.preparing_next": "Nächster Abschnitt wird vorbereitet …",
    "audiobook.interrupt_planning": "Dein Wunsch wird umgesetzt …",
    "audiobook.mute": "Mikro stummschalten",
    "audiobook.unmute": "Mikro einschalten",
    "audiobook.pause": "Pause",
    "audiobook.end": "Beenden",
    "audiobook.paused_title": "Pausiert",
    "audiobook.paused_hint": "Du kannst jederzeit weiterhören.",
    "audiobook.resume": "Weiterhören",
    "audiobook.ended_title": "Buch beendet",
    "audiobook.ended_summary": "Du hast dieses Hörbuch zu Ende gehört.",
    "audiobook.close": "Schließen",
    "audiobook.notification_title": "Hörbuch",
    "audiobook.notification_artist": "Lorath",
    // P6: Kapitelliste im Player, Diktat-Mikrofon und gespeicherte Sprecherstimme.
    "audiobook.chapters_title": "Kapitel",
    "audiobook.chapter_state_heard": "Schon gehört",
    "audiobook.chapter_state_available": "Verfügbar",
    "audiobook.chapter_state_planned": "Geplant",
    "audiobook.chapter_current": "Aktuelles Kapitel",
    "audiobook.chapter_jump": "Zu diesem Kapitel springen",
    "audiobook.chapter_jump_forward": "Nächster Abschnitt",
    "audiobook.dictation_hint": "Sprich deinen Wunsch, das Hörbuch passt sich danach an.",
    "audiobook.dictation_listening": "Ich höre dir zu …",
    "audiobook.dictation_transcribing": "Wird verstanden …",
    "audiobook.dictation_empty": "Konnte leider nichts verstehen. Bitte sprich deutlicher.",
    "audiobook.dictation_unsupported": "Hier ist kein Mikrofon verfügbar.",
    "audiobook.voice_saved_from_profile": "Aus deiner letzten Hörbuchwahl übernommen.",

    "admin.audio.title": "Audio-Betrieb",
    "admin.membership.title": "Mitgliedschaft",
    "admin.membership.tier": "Stufe",
    "admin.membership.tier_plus": "Plus",
    "admin.membership.tier_ultra": "Ultra",
    "admin.membership.tier_founders": "Founders",
    "admin.membership.tier_torchbearer": "Fackelträger",
    "admin.membership.duration": "Dauer",
    "admin.membership.duration_days": "Anzahl Tage",
    "admin.membership.duration_unlimited": "Unbefristet",
    "admin.membership.days": "Tage",
    "admin.membership.note": "Notiz",
    "admin.membership.note_placeholder": "Interne Begründung",
    "admin.membership.grant": "Mitgliedschaft vergeben",
    "admin.membership.revoke": "Entziehen",
    "admin.membership.empty": "Keine Mitgliedschaften vorhanden.",
    "admin.membership.loading_error": "Mitgliedschaften konnten nicht geladen werden.",
    "admin.membership.grant_success": "Mitgliedschaft wurde vergeben.",
    "admin.membership.revoke_success": "Mitgliedschaft wurde entzogen.",
    "admin.membership.action_error": "Mitgliedschaft konnte nicht geändert werden.",
    "admin.membership.until": "bis {date}",
    "admin.membership.unlimited": "unbefristet",
    "admin.membership.coins_granted": "{coins} Perioden-Coins wurden gutgeschrieben.",
    "admin.membership.status_trial": "Testphase",
    "admin.membership.status_active": "Aktiv",
    "admin.membership.status_grace": "Zahlungsfrist",
    "admin.membership.status_cancelled": "Gekündigt",
    "admin.membership.status_expired": "Abgelaufen",
    "admin.membership.write_locked": "Erst Schreibzugriff freischalten",
    "admin.role_tester_deprecated": "Die Rolle „tester\" wird nicht mehr vergeben — bitte stattdessen eine {alternative} anlegen.",
    "admin.audio.load_error": "Die Audio-Betriebsdaten konnten nicht geladen werden.",
    "admin.audio.month": "UTC-Monat {month}",
    "admin.audio.estimated": "Geschätzte Credits",
    "admin.audio.held": "Reservierte Credits",
    "admin.audio.remaining": "Verbleibende Credits",
    "admin.audio.limit": "Monatsgrenze in Credits",
    "admin.audio.volumes": "Schätzäquivalente: {minutes} Live-Minuten · {characters} Vorlesezeichen · {seconds} Sekunden Spracheingabe.",
    "admin.audio.state_ready": "Audio ist freigegeben.",
    "admin.audio.state_warning": "Mindestens 80 % des Monatsbudgets sind verbraucht oder reserviert.",
    "admin.audio.state_blocked": "Das Monatsbudget ist ausgeschöpft oder ungültig. Neue Audio-Vorgänge sind gesperrt.",
    "admin.audio.state_disabled": "Audio ist manuell abgeschaltet.",
    "admin.audio.state_unknown": "Das Audiobudget ist nicht lesbar. Neue Audio-Vorgänge bleiben gesperrt.",
    "admin.audio.state_calls_unconfigured": "Anrufe sind nicht konfiguriert. Vorlesen und Spracheingabe laufen.",
    "admin.audio.privacy_counts": "Offene Löschungen: Vorlesen {tts}, Spracheingabe {stt}. Ungeklärte Zuordnungen: {unresolved}.",
    "admin.audio.privacy_hint": "Gezählt werden offene Vorgänge ab zehn Minuten. Der nächtliche History-Abgleich ergänzt die Löschqueue; ein abgeschlossener Abgleich bestätigt noch keine Löschung. Direkte Echtzeit-Spracheingabe ist davon nicht erfasst.",
    "admin.audio.privacy_unknown": "Der Stand offener Löschvorgänge ist nicht verfügbar.",
    "admin.audio.sweep": "History-Abgleich: {state}. Letzter vollständiger Tag: {day}. Nicht eindeutige Treffer im Lauf: {unresolved}.",
    "admin.audio.sweep_never": "noch nicht gelaufen",
    "admin.audio.sweep_running": "läuft",
    "admin.audio.sweep_pending": "Fortsetzung offen",
    "admin.audio.sweep_failed": "unvollständig",
    "admin.audio.sweep_completed": "vollständig gelesen",
    "admin.audio.account_title": "Lesender Kontoabgleich",
    "admin.audio.account_total": "Credits laut Konto",
    "admin.audio.account_local": "Lokale Schätzung beim Abruf",
    "admin.audio.account_difference": "Abweichung in Credits",
    "admin.audio.account_period": "Zeitraum {from} bis {to}; abgerufen {checked}.",
    "admin.audio.account_hint": "Der Kontostand enthält auch Beta-Nutzung, andere Kontoaktivitäten und zusätzliche Modellkosten. Er wird mit der damaligen lokalen Schätzung verglichen. Abweichungen ändern weder das Ledger noch das Monatsbudget automatisch.",
    "admin.audio.account_never": "Es liegt noch kein Kontoabgleich vor.",
    "admin.audio.account_stale": "Der angezeigte Kontoabgleich ist veraltet.",
    "admin.audio.account_error": "Der letzte Kontoabgleich ist fehlgeschlagen. Ein vorhandener älterer Stand bleibt gekennzeichnet sichtbar.",
    "admin.audio.account_unavailable": "Der Kontoabgleich ist nicht verfügbar.",
    'ai_transparency.voice_data': "Für Sprachfunktionen arbeitet Lorath mit einem Sprachdienst in den USA zusammen. Je nach Funktion erhält er deinen Mikrofonton, den vorzulesenden Text und den nötigen Spielzusammenhang.",
    'ai_transparency.voice_account_data': "Lorath sendet deine E-Mail-Adresse und Nutzerkennung nicht als Kontodaten mit. Persönliche Angaben, die du selbst sagst oder schreibst, können enthalten sein.",
    'ai_transparency.voice_browser': "Für diese Spracheingabe verwenden wir die Spracherkennung deines Browsers oder Geräts. Dafür gelten dessen Datenschutz- und Speicherregeln. Die Verarbeitung kann auf externen Servern stattfinden.",
    'ai_transparency.voice_browser_option': "Manche Browser oder Geräte bieten eine eigene Spracherkennung. Wenn du diese nutzt, gelten deren Datenschutz- und Speicherregeln. Die Verarbeitung kann auf externen Servern stattfinden.",
    'ai_transparency.voice_batch': "Deine Aufnahme wird bei {operator} in Text umgewandelt.",
    'ai_transparency.voice_direct_storage': "Für diesen direkten Weg können wir eine automatische Löschung beim Sprachdienst derzeit nicht bestätigen.",
    'ai_transparency.voice_live_storage': "Beim Sprachdienst ist die automatische Löschung von Mitschnitt und Wortlaut nach dem Anruf eingestellt. Die Löschung kann sich verzögern.",
    'ai_transparency.voice_live_history': "Anrufe aus einem Chat speichern wir dort als Text. Du kannst diesen Verlauf löschen. Bei Interviews zum Erstellen eines Abenteuers legt Lorath keinen Chatverlauf an.",
    'ai_transparency.voice_delete_request': "Beim Sprachdienst können vorübergehend Einträge entstehen. Wenn uns die nötigen Löschangaben vorliegen, fordern wir nach der Verarbeitung die Löschung an und wiederholen fehlgeschlagene Versuche. Eine sofortige oder immer bestätigte Löschung können wir nicht zusagen.",
    "ai_transparency.confirm_understood": "Verstanden",
    "ai_transparency.stt_gate_intro": "Du sprichst deine Nachricht ein. Die Aufnahme geht an einen Sprachdienst in den USA und kommt als Text zurück in dein Eingabefeld.",
    "ai_transparency.stt_gate_price": "Kosten: 1 Coin je volle 45 Sekunden gesendeter Sprache, mindestens 1 Coin je Aufnahme. Ohne gesendetes Audio fallen keine Coins an.",
    "ai_transparency.stt_gate_hint": "Mit „Verstanden“ startet die Aufnahme. Mit „Abbrechen – nichts senden“ kehrst du zurück; Lorath sendet nichts. Dieser Hinweis erscheint nur einmal.",
    'coins.cost_voice_input_note': 'Mindestens 1 Coin pro Aufnahme, sobald Audio gesendet wurde. Ohne Audio fallen keine Coins an. Die Spracheingabe über die Gerätefunktion deines Browsers bleibt kostenlos.',
    'coins.cost_voice_input_per_minute': 'Je volle Minute gesendeter Sprache',
    'coins.cost_voice_input_per_interval': 'Je volle {seconds} Sekunden gesendeter Sprache',
    'coins.cost_voice_input_start': 'Keine Startgebühr',
    "stt.mic_busy": "Das Mikrofon ist gerade belegt. Sind deine Bluetooth-Kopfhörer mit zwei Geräten verbunden, hält oft das andere Gerät das Mikrofon: dort kurz trennen oder die Kopfhörer nur mit diesem Gerät verbinden, dann erneut aufnehmen.",
    'stt.session_ended': 'Spracheingabe wurde beendet.',
    'stt.recording_invalid': 'Die Aufnahme konnte nicht verarbeitet werden. Bitte nimm einen kürzeren Abschnitt erneut auf.',
    'stt.result_expired': 'Diese Aufnahme ist nicht mehr abrufbar. Bitte nimm den Text erneut auf.',
    'stt.retry_recording': 'Erneut versuchen',
    'stt.processing_retry': 'Deine Aufnahme wird noch verarbeitet. Du kannst sie gleich erneut abrufen.',
    'coins.cost_tts_regen': 'Vorlesen — erneut erzeugen',
    'chat.tts_first_use': 'Diese Vertonung kostet {coins} Coins. Bereits erstelltes Audio kannst du kostenlos erneut anhören.',
    'chat.tts_confirm_long': 'Vorlesen kostet für diese Nachricht {coins} Coins. Fortfahren?',
    'chat.tts_confirm_regen': 'Der Preis richtet sich nach der Zeichenanzahl und wird vor der Vertonung angezeigt.',
    'wizard.info_audio_mode_cost': 'Zusätzlich zur Textantwort kostet die Sprachausgabe 1 Coin je angefangene 100 Zeichen, mindestens 2 Coins. Sie wird nach der fertigen Antwort separat berechnet.',
    'audio.error_processing': 'Die Sprachausgabe wird noch erstellt. Du kannst sie gleich erneut abrufen.',
    'audio.error_auto_coins': 'Für die Sprachausgabe reichen deine Coins nicht. Die Textantwort bleibt erhalten.',
    'audio.error_quote_changed': 'Dieses Preisangebot ist nicht mehr aktuell. Rufe den Preis erneut ab und bestätige ihn.',
    'audio.auto_cost_hint': 'Zusätzlich zur Textantwort: 1 Coin je angefangene 100 Zeichen, mindestens 2 Coins. Die Sprachausgabe wird nach der fertigen Antwort separat berechnet. Reichen deine Coins nicht, bleibt die Textantwort erhalten.',
    'audio.confirm_cost': '{characters} Zeichen werden für {coins} Coins vorgelesen. Fortfahren?',
    'audio.error_busy': "Die Sprachfunktionen sind gerade ausgelastet. Versuch es in ein, zwei Minuten erneut.",
    'audio.error_unavailable': "Die Sprachfunktionen sind gerade nicht verfügbar. Bitte versuch es später erneut.",
    "audio.error_generic": "Die Sprachfunktion konnte nicht ausgeführt werden. Bitte versuch es erneut.",
    "audio.error_language": "In deiner Sprache können wir noch nicht sprechen. Schreib gern im Chat weiter.",
    'voice.selected': 'Stimme {voice}',
    'voice.speaking_style': 'Sprechweise (optional)',
    'voice.sample_error': 'Die Hörprobe ist gerade nicht verfügbar. Versuche es erneut.',
    'voice.sample_hint': 'Die Hörproben sind auf Englisch und zeigen dir den Klang der Stimme. Im Spiel spricht sie in deiner Sprache.',
    'voice.sample_listen': 'Anhören',
    'voice.profile_6': 'Neutral, gleichmäßig',
    'voice.profile_5': 'Samtig, geheimnisvoll',
    'voice.profile_4': 'Hell, verspielt',
    'voice.profile_3': 'Warm, zugewandt',
    'voice.profile_2': 'Ruhig, erzählend',
    'voice.profile_1': 'Tief, klar',
    'voice.no_format': '{no} – {label}',
    'voice.selection': 'Klangprofil',
    'pricing_card.audio.seconds.description': '1 Coin je volle {seconds} Sekunden gesendeter Sprache, mindestens {minimum} Coin sobald Audio gesendet wurde. Keine Startgebühr.',
    'pricing_card.audio.characters.description': '1 Coin je angefangene {characters} Zeichen, mindestens {minimum} Coins.',
    'coins.history_no_transactions': 'Keine Transaktionen.',
    'coins.history_date': 'Datum',
    'coins.history_description': 'Beschreibung',
    'coins.history_amount': 'Betrag',
    'coins.history_balance': 'Saldo',
    'coins.history_load_error': 'Der Kontoauszug konnte nicht geladen werden.',
    'coins.history_live_call': 'Lagerfeuer · {duration}',
    // W2c: Zaehler als vollstaendige Phrase, damit CLDR die Wortform waehlt.
    'world.overview_elements.one': '{count} Element',
    'world.overview_elements.other': '{count} Elemente',
    // ─── E5c (P25): Weltenbau-Split Empty-State (lokaler Fallback bis Server-i18n) ───
    'world.none_selected_title': 'Kein Weltelement gewählt',
    'world.none_selected_body': 'Wähle links ein Element aus – oder lege ein neues an.',
    // ─── Kosmos-Container + Weltenbau-Re-Cut (lokaler Fallback bis Server-i18n deployt) ───
    'world.group_kosmos': 'Geografie',
    'world.group_wesen': 'Lebewesen',
    'world.group_zeit': 'Zeit & Ebenen',
    'world.group_kultur': 'Kultur & Gesellschaft',
    'world.group_regeln': 'Regeln & Systeme',
    'world.group_abenteuer': 'Abenteuer',
    'world.type_multiversum': 'Multiversen',
    'world.type_single_multiversum': 'Multiversum',
    'chat.element_type_multiversum': 'Multiversum',
    // VI: Welt-Element-TYP "world" → "Planet" (interner Key bleibt 'world').
    'world.type_world': 'Planeten',
    'world.type_single_world': 'Planet',
    'chat.element_type_world': 'Planet',
    'coins.cost_wb_world': 'Planet',
    'coins.fq_worlds': 'Planeten',
    'world.kosmos_switch': 'Kosmos wechseln',
    'world.kosmos_active': 'Aktiver Kosmos',
    'world.kosmos_new': 'Neuer Kosmos',
    'world.kosmos_new_title': 'Neuen Kosmos anlegen',
    'world.kosmos_name_label': 'Name',
    'world.kosmos_name_placeholder': 'z.B. Fantasy, SciFi …',
    'world.kosmos_create': 'Anlegen',
    'world.kosmos_rename': 'Kosmos umbenennen',
    'world.kosmos_delete': 'Kosmos löschen',
    'world.kosmos_delete_confirm': 'Diesen Kosmos und ALLE darin enthaltenen Weltbausteine wirklich löschen? Das kann nicht rückgängig gemacht werden.',
    'world.kosmos_last': 'Dein letzter Kosmos kann nicht gelöscht werden.',
    'world.kosmos_offline_hint': 'Anlegen, Umbenennen und Löschen brauchen eine Internetverbindung.',
    // Aufgabe VIII: Weltelement zwischen Kosmen verschieben/kopieren.
    'world.move_copy_kosmos': 'In Kosmos verschieben/kopieren',
    'world.move_copy_title': 'In anderen Kosmos verschieben oder kopieren',
    'world.move_to_kosmos': 'Verschieben',
    'world.copy_to_kosmos': 'Kopieren',
    'world.move_copy_choose_target': 'Ziel-Kosmos wählen',
    'world.moved_to_kosmos': 'Verschoben.',
    'world.copied_to_kosmos': 'Kopiert.',
    'world.move_copy_invalid_target': 'Bitte wähle einen gültigen Ziel-Kosmos.',
    'world.kosmos_not_found': 'Kosmos nicht gefunden.',
    'world.move_copy_error': 'Fehler beim Verschieben/Kopieren.',
    // Generischer Fehler-Fallback fuer Toast-Anzeige statt roher Server-Meldung.
    'general.request_failed': "Die Anfrage ist fehlgeschlagen. Bitte versuche es erneut.",
    'group_chat.not_found': 'Dieser Gruppenchat wurde nicht gefunden.',
    'tindra.welcome_text': 'Ich bin Tindra, deine Assistentin rund um Weltenbau und Kampagnenideen. Ich kann deine Welt analysieren, NPCs erstellen, Kampagnen vorbereiten und lose Notizen in spielbare Lore verwandeln.',
    'app.content_setup_title': 'Deine Welt wird geladen',
    'app.content_setup_hint': 'Alle Inhalte werden heruntergeladen, damit du deine Welten, Kosmos und Charaktere auch ohne Internet ansehen kannst. Fürs Spielen mit der KI brauchst du eine Verbindung.',
    // Web-Variante desselben Hinweises: im Browser gibt es KEIN Offline-Versprechen
    // (die Web-SPA registriert keinen Service Worker, ohne Netz laedt app.lorath.eu
    // gar nicht erst, und der Browser darf den Storage jederzeit raeumen).
    'app.content_setup_hint_web': 'Deine Inhalte werden geladen. Das dauert nur einen Moment.',
    // Ehrliche Fehler-Ansicht nach mehreren erfolglosen Anlaeufen (Server-Fehler,
    // blockierter/kaputter Browser-Speicher) — statt eines Balkens, der nie
    // ankommt. „Ohne Offline-Modus fortfahren" gibt es nur im Web.
    'app.content_setup_error_title': 'Inhalte konnten nicht geladen werden',
    'app.content_setup_error_text': 'Der Server ist gerade nicht erreichbar oder dein Browser lässt keinen lokalen Speicher zu (z.B. blockierte Cookies oder privater Modus).',
    'app.content_setup_error_reload': 'Neu laden',
    'app.content_setup_error_continue': 'Ohne Offline-Modus fortfahren',
    // Immer sichtbarer Ausweg waehrend des Ladens (CRIT 6): der Download laeuft
    // im Hintergrund weiter, nur das Vollbild verschwindet.
    'app.content_setup_skip': 'Überspringen',
    // 404-Seite (Catch-all-Route). Ersetzt den stillen Redirect aufs Dashboard.
    'app.not_found_title': 'Seite nicht gefunden',
    'app.not_found_text': 'Diese Adresse gibt es nicht (mehr). Vielleicht hat sich ein Tippfehler eingeschlichen oder der Link ist veraltet.',
    'app.not_found_home': 'Zum Dashboard',
    'app.not_found_back': 'Zurück',
    // Cookie-/Consent-Banner (nur Web, nur fuer nicht eingeloggte Besucher).
    // Eingeloggte sind ueber die AGB-Zustimmung gedeckt und sehen den Banner nie.
    'cookie.title': 'Cookie-Hinweis',
    'cookie.text': 'Wir nutzen eigenes, datenschutzfreundliches Analytics sowie Google Ads. Mit deiner Zustimmung werden anonyme Nutzungsdaten erfasst. Details findest du in unserer',
    'cookie.privacy_link': 'Datenschutzerklärung',
    'cookie.accept': 'Akzeptieren',
    'cookie.reject': 'Ablehnen',
    // OTA-Bundle-Update (App-Aktualisierung im Hintergrund). Die Tipp-Zeilen
    // app.content_setup_tip_* werden für die Bundle-Phase wiederverwendet.
    'app.ota_bundle_title': 'Aktualisierung wird installiert',
    'app.ota_downloading': 'Neue Version wird geladen …',
    'app.ota_preparing': 'Aktualisierung wird vorbereitet …',
    // F-007: Offline-/Netzwerk-Hinweis beim Login (TODO: in Server-i18n übernehmen).
    'onboarding.tree.login.offline': 'Ich kann den Server gerade nicht erreichen. Bist du online? Prüf kurz deine Verbindung und versuch es dann noch einmal.',
    // Erststart-Gate: Dateimenge ({done}/{total} MB) + Warte-auf-Verbindung + rotierende Tipps.
    'app.content_setup_size': '{done} / {total} MB',
    'app.content_setup_waiting': 'Warte auf Internetverbindung…',
    'app.content_setup_tip_1': 'Tipp: Erstelle einen eigenen Kosmos und baue deine Welt von Grund auf.',
    'app.content_setup_tip_2': 'Tipp: Verknüpfe Orte, Figuren und Mächte zu einem lebendigen Beziehungsnetz.',
    'app.content_setup_tip_3': 'Tipp: Starte ein Abenteuer und erlebe deine Welt im Spiel.',
    'app.content_setup_tip_4': 'Tipp: Vier Beispiel-Kosmos – Realität, Fantasy, Sci-Fi und Postapokalypse – warten auf dich.',
    'app.content_setup_tip_5': 'Tipp: Jedes Welt-Element kann ein eigenes Porträt-Bild tragen.',
    'app.content_setup_tip_6': 'Tipp: Du kannst Elemente zwischen deinen Kosmos verschieben oder kopieren.',
    'app.content_setup_tip_7': 'Tipp: Vom Multiversum bis zum kleinsten Ort – alles hängt zusammen.',
    'app.content_setup_tip_8': 'Tipp: Deine Welten und Charaktere kannst du nach dem Laden auch ohne Internet ansehen — fürs Spielen mit der KI brauchst du eine Verbindung.',
    // Erst-Start-Bootstrap: ETA-Variable {s} = gerundete Sekunden, {percent} = Prozent.
    'app.content_setup_eta': 'noch ca. {s} s',
    // V: Beziehungs-Editor — „Hinzufügen"-Button (restliche rel_*-Labels kommen aus Server-i18n).
    'world_edit.rel_add': 'Beziehung hinzufügen',
    'app.content_setup_progress_label': 'Fortschritt: {percent} %',
    // Feedbackrunde 5, IV: Tindra-Eingabe wieder einzeilig. Der Live-Server (main)
    // liefert noch das lange Placeholder mit der "/"-Erklaerung; bis der Server-i18n
    // deployt ist, gewinnt dieser lokale Override (I18nProvider spreaded ihn zuletzt).
    'tindra.input_placeholder': 'Nachricht an Tindra…',
    'tindra.coins_charged': '{coins} Coins abgebucht',
    // 6.1 Banner-Versionserkennung (7.1.0). Bei Server-Deploy in die Server-de/en-
    // Quelle spiegeln, damit translate:budget sie in alle Sprachen übersetzt.
    'dashboard.release_banner_7_1': 'Neu in 7.1.0: flüssigere Chats, sichtbare Coin-Kosten, stabilere Käufe und viele Verbesserungen im Weltenbau. Viel Spaß beim Entdecken!',
    'dashboard.update_banner_7_1': 'Version 7.1.0 ist da — jetzt im Store aktualisieren für alle neuen Verbesserungen.',
    // A2: Proaktiv-Push-Einstellung.
    'settings.notifications.toggle_proactive_label': 'Nach dem Login nach Push fragen',
    'settings.notifications.toggle_proactive_desc': 'Zeigt den Berechtigungsdialog aktiv an. Aus: Push wird nur beim Einschalten einer Option oben angefragt.',
    'startup.push.title': 'Benachrichtigungen aktivieren?',
    'startup.push.body': 'Lorath kann dich informieren, wenn Abenteuer, Antworten oder Belohnungen bereit sind. Als Nächstes fragt dein Gerät nach der Erlaubnis.',
    'startup.push.later': 'Nicht jetzt',
    'startup.push.allow': 'Weiter',
    // W7-B (E12): Grund-Texte des Push-Primings. Ersetzen im Dialog den
    // allgemeinen Text `startup.push.body`, wenn ein ECHTES Ereignis fragt.
    'push_priming.reason.companion': 'Dein Begleiter hat dir gerade geschrieben. Sollen wir dich benachrichtigen, wenn er sich wieder meldet? Als Nächstes fragt dein Gerät nach der Erlaubnis.',
    'push_priming.reason.adventure': 'Dein Abenteuer ist fertig vorbereitet. Sollen wir dich künftig benachrichtigen, sobald es so weit ist? Als Nächstes fragt dein Gerät nach der Erlaubnis.',
    // W7-B (E11): Cross-Onboarding — einmal auf die jeweils andere Tür ansprechen.
    'cross_onboarding.companion_title': 'Auch einen festen Begleiter?',
    'cross_onboarding.companion_body': 'Möchtest du dir auch einen festen Begleiter erstellen? Eine Figur, die dir schreibt und mit dir im Gespräch bleibt.',
    'cross_onboarding.adventure_title': 'Auch ein Abenteuer?',
    'cross_onboarding.adventure_body': 'Möchtest du mit deinem Begleiter auch Abenteuer erleben?',
    'cross_onboarding.adventure_body_named': 'Möchtest du mit {name} auch Abenteuer erleben?',
    'cross_onboarding.accept': 'Ja, zeig mir das',
    'cross_onboarding.decline': 'Nein danke',
    // Feedbackrunde 5, III: Texte fuer den nativen Bewertungs-Button (lokaler Fallback,
    // falls der Live-Server die app_review-Keys noch nicht liefert).
    'app_review.q1_title': 'Gefällt dir Lorath?',
    'app_review.btn_rate_generic': 'Jetzt bewerten',
    // Phase 5: Native In-App-Kauf-Toasts (lokaler Fallback bis der
    // Server-i18n deployt ist; siehe backend/server/i18n).
    'coins.iap_processing': 'Kauf wird verarbeitet…',
    'coins.iap_success': 'Coins gutgeschrieben!',
    'coins.iap_failed': 'Kauf fehlgeschlagen. Bitte versuche es erneut.',
    'coins.iap_cancelled': 'Kauf abgebrochen.',
    'coins.iap_unavailable': 'Käufe sind auf diesem Gerät nicht verfügbar.',
    // Bug 2: Tindra-Navigations-Buttons. Lokaler Fallback bis der Server-i18n
    // die tindra.nav_*-Keys ausliefert.
    'tindra.nav_dashboard': 'Dashboard öffnen',
    'tindra.nav_characters': 'Charaktere öffnen',
    'tindra.nav_world': 'Welten öffnen',
    'tindra.nav_coins': 'Coins öffnen',
    'tindra.nav_settings': 'Einstellungen öffnen',
    'tindra.nav_profile': 'Profil öffnen',
    'tindra.nav_tindra': 'Tindra öffnen',
    'tindra.nav_generic': 'Öffnen',
    // E2/Rail-Navigation (lokaler Fallback bis der Server-i18n die Keys ausliefert).
    'nav.soundboard': "Klangbühne",
    'nav.rail_toggle': 'Seitenleiste umschalten',
    // W1-C („Zwei Einstiege"): neue Tabs Chats + Entdecken, Karte „Startseite".
    'nav.chats': 'Chats',
    'nav.discover': 'Entdecken',
    'settings.favorite_tab.title': 'Startseite',
    'settings.favorite_tab.desc': 'Lege fest, welcher Bereich sich beim Start der App öffnet.',
    'settings.favorite_tab.chats': 'Chats',
    'settings.favorite_tab.adventures': 'Abenteuer',
    'settings.favorite_tab.discover': 'Entdecken',
    'discover.coming_soon': 'Hier findest du bald Charaktere, die andere mit der Gemeinschaft teilen.',
    // W4-C: Entdecken-Tab (Liste/Detail/Melden) + Veroeffentlichen-Dialog.
    'discover.none_selected_body': 'Wähle links eine Figur aus, um ihren Bogen zu sehen.',
    'discover.search_placeholder': 'Nach Namen suchen',
    'discover.kind_label': 'Art',
    'discover.kind_all': 'Alle',
    'discover.kind_companion': 'Begleiter',
    'discover.kind_adventure': 'Abenteuer',
    'discover.setting_label': 'Welt',
    'discover.setting_all': 'Alle Welten',
    'discover.setting_alltag': 'Alltag',
    'discover.setting_fantasy': 'Fantasy',
    'discover.setting_scifi': 'Sci-Fi',
    'discover.setting_postapokalypse': 'Postapokalypse',
    'discover.setting_cyberpunk': 'Cyberpunk',
    'discover.setting_historisch': 'Historisch',
    'discover.setting_krimi': 'Krimi',
    'discover.load_more': 'Mehr laden',
    // ─── R2-12: Abenteuer-Vorlagen („Entdecken → Abenteuer") ───
    'discover.adventures_title': 'Abenteuer',
    'discover.adventures_intro': 'Fertige Abenteuer von Lorath. Such dir eines aus und leg sofort los.',
    'discover.adventures_search_placeholder': 'Abenteuer suchen',
    'discover.adventures_empty_title': 'Noch keine Abenteuer',
    'discover.adventures_empty_body': 'Hier erscheinen fertige Abenteuer, sobald wir die ersten freigegeben haben.',
    'discover.adventures_empty_filtered_title': 'Keine Treffer',
    'discover.adventures_empty_filtered_body': 'Zu dieser Auswahl gibt es gerade kein Abenteuer. Nimm einen Filter heraus oder ändere die Suche.',
    'discover.adventures_load_error': 'Die Abenteuer konnten nicht geladen werden. Versuch es später noch einmal.',
    'discover.adventures_none_selected_body': 'Wähle links ein Abenteuer aus, um es dir anzusehen.',
    'discover.adventures_soon': 'Hier findest du bald fertige Abenteuer zum Sofort-Loslegen.',
    'discover.adventure_not_found_title': 'Abenteuer nicht gefunden',
    'discover.adventure_not_found_body': 'Dieses Abenteuer gibt es nicht mehr oder es ist nicht für dich freigegeben.',
    'discover.adventure_back_to_list': 'Zurück zu den Abenteuern',
    'discover.adventure_play': 'Spielen',
    'discover.adventure_play_free': 'Kostenlos',
    'discover.adventure_play_cost': '{n} Coins',
    'discover.adventure_play_error': 'Das Abenteuer konnte nicht gestartet werden. Versuch es später noch einmal.',
    'discover.adventure_play_usk_blocked': 'Dieses Abenteuer passt nicht zu deiner Altersstufe.',
    'discover.adventure_by_lorath': 'Von Lorath',
    'discover.adventures_filter_setting': 'Welt',
    'discover.adventures_filter_usk': 'Altersstufe',
    'discover.adventures_filter_usk_all': 'Alle Stufen',
    'discover.adventures_filter_usk_upto': 'Bis {level}',

    'discover.load_error': 'Die Liste konnte nicht geladen werden. Versuch es später noch einmal.',
    'discover.empty_title': 'Noch nichts zu entdecken',
    'discover.empty_body': 'Hier erscheinen Figuren, die andere mit der Gemeinschaft teilen.',
    'discover.empty_filtered_title': 'Keine Treffer',
    'discover.empty_filtered_body': 'Zu dieser Auswahl gibt es gerade nichts. Nimm einen Filter heraus oder ändere die Suche.',
    'discover.portraits': 'Bilder',
    'discover.portrait_n': 'Bild {n}',
    'discover.by_creator': 'Von {name}',
    'discover.highlights': 'Momente',
    'discover.highlight_day': 'Tag {n}',
    'discover.highlight_day_unknown': 'Ohne Datum',
    'discover.section_behaviour': 'Verhalten',
    'discover.section_appearance': 'Aussehen',
    'discover.section_quirks': 'Eigenheiten',
    'discover.section_personality': 'Persönlichkeit',
    'discover.section_backstory': 'Hintergrund',
    'discover.adopt': 'Übernehmen',
    'discover.adopted': 'Die Figur ist jetzt bei dir und wartet im Chat.',
    'discover.adopt_error': 'Die Figur konnte nicht übernommen werden. Versuch es später noch einmal.',
    'discover.not_found_title': 'Nicht gefunden',
    'discover.not_found_body': 'Diese Veröffentlichung gibt es nicht mehr oder sie ist nicht für dich freigegeben.',
    'discover.back_to_list': 'Zurück zur Liste',
    'discover.report': 'Melden',
    'discover.report_title': 'Veröffentlichung melden',
    'discover.report_body': 'Der Wächter prüft die Figur erneut. Bleibt das Ergebnis gleich, sieht sich ein Mensch aus dem Team die Meldung an.',
    'discover.report_reason_label': 'Worum geht es?',
    'discover.report_reason_real_person': 'Bildet eine echte Person ab',
    'discover.report_reason_sexual_content': 'Sexuelle Inhalte',
    'discover.report_reason_violence': 'Gewalt',
    'discover.report_reason_hate': 'Hass oder Herabwürdigung',
    'discover.report_reason_illegal': 'Verbotene Inhalte',
    'discover.report_reason_other': 'Etwas anderes',
    'discover.report_note_label': 'Notiz (freiwillig)',
    'discover.report_note_placeholder': 'Was ist dir aufgefallen?',
    'discover.report_submit': 'Meldung senden',
    'discover.report_sent': 'Danke — deine Meldung ist eingegangen.',
    'discover.report_error': 'Die Meldung konnte nicht gesendet werden.',
    'discover.report_limit': 'Du hast heute schon viele Meldungen gesendet. Versuch es morgen wieder.',
    'discover.report_exists': 'Diese Figur hast du bereits gemeldet.',
    'publish.title': 'Figur veröffentlichen',
    'publish.submit': 'Zur Prüfung einreichen',
    'publish.submitted': 'Deine Figur ist eingereicht. Der Wächter prüft sie jetzt.',
    'publish.withdraw': 'Zurückziehen',
    'publish.withdrawn_done': 'Die Figur ist nicht mehr öffentlich.',
    'publish.creator_label': 'Ersteller-Angabe',
    'publish.creator_default': 'Ein Mitglied der Gemeinschaft',
    'publish.creator_hint': 'Freier Text, höchstens 40 Zeichen. Der Wächter prüft ihn mit. Dein Benutzername wird nie gezeigt.',
    'publish.usk_label': 'Altersstufe',
    'publish.usk_hint': 'Du kannst höchstens deine eigene Stufe wählen.',
    'publish.images_pending.one': 'Ein Bild wird noch geprüft.',
    'publish.images_pending.other': 'Noch {count} Bilder werden geprüft.',
    'publish.state_pending_title': 'Prüfung läuft',
    'publish.state_pending_body': 'Der Wächter sieht sich Bogen und Bilder an. Das dauert meist nur wenige Minuten.',
    'publish.state_approved_title': 'Öffentlich sichtbar',
    'publish.state_approved_body': 'Deine Figur steht in Entdecken. Ziehst du sie zurück, verschwindet sie aus der Liste — schon angelegte Kopien bleiben bestehen.',
    'publish.state_rejected_title': 'Nicht freigegeben',
    'publish.state_rejected_body': 'Die Prüfung war nicht erfolgreich. Ändere den Bogen und reiche ihn erneut ein.',
    'publish.state_withdrawn_body': 'Du hast diese Figur zurückgezogen. Du kannst sie jederzeit erneut einreichen.',
    'publish.state_blocked_title': 'Gesperrt',
    'publish.state_blocked_body': 'Diese Figur wurde vom Team gesperrt und kann nicht erneut eingereicht werden.',
    'publish.blocked_guest_title': 'Konto sichern',
    'publish.blocked_guest_body': 'Zum Veröffentlichen brauchst du ein gesichertes Konto. Lege eines an — deine Figuren und Chats ziehen mit um.',
    'publish.blocked_minor_title': 'Noch nicht verfügbar',
    'publish.blocked_minor_body': 'Figuren veröffentlichen kannst du ab der Inhaltsstufe „Ab 16". Bis dahin bleiben deine Figuren privat.',
    'publish.error_generic': 'Das hat nicht geklappt. Versuch es später noch einmal.',
    'publish.error_limit': 'Du hast heute schon viele Figuren eingereicht. Versuch es morgen wieder.',
    'publish.error_not_allowed': 'Für diese Figur ist das Veröffentlichen nicht möglich.',
    'publish.error_exists': 'Diese Figur ist bereits eingereicht.',
    'publish.consent.title': 'Das solltest du wissen',
    'publish.consent.intro': 'Wenn du zustimmst, reichst du deine Figur zur Prüfung ein. Nach der Freigabe ist sie für alle sichtbar. Bitte lies die fünf Punkte in Ruhe.',
    'publish.consent.public': 'Deine Figur wird für alle sichtbar: Name, Bogen und Bilder stehen dann in Entdecken.',
    'publish.consent.copies': 'Andere können sie übernehmen. Diese Kopien bleiben auch bestehen, wenn du die Figur später zurückziehst.',
    'publish.consent.no_real_people': 'Keine echten Personen und keine fremden Bilder. Verwende nur, was du selbst erdacht oder erzeugt hast.',
    'publish.consent.guardian': 'Der Wächter prüft Bogen und Bilder, bevor etwas öffentlich wird.',
    'publish.consent.label_optional': 'Wie du unter der Figur genannt wirst, wählst du frei: ein kurzer Text bis 40 Zeichen, den der Wächter mitprüft. Ohne Angabe steht dort „Ein Mitglied der Gemeinschaft". Dein Benutzer- oder Anzeigename wird nie veröffentlicht.',
    'publish.consent.checkbox': 'Ich habe das gelesen und stimme der Veröffentlichung zu.',
    // W4-A: Standard-Ersteller-Anzeige. Der Server liefert den lokalisierten
    // Text bereits mit; dieser Eintrag ist nur der Client-Rueckfall.
    'discover.creator_default': 'Ein Mitglied der Gemeinschaft',
    // E5/Split-Ansicht: aria-live-Ansage beim Pane-Wechsel (docs/30 §8.6).
    'split.showing_detail': 'Detail wird angezeigt',
    'split.showing_list': 'Liste wird angezeigt',
    'characters.none_selected_title': 'Charakter auswählen',
    'characters.none_selected_body': 'Wähle links einen Charakter aus, um Details zu sehen, oder erstelle einen neuen.',
    'characters.not_found_title': 'Charakter nicht gefunden',
    'characters.not_found_body': 'Dieser Charakter existiert nicht mehr oder wurde gelöscht.',
    'characters.back_to_list': "Zur Charakterübersicht",
    'chars.edit_btn': 'Bearbeiten',
    'character_edit.preview_label': 'Vorschau',
    'settings.section.account': "Konto und Profil",
    'settings.section.appearance': 'Darstellung',
    "settings.section.media": "Antworten & Audio",
    "settings.section.experience": "Lesen & Chat",
    'settings.section.notifications': "Mitteilungen",
    'settings.section.help': 'Hilfe',
    'settings.section.legal': "Rechtliches",
    'tindra.open_element': 'Element #{id} öffnen',
    // ─── Tindra-Overlay-Tour (Buttons + Schritt-Texte) ─────────────────
    // Part 1: interaktive Fuehrung bis zum ersten Abenteuer.
    'tour.buttons.next': 'Weiter',
    'tour.buttons.back': 'Zurück',
    'tour.buttons.skip': 'Überspringen',
    'tour.buttons.finish': 'Fertig',
    'tour.resume.title': 'Tour pausiert',
    'tour.resume.cta': 'Fortsetzen',
    'tour.resume.dismiss': 'Später',
    'tour.progress': 'Schritt {current} von {total}',
    'tour.part1.intro.title': 'Hallo, ich bin Tindra',
    'tour.part1.intro.body': 'Ich zeige dir jetzt in ein paar Schritten, wie du dein erstes Abenteuer startest. Wenn du mich nicht mehr brauchst, kannst du die Tour jederzeit überspringen.',
    'tour.part1.nav.title': 'Die Bereiche unten',
    'tour.part1.nav.body': "Mit der Leiste unten wechselst du zwischen den Bereichen von Lorath — deinen Chats mit Begleitern, deinen Abenteuern und Entdecken.",
    'tour.part1.new.title': 'Dein neuer Startpunkt',
    'tour.part1.new.body': "Hier baust du jederzeit deine eigene Geschichte: Ein kleiner Assistent fragt nach Setting, Regeln und Ton.",
    'tour.part1.open.title': 'Tippe hier',
    'tour.part1.open.body': "Tippe jetzt auf dein Abenteuer — oder auf eine der Geschichten, falls du noch keins hast. Sie beginnt sofort.",
    // Part 2: der Rest der App — Erzaehler, Modelle, Profil, Welten.
    'tour.part2.narrator.title': 'Erzähler-Modus',
    'tour.part2.narrator.body': 'Der „Neues Abenteuer"-Knopf bringt dich in den Erzähler-Wizard. Dort wählst du Setting, Regeln und Tonalität, bevor die Geschichte startet. Es werden keine Coins verbraucht, solange du nichts absendest.',
    'tour.part2.models.title': 'KI-Modelle & Stimmen',
    'tour.part2.models.body': 'Unter „Modelle & Medien" stellst du Bildmodell, TTS-Stimme und Lesegeschwindigkeit ein. Diese Defaults gelten für neue Abenteuer und Chats.',
    'tour.part2.profile.title': 'Dein Profil & Konto',
    'tour.part2.profile.body': 'Im Profil passt du Anzeigename, E-Mail und Passwort an. Hier findest du auch später dein Coin-Guthaben und deine Abo-Daten.',
    // W7-B: Tour nach Tür — die Chats-Strecke (/chats) und der Entdecken-Schritt.
    'tour.chats.list.title': 'Deine Gespräche',
    'tour.chats.list.body': 'Hier stehen alle Gespräche, die neuesten oben. Ein Tipp auf eine Zeile öffnet das Gespräch.',
    'tour.chats.new.title': 'Neuer Begleiter',
    'tour.chats.new.body': 'Mit diesem Knopf legst du einen neuen Begleiter an: Name, Verhalten, Aussehen, Eigenheiten. Danach zieht er bei dir ein und schreibt dir als Erster.',
    'tour.chats.profile.title': 'Zum Profil',
    'tour.chats.profile.body': 'Über dieses Menü kommst du zum Profil der Figur, kannst sie anrufen oder stummschalten.',
    'tour.discover.list.title': 'Entdecken',
    'tour.discover.list.body': 'Hier findest du Figuren, die andere veröffentlicht haben. Du kannst sie übernehmen und sofort mit ihnen sprechen.',
    // W7-B (Nachzug W1-A/W1-B): sichtbarer Zustimmungs-Hinweis im Gast-Schritt.
    'onboarding.tree.guest.terms_hint': 'Mit Weiter akzeptierst du die Nutzungsbedingungen und die Datenschutzerklärung.',
    'tour.part2.world.title': 'Deine Welten',
    'tour.part2.world.body': 'Im Welten-Bereich sammelst du Kosmos, Wesen, Zeiten und Kulturen. Diese Bausteine kannst du beim Erstellen eines Abenteuers direkt einbinden.',
    // Replay-Buttons in den Einstellungen.
    'tour.replay.part1_title': 'Tour Teil 1 wiederholen',
    'tour.replay.part1_btn': 'Tour Teil 1',
    'tour.replay.part2_title': 'Tour Teil 2 wiederholen',
    'tour.replay.part2_btn': 'Tour Teil 2',
    // Phase 6: Composer zeigt die Anzahl verbleibender Gratis-Nachrichten dezent an,
    // wenn der Coin-Balance-Hook einen Wert > 0 liefert.
    'composer.free_messages': '{count} Gratis-Nachrichten',
    // v1.1.0.42x — Negativ-Saldo-Sperre (Server 402 `account_negative`).
    'composer.account_locked_hint': 'Dein Konto ist im Minus — bitte lade Coins auf, um weiterzuspielen.',
    'coins_global.balance_negative_aria': 'Coin-Saldo im Minus — bitte aufladen',
    // Bug II + III.i: dezenter Hinweis, waehrend Antwortvorschlaege im Hintergrund
    // generiert werden (NICHT der Erzaehler-Tippindikator).
    'chat.suggestions_generating': 'Antwortvorschläge werden erstellt',
    // v1.2: neue Carousel-UI der Antwortvorschlaege (zentrierte Ueberschrift +
    // Spalten-Labels + Aria-Labels fuer die seitlichen Scroll-Pfeile).
    'chat.suggestions_from': 'Antwortvorschläge von',
    // Nachpruefung R3 (C71): unsichtbares Rollen-Praefix der Vorschlaege —
    // beide Rollen sind Handlungen der Spielerfigur, nicht des Erzaehlers.
    'chat.suggestions_narrator': 'Eigene Handlung',
    'chat.suggestions_companion': 'Mit Begleiter',
    'chat.suggestions_scroll_left': 'Vorschläge nach links scrollen',
    'chat.suggestions_scroll_right': 'Vorschläge nach rechts scrollen',
    // Anfangs-Chips (Retention): drei kurze Vorschlaege direkt ueber der Eingabe,
    // solange die Kampagne < 5 eigene Nachrichten hat. Gruppen-Label + Blocked-
    // Hinweis, wenn ein Chip gesendet werden soll, waehrend die KI schreibt.
    'chat.beginning_chips_group': 'Vorschläge für deine Aktion',
    'chat.beginning_chips_blocked_hint': 'Der Erzähler schreibt noch — gleich geht es weiter.',
    // Coins-Seite (Web): ehrlicher Hinweis statt drei deaktivierter "coming_soon"-Buttons.
    'coins.web_only_native_hint': 'Im Browser sind aktuell nur native Käufe (iOS/Android) verfügbar — Web-Zahlung folgt.',
    'coins.web_only_native_hint_aria': 'Hinweis: nur native Käufe verfügbar',
    // Native Store-Preise: lokale Absicherung bis der neue Server-Key ausgeliefert wird.
    'coins.native_price_hint': 'Der endgültige Preis wird beim Kauf vom Store bestätigt.',
    'coins.native_price_hint_currency': 'Die Preise werden in {currency} angezeigt. Der endgültige Preis wird beim Kauf vom Store bestätigt.',
    // ─── Kampagnen-Wizard (4 Schritte, mobile-first) ─────────────────
    // Modus-Dropdown (3 Optionen) — bis der Server-i18n die Keys ausliefert.
    'wizard.mode_player_only': 'Spieler',
    'wizard.mode_coop': 'Spieler + Charakter (Ko-op)',
    'wizard.mode_dm_only': 'Dungeon Master',
    'wizard.mode_coop_hint': 'Du spielst mit einem KI-Begleiter gemeinsam die Geschichte.',
    'wizard.mode_player_hint': 'Die KI führt als Spielleiter durch dein Abenteuer.',
    'wizard.mode_dm_hint': 'Du leitest das Spiel — die KI spielt die Charaktere.',
    // Import-Stabilisierung: Fehler-/Validierungstexte für die Welt-Element-Kaskade.
    'wizard.cascade_failed': 'Der Import der Welt-Elemente ist fehlgeschlagen. Bitte versuche es erneut.',
    'wizard.cascade_start_required': 'Bitte wähle ein Start-Element für den Import aus.',
    // Step 2 (Erzähler) — der Erzähler-Schritt wurde aus Step 1 herausgelöst.
    'wizard.step_narrator': 'Erzähler',
    'wizard.step_narrator_short': 'Erzähler:in',
    // Step 3 (Charakter & Welt) — kontextabhängig je wizardMode.
    'wizard.who_are_you': 'Wer bist du?',
    'wizard.who_are_you_hint': 'Wähle deinen Charakter oder spiele einfach als du selbst.',
    'wizard.simple_me': 'Einfach ich',
    // Charakter-Wizard Step-Labels (client-only, damit sie ohne Server-i18n-Deploy verfügbar sind).
    'character_new.step_basics': 'Grundlagen',
    'character_new.step_personality': 'Persönlichkeit & Gesinnung',
    'character_new.step_stats': 'Werte & Fähigkeiten',
    'character_new.step_finishing': 'Feinschliff',
    'wizard.simple_me_hint': 'Spiele ohne festen Charakterbogen — die KI führt dich.',
    'wizard.companion_label': 'Begleiter',
    'wizard.companion_hint': 'Wähle einen Charakter, der dich durch das Abenteuer begleitet.',
    'wizard.companion_required': 'Bitte wähle einen Begleiter.',
    'wizard.no_companion': 'Du hast noch keine Begleiter. Es wird automatisch der erste verfügbare Charakter gewählt.',
    // Step 4 (Erweiterte Einstellungen) — optionaler Pfad.
    'wizard.step_advanced': 'Erweiterte Einstellungen',
    'wizard.advanced_intro': 'Möchtest du erweiterte Einstellungen treffen?',
    'wizard.advanced_yes': 'Ja, ich will mehr einstellen',
    'wizard.advanced_no': 'Nein → Los geht\'s',
    'wizard.advanced_yes_hint': 'Regeln, Standardansicht, besondere Wünsche und Startszene.',
    'wizard.advanced_no_hint': 'Mit guten Defaults direkt starten.',
    'wizard.start_mode_label': 'Standardansicht',
    // Phase 2 — Abenteuer-Vorplanungs-Feinschliff (Blueprint + 7 Regler).
    // Lokaler Fallback, bis der Server-i18n deployt ist. Server-i18n ist
    // kanonische Quelle — siehe server/i18n/ui/de.json.
    'wizard.finetune_title': 'Story-Feinschliff',
    'wizard.finetune_hint': 'Ohne Auswahl würfelt der Erzähler passend zu deiner Welt, deinem USK-Level und deinem Erzähler.',
    'wizard.blueprint_label': 'Story-Aufbau',
    'wizard.surprise_me': 'Überrasch mich',
    'wizard.mood_label': 'Stimmung',
    'wizard.mood_duester': 'Düster',
    'wizard.mood_hoffnungsvoll': 'Hoffnungsvoll',
    'wizard.mood_humorvoll': 'Humorvoll',
    'wizard.mood_bittersuess': 'Bittersüß',
    'wizard.mood_episch': 'Episch',
    'wizard.mood_gemuetlich': 'Gemütlich',
    'wizard.pacing_label': 'Pacing',
    'wizard.pacing_gemaechlich': 'Gemächlich',
    'wizard.pacing_ausgewogen': 'Ausgewogen',
    'wizard.pacing_rasant': 'Rasant',
    'wizard.focus_label': 'Erzählfokus (max. 2)',
    'wizard.focus_action': 'Action',
    'wizard.focus_beziehungen': 'Beziehungen',
    'wizard.focus_erkundung': 'Erkundung',
    'wizard.focus_raetsel': 'Rätsel',
    'wizard.focus_intrige': 'Intrige',
    'wizard.length_label': 'Ziellänge',
    'wizard.length_oneshot': 'One-Shot',
    'wizard.length_kurz': 'Kurz',
    'wizard.length_mittel': 'Mittel',
    'wizard.length_episch': 'Episch',
    'wizard.ending_label': 'Endungstyp',
    'wizard.ending_offen': 'Offen',
    'wizard.ending_hoffnungsvoll': 'Hoffnungsvoll',
    'wizard.ending_tragisch_moeglich': 'Tragisch möglich',
    'wizard.ending_twist': 'Twist',
    'wizard.consequence_label': 'Konsequenzhärte',
    'wizard.consequence_wohlwollend': 'Wohlwollend',
    'wizard.consequence_fair': 'Fair',
    'wizard.consequence_gnadenlos': 'Gnadenlos',
    'wizard.npc_density_label': 'NSC-Dichte',
    'wizard.npc_density_fokussiert': 'Fokussiert',
    'wizard.npc_density_ausgewogen': 'Ausgewogen',
    'wizard.npc_density_breit': 'Breit',
    'wizard.price_badge_coins': '{coins} Coins',
    'wizard.price_badge_free': 'Gratis',
    // 50 setting-neutrale Abenteuer-Namen (DE) — generisch, kurz, passen in
    // Fantasy/SciFi/Horror/Mystery. Wird beim Mount des Wizards per Index
    // zufällig ausgewählt (Seed = Date.now() % 50, NICHT Math.random auf
    // Modulebene — siehe Step1Basics).
    'wizard.random_name_1': 'Der vergessene Pfad',
    'wizard.random_name_2': 'Schatten über dem Tal',
    'wizard.random_name_3': 'Das letzte Echo',
    'wizard.random_name_4': 'Jenseits der Schwelle',
    'wizard.random_name_5': 'Die leere Karte',
    'wizard.random_name_6': 'Ruf aus der Tiefe',
    'wizard.random_name_7': 'Der siebte Turm',
    'wizard.random_name_8': 'Worte im Nebel',
    'wizard.random_name_9': 'Die schlafende Stadt',
    'wizard.random_name_10': 'Splitter des Mondes',
    'wizard.random_name_11': 'Der stille Hafen',
    'wizard.random_name_12': 'Asche und Erinnerung',
    'wizard.random_name_13': 'Das ferne Versprechen',
    'wizard.random_name_14': 'Spur im Schnee',
    'wizard.random_name_15': 'Die verborgene Quelle',
    'wizard.random_name_16': 'Nacht ohne Sterne',
    'wizard.random_name_17': 'Die zerbrochene Krone',
    'wizard.random_name_18': 'Salz und Schweigen',
    'wizard.random_name_19': 'Der wandernde Stein',
    'wizard.random_name_20': 'Tür ohne Schlüssel',
    'wizard.random_name_21': 'Das flüsternde Moor',
    'wizard.random_name_22': 'Ruf des Raben',
    'wizard.random_name_23': 'Im Auge des Sturms',
    'wizard.random_name_24': 'Die verlorene Melodie',
    'wizard.random_name_25': 'Schwarze Flut',
    'wizard.random_name_26': 'Der brennende Wald',
    'wizard.random_name_27': 'Kalte Laternen',
    'wizard.random_name_28': 'Die letzte Wache',
    'wizard.random_name_29': 'Echo im Stein',
    'wizard.random_name_30': 'Schritte im Laub',
    'wizard.random_name_31': 'Der graue Morgen',
    'wizard.random_name_32': 'Geister im Licht',
    'wizard.random_name_33': 'Die offene Wunde',
    'wizard.random_name_34': 'Staub der Alten',
    'wizard.random_name_35': 'Die zweite Sonne',
    'wizard.random_name_36': 'Trümmer der Hoffnung',
    'wizard.random_name_37': 'Der fremde Gast',
    'wizard.random_name_38': 'Zwischen den Zeiten',
    'wizard.random_name_39': 'Stimmen im Wind',
    'wizard.random_name_40': 'Der kalte Thron',
    'wizard.random_name_41': 'Dämmerstunde',
    'wizard.random_name_42': 'Der zerbrochene Schwur',
    'wizard.random_name_43': 'Die weiße Festung',
    'wizard.random_name_44': 'Am Rande der Nacht',
    'wizard.random_name_45': 'Der leere Sessel',
    'wizard.random_name_46': 'Zeichen am Himmel',
    'wizard.random_name_47': 'Die flackernde Kerze',
    'wizard.random_name_48': 'Tiefer als die Wurzeln',
    'wizard.random_name_49': 'Der Namenlose',
    'wizard.random_name_50': 'Vorboten',
    // Zeichen-Seite: Live-Suche (case-insensitive, Teilstring) + Favoriten-Filter.
    // Lokaler Fallback bis der Server-i18n die Keys ausliefert.
    'chars.search_placeholder': 'Charaktere & Gruppen suchen …',
    'chars.filter_all': 'Alle',
    'chars.filter_favorites': 'Nur Favoriten',
    'chars.no_results': 'Keine passenden Einträge.',
    // VII-a: Kosmos-Auswahl für den Weltbau-Import im Wizard.
    'campaign_new.import_kosmos_label': 'Welt-Quelle (Kosmos)',
    // VII-b.4: "Erlebte Abenteuer"-Sektion im Welt-Element-Editor.
    'world_edit.played_adventures_title': 'Erlebte Abenteuer',
    'world_edit.played_adventures_empty': 'Noch keine Abenteuer in diesem Kosmos gespielt.',
    // VI: Gruppenchat — ein Chat mit mehreren KI-Charakteren.
    'group_chat.title': 'Gruppenchat',
    'group_chat.member_count': '{count} Mitglieder',
    // II.d: Gruppenchat-Sektion in "Deine Charaktere".
    'characters.group_chats_title': 'Gruppenchats',
    'characters.group_chats_empty': 'Noch keine Gruppenchats.',
    // V: neuer Push-Trigger "Erinnerung an dein laufendes Abenteuer".
    'settings.notifications.toggle_adventure_reminder_label': 'Abenteuer-Erinnerung',
    'settings.notifications.toggle_adventure_reminder_desc': 'Ein sanfter Stups, wenn ein laufendes Abenteuer auf dich wartet.',
    'settings.notifications.toggle_adventure_ready_label': 'Abenteuer ist bereit',
    'settings.notifications.toggle_adventure_ready_desc': 'Melde dich, sobald ein neu erstelltes Abenteuer fertig vorbereitet ist.',
    'settings.notifications.toggle_first_day_nudge_label': 'Deine Geschichte wartet',
    'settings.notifications.toggle_first_day_nudge_desc': 'Ein einziger Hinweis am ersten Tag, wenn du noch keine Nachricht geschrieben hast.',
    'group_chat.members_aria': 'Mitglieder der Gruppe',
    'group_chat.members_typing': 'Die Gruppe',
    'group_chat.empty_state': 'Schreib eine Nachricht — mehrere Charaktere antworten nacheinander.',
    'group_chat.input_placeholder': 'Nachricht an die Gruppe …',
    'group_chat.cost_hint': 'Kostet je antwortendem Charakter.',
    'group_chat.mention_aria': 'Charakter erwähnen',
    'group_chat.load_error': 'Der Gruppenchat konnte nicht geladen werden.',
    'group_chat.load_error_title': 'Laden fehlgeschlagen',
    'group_chat.send_failed': 'Die Nachricht konnte nicht gesendet werden.',
    // VI.e + VI.f: Einstiege ins Gruppenchat-Feature (Kampagnen-Bürgermenü + Charaktere-Seite).
    'group_chat.new_group': 'Neue Gruppe',
    'group_chat.menu_label': 'Gruppenchat',
    'group_chat.menu_hint': 'Mehrere Charaktere antworten nacheinander.',
    // GroupChatCreateSheet (CREATE + MANAGE) + Gruppenchat-Seite — vollständige Labels.
    'group_chat.create_title': 'Neuen Gruppenchat anlegen',
    'group_chat.manage_title': 'Gruppe verwalten',
    'group_chat.name_label': 'Name',
    'group_chat.name_placeholder': 'z.B. Die Gefährten',
    'group_chat.name_required': 'Bitte gib der Gruppe einen Namen.',
    'group_chat.description_label': 'Beschreibung',
    'group_chat.description_placeholder': 'Worum geht es in dieser Gruppe? (optional)',
    'group_chat.members_label': 'Mitglieder',
    'group_chat.members_hint': 'Wähle die Charaktere, die in der Gruppe antworten sollen.',
    'group_chat.selected_count': '{count} ausgewählt',
    'group_chat.current_members': 'Aktuelle Mitglieder',
    'group_chat.add_member': 'Mitglied hinzufügen',
    'group_chat.add_member_hint': 'Weitere eigene Charaktere zur Gruppe hinzufügen:',
    'group_chat.remove_member': 'Mitglied entfernen',
    'group_chat.member_add_failed': 'Mitglied konnte nicht hinzugefügt werden.',
    'group_chat.member_remove_failed': 'Mitglied konnte nicht entfernt werden.',
    'group_chat.member_limit': 'Eine Gruppe kann höchstens {max} Mitglieder haben.',
    'group_chat.image_label': 'Gruppenbild',
    'group_chat.image_prompt_placeholder': 'Beschreibe das gewünschte Gruppenbild …',
    'group_chat.generate_image': 'Bild generieren',
    'group_chat.image_cost_hint': 'Die Bildgenerierung kostet Coins (wie ein Porträt).',
    'group_chat.image_generated': 'Gruppenbild erstellt.',
    'group_chat.image_failed': 'Das Bild konnte nicht generiert werden.',
    'group_chat.create': 'Gruppe anlegen',
    'group_chat.create_failed': 'Die Gruppe konnte nicht angelegt werden.',
    'group_chat.create_offline': 'Zum Anlegen einer Gruppe brauchst du eine Internetverbindung.',
    'group_chat.save': 'Speichern',
    'group_chat.saved': 'Gespeichert.',
    'group_chat.save_failed': 'Speichern fehlgeschlagen.',
    'group_chat.manage_offline': 'Zum Verwalten der Gruppe brauchst du eine Internetverbindung.',
    'group_chat.manage_load_error': 'Die Gruppe konnte nicht geladen werden.',
    // II.a: "Wer bist du?"-Picker im Gruppenchat-Sheet.
    'group_chat.player_label': 'Wer bist du?',
    'group_chat.player_hint': 'Wähle, als wer du in dieser Gruppe auftrittst — die Charaktere sprechen dich dann passend an.',
    'group_chat.player_self': 'Einfach ich',
    // R4-02 d: Coin-Saldo steht seit dem Entschlacken der Kopfzeile im Menü.
    'chat.menu_coins_balance': 'Coins: {balance}',
    // IV.e: "Kosmos ändern/importieren" im Kampagnen-Bürgermenü.
    'chat.menu_more_label': 'Weitere Aktionen',
    'chat.kosmos_menu_label': 'Kosmos ändern/importieren',
    'chat.kosmos_menu_hint': 'Welt-Quelle wählen und in dieses Abenteuer importieren.',
    'chat.kosmos_sheet_hint': 'Wähle den Kosmos, dessen Welt du in diesem Abenteuer nutzen möchtest.',
    'chat.kosmos_import_btn': 'Kosmos „{name}" importieren',
    'chat.kosmos_import_hint': 'Importiert die Welt-Hierarchie des Kosmos in dieses Abenteuer. Bereits vorhandene Elemente werden übersprungen.',
    'chat.kosmos_pick_first': 'Bitte wähle zuerst einen Kosmos.',
    'chat.kosmos_import_empty': 'In diesem Kosmos wurde kein Startelement gefunden.',
    'chat.kosmos_imported': '{count} Elemente importiert.',
    'chat.kosmos_import_error': 'Der Import ist fehlgeschlagen.',
    // V: Admin-Gedächtnis-Editor im Abenteuer-/Tafelrunden-Chat. Liegt jetzt in
    // der vereinheitlichten memories-Tabelle (additiv, mit [Zeitstempel]-Präfixen
    // und \n---\n-Trennern, KEIN hartes 1500-Zeichen-Limit). Wird serverseitig
    // automatisch komprimiert (soft_limit wächst um Faktor 1.2 pro Komprimierung).
    'chat.memory_hint': 'Additives KI-Gedächtnis für dieses Abenteuer (Einträge werden mit Zeitstempel versehen und mit „---" getrennt). Wird automatisch komprimiert — kein hartes Zeichenlimit. Nur sichtbar für Admins.',
    'chat.memory_counter': 'Zeichen',
    // ─── Settings / Benachrichtigungen (eigene Sub-Seite) ──────────────────
    'settings.notifications.menu_title': 'Benachrichtigungen',
    'settings.notifications.card_label': 'Benachrichtigungen',
    'settings.notifications.card_desc': 'Push, E-Mail und Test-Werkzeuge an einem Ort.',
    'settings.notifications.group_play': 'Dein Abenteuer',
    'settings.notifications.group_rewards': 'Deine Belohnungen',
    'settings.notifications.group_reminders': 'Erinnerungen',
    'settings.notifications.group_news': 'App-Neuigkeiten',
    'settings.notifications.group_email': 'E-Mail',
    'settings.notifications.group_test': 'Test-Werkzeuge (intern)',
    'settings.notifications.transactional_always_on_label': 'Wichtige Konto-Infos',
    'settings.notifications.transactional_always_on_desc': 'Sicherheits- und Service-Meldungen zu deinem Konto (Login, Käufe, Passwort). Immer aktiv.',
    'settings.notifications.transactional_always_on': 'Immer aktiv',
    'settings.notifications.email_label': 'E-Mail-Benachrichtigungen erlauben',
    'settings.notifications.email_desc': 'Newsletter, Aktionen und Umfragen. Diese Einstellung ist unabhängig vom Push-Toggle.',
    'settings.notifications.test_panel_title': 'Test-Werkzeuge (intern)',
    'settings.notifications.test_panel_hint': 'Löst den jeweiligen Push sofort an dich selbst aus (umgeht Zeitfenster/Limits). Funktioniert nur in der App mit aktivierter Berechtigung.',
    'settings.notifications.trigger_success': 'Push ausgelöst',
    'settings.notifications.trigger_failed': 'Push konnte nicht ausgelöst werden',
    // Spiegelung der Server-i18n-Keys, die fuer die neue Sub-Seite sofort
    // verfügbar sein müssen (unabhängig vom Server-Deploy-Stand).
    'settings.notifications.toggle_character_message_label': 'Ein Charakter meldet sich',
    'settings.notifications.toggle_character_message_desc': 'Charaktere, mit denen du oft schreibst, melden sich von sich aus, wenn du länger weg warst.',
    // B3 (Runde 6): Native Google/Apple-Login — Status-/Fehlertexte für die
    // Social-Login-Buttons in LoginPage + OnboardingChat. Werden lokal gespiegelt,
    // bis der Server-i18n deployt ist (gleicher Mechanismus wie andere Auth-Keys).
    'auth.social_opening': 'Browser wird geöffnet …',
    'auth.social_login_failed': 'Login fehlgeschlagen. Bitte versuche es erneut.',
    // F88 (22.10.2026): OAuth-Login trifft auf ein bestehendes Konto, das nicht automatisch verknüpft wird.
    'auth.oauth_link_login_first': 'Zu dieser E-Mail-Adresse gibt es bereits ein Lorath-Konto. Bitte melde dich zuerst wie gewohnt an (Passwort, Google oder Apple) und verknüpfe dann Google oder Apple in den Einstellungen.',
    'auth.social_login_timeout': 'Login hat zu lange gedauert. Bist du online? Versuche es bitte nochmal.',
    // K1-III: SectionErrorBoundary — dezenter Inline-Hinweis, wenn ein Teilbereich
    // der Seite (Charakter-Grid, Gruppenchat-Grid, …) einen Render-Throw fängt.
    'common.section_error': 'Dieser Bereich konnte nicht geladen werden.',
    // K1-III: RouteErrorBoundary — Hard-Reload-Button + einklappbarer Details-Block
    // mit error.message/stack (für Diagnose über Safari Web Inspector / adb logcat).
    'common.reload': 'Neu laden',
    'common.error_details': 'Details',
    'common.close': 'Schließen',
    // Ankündigungs-Banner in der Abenteuerübersicht (einzeilig, durchlaufend).
    // v7.0.1.55: Preissenkung angekündigt. Sobald live → Text auf "Preise sind gesenkt"
    // wechseln UND BANNER_ID in PromoBanner.tsx erhöhen (siehe promo_banner_live unten).
    'dashboard.promo_banner': 'Bald wird es günstiger! Wir senken die Coin-Preise – schaut regelmäßig rein und sichert euch die neuen Angebote.',
    // Bereit für später (nach der Preissenkung): diesen Text in dashboard.promo_banner
    // übernehmen und BANNER_ID hochzählen.
    'dashboard.promo_banner_live': 'Die Preise sind gesenkt! Neu: das Einstiegspaket „Funke“ – schaut in den Coin-Shop.',
    // ─── Runde 6: neue Feature-Keys (lokaler Fallback bis Server-i18n-Pipeline) ───
    // K1-II: Antwortvorschläge-Überschrift (zentriert, ohne "von").
    'chat.suggestions_heading': 'Antwortvorschläge',
    // B1: Legal-Re-Akzept-Gate — Fehlertexte.
    'legal_reaccept.status_fetch_error': 'Der rechtliche Status konnte nicht geladen werden.',
    'legal_reaccept.accept_failed': 'Akzeptieren fehlgeschlagen. Bitte versuche es erneut.',
    'legal_reaccept.postpone_failed': 'Verschieben fehlgeschlagen. Bitte versuche es erneut.',
    'legal_reaccept.postpone_blocked': 'Verschieben ist nicht mehr möglich — bitte akzeptiere die aktualisierten Dokumente.',
    'legal_reaccept.session_expired': 'Deine Sitzung ist abgelaufen.',
    'legal_reaccept.session_expired_hint': 'Melde dich erneut an, um die aktualisierten Dokumente zu bestätigen.',
    'legal_reaccept.login_again': 'Erneut anmelden',
    // B4: Flat/Abo-Status, Kündigung, Store-Verwaltung.
    'coins.flat_status_active': 'Aktive Flat: {tier}',
    'coins.flat_status_subscription': 'Abo: {tier}',
    'coins.flat_native_managed': 'Dein Abo wird über {store} verwaltet — die Kündigung ist nur dort möglich.',
    'coins.flat_native_manage_ios': 'Im App Store verwalten',
    'coins.flat_native_manage_android': 'Im {store} verwalten',
    'coins.flat_cancel_btn': 'Abo kündigen',
    'coins.flat_cancel_confirm': 'Dein Abo bleibt bis zum {expires_at} aktiv und endet dann. Jetzt kündigen?',
    'coins.flat_cancel_deadline': 'Die Kündigungsfrist ist abgelaufen — dein Abo läuft noch {hours} Std.',
    'coins.flat_cancel_error': 'Kündigung fehlgeschlagen.',
    'coins.flat_cancel_success': 'Abo gekündigt.',
    'coins.flat_subscriptions_title': 'Flat-Abos',
    'coins.flat_subscriptions_coming_soon': 'Flat-Abos (wöchentlich/monatlich) sind bald verfügbar.',
    'coins.flat_remaining_hours': 'noch {hours} Std.',
    'coins.flat_expires_at': 'bis {date}',
    'coins.flat_legacy_tier_budget': 'Budget',
    'coins.flat_legacy_tier_normal': 'Normal',
    'coins.flat_legacy_tier_premium': 'Premium',
    'coins.flat_legacy_tier_legendary': 'Legendär',
    // App Review 2.1b: Abo-Kauf-UI (Flatrate abonnieren) — nativer IAP-Kauf
    // direkt in der App sichtbar. Lokaler Fallback bis Server-i18n deployt.
    'coins.sub_title': 'Flatrate abonnieren',
    'coins.sub_weekly': 'Wöchentlich',
    'coins.sub_monthly': 'Monatlich',
    'coins.sub_tier_budget': 'Budget',
    'coins.sub_tier_normal': 'Normal',
    'coins.sub_tier_premium': 'Premium',
    'coins.sub_tier_legendary': 'Legendär',
    // v7.2.x: Nutzen der (zwei) kaufbaren Abo-Stufen in je EINEM Satz —
    // Abos stehen in der Kaufansicht oben (Lineup-Reduktion auf
    // budget + legendary, siehe server/flats.js PURCHASABLE_FLAT_TIERS).
    'coins.sub_benefit_budget': 'Unbegrenzte Nachrichten mit den schnellen Standard-Modellen.',
    'coins.sub_benefit_legendary': 'Unbegrenzte Nachrichten mit allen Modellen inklusive GPT-Standard.',
    'coins.sub_per_week': '/ Woche',
    'coins.sub_per_month': '/ Monat',
    'coins.sub_subscribe_btn': 'Abonnieren',
    'coins.sub_restore_btn': 'Käufe wiederherstellen',
    'coins.sub_renew_hint': 'Abo verlängert sich automatisch, jederzeit im Store kündbar.',
    'coins.sub_purchase_success': 'Abo aktiviert. Viel Spaß!',
    'coins.sub_restore_done': 'Käufe wiederhergestellt.',
    // W7-A: Web-Zahlwege (Abo-Abschluss im Browser, Coin-Zahlweg der Flat,
    // Spenden-Betrag). Lokaler Fallback bis der Server-i18n-Stand deployt ist —
    // die Keys liegen bereits in server/i18n/ui/{de,en}.json.
    'coins.sub_buy_stripe': 'Mit Karte abonnieren',
    'coins.sub_buy_paypal': 'Mit PayPal abonnieren',
    'coins.flat_confirm_coins_amount': '{coins} Coins für die Flat ausgeben?',
    'coins.donate_amount_label': 'Eigenen Betrag wählen ({min} – {max} €)',
    // B5: Krisen-Hilfe-Dialog.
    'help.dialog_title': 'Du bist nicht allein',
    'help.dialog_intro': 'Wenn es dir gerade nicht gut geht oder du dich unsicher fühlst, kannst du dich an eine dieser Stellen wenden. Sie sind vertraulich und kostenlos erreichbar.',
    'help.close': 'Schließen',
    'help.call_now': 'Jetzt anrufen',
    'help.visit_site': 'Website öffnen',
    'help.hours_label': 'Erreichbar:',
    'help.eu_emergency_name': 'EU-Notruf',
    'help.error': 'Wir konnten die Hilfe-Liste gerade nicht laden. Bitte versuch es später nochmal — in einer Notlage wähle direkt 112.',
    'help.disclaimer': 'Lorath ist kein Notfall- oder Beratungsdienst. Bei unmittelbarer Gefahr rufe bitte den örtlichen Notruf.',
    // Feature #36B: Freitext-Felder für nicht-menschliche Charaktere im
    // Charakter-Editor (Schuppen, Fell, Hörner, Flügel, Schwanz …). Lokaler
    // Fallback, bis der Server-i18n deployt ist.
    'character_edit.intimate.skin_tone_text': 'Haut-/Fell-/Schuppenfarbe',
    'character_edit.intimate.skin_tone_text_placeholder': 'z.B. blau-grüne Schuppen, silbernes Fell',
    'character_edit.intimate.appearance_features': 'Aussehensmerkmale',
    'character_edit.intimate.appearance_features_placeholder': 'Kopf, Gesicht, Haare und besondere Merkmale wie Hörner, Flügel, Schwanz …',
    // v7.1.0.74: Theme-Redesign — Gruppen-Labels + neue Theme-Namen als lokaler
    // Fallback (der Prod-Server hatte die Keys beim OTA 7.1.0.73 noch nicht →
    // roher Key im UI). Muss mit server/i18n/ui/de.json synchron bleiben.
    'settings.theme_group_light': 'Helle Designs',
    'settings.theme_group_dark': 'Dunkle Designs',
    'theme.light': 'Sanftes Hellgrau',
    'theme.sage': 'Zartes Grün',
    'theme.coral': 'Zartes Gelb',
    'theme.rose': 'Puderrosa',
    'theme.blue': 'Königsblau',
    'theme.fantasy': 'Dunkellila',
    'theme.dark': 'Dunkles Waldgrün',
    'theme.gray': 'Dunkles Schiefergrau',
    // M6 Kosmetik: zwei neue Themes mit strikter Tier-Gate (starlight=Ultra,
    // founders=Founders). Defense-in-Depth: der Server kennt die Keys und
    // verweigert PUT ohne passende Mitgliedschaft mit 403.
    'theme.starlight': 'Sternennacht',
    'theme.founders': 'Erstausgabe',
    // Phase 2: Planungs-Overlay im Kampagnen-Chat. Lokaler Fallback bis der
    // Server-i18n deployt ist (gleicher Mechanismus wie andere Chat-Keys).
    'chat.planning_title': 'Dein Abenteuer wird erschaffen…',
    'chat.planning_phase_material': 'Der Erzähler sichtet deine Welt…',
    'chat.planning_phase_core': 'Schmiedet Schicksale…',
    'chat.planning_phase_core_done': 'Der Kern steht…',
    'chat.planning_phase_expand': 'Erschafft Orte und Gesichter…',
    'chat.planning_phase_finish': 'Letzte Striche…',
    'chat.planning_phase_generic': 'Dein Abenteuer nimmt Gestalt an…',
    'chat.planning_retry': 'Planung erneut starten',
    'chat.planning_retry_hint': 'Die Planung dauert ungewöhnlich lange — du kannst sie neu starten.',
    'chat.planning_wait_hint': 'Die Erschaffung deines Abenteuers kann bis zu 10 Minuten dauern. Du bekommst eine Push-Benachrichtigung, sobald es bereit ist — du kannst die App also ruhig schließen.',
    'chat.planning_push_settings': 'Push-Benachrichtigungen aktiviert? Zu den Einstellungen',
    'chat.planning_input_locked': 'Erst spielbar, wenn dein Abenteuer fertig geplant ist.',
    // (P42: Gratis-Tier-Toggle/Status-Keys entfernt — Free-Modus gestrichen.)
    'settings.push.free_reply_ready': 'Gratis-Antwort fertig',
    'settings.push.free_reply_ready_hint': 'Benachrichtige mich, wenn eine eingereihte Gratis-Antwort da ist.',
    // ─── TTS / Audio-First (lokaler Fallback bis Server-i18n diese Keys liefert) ───
    'chat.tts_pause': 'Pause',
    'chat.tts_seek': 'Zu Position springen',
    'chat.audio_mode_toggle_label': 'Audio-Nachrichten',
    // ─── Feedback-Dialog (Bug-/Wunsch-Meldungen aus den Einstellungen) ─────
    // Lokaler Fallback bis der Server-i18n diese Keys ausliefert. Server-
    // Contract siehe server/feedback.js.
    'feedback.title': 'Feedback senden',
    'feedback.message_label': 'Deine Nachricht',
    'feedback.message_placeholder': 'Was ist passiert? Was sollten wir verbessern?',
    'feedback.attach_screenshot': 'Screenshot anhängen',
    'feedback.remove_screenshot': 'Entfernen',
    'feedback.send': 'Senden',
    'feedback.sending': 'Wird gesendet …',
    'feedback.sent_success': "Danke, deine Rückmeldung wurde gesendet.",
    'feedback.help_action': 'Feedback senden',
    'feedback.help_action_desc': 'Du hast einen Fehler gefunden oder eine Idee? Schreib uns — gerne mit Screenshot.',
    // Kontaktseite: direkter In-App-Meldeweg fuer eingeloggte Nutzer (die
    // Chat-Menues verlinken auf /kontakt). Oeffnet den FeedbackDialog.
    'feedback.inapp_heading': 'Aus der App melden',
    'feedback.inapp_desc': 'Du bist angemeldet: Sende deine Meldung direkt an uns — gerne mit Screenshot. Sie landet sofort in unserem Meldungseingang.',
    // ─── Live-Gespräch (Live-Audio-Neubau, lokaler Fallback bis Server-i18n deployt) ───
    'chat.live_talk_button': 'Lagerfeuer',
    'chat.live_talk_menu_label': 'Lagerfeuer',
    'chat.live_talk_menu_hint': 'Sprich live mit deinem Erzähler',
    'live_talk.confirm_title': "Lagerfeuer: Live-Gespräch starten?",
    'live_talk.confirm_body':
      '15 Coins pro Minute — abgerechnet als 1 Coin je angefangene 4 Sekunden.\n\nDie Abrechnung beginnt, sobald die Verbindung steht.\n\nDas Gespräch wird als Text im Chatverlauf gespeichert, du kannst es später jederzeit fortsetzen.',
    'live_talk.confirm_balance': 'Dein Kontostand: {balance} Coins',
    'live_talk.start': 'Starten',
    'live_talk.cancel': 'Abbrechen',
    'live_talk.connecting': 'Verbindung wird aufgebaut …',
    'live_talk.listening': 'Ich höre zu …',
    'live_talk.speaking': 'Erzähler spricht …',
    'live_talk.muted_status': 'Mikrofon aus',
    'live_talk.mute': 'Stummschalten',
    'live_talk.unmute': 'Stummschaltung aufheben',
    'live_talk.end': 'Beenden',
    'live_talk.warning_low_coins': 'Deine Coins gehen zur Neige — das Gespräch endet gleich.',
    'live_talk.ended_title': 'Lagerfeuer beendet',
    'live_talk.ended_duration': 'Dauer: {duration}',
    'live_talk.close': 'Schließen',
    'live_talk.error_connect': 'Verbindung fehlgeschlagen. Bitte versuch es später erneut.',
    'live_talk.error_unavailable': 'Das Lagerfeuer ist gerade nicht verfügbar.',
    'live_talk.error_insufficient': 'Nicht genug Coins für ein Lagerfeuer (mindestens 15).',
    'live_talk.error_session_active': 'Es läuft bereits ein Lagerfeuer auf deinem Konto.',
    'live_talk.error_mic': 'Mikrofon-Zugriff wurde verweigert. Erlaube den Zugriff in den Einstellungen deines Geräts.',
    "live_talk.error_mic_busy": "Das Mikrofon ist gerade belegt. Sind deine Bluetooth-Kopfhörer mit zwei Geräten verbunden, hält oft das andere Gerät das Mikrofon: dort kurz trennen oder die Kopfhörer nur mit diesem Gerät verbinden, dann erneut anrufen.",
    'live_talk.error_generic': 'Beim Lagerfeuer ist ein Fehler aufgetreten.',
    // ─── R3-05 (D5/D7): Verbindungsfortschritt + ehrliche Fehlertexte ───
    'live_talk.stage_audio': 'Ton wird vorbereitet …',
    'live_talk.stage_mic': 'Mikrofon wird freigegeben …',
    'live_talk.stage_session': 'Gespräch wird angemeldet …',
    'live_talk.stage_socket': 'Verbindung wird aufgebaut …',
    'live_talk.stage_voice': 'Stimme wird vorbereitet …',
    'live_talk.stage_ready': 'Bereit',
    'live_talk.connect_elapsed': '{seconds} s',
    'live_talk.connect_hint_slow': 'Das kann bis zu 35 Sekunden dauern. Du kannst jederzeit abbrechen.',
    'live_talk.error_stage': 'Abgebrochen bei: {stage}',
    'live_talk.error_audio_setup':
      'Mikrofon oder Audio-Verarbeitung konnten nicht gestartet werden. Schließe andere Apps, die dein Mikrofon benutzen, und versuch es noch einmal.',
    'live_talk.error_ws_unreachable': 'Die Sprachverbindung ist gerade nicht erreichbar. Versuch es in einem Moment noch einmal.',
    'live_talk.error_timeout': 'Der Server hat nicht rechtzeitig geantwortet. Versuch es gleich noch einmal.',
    'live_talk.error_not_openable': 'Dieses Gespräch lässt sich gerade nicht öffnen.',
    'live_talk.error_age_blocked': 'Dieses Gespräch ist für deine Altersstufe nicht freigegeben.',
    // ─── Live-Gespräch 7.1.1: Kulanz/Mikro-Hinweise, Banner, Tour, Stimmen-Einstellungen ───
    'composer.suggestions_toggle': 'Antwortvorschläge',
    'live_talk.refunded_notice':
      'Es gab wohl ein technisches Problem — deine Coins für dieses Gespräch wurden automatisch erstattet.',
    'live_talk.mic_silent_hint': 'Wir hören dich nicht — prüfe dein Mikrofon oder beende andere Audio-Apps.',
    'dashboard.live_audio_banner':
      'Der Live-Audio-Modus ist wieder da! Endlich einfach mit deinem Erzähler plaudern — ohne lästiges Tippen. Starte ihn im Chat oben neben deinen Coins.',
    'dashboard.live_audio_update_banner': 'Neu: Live-Gespräche mit deinem Erzähler! Aktualisiere die App, um mitzureden.',
    'tour.live_talk_title': 'Sprich mit deinem Erzähler',
    'tour.live_talk_body':
      'Neu: Tippe hier und plaudere live mit deinem Erzähler — ganz ohne Tippen. 15 Coins pro Minute, dein Gespräch landet als Text im Verlauf.',
    'profile.live_voice_mode': 'Erzähler und Vorlesen',
    'profile.live_voice_mode_system': 'System-Empfehlung (je Erzähler)',
    'profile.live_voice_mode_custom': 'Individuell',
    'profile.live_voice_choice': 'Deine individuelle Stimme',
    'profile.live_voice_hint':
      'Die System-Empfehlung passt zum Erzähler. Deine individuelle Wahl gilt für Erzähler und Vorlesen.',
    // ─── Live-Gespräch v3 (7.1.1.02): Gesprächs-Stile, Sprach-Wizard, Musik ───
    'live_talk.style_gespraech': 'Gespräch',
    'live_talk.style_gespraech_hint': 'Ihr redet miteinander — kurze, lebendige Runden.',
    'live_talk.style_hoerbuch': 'Hörbuch',
    'live_talk.style_hoerbuch_hint': 'Dein Erzähler erzählt ausführlich, du hörst zu und lenkst.',
    'live_talk.wizard_title': 'Dein Erzähler plant mit dir',
    'live_talk.wizard_listening': 'Erzähl einfach drauflos …',
    'live_talk.music_playing': 'Musik: {title}',
    // Wizard-eigener Kauf-Text beschreibt nur Loraths lokale Chatablage.
    // Vorübergehende Speicherung beim Sprachdienst wird im i-Dialog erklärt.
    'live_talk.wizard_confirm_body':
      "Du planst dein Abenteuer in einem gesprochenen Live-Gespräch mit deinem Erzähler.\n\n15 Coins pro Minute — abgerechnet als 1 Coin je angefangene 4 Sekunden ab Verbindungsaufbau.\n\nDein Erzähler stellt dir ein paar Fragen; am Ende wird dein Abenteuer wie gewohnt erstellt (Gratis-Kontingent oder Coins). Lorath legt für dieses Interview keinen Chatverlauf an.",
    'live_talk.style_group': 'Gesprächs-Stil',
    'campaign.voice_wizard_title': 'Erstell dein Abenteuer im Gespräch',
    'campaign.voice_wizard_desc':
      'Erzähl deinem Erzähler, worauf du Lust hast — er stellt dir ein paar Fragen und kümmert sich um den Rest.',
    'campaign.voice_wizard_price': '15 Coins pro Minute',
    'campaign.voice_wizard_confirm_hint':
      'Am Ende des Gesprächs wird dein Abenteuer wie gewohnt erstellt (Gratis-Kontingent oder Coins).',
    // ─── Live-Gespräch: Hintergrund-Call-Modus (Call-Notification/Sperrbildschirm) ───
    'live_talk.call_notification_title': 'Lagerfeuer läuft',
    'live_talk.call_notification_text': 'Tippe, um zurückzukehren.',
    'live_talk.call_notification_channel': 'Lagerfeuer',
    'live_talk.call_notification_end': 'Beenden',
    // ─── Charakter-Anruf (LiveCall-Plugin, F-C) — Bestätigungs-/Status-Texte ─────
    'live_call.button': 'Anrufen',
    'live_call.menu_label': 'Anrufen',
    'live_call.menu_hint': 'Sprich live mit deinem Charakter — wie am Telefon.',
    'live_call.confirm_title': 'Anruf starten?',
    'live_call.confirm_body': 'Du rufst deinen Charakter an und ihr sprecht live miteinander. Kosten: 15 Coins pro Minute (1 Coin je angefangene 4 Sekunden), abgerechnet ab Verbindungsaufbau.',
    'live_call.ringing': 'Klingelt …',
    'live_call.ended_title': 'Anruf beendet',
    'live_call.end': 'Auflegen',
    'live_call.notification_title': 'Anruf läuft',
    'live_call.notification_text': 'Anruf läuft — tippe, um zurückzukehren.',
    // R4-06a: Anbieter-Schalter im Anruf-Dialog (nur Tester/Admin auf Beta).
    // ─── Chat-Hintergründe v2 (Farbe/Crop/Per-Chat) + zentrale Crop-UI + Profilbild ───
    // Hint für den Menü-Eintrag in Character-Char- und Tafelrunden-Chat-Bürgermenü.
    'settings.chat_bg.menu_hint': 'Bild, Farbe oder Galerie für diesen Chat wählen.',
    'settings.chat_bg.mode_color': 'Farbe',
    'settings.chat_bg.color_hint': 'Eine ruhige Vollfarbe als Chat-Hintergrund.',
    'settings.chat_bg.color_custom': 'Eigene Farbe',
    'settings.chat_bg.summary_color': 'Farbe',
    'settings.chat_bg.invalid_color': 'Ungültige Farbe.',
    'settings.chat_bg.apply_title': 'Anwenden auf',
    'settings.chat_bg.apply_this_chat': 'Nur dieser Chat',
    'settings.chat_bg.apply_type_campaign': 'Alle Abenteuer-Chats',
    'settings.chat_bg.apply_type_character': 'Alle Charakter-Chats',
    'settings.chat_bg.apply_type_tableround': 'Alle Tafelrunden',
    'settings.chat_bg.apply_global': 'Überall',
    'settings.chat_bg.chat_not_found': 'Dieser Chat wurde nicht gefunden.',
    'settings.chat_bg.recrop_btn': 'Zuschnitt anpassen',
    'settings.chat_bg.recropped': 'Zuschnitt aktualisiert.',
    'settings.chat_bg.invalid_crop': 'Bitte mindestens einen gültigen Zuschnitt angeben.',
    'settings.chat_bg.no_original': 'Für dieses Bild ist kein Original mehr vorhanden — bitte lade es neu hoch.',
    'settings.chat_bg.scrim_title': 'Lesbarkeits-Abdunklung',
    'settings.chat_bg.scrim_hint': 'Wie stark Hintergrundbilder hinter dem Chat abgedunkelt werden.',
    'settings.chat_bg.scrim_auto': 'Automatisch',
    'settings.chat_bg.scrim_light': 'Leicht',
    'settings.chat_bg.scrim_medium': 'Mittel',
    'settings.chat_bg.scrim_strong': 'Stark',
    'settings.chat_bg.scrim_off': 'Aus',
    'settings.chat_bg.section_uploaded': 'Hochgeladen',
    'settings.chat_bg.section_ai': 'KI-generiert',
    'settings.chat_bg.ai_cost_hint': 'Kosten: {cost} Coins',
    'settings.chat_bg.prompt_ideas': 'Ideen',
    'settings.chat_bg.this_chat_active': 'Dieser Chat nutzt einen eigenen Hintergrund.',
    'media.crop.title': 'Bild zuschneiden',
    'media.crop.step_landscape': 'Querformat',
    'media.crop.step_portrait': 'Hochformat',
    'media.crop.step_square': 'Quadratisch',
    'media.crop.zoom': 'Zoom',
    'media.crop.back': 'Zurück',
    'media.crop.next': 'Weiter',
    'media.crop.apply': 'Übernehmen',
    'media.crop.cancel': 'Abbrechen',
    'media.crop.loading': 'Bild wird geladen …',
    'settings.profile.portrait_title': 'Profilbild',
    'settings.profile.portrait_hint': 'Wird quadratisch zugeschnitten und rund angezeigt.',
    'settings.profile.portrait_upload': 'Bild auswählen',
    'settings.profile.portrait_generate': 'Mit KI erstellen',
    'settings.profile.portrait_delete': 'Entfernen',
    'settings.profile.portrait_uploaded': 'Profilbild aktualisiert.',
    'settings.profile.portrait_deleted': 'Profilbild entfernt.',
    'settings.profile.portrait_delete_confirm_title': 'Profilbild entfernen?',
    'settings.profile.portrait_delete_confirm_body': 'Dein aktuelles Profilbild wird dauerhaft gelöscht.',
    // ─── Nachricht bearbeiten (Branching) + KI-Nachricht melden (2026-07-19) ───
    // Senden/Abbrechen nutzen die generischen Bestands-Keys chat.send/common.cancel.
    'chat.edit.button': 'Nachricht bearbeiten',
    'chat.edit.invalid_target': 'Diese Nachricht kann nicht mehr bearbeitet werden.',
    'chat.branch.prev': 'Vorherige Variante',
    'chat.branch.next': 'Nächste Variante',
    'chat.branch.position': 'Variante {current} von {total}',
    'chat.report.button': 'Nachricht melden',
    'chat.report.title': 'KI-Nachricht melden',
    'chat.report.body': 'Die Nachricht wird sofort mit hoher Priorität erneut von unserer KI-Moderation geprüft. Bleibt das Ergebnis unverändert, schaut sich unser Team die Nachricht persönlich an.',
    'chat.report.submit': 'Melden',
    'chat.report.success': 'Danke für deine Meldung! Die Nachricht wird jetzt erneut geprüft.',
    'chat.report.exists': 'Diese Nachricht wurde bereits gemeldet und wird geprüft.',
    'chat.report.error': 'Die Meldung konnte nicht gesendet werden. Bitte versuch es später erneut.',
    'chat.report.limit': 'Du hast dein Melde-Limit für heute erreicht. Bitte versuch es morgen erneut.',
    'character_chat.message_not_found': 'Die Nachricht wurde nicht gefunden.',
    'character_chat.not_user_message': 'Nur eigene Nachrichten können bearbeitet werden.',
    'character_chat.invalid_edit_of_ts': 'Diese Nachricht kann nicht bearbeitet werden.',
    'character_chat.no_sibling': 'Keine weitere Variante vorhanden.',
    // R2-FixN: Rueckfall, falls der Server keinen `message`-Text mitschickt.
    'character_chat.usk_hint_blocked': 'Diese Figur ist für eine höhere Altersstufe freigegeben als die, die du gerade eingestellt hast. Du kannst wieder mit ihr schreiben, sobald deine Inhaltsstufe passt.',
    // ─── Tafelrunde-Revival Block 1 (2026-07-20) ───
    'pwa.table_rounds': 'Tafelrunde',
    'settings.game_settings.card_desc': 'Erzähler · Setting · Regelkonformität',
    'dashboard.table_rounds_back_banner': 'Die Tafelrunde ist zurück! Spiel wieder gemeinsam am Tisch — mit Charakteren, NPCs und Chronist.',
    'tr.kosmos_select_label': 'Kosmos',
    'tr.kosmos_select_hint': 'Wähle den Kosmos, in dem diese Tafelrunde spielt.',
    'tr.import_campaign': 'Aus Kampagne importieren',
    'tr.campaign_import_select': 'Kampagne',
    'tr.campaign_import_loading': 'Kampagnen werden geladen …',
    'tr.campaign_import_hint': 'Übernimmt Weltbausteine, Charaktere, Erzähler, Setting, Regeln und die bisherige Geschichte der gewählten Kampagne.',
    'world.kosmos_favorite_add': '{name} als Favorit markieren',
    'world.kosmos_favorite_remove': '{name} aus Favoriten entfernen',
    'world.kosmos_favorite_hint': 'Der Favorit ist deine Standard-Vorauswahl in Kampagnen, Tafelrunden und beim Verschieben/Kopieren.',
    // ─── Tafelrunde Block 2 (Würfel/Impro/Events) ───
    'table_rounds.event_invalid_type': 'Unbekannter Ereignistyp.',
    'table_rounds.event_empty': 'Ereignis darf nicht leer sein.',
    'table_rounds.event_saved': 'Ereignis gespeichert.',
    'table_rounds.event_error': 'Ereignis konnte nicht gespeichert werden.',
    'dice.menu_label': 'Würfel',
    'dice.menu_hint': 'Echte Würfe für deine Runde',
    'dice.modal_title': 'Würfeln',
    'dice.select_die': 'Würfel wählen',
    'dice.mode_normal': 'Normal',
    'dice.mode_advantage': 'Vorteil',
    'dice.mode_disadvantage': 'Nachteil',
    'dice.modifier_label': 'Modifikator',
    'dice.roll_button': 'Würfeln',
    'dice.result_label': 'Ergebnis',
    'dice.journal_title': 'Wurf-Journal',
    'dice.journal_empty': 'Noch keine Würfe',
    'dice.crit_success': 'Kritischer Erfolg!',
    'dice.crit_fail': 'Patzer!',
    'dice.insert_to_chat': 'In Chat protokollieren',
    'dice.roll_prefix': 'Würfelwurf',
    'tr.qa_card_keep': 'Im Kosmos behalten',
    'tr.qa_card_kept': 'Gespeichert ✓',
    'tr.qa_card_keep_error': 'Konnte nicht gespeichert werden',
    'tr.qa_card_type_begegnung': 'Begegnung',
    'tr.qa_card_type_npc': 'NPC',
    'tr.qa_card_type_ort': 'Ort',
    'tr.qa_card_type_loot': 'Beute',
    'tr.qa_card_type_raetsel': 'Rätsel',
    'tr.qa_card_type_wendepunkt': 'Wendepunkt',
    // ─── Tafelrunde Block 2 Wave 2 (Cockpit/Timer/Soundboard) ───
    'tr_chat.cockpit_title': 'Sitzungs-Cockpit',
    'tr_chat.cockpit_open': 'Sitzungs-Cockpit',
    'tr_chat.cockpit_close': 'Zum Chat',
    'tr_chat.timers_title': 'Zeitmesser',
    'tr_chat.timer_add': '+ Timer',
    'tr_chat.timer_doom_clock': '+ Untergangsuhr',
    'tr_chat.timer_label': 'Bezeichnung',
    'tr_chat.timer_start': 'Starten',
    'tr_chat.timer_pause': 'Pause',
    'tr_chat.timer_reset': 'Zurücksetzen',
    'tr_chat.timer_delete': 'Löschen',
    'tr_chat.timer_none': 'Keine Timer aktiv',
    'soundboard.title': 'Klangbühne',
    'soundboard.empty': 'Keine Szenen gefunden',
    'soundboard.empty_title': "Die Klangbühne gehört zu einer Tafelrunde",
    'soundboard.empty_desc': "Erstelle oder öffne eine Tafelrunde, um hier Musik und Hintergrundklänge auszuwählen.",
    'soundboard.load_error': 'Musik konnte nicht geladen werden',
    'soundboard.call_notification_title': 'Musik läuft im Hintergrund',
    'soundboard.call_notification_text': "Lorath-Klangbühne",
    'soundboard.call_notification_channel': 'Klangbühne',
    'soundboard.call_notification_end': 'Musik stoppen',
    // S1 (18.09.2026): Mini-Leiste der Klangbuehne — laeuft app-weit weiter.
    'soundboard.now_playing': 'Läuft gerade',
    'soundboard.open': 'Klangbühne öffnen',
    'soundboard.play': 'Weiter abspielen',
    'soundboard.pause': 'Pause',
    'soundboard.stop': 'Stoppen',
    'soundboard.volume': 'Lautstärke',
    'soundboard.last_played': 'Zuletzt gespielt',
    // ─── Tafelrunde Block 3 Wave 1 (Session-Protokoll Server) ───
    'session_recordings.not_found': 'Aufnahme nicht gefunden.',
    'session_recordings.consent_required': 'Bitte bestätige zuerst die Einwilligung aller Teilnehmer.',
    'session_recordings.unsupported_format': 'Dieses Audioformat wird nicht unterstützt.',
    'session_recordings.disk_full': 'Serverspeicher aktuell voll — bitte später erneut versuchen.',
    'session_recordings.audio_expired': 'Das Original-Audio wurde nach 30 Tagen automatisch gelöscht.',
    'session_recordings.purchase_insufficient': 'Nicht genug Coins für die Auswertung.',
    'session_recordings.recording_not_ready': 'Diese Aufnahme ist noch nicht bereit.',
    'pricing_card.session_transcript.transcript.description': 'Rohes Transkript mit Sprecher-Labels',
    'pricing_card.session_transcript.protocol.description': 'Gesprächsprotokoll (setzt Transkript voraus)',
    'pricing_card.session_transcript.kosmos.description': 'Kosmos-Synchronisation (setzt Protokoll voraus)',
    // Tafelrunde Block 3 Wave 4b (Session-Protokoll UI)
    'tr_session.title': 'Session-Protokoll',
    'tr_session.intro': 'Nimm eine Sitzung auf und lass sie zu Transkript, Protokoll und Kosmos-Übernahme auswerten.',
    'tr_session.upload_button': 'Aufnahme hochladen',
    'tr_session.upload_success': 'Aufnahme hochgeladen',
    'tr_session.upload_error': 'Upload fehlgeschlagen',
    'tr_session.auto_delete_hint': 'Die Audiodatei wird nach 30 Tagen automatisch gelöscht.',
    'tr_session.consent_title': 'Einverständnis',
    'tr_session.consent_body': 'Du bestätigst, dass alle Teilnehmenden der Aufnahme dieser Sitzung zugestimmt haben. Die Audiodatei wird verschlüsselt gespeichert und nach 30 Tagen gelöscht.',
    'tr_session.consent_confirm': 'Verstanden & Datei wählen',
    'tr_session.recordings_empty': 'Noch keine Aufnahmen',
    'tr_session.recordings_empty_hint': 'Lade eine Sitzungsaufnahme hoch, um sie auszuwerten.',
    'tr_session.load_error': 'Aufnahmen konnten nicht geladen werden.',
    'tr_session.status_uploading': 'Wird hochgeladen',
    'tr_session.status_stored': 'Bereit',
    'tr_session.status_transcribing': 'Wird transkribiert',
    'tr_session.status_transcribed': 'Transkribiert',
    'tr_session.status_analyzing': 'Wird ausgewertet',
    'tr_session.status_done': 'Fertig',
    'tr_session.status_failed': 'Fehlgeschlagen',
    'tr_session.tab_recording': 'Aufnahme',
    'tr_session.tab_protocol': 'Protokoll',
    'tr_session.tab_speakers': 'Sprecher',
    'tr_session.tab_changes': 'Weltänderungen',
    'tr_session.audio_loading': 'Audio wird geladen …',
    'tr_session.audio_load_error': 'Audio konnte nicht geladen werden.',
    'tr_session.audio_expired': 'Die Audiodatei ist nicht mehr verfügbar.',
    'tr_session.purchase_kit_title': 'Auswerten',
    'tr_session.component_transcript': 'Transkript',
    'tr_session.component_transcript_hint': 'Wörtliches Gesprächsprotokoll (25 Coins/Std.)',
    'tr_session.component_protocol': 'Protokoll',
    'tr_session.component_protocol_hint': 'KI-Zusammenfassung der Sitzung (+10 Coins/Std.)',
    'tr_session.component_kosmos': 'Kosmos-Übernahme',
    'tr_session.component_kosmos_hint': 'Änderungen in deinen Kosmos übernehmen (+5 Coins/Std.)',
    'tr_session.component_owned': 'Gekauft',
    'tr_session.price_estimate': 'bis zu {coins} Coins',
    'tr_session.price_free_hint': 'Erste 60 Min gratis — endgültiger Preis nach Abzug deines Gratis-Kontingents.',
    'tr_session.purchase_button': 'Kaufen ({coins} Coins)',
    'tr_session.purchase_success': '{coins} Coins abgebucht',
    'tr_session.purchase_free': 'Kostenlos freigeschaltet',
    'tr_session.purchase_error': 'Kauf fehlgeschlagen',
    'tr_session.delete': 'Löschen',
    'tr_session.delete_title': 'Aufnahme löschen?',
    'tr_session.delete_body': 'Die Aufnahme und ihre Auswertung werden entfernt.',
    'tr_session.delete_warning_no_transcript': 'Diese Aufnahme wurde noch nicht ausgewertet. Beim Löschen geht die Audiodatei unwiderruflich verloren.',
    'tr_session.delete_success': 'Aufnahme gelöscht',
    'tr_session.delete_error': 'Löschen fehlgeschlagen',
    'tr_session.protocol_empty': 'Noch kein Protokoll',
    'tr_session.protocol_empty_hint': 'Kaufe das Protokoll, um eine Zusammenfassung zu erhalten.',
    'tr_session.speakers_empty': 'Keine Sprecher erkannt',
    'tr_session.speakers_empty_hint': 'Sobald das Transkript vorliegt, erscheinen hier die Sprecher.',
    'tr_session.speakers_intro': 'Benenne die erkannten Sprecher und weise ihnen eine Rolle zu.',
    'tr_session.speaker_name_label': 'Name',
    'tr_session.speaker_kind_unset': 'Rolle wählen',
    'tr_session.speaker_kind_dm': 'Spielleitung',
    'tr_session.speaker_kind_player': 'Spieler',
    'tr_session.speakers_confirm': 'Zuordnung bestätigen',
    'tr_session.speakers_saved': 'Sprecher gespeichert',
    'tr_session.speakers_error': 'Speichern fehlgeschlagen',
    'tr_session.changes_empty': 'Keine Weltänderungen',
    'tr_session.changes_empty_hint': 'Die Kosmos-Übernahme trägt hier ihre Änderungen ein.',
    'tr_session.changes_error': 'Änderungen konnten nicht geladen werden.',
    'tr_session.change_created': 'Neu angelegt',
    'tr_session.change_updated': 'Geändert',
    'tr_session.change_deleted': 'Entfernt',
    'tr_session.change_deleted_note': 'Dieses Element wurde entfernt.',
    'tr_session.change_no_fields': 'Keine Feldänderungen.',
    'tr_session.change_undo': 'Rückgängig',
    'tr_session.change_undo_success': 'Änderung zurückgenommen',
    'tr_session.change_undo_error': 'Rückgängig fehlgeschlagen',
    'tr_session.change_already_reverted': 'Bereits zurückgenommen',
    'tr_session.change_reverted': 'Zurückgenommen',
    'tr_session.menu_label': 'Session-Protokoll',
    'tr_session.menu_hint': 'Sitzung aufnehmen & auswerten',
    'settings.notifications.toggle_session_protocol_ready_label': 'Session-Protokoll fertig',
    'settings.notifications.toggle_session_protocol_ready_desc': 'Wenn dein Transkript oder Protokoll ausgewertet wurde.',
    // Tafelrunde Block 2 Rest (Poster/Portrait-Batch)
    'tr.session_poster_generate': 'Poster erstellen',
    'tr.session_poster_regenerate': 'Poster neu erstellen',
    'tr.session_poster_share': 'Teilen',
    'tr.session_poster_done': 'Poster erstellt',
    'tr.session_poster_error': 'Poster konnte nicht erstellt werden.',
    'tr.session_poster_no_coins': 'Nicht genug Coins für das Poster.',
    'tr.session_poster_share_error': 'Teilen fehlgeschlagen.',
    'tr.session_poster_alt': 'Poster für Session {n}',
    'tr.portraits_batch_title': 'Portrait-Paket',
    'tr.portraits_batch_hint': '{count} Charaktere/NSCs ohne Portrait. Bilder werden nacheinander erzeugt.',
    'tr.portraits_batch_start': 'Portrait-Paket erstellen ({cost} Coins)',
    'tr.portraits_batch_result': '{done} von {total} Portraits erstellt.',
    'tr.portraits_batch_skipped': '{count} intime Charaktere übersprungen.',
    'tr.portraits_batch_error': 'Portrait-Paket konnte nicht erstellt werden.',
    'tr.portraits_batch_no_coins': 'Nicht genug Coins für das Portrait-Paket.',
    // Tafelrunde Block 4: Recap-Hoerbuch
    'tr_recap.play_button': 'Was bisher geschah',
    'tr_recap.title': 'Was bisher geschah',
    'tr_recap.generating': 'Rückblick wird erzählt…',
    'tr_recap.playing': 'Läuft…',
    'tr_recap.replay': 'Erneut abspielen',
    'tr.call_npc': 'Anrufen',
    'tr.push_to_talk': 'Zum Sprechen gedrückt halten',
    // Tafelrunde Block 5: In-App-Recorder
    'tr_rec.tile': 'Aufnahme',
    'tr_rec.start': 'Aufnahme starten',
    'tr_rec.stop': 'Aufnahme beenden',
    'tr_rec.pause': 'Pause',
    'tr_rec.resume': 'Fortsetzen',
    'tr_rec.recording': 'Nimmt auf',
    'tr_rec.consent_title': 'Aufnahme starten?',
    'tr_rec.consent_body': 'Der Spielabend wird als Audio aufgenommen und hochgeladen. Hole vorher das Einverständnis aller am Tisch ein.',
    'tr_rec.consent_confirm': 'Einverstanden, aufnehmen',
    'tr_rec.error_permission': 'Kein Mikrofon-Zugriff. Erlaube den Zugriff in den Einstellungen und versuche es erneut.',
    'tr_rec.error_generic': 'Die Aufnahme konnte nicht gestartet werden.',
    'tr_rec.hint': 'Die Aufnahme läuft im Hintergrund weiter. Danach kannst du sie im Session-Protokoll auswerten.',
    'tr_rec.uploading': 'Wird hochgeladen…',
    'tr_rec.finalizing': 'Wird gespeichert…',
    'tr_rec.notification_title': 'Aufnahme läuft',
    'tr_rec.notification_text': 'Der Spielabend wird aufgenommen.',
    'tr_rec.notification_channel': 'Session-Aufnahme',
    'tr_rec.notification_end': 'Beenden',
    'tr_rec.started': 'Aufnahme gestartet.',
    'tr_rec.saved': 'Aufnahme gespeichert. Du findest sie im Session-Protokoll.',
    'tr_recap.no_coins': 'Nicht genug Coins für den Rückblick.',
    'tr_recap.error': 'Der Rückblick konnte nicht erstellt werden.',
    'tr_recap.no_history': 'Für diese Runde gibt es noch keinen Verlauf zum Zusammenfassen.',
    // ─── OpenRouter-Migration: TTS-Stufen + STT (lokaler Fallback bis Server-i18n) ───
    // R4-03b: Die sechs `profile.image_tier_krea_*`-Keys sind entfallen — die
    // Bildqualitaet ist keine Profil-Einstellung mehr, sondern wird pro Bild
    // gewaehlt (images.tier_* weiter unten).
    'stt.recording_seconds': 'Nimmt auf… {seconds}s',
    'stt.transcribing_hint': 'Deine Aufnahme wird in Text umgewandelt.',
    'ai_transparency.open': 'KI: Was passiert mit deiner Eingabe?',
    'ai_transparency.title': 'Was die KI mit deiner Eingabe macht',
    'ai_transparency.intro': 'Du nutzt hier KI. Sie erstellt aus deinen Eingaben Texte, Bilder oder Sprache. Ergebnisse können falsch sein. Prüfe wichtige Informationen selbst.',
    'ai_transparency.intro_child': 'Hier antwortet eine KI. Das ist ein Computerprogramm. Es kann sich Dinge ausdenken und Fehler machen. Damit es antworten kann, sendet Lorath deine Nachricht an ein Rechenzentrum, das die KI betreibt.',
    'ai_transparency.gate_hint': 'Mit „Bestätigen und fortfahren“ führst du die gewählte KI-Funktion aus. Mit „Abbrechen – nichts senden“ kehrst du zurück; Lorath sendet deine Eingabe nicht.',
    'ai_transparency.details': 'Wohin gehen deine Daten?',
    'ai_transparency.loading': 'Wir laden die aktuellen Datenwege …',
    'ai_transparency.load_error': 'Wir konnten die aktuellen Datenwege nicht laden. Die KI kann trotzdem Fehler machen.',
    'ai_transparency.operator_fallback': 'einen externen KI-Dienst',
    'ai_transparency.zdr_verified': 'Für diesen Weg verlangen wir von OpenRouter und dem Rechenzentrum, deine Anfrage nicht zu speichern (Zero Data Retention).',
    'ai_transparency.zdr_neutral': 'Für diesen Weg gelten die Speicherregeln des beteiligten Dienstes; eine Speicherung können wir nicht ausschließen.',
    'ai_transparency.provider_definition': 'Deine Nachricht geht über unseren Server an einen Provider. Provider sind Rechenzentren, die die KI für uns betreiben.',
    'ai_transparency.chat_target': 'Deine Antwort entsteht bei {operator}.',
    'ai_transparency.chat_fallback': 'Wenn {operator} gerade nicht erreichbar ist, übernimmt {fallbacks}.',
    'ai_transparency.chat_fallback_multiple': 'Wenn {operator} gerade nicht erreichbar ist, versuchen wir es der Reihe nach bei {fallbacks}.',
    'ai_transparency.moderation_heading': 'Sicherheitsprüfung',
    'ai_transparency.moderation_precheck': 'Ein schneller Vor-Check bei {operator} prüft deine Nachricht auf Gefahren.',
    'ai_transparency.moderation_deep_local': 'Die gründliche Prüfung läuft auf unseren eigenen Servern.',
    'ai_transparency.moderation_deep_fallback': 'Nur wenn unsere Server gerade überlastet sind, prüft {operator}.',
    'ai_transparency.moderation_no_enrichment': 'Lorath fügt dafür weder deinen Klarnamen noch persönliche Profildaten hinzu.',
    'ai_transparency.voice_mic': "Bei direkter Spracheingabe wird dein Mikrofonton während der Aufnahme an {operator} übertragen und in Text umgewandelt.",
    'ai_transparency.voice_live': 'Dein Lagerfeuer läuft über {operator}.',
    'ai_transparency.voice_storage': 'Dabei gelten die Speicherregeln der beteiligten Dienste.',
    'ai_transparency.tts_steps': 'Der Vorlesetext wird bei {preparation} vorbereitet und bei {speech} in Sprache umgewandelt.',
    'ai_transparency.tts_single': 'Der Vorlesetext wird bei {operator} in Sprache umgewandelt.',
    'ai_transparency.images': 'Dein KI-Bild entsteht bei {operator}.',
    'ai_transparency.adult': 'Die nötigen Inhalte für den 18+-Bereich werden bei {operator} verarbeitet.',
    'ai_transparency.links_heading': 'Datenschutz und Bedingungen',
    'ai_transparency.links_intro': 'Hier findest du Loraths Rechtstexte und die Regeln aller aktuell beteiligten Dienste – auch des Betreibers für den Moderations-Vor-Check.',
    'ai_transparency.external_privacy': 'Datenschutz bei {operator}',
    'ai_transparency.external_terms': 'Bedingungen bei {operator}',
    'ai_transparency.external_link': 'externer Link',
    'ai_transparency.cancel': 'Abbrechen – nichts senden',
    'ai_transparency.confirm_send': 'Bestätigen und fortfahren',
    // ─── Kontextmenü (Paket C / E4a): Rechtsklick, Long-Press, ⋯-Zwilling ───
    'ctxmenu.menu_label': 'Aktionen',
    'ctxmenu.open_chat': 'Chat öffnen',
    'ctxmenu.duplicate': 'Duplizieren',
    'ctxmenu.continue': 'Weiterspielen',
    'ctxmenu.select': 'Auswählen',
    'ctxmenu.open': 'Öffnen',
    // ─── Kommandoschicht (E4b): Palette (⌘K) + Kürzelhilfe (?) ───
    'command.open': 'Kommando-Palette öffnen',
    'command.placeholder': 'Suchen oder Kommando eingeben …',
    'command.section.commands': 'Kommandos',
    'command.section.characters': 'Charaktere',
    'command.section.world': 'Welt',
    'command.section.campaigns': 'Abenteuer',
    'command.section.rounds': "Tafelrunden",
    'command.empty': 'Keine Treffer',
    'shortcut.key.ctrl': 'Strg',
    'shortcut.key.alt': 'Alt',
    'shortcut.key.win': 'Win',
    'shortcut.title': 'Tastenkürzel',
    'shortcut.empty': 'Keine Tastenkürzel verfügbar.',
    'shortcut.group.global': 'Allgemein',
    'shortcut.group.navigation': 'Navigation',
    'shortcut.group.ansicht': 'Ansicht',
    'shortcut.group.spiel': 'Spiel',
    'shortcut.group.konto': 'Konto',
    // ─── W7-E: Erzählerwechsel, Weltenkontext, Weltbausteine lösen ───
    'narrators.load_error': 'Die Erzählerliste konnte gerade nicht geladen werden.',
    'narrators.none_available': 'Für dieses Abenteuer steht gerade kein weiterer Erzähler zur Wahl.',
    'narrators.switch_menu_hint': 'Zum Wechseln tippen',
    'chat.world_context_menu_hint': 'Weltenkontext ansehen, bearbeiten oder neu erzeugen',
    'chat.world_context_regen_free': 'Neu erzeugen kostet nichts: Der Kontext wird ohne KI aus deinen verknüpften Weltbausteinen neu zusammengesetzt.',
    'chat.world_elements_unlink_hint': 'Diese Bausteine kennt der Erzähler in diesem Abenteuer. Entfernen löst nur die Verknüpfung — der Baustein selbst bleibt in deinem Weltenbau.',
    'chat.world_element_remove': 'Verknüpfung lösen',
    'chat.world_element_remove_error': 'Der Baustein konnte gerade nicht entfernt werden.',
    'chat.world_element_remove_unsupported': 'Nur im Weltenbau lösbar',
    // ─── W7-D: Canvas-Weltenbaum ───
    'tree.view_switcher': 'Weltenbaum-Ansicht',
    'tree.view_canvas': 'Canvas',
    'tree.view_list': 'Hierarchieliste',
    'tree.canvas_toolbar': 'Canvas-Werkzeuge',
    'tree.canvas_gesture_hint': 'Ziehe Karten, um sie anzuordnen. Ziehe die freie Fläche zum Verschieben; zoome mit dem Mausrad oder zwei Fingern.',
    'tree.line_routing': 'Linienführung',
    'tree.minimap': 'Weltenbaum-Minimap',
    'tree.timeline_range_invalid': 'Das Endjahr muss größer als das Startjahr sein.',
    // ─── W7-H: Formular-Entwuerfe, Cache-Karte, Umgebungswechsel ───
    'form_draft.restore_prompt_minutes': 'Ungespeicherten Entwurf von vor {minutes} Min. wiederherstellen?',
    'form_draft.restore_prompt_hours': 'Ungespeicherten Entwurf von vor {hours} Std. wiederherstellen?',
    'settings.native.clear_cache_body': 'Löscht Zwischenspeicher und lokale Kopien auf diesem Gerät. Du bleibst angemeldet, deine Daten auf dem Server bleiben unberührt.',
    'settings.native.clear_cache_body_web': 'Löscht die im Browser gespeicherten Zwischenkopien deiner Inhalte. Du bleibst angemeldet, deine Daten auf dem Server bleiben unberührt.',
    'settings.native.clear_cache_confirm_body': 'Zwischenspeicher und lokale Kopien werden gelöscht, danach startet die App neu und lädt deine Inhalte erneut. Du bleibst angemeldet.',
    'settings.native.clear_cache_confirm_body_web': 'Die im Browser gespeicherten Zwischenkopien werden gelöscht, danach lädt die Seite neu. Du bleibst angemeldet.',
    'settings.native.clear_cache_done': 'Zwischenspeicher geleert.',
    'settings.beta.section_title': 'Umgebung',
    'settings.beta.current_label': 'Aktuelle Umgebung',
    'settings.beta.env_beta': 'Beta',
    'settings.beta.env_production': 'Produktion',
    'settings.beta.switch_desc': 'Wechselt mit deiner bestehenden Anmeldung in die andere Umgebung. Nur für Admin- und Testkonten.',
    'settings.beta.switch_to_beta': 'Zur Beta wechseln',
    'settings.beta.switch_to_production': 'Zur Produktion wechseln',
    'settings.beta.switch_error': 'Der Wechsel hat nicht geklappt.',
    // ─── R6-02: Beta-Umgebung in der nativen App (Wasserzeichen + Umschalter) ───
    // MUSS hier stehen: ein reines Frontend-OTA ohne Server-Deploy holt die
    // Uebersetzungen sonst nicht — die Produktions-App zeigte rohe Schluessel.
    'beta.watermark': 'BETA-Version',
    'beta.purchase_blocked': 'In der Beta-Umgebung sind Käufe gesperrt. Sie liefen gegen echte Zahlungsdaten, würden aber einem Testkonto gutgeschrieben. Kaufe in der Produktion.',
    'settings.beta.env_warning_intro': 'Die Beta-Umgebung ist eine getrennte Welt. Was du dort tust, bleibt dort.',
    'settings.beta.env_warning_db': 'Eigene Datenbank: deine Inhalte aus der Produktion sind dort nicht vorhanden.',
    'settings.beta.env_warning_login': 'Eigener Login: du musst dich dort neu anmelden oder ein Testkonto anlegen.',
    'settings.beta.env_warning_purchases': 'Keine Käufe: Coins und Abos sind in der Beta gesperrt.',
    'settings.beta.env_warning_data_loss': 'Daten können dort jederzeit verschwinden — die Beta wird regelmäßig neu aufgesetzt.',
    'settings.beta.activate_beta': 'Beta-Umgebung aktivieren',
    'settings.beta.return_production': 'Zur Produktion zurück',
    'settings.beta.open_beta_browser': 'Beta im Browser öffnen',
    'settings.beta.open_production_browser': 'Produktion im Browser öffnen',
    'settings.beta.switching': 'Die Umgebung wird gewechselt, die App startet gleich neu.',
    'settings.beta.activate_no_update': 'Die Beta-Umgebung bietet gerade nichts an. Entweder ist sie nicht erreichbar oder deine installierte App-Version ist zu alt.',
    'settings.beta.activate_not_native': 'Der Wechsel in der App geht nur in der installierten App. Nutze im Browser den Weg über den Link.',
    // ─── W7-F: Nutzer bearbeitet sein eigenes KI-Gedächtnis (lokaler Fallback bis Server-i18n deployt) ───
    'chat.memory_menu_hint': 'Sieh nach, was die KI sich gemerkt hat — ändern, löschen, ergänzen.',
    'chat.memory_sheet_hint': 'Die KI liest diese Einträge vor jeder Antwort. Änderungen wirken sofort.',
    'chat.memory_add_label': 'Erinnerung hinzufügen',
    'chat.memory_add_placeholder': 'Was soll sich die KI merken?',
    'chat.memory_delete_confirm': 'Diese Erinnerung löschen? Die KI weiß sie danach nicht mehr.',
    'chat.memory_conflict': 'Das Gedächtnis hat sich zwischenzeitlich geändert — die Liste wurde neu geladen.',
    'chat.memory_too_long': 'Dieser Eintrag ist zu lang.',
    'chat.memory_scope_adventure': 'Dieses Abenteuer',
    'chat.memory_scope_tableround': 'Diese Tafelrunde',
    'chat.memory_scope_user': 'Über dich',
    'chat.memory_user_hint': 'Was die KI sich über dich gemerkt hat — das gilt in allen deinen Chats.',
    'chat.memory_tableround_hint': 'Die KI-Erinnerung an den bisherigen Verlauf dieser Tafelrunde.',
    'chat.memory_scope_character': 'Was {name} von euch weiß',
    'chat.memory_character_hint':
      'Was {name} aus euren Gesprächen behalten hat — gemeinsame Erlebnisse, Verabredungen, Versprechen. Das gilt nur zwischen euch beiden.',
    // ─── W7-C: Bild-/Videoerzeugung im Chat (lokaler Fallback bis Server-i18n deployt) ───
    'chat.media_menu_label': 'Bilder und Videos',
    'chat.media_price_short': '{coins} Coins',
    'chat.media_menu_hint': 'Szene als Bild festhalten oder ein Video erzeugen — kostet Coins.',
    'chat.media_none_available': 'Für diesen Chat steht gerade keine Bild- oder Videoerzeugung bereit.',
    'chat.media_flat_covered': 'Von deiner Flatrate gedeckt',
    'chat.media_nsfw_hint': 'Nur für dieses Abenteuer freigeschaltet. Du beschreibst das Bild selbst.',
    // ─── W7-G: Verknuepfte Konten (lokaler Fallback bis Server-i18n deployt) ───
    'settings.linked_accounts.title': 'Verknüpfte Konten',
    'settings.linked_accounts.desc': 'Melde dich zusätzlich mit Google oder Apple an. Dein Passwort bleibt bestehen.',
    'settings.linked_accounts.unlink': 'Trennen',
    'settings.linked_accounts.unlink_confirm_title': 'Verknüpfung trennen?',
    'settings.linked_accounts.unlink_confirm_body': 'Du kannst dich danach nicht mehr über {provider} anmelden. Deine anderen Anmeldewege bleiben bestehen.',
    'settings.linked_accounts.unlink_blocked': 'Das ist gerade dein einziger Anmeldeweg. Setze zuerst ein Passwort oder verknüpfe den anderen Anbieter.',
    'settings.linked_accounts.unlinked': 'Verknüpfung getrennt.',
    'settings.linked_accounts.unlink_error': 'Die Verknüpfung konnte nicht getrennt werden.',
    'settings.linked_accounts.linking': 'Schließe die Anmeldung im Browser ab. Wir warten hier auf das Ergebnis.',
    'settings.linked_accounts.link_timeout': 'Die Verknüpfung hat zu lange gedauert. Bitte erneut versuchen.',
    'auth.unlink_not_linked': 'Dieses Konto ist mit diesem Anbieter nicht verknüpft.',
    'auth.unlink_last_method': 'Das ist dein einziger Anmeldeweg. Setze zuerst ein Passwort oder verknüpfe einen anderen Anbieter.',
    'auth.unlink_error': 'Die Verknüpfung konnte nicht getrennt werden.',
    // ─── W1-B: Tueren-Frontend (lokaler Fallback bis Server-i18n deployt) ───
    "onboarding.tree.start.option_create_account": "Ich möchte gleich ein Konto anlegen",
    "onboarding.tree.guest.purpose_intro": "Schön, dass du da bist! Wofür bist du hier?",
    "onboarding.tree.guest.purpose_companion": "Einen Begleiter kennenlernen",
    "onboarding.tree.guest.purpose_adventure": "Ein Abenteuer erleben",
    "onboarding.tree.guest.age_intro": "Damit ich dir passende Inhalte zeige: Wie alt bist du?",
    "onboarding.tree.guest.age_under12": "Ich bin unter 12",
    "onboarding.tree.guest.age_12to15": "Ich bin 12 bis 15",
    "onboarding.tree.guest.age_16plus": "Ich bin 16 oder älter",
    "onboarding.tree.guest.failed": "Das hat gerade nicht geklappt: {error}",
    "onboarding.tree.guest.retry": "Nochmal versuchen",
    "onboarding.tree.guest.register_instead": "Lieber gleich ein Konto anlegen",
    "onboarding.tree.guest.error_rate_limited": "Gerade sind zu viele Anläufe unterwegs. Bitte später noch einmal.",
    "onboarding.tree.guest.error_beta_restricted": "Auf dieser Testumgebung sind neue Zugänge gesperrt. Bitte melde dich mit einem bestehenden Konto an.",
    "account.secure.title": "Konto sichern",
    "account.secure.intro": "Du spielst gerade ohne Konto. Mit einem Konto bleibt alles erhalten:",
    "account.secure.reason_age": "Inhalte ab 16 Jahren freischalten",
    "account.secure.reason_sync": "Auf allen deinen Geräten weiterspielen",
    "account.secure.reason_safety": "Charaktere und Coins gegen Verlust sichern",
    "account.secure.reason_status": "Täglicher Status deiner Begleiter",
    "account.secure.username_label": "Benutzername",
    "account.secure.password_label": "Passwort",
    "account.secure.password_hint": "Mindestens 8 Zeichen.",
    "account.secure.password_confirm_label": "Passwort wiederholen",
    "account.secure.email_label": "E-Mail (freiwillig)",
    "account.secure.email_hint": "Ohne E-Mail kannst du dein Passwort nicht zurücksetzen.",
    "account.secure.terms_checkbox": "Ich stimme den Nutzungsbedingungen, den AGB und der Datenschutzerklärung zu.",
    "account.secure.terms_required": "Bitte stimme den Nutzungsbedingungen und der Datenschutzerklärung zu.",
    "account.secure.submit": "Konto sichern",
    "account.secure.success_title": "Dein Konto ist gesichert.",
    "account.secure.success_bonus": "{coins} Bonus-Coins gutgeschrieben.",
    "account.secure.social_intro": "Oder sichere dein Konto mit einem bestehenden Anbieter:",
    "account.secure.link_google": "Mit Google sichern",
    "account.secure.link_apple": "Mit Apple sichern",
    "auth.guest_logout.title": "Ohne Konto abmelden?",
    "auth.guest_logout.body": "Ohne Konto verlierst du deine Charaktere und Coins. Sie lassen sich danach nicht wiederherstellen.",
    "auth.guest_logout.secure_account": "Konto sichern",
    "auth.guest_logout.logout_anyway": "Trotzdem abmelden",
    // ─── W3-A: Wizard-Schritt 0 + Abenteuer-Tab (lokaler Fallback bis Server-i18n deployt) ───
    'campaign_new.step0.label': 'Spielart',
    'campaign_new.step0.title': 'Mit Regeln und Bogen, oder einfach eine Geschichte?',
    'campaign_new.step0.hint':
      'Das legt fest, ob dein Erzähler mit Würfeln und Proben arbeitet. Du entscheidest, wie viel Regelwerk du willst.',
    'campaign_new.step0.story_title': 'Einfach eine Geschichte',
    'campaign_new.step0.story_desc':
      'Kein Würfeln, keine Proben, kein Charakterbogen. Ihr erzählt gemeinsam — du sagst, was du tust, und es passiert.',
    'campaign_new.step0.rules_title': 'Mit Regeln und Bogen',
    'campaign_new.step0.rules_desc':
      'Würfelproben entscheiden über Erfolg und Misserfolg, und deine Spielfigur bringt eigene Werte mit.',
    'campaign_new.step0.change_later':
      'Du kannst später jederzeit ein neues Abenteuer mit der anderen Spielart beginnen.',
    'wizard.who_are_you_details': 'Im Detail',
    'dashboard.continue.empty_title': 'Dein erstes Abenteuer',
    'dashboard.continue.empty_body': 'Noch keine Geschichte begonnen. Ein paar Fragen, und du bist mittendrin.',
    'dashboard.continue.empty_btn': 'Erstes Abenteuer beginnen',
    'dashboard.tools.title': 'Werkzeuge',
    'tour.continue_title': 'Hier geht es weiter',
    'tour.continue_body':
      'Diese Kachel bringt dich mit einem Tipp zurück in dein zuletzt gespieltes Abenteuer — genau dort, wo du aufgehört hast.',
    // ─── W2-C: Begleiter-Bogen (lokaler Fallback bis Server-i18n deployt) ───
    "character_edit.sheet_companion": "Begleiter",
    "character_edit.sheet_hint_companion": "Ein Freund zum Chatten. Vier Felder, fertig.",
    "character_edit.companion_preview_hint": "Du nutzt hier KI. Sie erstellt aus deinen Eingaben Texte, Bilder oder Sprache. Ergebnisse können falsch sein. Prüfe wichtige Informationen selbst.",
    "character_edit.companion.step_who": "Wer ist dein Begleiter?",
    "character_edit.companion.step_details": "Im Detail anpassen",
    "character_edit.companion.name_placeholder": "z.B. Mira",
    "character_edit.companion.verhalten": "Verhalten",
    "character_edit.companion.verhalten_help": "Wie ist er oder sie im Gespräch?",
    "character_edit.companion.verhalten_placeholder": "z.B. hört ruhig zu, fragt nach, macht gern kleine Witze",
    "character_edit.companion.aussehen": "Aussehen",
    "character_edit.companion.aussehen_help": "Wie sieht er oder sie aus?",
    "character_edit.companion.aussehen_placeholder": "z.B. kurze dunkle Locken, warme braune Augen, eine abgewetzte Jacke",
    "character_edit.companion.eigenheiten": "Eigenheiten",
    "character_edit.companion.eigenheiten_help": "Kleine Dinge, die ihn oder sie unverwechselbar machen. Jede Zeile hat einen Würfel; weitere Zeilen kannst du hinzufügen.",
    "character_edit.companion.eigenheit_1": "Eigenheit 1",
    "character_edit.companion.eigenheit_2": "Eigenheit 2",
    "character_edit.companion.eigenheit_3": "Eigenheit 3",
    "character_edit.companion.eigenheit_placeholder": "z.B. trinkt Tee nur aus einer bestimmten Tasse",
    "character_edit.companion.quirk_suggestions.1": "sammelt an jedem Ort einen Stein",
    "character_edit.companion.quirk_suggestions.2": "summt leise beim Nachdenken",
    "character_edit.companion.quirk_suggestions.3": "vergisst ständig Namen",
    "character_edit.companion.quirk_suggestions.4": "trinkt Kaffee nur kalt",
    "character_edit.companion.quirk_suggestions.5": "redet mit Pflanzen",
    "character_edit.companion.quirk_suggestions.6": "bleibt auf jeder Brücke kurz stehen",
    "character_edit.companion.quirk_suggestions.7": "hat für alles ein Sprichwort",
    "character_edit.companion.quirk_suggestions.8": "schreibt sich alles auf kleine Zettel",
    "character_edit.companion.preview_toggle": "Vorschau aktivieren?",
    "character_edit.companion.preview_bubble_title": "So würde {name} dich begrüßen",
    "character_edit.companion.preview_needs": "Trage Name und Verhalten ein — dann zeige ich dir hier eine Begrüßung.",
    "character_edit.companion.preview_error_rate": "Kurz warten – gleich geht es weiter.",
    "character_edit.companion.preview_error_unavailable": "Vorschau gerade nicht möglich.",
    "character_edit.companion.wuerfel": "Zufällig ausfüllen",
    "character_edit.companion.wuerfel_failed": "Das hat nicht geklappt. Versuch es gleich noch einmal.",
    "character_edit.companion.preview_loading": "Wird geschrieben …",
    "character_edit.companion.first_portrait_hint": "Dein erstes Porträt entsteht gratis nach dem Speichern.",
    "character_edit.companion.details_hint": "Alles hier ist freiwillig. Was du leer lässt, denkt sich dein Begleiter selbst aus.",
    "character_edit.companion.alter": "Alter",
    "character_edit.companion.geschlechtsidentitaet": "Geschlechtsidentität",
    "character_edit.companion.groesse": "Größe",
    "character_edit.companion.gewicht": "Gewicht",
    "character_edit.companion.kleidungsstil": "Kleidungsstil",
    "character_edit.companion.vorlieben": "Vorlieben",
    "character_edit.companion.charakterzuege": "Charakterzüge",
    "character_edit.companion.beziehungsstart": "Beziehungsstart",
    "character_edit.companion.beziehungsstart_help": "Wie kennt ihr euch, wenn das erste Gespräch beginnt?",
    "character_edit.companion.kommunikation": "Kommunikation",
    "character_edit.companion.kommunikation_hint": "So schreibt dein Begleiter dir.",
    "character_edit.companion.length_label": "Länge der Nachrichten",
    "character_edit.companion.length_short": "kurz",
    "character_edit.companion.length_standard": "mittel",
    "character_edit.companion.length_long": "lang",
    "character_edit.companion.initiative_label": "Eigeninitiative",
    "character_edit.companion.initiative_low": "niedrig",
    "character_edit.companion.initiative_medium": "mittel",
    "character_edit.companion.initiative_high": "hoch",
    "character_edit.companion.style_label": "Gesprächsstil",
    "character_edit.companion.style_listen": "zuhören",
    "character_edit.companion.style_balanced": "ausgewogen",
    "character_edit.companion.style_discuss": "diskutieren",
    "character_edit.companion.verhalten_required": "Bitte beschreibe, wie dein Begleiter im Gespräch ist.",
    "character_edit.companion.aussehen_required": "Bitte beschreibe, wie dein Begleiter aussieht.",
    "character_edit.companion.eigenheiten_required": "Bitte fülle alle drei Eigenheiten aus.",
    "character_edit.companion.voice": "Stimme",
    "character_edit.companion.voice_hint": 'Diese Stimme nutzt deine Figur für Anrufe und Sprachnachrichten. Änderungen wirken beim nächsten Gespräch und neu erzeugten Nachrichten.',
    "character_edit.companion.voice_traits_label": "Eigenschaften der Stimme",
    "character_edit.companion.voice_traits_help": "Bis zu drei. Der Würfel schlägt dir welche vor; tippe auf das Kreuz, um eine zu entfernen.",
    "character_edit.companion.voice_traits_empty": "Noch keine Eigenschaft gewählt.",
    "character_edit.companion.voice_trait_remove": "{trait} entfernen",
    // ─── R3-03: Seite 2 mit Zufallsdatenbanken, Vorschau-Karte, Eigenheiten-Zeilen ───
    "character_edit.companion.preview_card_title": "Vorschau der Begrüßung",
    "character_edit.companion.preview_below": "Eine Vorschau der Begrüßung findest du ganz unten.",
    "character_edit.companion.eigenheit_n": "Eigenheit {n}",
    "character_edit.companion.quirk_add": "Zeile hinzufügen",
    "character_edit.companion.quirk_remove": "Zeile entfernen",
    "character_edit.companion.wuerfel_for": "{field} zufällig ausfüllen",
    "character_edit.companion.gender_male": "männlich",
    "character_edit.companion.gender_female": "weiblich",
    "character_edit.companion.gender_nonbinary": "nicht-binär",
    "character_edit.companion.alter_hint": "Bilder entstehen nur für erwachsene Figuren.",
    "character_edit.companion.alter_placeholder": "z.B. 34",
    "character_edit.companion.groesse_placeholder": "z.B. 173 cm",
    "character_edit.companion.gewicht_placeholder": "z.B. 68 kg",
    "character_edit.companion.kleidungsstil_placeholder": "z.B. abgewetzte Jacke, feste Stiefel",
    "character_new.badge_new": "Neu",
    "chars.sheet_companion": "Begleiter",
    // ─── W4-B: Gesprächsliste + Profil (lokaler Fallback bis der Server-i18n-Stand deployt ist) ───
    'chats.title': 'Chats',
    'chats.profile_title': 'Profil',
    'chats.search_placeholder': 'Chats durchsuchen',
    'chats.new_companion': 'Neuer Begleiter',
    'chats.manage_characters': 'Meine Charaktere verwalten',
    'chats.unnamed': 'Ohne Namen',
    'chats.no_messages_yet': 'Noch keine Nachricht',
    'chats.no_results': 'Kein Gespräch passt zu deiner Suche.',
    'chats.load_error': 'Die Gespräche konnten nicht geladen werden.',
    'chats.empty_title': 'Noch keine Chats',
    'chats.empty_body':
      'Leg dir einen Begleiter an — jemanden, mit dem du einfach schreiben kannst. Danach steht euer Gespräch hier.',
    'chats.none_selected_title': 'Kein Profil gewählt',
    'chats.none_selected_body': 'Wähle links ein Gespräch aus — oder leg dir einen neuen Begleiter an.',
    'chats.back_to_list': 'Zurück zu den Gesprächen',
    'chats.you_prefix': 'Du: {text}',
    'chats.yesterday': 'Gestern',
    'chats.unread_hint': 'Ungelesene Nachricht von {name}',
    'chats.muted_hint': '{name} ist stummgeschaltet',
    'chats.menu_open': 'Öffnen',
    'chats.menu_profile': 'Profil',
    "chats.menu_profile_named": "Profil: {name}",
    'chats.menu_call': 'Anrufen',
    'chats.menu_mute': 'Stummschalten',
    'chats.menu_unmute': 'Stummschaltung aufheben',
    // R2-09: Anpinnen in der Gespraechsliste.
    'chats.menu_pin': 'Anpinnen',
    'chats.menu_unpin': 'Lösen',
    'chats.pinned_hint': '{name} ist angepinnt',
    'chats.pin_error': 'Das Anpinnen hat nicht geklappt.',
    'chats.pin_cap': 'Du kannst höchstens {count} Gespräche anpinnen. Löse zuerst eines.',
    'chats.pin_archived': 'Archivierte Chats lassen sich nicht anpinnen.',
    'chats.badge_companion': 'Begleiter',
    'chats.gallery_title': 'Bilder',
    'chats.highlights_title': 'Highlights',
    'chats.highlights_empty': 'Noch keine Status-Bilder.',
    'chats.section_behaviour': 'Verhalten',
    'chats.section_appearance': 'Aussehen',
    'chats.section_traits': 'Charakterzüge',
    'chats.section_quirks': 'Eigenheiten',
    'chats.section_memories': 'Erinnerungen',
    'chats.memories_hint':
      'Zwei Bereiche: was diese Figur aus euren Gesprächen behalten hat, und was die KI sich über dich gemerkt hat. Du kannst beides jederzeit ändern oder löschen.',
    'chats.open_memories': 'Erinnerungen öffnen',
    'chats.action_open_chat': 'Chat öffnen',
    'chats.action_publish': 'Veröffentlichen',
    'chats.publish_soon': 'Das Veröffentlichen wird gerade eingebaut.',
    'chats.delete_blocked': 'Diese Figur hängt noch an Abenteuern. Lösche sie unter „Meine Charaktere“.',
    // ─── W6-C: Meldungen + Aufträge (lokaler Fallback bis der Server-i18n-Stand deployt ist) ───
    'proactivity.title': 'Meldungen',
    'proactivity.open': 'Meldungen einstellen',
    'proactivity.explainer': 'Lege fest, ob und wann sich diese Figur von selbst bei dir meldet.',
    'proactivity.enabled_label': 'Darf sich melden',
    'proactivity.enabled_hint': 'Aus heißt: Es kommt nur, was du selbst anstößt.',
    'proactivity.on': 'An',
    'proactivity.off': 'Aus',
    'proactivity.per_day_label': 'Wie oft am Tag',
    'proactivity.per_day_cap_hint': 'Höchstens {max}, auch wenn du mehr willst.',
    'proactivity.per_day_zero_hint': 'Bei null meldet sich niemand von selbst — geplante Aufträge laufen trotzdem.',
    'proactivity.hours_label': 'Wann',
    'proactivity.hours_default': 'Ruhezeiten der App',
    'proactivity.hours_custom': 'Eigenes Zeitfenster',
    'proactivity.hours_default_hint': 'Zwischen 22 und 9 Uhr bleibt es still; alles andere kommt tagsüber.',
    'proactivity.hours_from': 'Von',
    'proactivity.hours_to': 'Bis',
    'proactivity.hours_night_hint': 'Dann klingelt es auch um zwei Uhr.',
    'proactivity.delivery_label': 'Wo es ankommt',
    'proactivity.in_app_label': 'In der App',
    'proactivity.in_app_hint': 'Die Nachricht steht im Gespräch, wenn du es öffnest.',
    'proactivity.push_label': 'Als Benachrichtigung',
    'proactivity.push_hint': 'Dein Gerät meldet sich, sobald etwas da ist.',
    'proactivity.push_needs_in_app': 'Geht nur zusammen mit „In der App“ — sonst tippst du auf eine Meldung und findest nichts.',
    'proactivity.voice_label': 'Als Sprachnachricht',
    'proactivity.voice_hint': '1 Coin je angefangene 100 Zeichen, mindestens 2 Coins je Sprachnachricht. Reichen deine Coins nicht, bleibt die Textnachricht erhalten.',
    'proactivity.rituals_label': 'Rituale',
    'proactivity.rituals_hint': 'Wiederkehrende kleine Anlässe. Mehrfachauswahl.',
    'proactivity.ritual_riddle': 'Rätsel',
    'proactivity.ritual_evening_question': 'Abendfrage',
    'proactivity.ritual_continuation': 'Fortsetzungsgeschichte',
    'proactivity.summary_off': 'Meldet sich nicht von selbst.',
    'proactivity.summary_on': '{count} am Tag, {when}.',
    'proactivity.summary_quiet_hours': 'außerhalb der Ruhezeiten',
    'proactivity.summary_window': 'zwischen {from} und {to} Uhr',
    'proactivity.error_save': 'Die Einstellung konnte nicht gespeichert werden.',
    'proactivity.error_push_needs_in_app': 'Benachrichtigungen gehen nur zusammen mit „In der App“.',
    'schedules.title': 'Aufträge',
    'schedules.explainer': 'Geplante Nachrichten dieser Figur. Sie gelten auch außerhalb der eingestellten Meldungen.',
    'schedules.empty': 'Noch kein Auftrag.',
    'schedules.new': 'Neuer Auftrag',
    'schedules.create': 'Auftrag anlegen',
    'schedules.kind_label': 'Art',
    'schedules.kind_daily': 'Täglich',
    'schedules.kind_weekdays': 'Wochentage',
    'schedules.kind_once': 'Einmalig',
    'schedules.time_label': 'Uhrzeit',
    'schedules.date_label': 'Datum',
    'schedules.weekdays_label': 'An welchen Tagen',
    'schedules.weekdays_required': 'Wähle mindestens einen Wochentag.',
    // W8-C (MINOR 7 der Nachschau): leeres Zeitfeld VOR dem POST abfangen.
    'schedules.time_required': 'Wähle eine Uhrzeit.',
    'schedules.weekday_mon': 'Mo',
    'schedules.weekday_tue': 'Di',
    'schedules.weekday_wed': 'Mi',
    'schedules.weekday_thu': 'Do',
    'schedules.weekday_fri': 'Fr',
    'schedules.weekday_sat': 'Sa',
    'schedules.weekday_sun': 'So',
    'schedules.intent_label': 'Was soll {name} schreiben?',
    'schedules.intent_placeholder': 'z.B. mich an das Training erinnern',
    'schedules.intent_required': 'Schreib kurz, worum es gehen soll.',
    'schedules.intent_rejected': 'Dieser Auftragstext ist nicht erlaubt.',
    'schedules.price_recurring': "Wiederkehrender Auftrag: Jede zugestellte Nachricht kostet 1 Coin, solange der Auftrag aktiv ist. Du kannst ihn jederzeit pausieren oder löschen.",
    'schedules.price_once': '1 Coin jetzt.',
    'schedules.timezone_hint': 'Zeitzone: {zone}',
    'schedules.desc_daily': 'täglich {time}',
    'schedules.desc_weekdays': '{days} {time}',
    'schedules.desc_once': 'am {date} um {time}',
    'schedules.next_run': 'Nächste Nachricht: {when}',
    'schedules.state_paused': 'Pausiert',
    'schedules.state_done': 'Erledigt',
    'schedules.pause': 'Pausieren',
    'schedules.resume': 'Fortsetzen',
    'schedules.delete': 'Auftrag löschen',
    'schedules.deleted': 'Auftrag gelöscht.',
    'schedules.created': 'Auftrag angelegt.',
    'schedules.created_paid': 'Auftrag angelegt, 1 Coin abgebucht.',
    'schedules.cap_reached_client': 'Höchstens {max} Aufträge je Begleiter.',
    'schedules.insufficient_coins_client': 'Dafür reichen deine Coins nicht.',
    'schedules.date_in_past': 'Dieser Termin liegt in der Vergangenheit.',
    'schedules.invalid_timezone': 'Die Zeitzone deines Geräts konnte nicht gelesen werden.',
    'schedules.error_generic': 'Der Auftrag konnte nicht gespeichert werden.',
    'schedules.chip_label': 'Auftrag anlegen: {when}',
    'schedules.chip_dismiss': 'Vorschlag verwerfen',
    'schedules.confirm_title': 'Auftrag anlegen?',
    // ─── W5-D: Bilder, Status, Stimme (lokaler Fallback bis der Server-i18n-Stand deployt ist) ───
    "images.tabs_aria": "Bilder oder Album",
    "images.tab_images": "Bilder",
    "images.tab_album": "Album",
    "images.empty": "Noch keine Bilder.",
    "images.album_empty": "Noch keine Szenenbilder aus euren Abenteuern.",
    "images.tile_aria": "Bild öffnen",
    "images.tile_primary_aria": "Profilbild öffnen",
    "images.badge_primary": "Profilbild",
    "images.soon": "Neue Bilder sind gerade abgeschaltet. Bald wieder verfügbar.",
    "images.action_series": "Bilderreihe erzeugen ({cost} Coins)",
    "images.action_single": "Weiteres Bild ({cost} Coins)",
    "images.action_reference": "Startporträt erzeugen ({cost} Coins)",
    "images.action_primary": "Als Profilbild",
    "images.action_replace": "Ersetzen ({cost} Coins)",
    "images.reference_needed": "Erst ein Startporträt erzeugen ({cost} Coins) — daran orientieren sich alle weiteren Bilder.",
    "images.reference_hint": "Das ist das Startporträt. Es bleibt die Vorlage für alle weiteren Bilder.",
    "images.menu_title": "Bild",
    "images.confirm_pay": "Erzeugen",
    "images.series_confirm_title": "Bilderreihe erzeugen?",
    "images.series_confirm_body": "Vier neue Bilder dieser Figur für {cost} Coins. Das dauert einen Moment — du kannst weiterlesen.",
    "images.single_confirm_title": "Weiteres Bild erzeugen?",
    "images.single_confirm_body": "Ein neues Bild dieser Figur für {cost} Coins.",
    "images.reference_confirm_title": "Startporträt erzeugen?",
    "images.reference_confirm_body": "Das erste Bild dieser Figur für {cost} Coins. Alle weiteren Bilder orientieren sich daran.",
    "images.replace_confirm_title": "Bild ersetzen?",
    "images.replace_confirm_body": "Das alte Bild wird durch ein neues ersetzt. Kosten: {cost} Coins.",
    "images.delete_confirm_title": "Bild löschen?",
    "images.delete_confirm_body": "Das Bild wird endgültig entfernt.",
    "images.series_progress": "{done} von {total}",
    "images.series_done": "Die Bilderreihe ist fertig.",
    "images.series_partial": "Nicht alle Bilder sind fertig geworden. Der Rest wurde dir erstattet.",
    // ─── R3-02 (D1-09/D1-10/D1-11): Teilerfolg, Betrachter, Warten aufs Erstporträt ───
    "images.series_partial_count": "{done} von {total} Bildern erzeugt, {refund} Coins wurden erstattet.",
    "images.reference_pending": "Das erste Porträt entsteht gerade — das dauert etwa eine Minute.",
    "images.viewer_position": "{index} / {total}",
    "images.viewer_prev": "Vorheriges Bild",
    "images.viewer_next": "Nächstes Bild",
    "images.strip_prev": "Vorherige Bilder zeigen",
    "images.strip_next": "Weitere Bilder zeigen",
    "images.reference_done": "Das Startporträt ist da.",
    "images.added": "Das Bild ist da.",
    "images.replaced": "Das Bild wurde ersetzt.",
    "images.deleted": "Das Bild wurde gelöscht.",
    "images.primary_done": "Neues Profilbild gesetzt.",
    "images.not_enough_title": "Nicht genug Coins",
    "images.not_enough_body": "Dafür brauchst du {cost} Coins, du hast {balance}.",
    "images.error_generic": "Das hat nicht geklappt. Versuch es gleich noch einmal.",
    "images.error_cap": "Diese Figur hat die höchste Zahl an Bildern erreicht. Lösche erst eines.",
    "images.error_series_failed": "Die Bilderreihe konnte nicht erzeugt werden. Deine Coins sind zurück.",
    "images.error_job_running": "Für diese Figur läuft schon eine Bilderreihe.",
    "images.error_reference_protected": "Das Startporträt lässt sich nicht austauschen — es ist die Vorlage für alle weiteren Bilder.",
    "images.error_reference_in_use": "Das Startporträt lässt sich erst löschen, wenn keine weiteren erzeugten Bilder mehr da sind.",
    "images.error_reference_exists": "Diese Figur hat schon ein Startporträt.",
    "images.error_reference_unreadable": "Das Startporträt ist nicht lesbar. Erzeuge es bitte neu.",
    // ─── R4-03b: Bildstufen (Stufenwahl + Serienhaken) ───
    "images.tier_label": "Bildqualität",
    "images.tier_price": "{cost} Coins",
    "images.tier_good": "Gut",
    "images.tier_good_desc": "Schnell und günstig — für den Alltag.",
    "images.tier_premium": "Premium",
    "images.tier_premium_desc": "Wird als Standard zum Standardpreis ausgeführt.",
    "images.tier_ultra": "Ultra",
    "images.tier_ultra_desc": "Höchste Bildqualität. Kann sich nicht an einem vorhandenen Porträt orientieren.",
    "images.action_generate": "Erzeugen ({cost} Coins)",
    "images.series_toggle": "Mehrere Bilder zum Durchklicken",
    "images.series_toggle_hint": "Vier Bilder statt einem, dreifacher Preis.",
    "images.series_needs_reference": "Dafür braucht es erst ein Porträt dieser Figur.",
    "images.series_after_free_title": "Bilderreihe danach starten?",
    "images.series_after_free_body": "Das erste Porträt ist gratis und kommt gleich. Direkt danach starten vier weitere Bilder für {cost} Coins.",
    "images.series_after_free_pending": "Die Bilderreihe startet, sobald das erste Porträt da ist.",
    "status.title": "Status",
    "status.switch_label": "Täglicher Status",
    "status.price_hint": "{day} Coins pro Tag, {month} Coins im Monat, solange eingeschaltet",
    "status.explainer": "Deine Figur erzählt einmal am Tag, was sie erlebt hat — mit Bild. Du kannst das jederzeit wieder ausschalten.",
    "status.on": "An",
    "status.off": "Aus",
    "status.guest_hint": "Für den Status brauchst du ein Konto.",
    "status.guest_cta": "Konto sichern",
    "status.cap_hint": "Höchstens {max} Charaktere gleichzeitig.",
    "status.error_generic": "Der Status konnte nicht umgestellt werden.",
    "status.soon": "Der tägliche Status ist gerade abgeschaltet. Bald wieder verfügbar.",
    "status.notice_off": "Der Status wurde nach drei Tagen ohne Coins ausgeschaltet. Schalte ihn wieder ein, wenn du magst.",
    "status.highlight_expired": "Dieses Bild ist nach 90 Tagen verfallen. Die Notiz bleibt.",
    "status.highlight_aria": "Status vom {day}",
    "status.highlight_prev": "Vorheriger Tag",
    "status.highlight_next": "Nächster Tag",
    "status.highlight_position": "{index} von {total}",
    "voice.listen": "Anhören ({cost} Coins)",
    "voice.play": "Abspielen",
    "voice.pause": "Pause",
    "voice.seek": "Stelle in der Sprachnachricht wählen",
    "voice.soon": "Sprachnachrichten sind gerade abgeschaltet. Bald wieder verfügbar.",
    "voice.error_failed": "Die Sprachnachricht konnte nicht erstellt werden. Deine Coins sind zurück.",
    "voice.error_message_gone": "Diese Nachricht gibt es nicht mehr.",
    "voice.error_too_short": "Diese Nachricht ist zu kurz zum Vorlesen.",
    "publish.badge_pending": "In Prüfung",
    "publish.badge_approved": "Öffentlich",
    "publish.badge_rejected": "Abgelehnt",
    "publish.badge_withdrawn": "Zurückgezogen",
    "publish.badge_blocked": "Gesperrt",
    // W8-A-Nachzug: neue Server-Keys auch im lokalen Rueckfall.
    'publish.error_no_image': 'Diese Figur braucht mindestens ein Bild, das der Wächter prüfen kann. Erzeuge oder lade eines hoch und reiche sie danach erneut ein.',
    // ─── W8-C (Liste B + MINOR 6): Nachzug in den lokalen Rueckfall ───────────
    // Diese Keys stehen laengst in server/i18n/ui/{de,en}.json, fehlten hier
    // aber. Der lokale Rueckfall greift beim Kaltstart ohne i18n-Cache und bei
    // einem OTA-Frontend, das dem Server-Buendel voraus ist — genau dort haetten
    // die Entdecken-Karten, der Veroeffentlichen-Dialog und die Galerie sonst
    // rohe Schluessel gezeigt.
    "character_chat.age_badge_tooltip": "Stufe aus deinem Profil. Im Profil änderbar.",
    "character_chat.age_badge_age_0": "Ab 0",
    "character_chat.age_badge_age_6": "Ab 6",
    "character_chat.age_badge_age_12": "Ab 12",
    "character_chat.age_badge_age_16": "Ab 16",
    "character_chat.age_badge_age_18": "Ab 18",
    "common.cancel": "Abbrechen",
    "common.delete": "Löschen",
    "common.error": "Ein Fehler ist aufgetreten.",
    "common.loading": "Lädt...",
    "coins.insufficient": "Nicht genügend Coins.",
    "nav.coins_buy": "Coins kaufen",
    "onboarding.tree.register.terms_link_use_terms": "Nutzungsbedingungen",
    "onboarding.tree.register.terms_link_agb": "AGB",
    "onboarding.tree.register.terms_link_privacy": "Datenschutzerklärung",
    "onboarding.tree.register.terms_link_privacy_sub": "Auch kinderfreundlich formuliert",
    "discover.adopt_own": "Das ist deine eigene Figur — sie ist längst bei dir.",
    "discover.adopt_usk_blocked": "Diese Figur passt nicht zu deiner Altersstufe.",
    // ─── R2-10: Entdecken-Filterleiste (lokaler Fallback bis Server-i18n deployt) ───
    "discover.filter_usk_label": "Altersstufe",
    "discover.filter_usk_all": "Alle Stufen",
    "discover.usk_option_age_0": "Ab 0",
    "discover.usk_option_age_6": "Ab 6 und darunter",
    "discover.usk_option_age_12": "Ab 12 und darunter",
    "discover.usk_option_age_16": "Ab 16 und darunter",
    "discover.usk_option_age_18": "Ab 18 und darunter",
    "discover.usk_locked_guest_hint": "Erst mit einem Konto verfügbar.",
    "discover.usk_locked_age_hint": "Für deine Altersstufe nicht freigeschaltet.",
    "discover.usk_locked_age": "Diese Stufe ist für deine Altersstufe nicht freigeschaltet. Du kannst sie in den Einstellungen anpassen.",
    "discover.usk_locked_age_cta": "Zur Altersstufe",
    "discover.usk_locked_max": "Diese Stufe ist für dein Konto nicht freigegeben.",
    "discover.usk_locked_max_hint": "Für dein Konto nicht freigegeben.",
    "discover.filter_lang_label": "Sprache",
    "discover.filter_lang_all": "Alle Sprachen",
    "discover.filter_reset": "Filter zurücksetzen",
    // ─── R4-04: Adult-Gate der Bilderzeugung (lokaler Fallback bis Server-i18n deployt) ───
    "character_images.age_below_adult": "Für diese Figur lassen sich keine Bilder erzeugen: Der Bogen nennt ein Alter unter 18. Trage ein Alter ab 18 ein, wenn du Bilder möchtest.",
    // ─── R4-01: Zeichenzaehler an gedeckelten Formularfeldern (lokaler
    //     Fallback bis zum naechsten Server-i18n-Sammellauf) ───
    'form.char_counter': '{n}/{max}',
    'form.char_counter_label': '{n} von {max} Zeichen',
    "character_images.image_tier_invalid": "Diese Bildqualität kennen wir nicht. Wähle eine der angebotenen Stufen.",
    "character_images.image_tier_unsupported": "Diese Bildqualität kann kein Vorlagenbild verwenden — die Figur sähe darauf anders aus. Wähle für Bilder dieser Figur eine der beiden anderen Stufen.",
    // ─── R9-03: zentrale Einstellung „Erzählerstimme in Abenteuern" (neuer
    //     Kartentitel inklusive) — bis zum Pipeline-Nachlauf lokal ───
    "profile.adventure_voice": "Erzählerstimme in Abenteuern",
    "profile.adventure_voice_auto": "Automatisch (je Erzähler)",
    "profile.adventure_voice_hint": "Diese Stimme gilt im ganzen Abenteuer: beim Vorlesen, bei Sprachnachrichten des Erzählers und am Lagerfeuer. „Automatisch\" nimmt die Stimme, die zum jeweiligen Erzähler passt. Deine Figuren behalten ihre eigene Stimme.",
    "settings.media_models_title": "Ton & Stimme",
    // ─── R9-05: ergänzte Absätze der Datenschutz-Kurzfassung
    //     (Rechtsgrundlagen, Technikdaten, Sichtbarkeit, Cookies/Cache, Zahlung,
    //     Push, Stimme, Berechtigungen, Stores, Drittland, Zustimmungsnachweis,
    //     automatische Prüfung, Speicherdauer, Werbung, Support, Newsletter,
    //     Rechte) — bis zum Pipeline-Nachlauf lokal ───
  },
  en: {
    ...M5_EN_OVERRIDES,
    "ai_transparency.moderation_deep_external": "The thorough check runs at {operator}.",
    // S-30 (Fix 7.3.3.2): siehe de-Block.
    "helpbot.action_unverified": "Note: Tindra could not confirm that this change was actually carried out. Please check the result in the editor.",
    // FIX2-C/D-11: siehe de-Block.
    "intimate_videos.status_processing": "Your video is being created. This can take a few minutes.",
    "intimate_videos.status_failed": "Video creation failed. The coins were refunded.",
    // FIX2-C/N-17: siehe de-Block.
    "sync.error_persistent": "Background sync has been stuck for a while. Your data may be out of date.",
    // FIX2-C/N-19: siehe de-Block.
    "helpbot.history": "History",
    "helpbot.archive_action": "Archive",
    // W2-B (Erstkontakt, 7.4): neue und geaenderte Quelltexte fuer Sofortstart,
    // Leiste, Tour und Glossar. Stehen im Manifest scripts/i18n-pending-sources.json
    // und muessen wortgleich mit server/i18n/ui/<lang>.json sein (localOverrides.test.ts).
    "nav.more": "More",
    "more.intro": "All areas of Lorath at a glance.",
    "more.unlock_hint": "World and Table Round join the bar once you have written {count} messages of your own — or right away with “I run a game group” in the settings.",
    "more.desc.world": "Your world-building: places, peoples and characters that adventures and companions draw on.",
    "more.desc.table_rounds": "For real games at the table: Lorath keeps the log, remembers everything and plays the NPCs.",
    "more.desc.tindra": "Tindra answers your questions about Lorath.",
    "more.desc.soundboard": "Sounds and music for your game session.",
    "more.desc.milestones": "Your achievements and badges.",
    "more.desc.memory_book": "Read and manage the memories Lorath has saved for you.",
    "more.desc.spielbau": "Set the tone, setting and rules for your stories and game sessions.",
    "more.desc.coins": "Coins, packs and your membership.",
    "more.desc.settings": "Account, appearance, language and help.",
    "first_scene.adventure.title": "Choose your first story",
    "first_scene.adventure.intro": "Tap a story — it starts right away and costs nothing.",
    "first_scene.adventure.own": "Build your own story",
    "first_scene.companion.title": "Choose your first companion",
    "first_scene.companion.intro": "Tap a character and start writing right away — free of charge.",
    "first_scene.companion.own": "Build your own companion",
    "first_scene.companion.cta": "Start chatting",
    "first_scene.unavailable": "No suggestions can be loaded right now. You can still start right away:",
    "first_scene.empty": "There are no suggestions for you here right now. Just build your own:",
    "first_scene.retry": "Try again",
    "dashboard.continue.starter_body": "Pick a story — one tap and you are right in the middle of it.",
    "chats.starter_body": "Pick a companion and start writing — your chat will then appear here.",
    "settings.leads_round.title": "Game group",
    "settings.leads_round.label": "I run a game group",
    "settings.leads_round.desc": "Keeps World and Table Round in the bottom bar — for everyone who runs a group at the table.",
    "push_priming.reason.adventure_planning": "Your adventure is being prepared, this can take a few minutes. Should we let you know as soon as it is ready? Next, your device will ask for permission.",
    "world.overview_title": "Your World",
    "world.area_places_time": "Places & Time",
    "world.area_beings_culture": "Characters, Beings & Cultures",
    "world.area_custom": "Custom Areas",
    "world.areas_back": "All areas",
    "world.area_things_quests": "Things & Quests",
    "world.area_card_empty": "Nothing here yet",
    "world.area_empty": "Nothing has been added to this area yet. Choose a category and create your first element.",
    "world.cosmos_empty": "Your cosmos is still empty. Open an area and create your first element.",
    "world.areas_all_hidden": "All categories are hidden",
    "world.areas_all_hidden_body": "There is nothing to show in this cosmos right now because all categories are hidden.",
    "world.kosmos_create_hint": "A new cosmos comes with the system templates: places, peoples, beings and more. Use them or create your own elements.",
    "world.kosmos_intro": "A cosmos brings together the building blocks of your world. The system templates are included from the start, so a new cosmos is never completely empty.",
    "tree.empty_tree_hint": "No elements in this world tree yet.",
    "tree.add_element": "Add element",
    "tree.no_matching_elements": "No matching elements.",
    "tr.no_rounds_hint": "Running a real game at the table? Lorath keeps the log, remembers everything and plays the NPCs.",
    // D1 (Waechter v2.1): DSE-Nachtrag zum Waechter. Diese Keys stehen im
    // Manifest scripts/i18n-pending-sources.json und muessen deshalb hier
    // wortgleich mit server/i18n/ui/<lang>.json stehen (localOverrides.test.ts).

    // Nachtrag Schritt 2.7: diese Hoerbuch-Fehlertexte stehen im Manifest
    // (scripts/i18n-pending-sources.json), fehlten hier aber — dadurch war die
    // generierte Keyliste nicht mit den lokalen Quelltexten deckungsgleich.
    "waechter.restored.title": "Answer restored",
    "waechter.restored.body": "Our automated system flagged this answer, but a human reviewer found it to be unobjectionable. We are sorry.",
    "audiobook.error_asset_missing": "The audio file is no longer available.",
    "audiobook.error_campaign_unavailable": "This campaign cannot be used to start an audiobook.",
    "audiobook.error_generic": "The audiobook request could not be completed. Please try again.",
    "audiobook.error_insufficient_coins": "You do not have enough coins or prepaid credit for this audio chunk.",
    "audiobook.error_invalid_request": "The request is missing required fields or contains invalid values.",
    "audiobook.error_not_found": "This audiobook or chapter could not be found.",
    "audiobook.error_planning": "The audiobook plan could not be created. Please try again with a shorter request.",
    "audiobook.error_provider": "The audio provider is currently unavailable. Please try again in a moment.",
    "audiobook.error_state_conflict": "The audiobook is in a state that does not allow this action.",

    // Waechter-Eingabesperre und Fuehrung zum Fork (Schritt 2.7).
    "waechter.lock.hint": "One reply in this story was taken down by our moderation — things cannot go on from here. Write your own last message again, and the story carries on from there.",
    "waechter.lock.button": "Start again from here",
    "waechter.lock.edit_intro": "Your message is already here. Change it and send it — the story carries on from this point, and the part that was taken down falls away.",
    "waechter.lock.edit_active": "Send your edited message above — down here things only carry on after that.",
    "waechter.lock.no_anchor": "There is no message of your own here to carry on from. Please start a new conversation.",
    "waechter.lock.degraded": "The check cannot be reached right now. Wait a moment and then try again.",
    "waechter.lock.retry": "Try again",
    "waechter.lock.stale": "This story has changed — the place to carry on from is no longer there. Reload the story and you will see how it goes on.",
    // L1 (landscape split, 18 Sep 2026) — wide split controls.
    "split.resize_handle": "Adjust column width",
    "split.maximize": "Maximize detail",
    "split.restore": "Show list again",
    "waechter.lock.reload": "Reload story",
    "waechter.lock.dead_branch": "This path contains a reply that was taken down and cannot be opened any more.",

    "waechter.card.title": "Answer withheld",
    "waechter.card.body": "Our moderation AI has withheld this answer.",
    "waechter.card.reason_label": "Brief reason:",
    "waechter.card.coins_kept": "The coins for this answer remain deducted.",
    "waechter.card.appeal_hint": "You can ask a human to review this decision.",
    "waechter.card.appeal_button": "Request human review",
    "waechter.card.objection_open": "Your objection is under review.",
    "waechter.card.objection_upheld": "A human reviewer has confirmed this decision.",
    "waechter.card.appeal_error_duplicate": "An objection has already been submitted for this answer.",
    "waechter.card.appeal_error_limit": "You can submit up to five objections within 24 hours.",
    "waechter.card.wartung_title": "Review temporarily unavailable",
    "waechter.card.wartung": "Our content review cannot be reached right now. We did not create an answer and did not deduct any coins. Please try again shortly.",
    "waechter.card.retry": "Try again",
    "moderation.sor.appeal": "If you think this is a mistake, you can have the decision reviewed by a person right at the affected answer.",
    "waechter.category.csam": "Sexual content involving children",
    "waechter.category.tsam": "Sexual content involving adolescents",
    "waechter.category.rape": "Sexual violence",
    "waechter.category.porn": "Pornographic content",
    "waechter.category.bestiality": "Sexual acts involving animals",
    "waechter.category.illegal_instructions": "Instructions for illegal activities",
    "waechter.category.drugs": "Drugs",
    "waechter.category.hate": "Hate",
    "waechter.category.other": "Content review",
    "moddesk.title": "Moderation dashboard",
    "moddesk.no_access": "This page is for moderators.",
    "moddesk.confidentiality_title": "Confidentiality undertaking",
    "moddesk.error": "The moderation request could not be completed.",
    "moddesk.already_decided": "This case has already been decided.",
    "moddesk.confidentiality_body": "You only see AI replies from other people's conversations — user messages stay hidden and appear only as placeholders in the sequence. Names that occur inside an AI reply remain visible; treat them as confidential. You only decide whether the guardian was right. None of this may leave Lorath. Every request for a withheld text is logged.",
    "moddesk.confidentiality_accept": "Understood",
    "moddesk.list_empty": "No cases in this selection.",
    "moddesk.auto_badge": "Automatic case — a human must decide",
    "moddesk.source_objection": "Objection",
    "moddesk.case_context": "Context before the message",
    "moddesk.case_reason": "AI reasoning",
    "moddesk.show_text": "Show withheld text",
    "moddesk.show_text_logged": "This request will be logged.",
    "moddesk.text_unavailable": "Withheld text is no longer available",
    "moddesk.text_expires_in": "Withheld text available for {count} more days",
    "moddesk.text_expired_ab": "After expiry, only encrypted evidence may remain. The system cannot read it.",
    "moddesk.ab_retry_warning": "{count} a/b retries without a confirmed dashboard case. Check the recovery process.",
    "moddesk.decision_reason": "Reason",
    "moddesk.decision_reason_hint": "Explain the decision in 10 to 1000 characters.",
    "moddesk.decide_overturn": "Release",
    "moddesk.decide_uphold_keep": "Uphold (keep evidence)",
    "moddesk.decide_uphold_delete": "Uphold (delete evidence)",
    "moddesk.police_toggle": "Police report",
    "moddesk.police_reference": "Police reference",
    "moddesk.decided": "Decided",
    "moddesk.settings_card_title": "Moderation dashboard",
    "moddesk.settings_card_open": "Open moderation dashboard",
    "moddesk.back_settings": "Back to settings",
    "moddesk.back_list": "Back to cases",
    "moddesk.loading": "Loading …",
    "moddesk.refresh": "Refresh",
    "moddesk.filter_status": "Status",
    "moddesk.filter_category": "Category",
    "moddesk.filter_source": "Source",
    "moddesk.status_open": "Open",
    "moddesk.all": "All",
    "moddesk.previous": "Previous page",
    "moddesk.next": "Next page",
    "moddesk.open_case": "Open case {id}",
    "moddesk.role_assistant": "AI",
    "moddesk.evidence_warning": "Evidence key unavailable: no evidence is being stored. “Keep evidence” does not confirm that a copy exists.",
    "moddesk.health": "Unresolvable checks (24 h): {runs} · Open Tier-A escalations: {tier}",
    "moddesk.evidence_status": "Evidence action",
    "moddesk.followup_status": "Redelivery and compensation",
    "moddesk.history": "Audit history (last 100 events)",
    "moddesk.not_allowed": "Not allowed for this case.",
    "moddesk.police_reference_without_report": "A police reference requires a police report.",
    "moddesk.invalid_police": "Please check the police report fields.",
    "moddesk.case_not_found": "Case not found.",
    "moddesk.category.csam": "Sexualization of children",
    "moddesk.category.tsam": "Sexualization of teenagers",
    "moddesk.category.rape": "Sexual violence",
    "moddesk.category.porn": "Pornography",
    "moddesk.category.bestiality": "Sexualization of animals",
    "moddesk.category.illegal_instructions": "Instructions for crimes",
    "moddesk.category.drugs": "Drugs",
    "moddesk.category.hate": "Hate",
    "moddesk.category.unknown": "Other category",
    "moddesk.surface.character_chat": "Character chat",
    "moddesk.surface.table_round": "Table round",
    "moddesk.surface.group_chat": "Group chat",
    "moddesk.surface.tindra": "Tindra",
    "moddesk.surface.demo": "Demo",
    "moddesk.surface.campaign_planning": "Adventure planning",
    "moddesk.evidence.unknown": "No action recorded; existence unconfirmed",
    "moddesk.evidence.kept": "Retention recorded; existence unconfirmed",
    "moddesk.evidence.deleted": "Deleted",
    "moddesk.evidence.delete_pending": "Deletion pending",
    "moddesk.evidence.delete_failed": "Deletion failed",
    "moddesk.followup.pending": "Pending",
    "moddesk.followup.done": "Done",
    "moddesk.followup.failed": "Failed",
    "moddesk.event.moderation.case_text_viewed": "Withheld text requested",
    "moddesk.event.moderation.case_decided": "Case decided",
    "moddesk.event.moderation.evidence_deleted": "Evidence deleted",
    "moddesk.event.moderation.evidence_delete_failed": "Evidence deletion incomplete",
    "moddesk.category.real_person_sexual": "Sexualization of a real person",
    "moddesk.category.violence_glorification": "Glorification of violence",
    "moddesk.category.sexual_violence_glorification": "Glorification of sexual violence",
    "moddesk.category.dangerous_practice": "Dangerous instructions",
    "moddesk.category.usk_violation": "Age rating violated",
    "moddesk.category.hate_speech": "Hate speech",
    "moddesk.category.self_harm": "Self-harm",
    "moddesk.category.other_concern": "Other concern",
    "moddesk.category.csam_review": "Abuse depiction — review",
    "moddesk.category.real_person_defamation": "Defamation of a real person",
    "moddesk.category.real_world_violence": "Danger to real people",
    "moddesk.category.user_distress": "User in distress",
    "moddesk.surface.campaign": "Adventure",
    "moddesk.context_user_hidden": "[User turn — not visible]",
    "moddesk.evidence.not_found": "No evidence record found",
    "moddesk.invalid_decision": "Unknown decision.",
    "moddesk.event.moderation.case_decision_completed": "Follow-up completed",
    "moddesk.abandoned_warning": "{count} a/b retry record(s) could not be resolved and were abandoned. Those messages stay withheld, but there is no dashboard case for them.",
    "moddesk.followup_warning": "{count} decided case(s) are still waiting for evidence deletion or compensation. The retry runs every 15 minutes.",
    "live_talk.settings.title": "Audio settings",
    "live_talk.settings.music_label": "Music",
    "live_talk.settings.music_hint": "AI-generated and free to use.",
    "live_talk.settings.music_volume": "Music volume",
    "live_talk.settings.speaker_volume": "Voice volume",
    "live_talk.settings.show_costs": "Show total cost",
    "live_talk.settings.show_balance": "Show remaining coins",
    "live_talk.settings.total_coins": "Coins so far",
    "live_talk.settings.remaining_coins": "Remaining coins",
    "live_talk.endless": "Keep narrating",
    "live_talk.endless_hint": "Automatically continues the story and makes decisions until you stop or run out of coins. The usual coins per minute continue to apply.",

    // Audiobook in the frontend (package P4): start dialog, player, lock screen.
    "audiobook.menu_label": "Audiobook",
    "audiobook.menu_hint": "Listen to your adventure as a continuing narration.",
    "audiobook.dialog_title": "Start audiobook",
    "audiobook.start_title": "Audiobook",
    "audiobook.start_price": "{startCoins} coins start your audiobook, including {includedCoins} coins of audio credit.",
    "audiobook.start_price_hint": "New sections: {coinsPerThousand} coins per 1,000 characters, roughly one minute of listening. Paid sections can be re-listened to for free.",
    "audiobook.start_balance": "Current balance: {balance} coins.",
    "audiobook.start_price_loading": "Loading price …",
    "audiobook.start_voice_show": "Choose speaker voice",
    "audiobook.start_voice_hide": "Hide speaker voice",
    "audiobook.start_voice_label": "Speaker voice",
    "audiobook.start_voice_auto": "Automatic",
    "audiobook.start_begin": "Start audiobook",
    "audiobook.start_continue": "Resume audiobook",
    "audiobook.player_title": "Audiobook",
    "audiobook.player_playing": "Narrating",
    "audiobook.player_muted": "Microphone muted",
    "audiobook.player_voice_summary": "Speaker and narration follow the audiobook plan.",
    "audiobook.planning": "Preparing narration …",
    "audiobook.preparing_next": "Preparing next section …",
    "audiobook.interrupt_planning": "Applying your direction …",
    "audiobook.mute": "Mute microphone",
    "audiobook.unmute": "Unmute microphone",
    "audiobook.pause": "Pause",
    "audiobook.end": "End",
    "audiobook.paused_title": "Paused",
    "audiobook.paused_hint": "You can resume listening at any time.",
    "audiobook.resume": "Resume",
    "audiobook.ended_title": "Book finished",
    "audiobook.ended_summary": "You have finished this audiobook.",
    "audiobook.close": "Close",
    "audiobook.notification_title": "Audiobook",
    "audiobook.notification_artist": "Lorath",
    // P6: Chapter list in the player, dictation microphone, saved speaker voice.
    "audiobook.chapters_title": "Chapters",
    "audiobook.chapter_state_heard": "Already heard",
    "audiobook.chapter_state_available": "Available",
    "audiobook.chapter_state_planned": "Planned",
    "audiobook.chapter_current": "Current chapter",
    "audiobook.chapter_jump": "Jump to this chapter",
    "audiobook.chapter_jump_forward": "Next section",
    "audiobook.dictation_hint": "Speak your wish and the audiobook adapts afterwards.",
    "audiobook.dictation_listening": "Listening …",
    "audiobook.dictation_transcribing": "Transcribing …",
    "audiobook.dictation_empty": "Sorry, nothing was understood. Please speak more clearly.",
    "audiobook.dictation_unsupported": "No microphone is available here.",
    "audiobook.voice_saved_from_profile": "Taken from your last audiobook choice.",

    "admin.audio.title": "Audio operations",
    "admin.membership.title": "Membership",
    "admin.membership.tier": "Tier",
    "admin.membership.tier_plus": "Plus",
    "admin.membership.tier_ultra": "Ultra",
    "admin.membership.tier_founders": "Founders",
    "admin.membership.tier_torchbearer": "Torchbearer",
    "admin.membership.duration": "Duration",
    "admin.membership.duration_days": "Number of days",
    "admin.membership.duration_unlimited": "No end date",
    "admin.membership.days": "Days",
    "admin.membership.note": "Note",
    "admin.membership.note_placeholder": "Internal reason",
    "admin.membership.grant": "Grant membership",
    "admin.membership.revoke": "Revoke",
    "admin.membership.empty": "No memberships yet.",
    "admin.membership.loading_error": "Memberships could not be loaded.",
    "admin.membership.grant_success": "Membership granted.",
    "admin.membership.revoke_success": "Membership revoked.",
    "admin.membership.action_error": "Membership could not be changed.",
    "admin.membership.until": "until {date}",
    "admin.membership.unlimited": "no end date",
    "admin.membership.coins_granted": "{coins} period coins were credited.",
    "admin.membership.status_trial": "Trial",
    "admin.membership.status_active": "Active",
    "admin.membership.status_grace": "Grace period",
    "admin.membership.status_cancelled": "Cancelled",
    "admin.membership.status_expired": "Expired",
    "admin.membership.write_locked": "Unlock write access first",
    "admin.role_tester_deprecated": "The role \"tester\" is no longer assigned — please grant a {alternative} instead.",
    "admin.audio.load_error": "Audio operations data could not be loaded.",
    "admin.audio.month": "UTC month {month}",
    "admin.audio.estimated": "Estimated credits",
    "admin.audio.held": "Reserved credits",
    "admin.audio.remaining": "Remaining credits",
    "admin.audio.limit": "Monthly credit limit",
    "admin.audio.volumes": "Estimated equivalents: {minutes} live minutes · {characters} read-aloud characters · {seconds} seconds of speech input.",
    "admin.audio.state_ready": "Audio is enabled.",
    "admin.audio.state_warning": "At least 80% of the monthly budget has been consumed or reserved.",
    "admin.audio.state_blocked": "The monthly budget is exhausted or invalid. New audio requests are blocked.",
    "admin.audio.state_disabled": "Audio has been disabled manually.",
    "admin.audio.state_unknown": "The audio budget cannot be read. New audio requests remain blocked.",
    "admin.audio.state_calls_unconfigured": "Calls are not configured. Read aloud and speech input are running.",
    "admin.audio.privacy_counts": "Pending deletions: read aloud {tts}, speech input {stt}. Unresolved identities: {unresolved}.",
    "admin.audio.privacy_hint": "Open requests are counted after ten minutes. The nightly history scan fills the deletion queue; a completed scan does not confirm deletion. Direct realtime speech input is not covered.",
    "admin.audio.privacy_unknown": "The status of pending deletions is unavailable.",
    "admin.audio.sweep": "History scan: {state}. Last completed day: {day}. Ambiguous matches during the run: {unresolved}.",
    "admin.audio.sweep_never": "not run yet",
    "admin.audio.sweep_running": "running",
    "admin.audio.sweep_pending": "continuation pending",
    "admin.audio.sweep_failed": "incomplete",
    "admin.audio.sweep_completed": "fully scanned",
    "admin.audio.account_title": "Read-only account comparison",
    "admin.audio.account_total": "Account credits used",
    "admin.audio.account_local": "Local estimate at retrieval",
    "admin.audio.account_difference": "Difference in credits",
    "admin.audio.account_period": "Period from {from} to {to}; retrieved {checked}.",
    "admin.audio.account_hint": "Account usage also includes beta usage, other account activity and additional model costs. It is compared with the local estimate at retrieval. Differences never update the ledger or monthly budget automatically.",
    "admin.audio.account_never": "No account comparison is available yet.",
    "admin.audio.account_stale": "The displayed account comparison is stale.",
    "admin.audio.account_error": "The last account comparison failed. Any previous snapshot remains visible with this warning.",
    "admin.audio.account_unavailable": "The account comparison is unavailable.",
    'ai_transparency.voice_data': "Lorath uses a speech service in the United States. Depending on the feature, it receives your microphone audio, the text to read aloud and the relevant game context.",
    'ai_transparency.voice_account_data': "Lorath does not send your email address or user ID as account details. Personal information you say or write yourself may be included.",
    'ai_transparency.voice_browser': "This speech input uses the speech recognition provided by your browser or device. Its privacy and storage rules apply. Processing may take place on external servers.",
    'ai_transparency.voice_browser_option': "Some browsers or devices provide their own speech recognition. If you use it, their privacy and storage rules apply. Processing may take place on external servers.",
    'ai_transparency.voice_batch': "Your recording is turned into text at {operator}.",
    'ai_transparency.voice_direct_storage': "We currently cannot confirm automatic deletion at the speech service for this direct input path.",
    'ai_transparency.voice_live_storage': "The speech service is configured to automatically delete the recording and transcript after the call. Deletion may be delayed.",
    'ai_transparency.voice_live_history': "We save calls made from a chat as text in that chat. You can delete this history. Lorath does not create a chat history for adventure creation interviews.",
    'ai_transparency.voice_delete_request': "Temporary records may be created at the speech service. When we have the information needed to delete them, we request deletion after processing and retry failed attempts. We cannot promise immediate deletion or confirm it in every case.",
    "ai_transparency.confirm_understood": "Understood",
    "ai_transparency.stt_gate_intro": "You speak your message. The recording goes to a speech service in the USA and comes back as text in your input field.",
    "ai_transparency.stt_gate_price": "Cost: 1 coin per full 45 seconds of transmitted speech, at least 1 coin per recording. No coins are charged if no audio is sent.",
    "ai_transparency.stt_gate_hint": "“Understood” starts the recording. “Cancel – send nothing” takes you back; Lorath sends nothing. This notice appears only once.",
    'coins.cost_voice_input_note': 'At least 1 coin per recording once audio is submitted. No audio means no charge. Speech input through your browser’s built-in feature remains free.',
    'coins.cost_voice_input_per_minute': 'Per full minute of submitted speech',
    'coins.cost_voice_input_per_interval': 'Per full {seconds} seconds of submitted speech',
    'coins.cost_voice_input_start': 'No starting fee',
    "stt.mic_busy": "The microphone is currently in use. If your Bluetooth headphones are paired with two devices, the other device often holds the microphone: disconnect it there for a moment, or pair the headphones with this device only, then record again.",
    'stt.session_ended': 'Speech input has ended.',
    'stt.recording_invalid': 'The recording could not be processed. Please record a shorter section again.',
    'stt.result_expired': 'This recording is no longer available. Please record your speech again.',
    'stt.retry_recording': 'Try again',
    'stt.processing_retry': 'Your recording is still being processed. You can try retrieving it again shortly.',
    'coins.cost_tts_regen': 'Read aloud — generate again',
    'chat.tts_first_use': 'This audio costs {coins} coins. You can listen to existing audio again for free.',
    'chat.tts_confirm_long': 'Reading this message aloud costs {coins} coins. Continue?',
    'chat.tts_confirm_regen': 'The price depends on the number of characters and is shown before audio is created.',
    'wizard.info_audio_mode_cost': 'In addition to the text reply, audio costs 1 coin per started 100 characters, at least 2 coins. It is charged separately after the reply is complete.',
    'audio.error_processing': 'Audio is still being created. You can try retrieving it again shortly.',
    'audio.error_auto_coins': 'You do not have enough coins for audio. The text reply is kept.',
    'audio.error_quote_changed': 'This price quote is no longer current. Request the price again and confirm it.',
    'audio.auto_cost_hint': 'In addition to the text reply: 1 coin per started 100 characters, at least 2 coins. Audio is charged separately after the reply is complete. If you do not have enough coins, the text reply is kept.',
    'audio.confirm_cost': 'Read aloud {characters} characters for {coins} coins. Continue?',
    'audio.error_busy': "Audio services are busy right now. Please try again in a minute or two.",
    'audio.error_unavailable': "Audio services are currently unavailable. Please try again later.",
    "audio.error_generic": "The audio request could not be completed. Please try again.",
    "audio.error_language": "We cannot speak your language yet. You can keep chatting by text.",
    'voice.selected': 'Voice {voice}',
    'voice.speaking_style': 'Speaking style (optional)',
    'voice.sample_error': 'This sample is currently unavailable. Please try again.',
    'voice.sample_hint': 'The samples are in English so you can hear how each voice sounds. In the game, the voice speaks your language.',
    'voice.sample_listen': 'Listen',
    'voice.profile_6': 'Neutral, even',
    'voice.profile_5': 'Velvety, mysterious',
    'voice.profile_4': 'Bright, playful',
    'voice.profile_3': 'Warm, caring',
    'voice.profile_2': 'Calm, storytelling',
    'voice.profile_1': 'Deep, clear',
    'voice.no_format': '{no} – {label}',
    'voice.selection': 'Voice profile',
    'pricing_card.audio.seconds.description': '1 coin per full {seconds} seconds of transmitted speech, at least {minimum} coin once audio has been sent. No starting fee.',
    'pricing_card.audio.characters.description': '1 coin per started {characters} characters, at least {minimum} coins.',
    'coins.history_no_transactions': 'No transactions.',
    'coins.history_date': 'Date',
    'coins.history_description': 'Description',
    'coins.history_amount': 'Amount',
    'coins.history_balance': 'Balance',
    'coins.history_load_error': 'Could not load transaction history.',
    'coins.history_live_call': 'Campfire · {duration}',
    // W2c: Vollstaendige Zaehlerphrase fuer die Auswahl per CLDR-Kategorie.
    'world.overview_elements.one': '{count} element',
    'world.overview_elements.other': '{count} elements',
    // ─── E5c (P25): worldbuilding split empty-state (local fallback until server i18n) ───
    'world.none_selected_title': 'No world element selected',
    'world.none_selected_body': 'Pick an element on the left — or create a new one.',
    // ─── Cosmos container + worldbuilding re-cut (local fallback until server i18n deploys) ───
    'world.group_kosmos': 'Geography',
    'world.group_wesen': 'Living Beings',
    'world.group_zeit': 'Time & Planes',
    'world.group_kultur': 'Culture & Society',
    'world.group_regeln': 'Rules & Systems',
    'world.group_abenteuer': 'Adventure',
    'world.type_multiversum': 'Multiverses',
    'world.type_single_multiversum': 'Multiverse',
    'chat.element_type_multiversum': 'Multiverse',
    // VI: world element TYPE "world" → "Planet" (internal key stays 'world').
    'world.type_world': 'Planets',
    'world.type_single_world': 'Planet',
    'chat.element_type_world': 'Planet',
    'coins.cost_wb_world': 'Planet',
    'coins.fq_worlds': 'Planets',
    'world.kosmos_switch': 'Switch cosmos',
    'world.kosmos_active': 'Active cosmos',
    'world.kosmos_new': 'New cosmos',
    'world.kosmos_new_title': 'Create a new cosmos',
    'world.kosmos_name_label': 'Name',
    'world.kosmos_name_placeholder': 'e.g. Fantasy, SciFi …',
    'world.kosmos_create': 'Create',
    'world.kosmos_rename': 'Rename cosmos',
    'world.kosmos_delete': 'Delete cosmos',
    'world.kosmos_delete_confirm': 'Really delete this cosmos and ALL world elements inside it? This cannot be undone.',
    'world.kosmos_last': "You can't delete your last cosmos.",
    'world.kosmos_offline_hint': 'Creating, renaming and deleting require an internet connection.',
    // Task VIII: move/copy a world element between cosmos.
    'world.move_copy_kosmos': 'Move/copy to cosmos',
    'world.move_copy_title': 'Move or copy to another cosmos',
    'world.move_to_kosmos': 'Move',
    'world.copy_to_kosmos': 'Copy',
    'world.move_copy_choose_target': 'Choose target cosmos',
    'world.moved_to_kosmos': 'Moved.',
    'world.copied_to_kosmos': 'Copied.',
    'world.move_copy_invalid_target': 'Please pick a valid target cosmos.',
    'world.kosmos_not_found': 'Cosmos not found.',
    'world.move_copy_error': 'Error moving/copying.',
    // Generischer Toast-Fallback statt roher Server-Meldungen.
    'general.request_failed': "The request failed. Please try again.",
    'group_chat.not_found': 'This group chat could not be found.',
    'tindra.welcome_text': 'I am Tindra, your assistant for worldbuilding and campaign ideas. I can analyze your world, create NPCs, prepare campaigns, and turn loose notes into playable lore.',
    'app.content_setup_title': 'Loading your world',
    'app.content_setup_hint': 'All your content is downloaded so you can view your worlds, cosmos and characters without internet. Playing with the AI still needs a connection.',
    // Web variant of the same hint: no offline promise in the browser (no service
    // worker, app.lorath.eu simply does not load without a connection, and the
    // browser may evict the storage at any time).
    'app.content_setup_hint_web': 'Your content is loading. This only takes a moment.',
    // Honest error view after several failed attempts (server error, blocked or
    // broken browser storage) instead of a bar that never arrives. "Continue
    // without offline mode" only exists on the web.
    'app.content_setup_error_title': 'Your content could not be loaded',
    'app.content_setup_error_text': 'The server is unreachable right now, or your browser does not allow local storage (blocked cookies or private mode, for example).',
    'app.content_setup_error_reload': 'Reload',
    'app.content_setup_error_continue': 'Continue without offline mode',
    // Always-visible escape while loading (CRIT 6): the download keeps running in
    // the background, only the full-screen overlay disappears.
    'app.content_setup_skip': 'Skip',
    // 404 page (catch-all route). EN is the fallback map for all other languages.
    'app.not_found_title': 'Page not found',
    'app.not_found_text': 'This address does not exist (any more). Maybe there is a typo, or the link is outdated.',
    'app.not_found_home': 'Go to dashboard',
    'app.not_found_back': 'Back',
    // Cookie/consent banner (web only). Strict opt-in for ALL visitors —
    // guests and logged-in users alike (P15): our own analytics and Google Ads
    // start only after explicit consent, never on the basis of the accepted
    // terms. EN is the fallback map for every language other than de.
    'cookie.title': 'Cookie notice',
    'cookie.text': 'We use our own privacy-friendly analytics as well as Google Ads. With your consent, anonymous usage data is collected. Details are in our',
    'cookie.privacy_link': 'privacy policy',
    'cookie.accept': 'Accept',
    'cookie.reject': 'Reject',
    // OTA bundle update (background app update). The app.content_setup_tip_*
    // lines are reused for the bundle phase.
    'app.ota_bundle_title': 'Installing update',
    'app.ota_downloading': 'Downloading the new version …',
    'app.ota_preparing': 'Preparing the update …',
    // F-007: offline/network hint on login (TODO: move into server i18n source).
    'onboarding.tree.login.offline': "I can't reach the server right now. Are you online? Check your connection and try again.",
    // First-launch gate: file size ({done}/{total} MB) + waiting-for-connection + rotating tips.
    'app.content_setup_size': '{done} / {total} MB',
    'app.content_setup_waiting': 'Waiting for an internet connection…',
    'app.content_setup_tip_1': 'Tip: Create your own cosmos and build your world from scratch.',
    'app.content_setup_tip_2': 'Tip: Link places, characters and powers into a living web of relationships.',
    'app.content_setup_tip_3': 'Tip: Start an adventure and experience your world in play.',
    'app.content_setup_tip_4': 'Tip: Four example cosmos — Reality, Fantasy, Sci-Fi and Post-Apocalypse — are waiting for you.',
    'app.content_setup_tip_5': 'Tip: Every world element can have its own portrait image.',
    'app.content_setup_tip_6': 'Tip: You can move or copy elements between your cosmos.',
    'app.content_setup_tip_7': 'Tip: From the multiverse down to the smallest place — everything connects.',
    'app.content_setup_tip_8': 'Tip: Once loaded you can view your worlds and characters without internet — playing with the AI needs a connection.',
    // First-launch bootstrap ETA: {s} = rounded seconds, {percent} = current percent.
    'app.content_setup_eta': 'about {s}s left',
    'app.content_setup_progress_label': 'Progress: {percent}%',
    // V: relationships editor — "add" button (other rel_* labels come from server i18n).
    'world_edit.rel_add': 'Add relationship',
    // Feedbackrunde 5, IV: keep the Tindra input single-line until server i18n ships.
    'tindra.input_placeholder': 'Message to Tindra…',
    'tindra.coins_charged': '{coins} coins charged',
    // 6.1 version-aware release banner (7.1.0).
    'dashboard.release_banner_7_1': 'New in 7.1.0: smoother chats, visible coin costs, more reliable purchases and many world-building improvements. Enjoy exploring!',
    'dashboard.update_banner_7_1': 'Version 7.1.0 is here — update in the store now for all the latest improvements.',
    // A2: proactive push setting.
    'settings.notifications.toggle_proactive_label': 'Ask for push after login',
    'settings.notifications.toggle_proactive_desc': 'Actively shows the permission dialog. Off: push is only requested when you enable an option above.',
    'startup.push.title': 'Enable notifications?',
    'startup.push.body': 'Lorath can tell you when adventures, replies or rewards are ready. Next, your device will ask for permission.',
    'startup.push.later': 'Not now',
    'startup.push.allow': 'Continue',
    // W7-B (E12): reason copy for push priming (replaces startup.push.body).
    'push_priming.reason.companion': 'Your companion just wrote to you. Should we let you know when they get in touch again? Next, your device will ask for permission.',
    'push_priming.reason.adventure': 'Your adventure is ready. Should we let you know as soon as the next one is? Next, your device will ask for permission.',
    // W7-B (E11): cross-onboarding — one nudge towards the other door.
    'cross_onboarding.companion_title': 'A companion as well?',
    'cross_onboarding.companion_body': 'Would you like to create a companion of your own too? A character who writes to you and stays in conversation.',
    'cross_onboarding.adventure_title': 'An adventure as well?',
    'cross_onboarding.adventure_body': 'Would you like to go on adventures with your companion, too?',
    'cross_onboarding.adventure_body_named': 'Would you like to go on adventures with {name}, too?',
    'cross_onboarding.accept': 'Yes, show me',
    'cross_onboarding.decline': 'No thanks',
    // Feedbackrunde 5, III: native review button labels (local fallback).
    'app_review.q1_title': 'Do you like Lorath?',
    'app_review.btn_rate_generic': 'Rate now',
    // Phase 5: native in-app purchase toasts (local fallback until server i18n ships).
    'coins.iap_processing': 'Processing purchase…',
    'coins.iap_success': 'Coins added!',
    'coins.iap_failed': 'Purchase failed. Please try again.',
    'coins.iap_cancelled': 'Purchase cancelled.',
    'coins.iap_unavailable': 'Purchases are not available on this device.',
    // Bug 2: Tindra navigation button labels (local fallback until server i18n ships).
    'tindra.nav_dashboard': 'Open dashboard',
    'tindra.nav_characters': 'Open characters',
    'tindra.nav_world': 'Open worlds',
    'tindra.nav_coins': 'Open coins',
    'tindra.nav_settings': 'Open settings',
    // E2/Rail navigation (local fallback until server i18n ships).
    'nav.soundboard': 'Soundboard',
    'nav.rail_toggle': 'Toggle sidebar',
    // W1-C ("two doors"): new Chats + Discover tabs, "home tab" settings card.
    'nav.chats': 'Chats',
    'nav.discover': 'Discover',
    'settings.favorite_tab.title': 'Home tab',
    'settings.favorite_tab.desc': 'Choose which area opens when you start the app.',
    'settings.favorite_tab.chats': 'Chats',
    'settings.favorite_tab.adventures': 'Adventures',
    'settings.favorite_tab.discover': 'Discover',
    'discover.coming_soon': 'Soon you will find characters here that others share with the community.',
    // W4-C: Discover tab (list/detail/report) + publish dialog.
    'discover.none_selected_body': 'Pick a character on the left to read their sheet.',
    'discover.search_placeholder': 'Search by name',
    'discover.kind_label': 'Type',
    'discover.kind_all': 'All',
    'discover.kind_companion': 'Companions',
    'discover.kind_adventure': 'Adventures',
    'discover.setting_label': 'World',
    'discover.setting_all': 'All worlds',
    'discover.setting_alltag': 'Everyday',
    'discover.setting_fantasy': 'Fantasy',
    'discover.setting_scifi': 'Sci-fi',
    'discover.setting_postapokalypse': 'Post-apocalypse',
    'discover.setting_cyberpunk': 'Cyberpunk',
    'discover.setting_historisch': 'Historical',
    'discover.setting_krimi': 'Crime',
    'discover.load_more': 'Load more',
    'discover.load_error': 'The list could not be loaded. Please try again later.',
    'discover.empty_title': 'Nothing to discover yet',
    'discover.empty_body': 'Characters that others share with the community will appear here.',
    'discover.empty_filtered_title': 'No matches',
    'discover.empty_filtered_body': 'Nothing fits this selection right now. Remove a filter or change your search.',
    'discover.portraits': 'Pictures',
    'discover.portrait_n': 'Picture {n}',
    'discover.by_creator': 'By {name}',
    'discover.highlights': 'Moments',
    'discover.highlight_day': 'Day {n}',
    'discover.highlight_day_unknown': 'No date',
    'discover.section_behaviour': 'Behaviour',
    'discover.section_appearance': 'Appearance',
    'discover.section_quirks': 'Quirks',
    'discover.section_personality': 'Personality',
    'discover.section_backstory': 'Background',
    'discover.adopt': 'Add to my characters',
    'discover.adopted': 'The character is yours now and waiting in the chat.',
    'discover.adopt_error': 'The character could not be added. Please try again later.',
    'discover.not_found_title': 'Not found',
    'discover.not_found_body': 'This publication no longer exists, or it is not available for you.',
    'discover.back_to_list': 'Back to list',
    'discover.report': 'Report',
    'discover.report_title': 'Report this publication',
    'discover.report_body': 'The guardian checks the character again. If the result stays the same, a person from the team takes a look.',
    'discover.report_reason_label': 'What is this about?',
    'discover.report_reason_real_person': 'Depicts a real person',
    'discover.report_reason_sexual_content': 'Sexual content',
    'discover.report_reason_violence': 'Violence',
    'discover.report_reason_hate': 'Hate or degradation',
    'discover.report_reason_illegal': 'Prohibited content',
    'discover.report_reason_other': 'Something else',
    'discover.report_note_label': 'Note (optional)',
    'discover.report_note_placeholder': 'What did you notice?',
    'discover.report_submit': 'Send report',
    'discover.report_sent': 'Thank you — your report has been received.',
    'discover.report_error': 'The report could not be sent.',
    'discover.report_limit': 'You have already sent many reports today. Please try again tomorrow.',
    'discover.report_exists': 'You have already reported this character.',
    'publish.title': 'Publish character',
    'publish.submit': 'Submit for review',
    'publish.submitted': 'Your character has been submitted. The guardian is checking it now.',
    'publish.withdraw': 'Withdraw',
    'publish.withdrawn_done': 'The character is no longer public.',
    'publish.creator_label': 'Creator credit',
    'publish.creator_default': 'A member of the community',
    'publish.creator_hint': 'Free text, up to 40 characters. The guardian checks it too. Your username is never shown.',
    'publish.usk_label': 'Age level',
    'publish.usk_hint': 'You can choose at most your own level.',
    'publish.images_pending.one': 'One picture is still being checked.',
    'publish.images_pending.other': '{count} pictures are still being checked.',
    'publish.state_pending_title': 'Review in progress',
    'publish.state_pending_body': 'The guardian is looking at the sheet and the pictures. This usually takes only a few minutes.',
    'publish.state_approved_title': 'Publicly visible',
    'publish.state_approved_body': 'Your character is listed in Discover. If you withdraw it, it disappears from the list — copies that already exist remain.',
    'publish.state_rejected_title': 'Not approved',
    'publish.state_rejected_body': 'The review was not successful. Change the sheet and submit it again.',
    'publish.state_withdrawn_body': 'You withdrew this character. You can submit it again at any time.',
    'publish.state_blocked_title': 'Blocked',
    'publish.state_blocked_body': 'This character was blocked by the team and cannot be submitted again.',
    'publish.blocked_guest_title': 'Secure your account',
    'publish.blocked_guest_body': 'Publishing needs a secured account. Create one — your characters and chats come along.',
    'publish.blocked_minor_title': 'Not available yet',
    'publish.blocked_minor_body': 'Publishing characters is available from content level "16+". Until then your characters stay private.',
    'publish.error_generic': 'That did not work. Please try again later.',
    'publish.error_limit': 'You have already submitted many characters today. Please try again tomorrow.',
    'publish.error_not_allowed': 'This character cannot be published.',
    'publish.error_exists': 'This character has already been submitted.',
    'publish.consent.title': 'What you should know',
    'publish.consent.intro': 'If you agree, you submit your character for review. Once approved it is visible to everyone. Please read these five points carefully.',
    'publish.consent.public': 'Your character becomes visible to everyone: name, sheet and pictures appear in Discover.',
    'publish.consent.copies': 'Others can add it to their own characters. Those copies remain even if you withdraw the character later.',
    'publish.consent.no_real_people': 'No real people and no third-party images. Use only what you made up or created yourself.',
    'publish.consent.guardian': 'The guardian checks the sheet and the pictures before anything becomes public.',
    'publish.consent.label_optional': 'You freely choose how you are credited under the character: a short text of up to 40 characters that the guardian also checks. Without it, the credit reads "A member of the community". Your username or display name is never published.',
    'publish.consent.checkbox': 'I have read this and agree to publish.',
    // W4-A: default creator label (server already delivers it localized).
    'discover.creator_default': 'A member of the community',
    // E5/split view: aria-live announcement on pane change (docs/30 §8.6).
    'split.showing_detail': 'Showing detail',
    'split.showing_list': 'Showing list',
    'characters.none_selected_title': 'Select a character',
    'characters.none_selected_body': 'Pick a character on the left to see its details, or create a new one.',
    'characters.not_found_title': 'Character not found',
    'characters.not_found_body': 'This character no longer exists or was deleted.',
    'characters.back_to_list': "Back to characters",
    'chars.edit_btn': 'Edit',
    'character_edit.preview_label': 'Preview',
    'settings.section.account': "Account and profile",
    'settings.section.appearance': 'Appearance',
    "settings.section.media": "Replies & audio",
    "settings.section.experience": "Reading & chat",
    'settings.section.notifications': 'Notifications',
    'settings.section.help': 'Help',
    'settings.section.legal': "Legal",
    'tindra.nav_profile': 'Open profile',
    'tindra.nav_tindra': 'Open Tindra',
    'tindra.nav_generic': 'Open',
    'tindra.open_element': 'Open element #{id}',
    // ─── Tindra overlay tour (buttons + step copy) ─────────────────────
    'tour.buttons.next': 'Next',
    'tour.buttons.back': 'Back',
    'tour.buttons.skip': 'Skip',
    'tour.buttons.finish': 'Done',
    'tour.resume.title': 'Tour paused',
    'tour.resume.cta': 'Resume',
    'tour.resume.dismiss': 'Later',
    'tour.progress': 'Step {current} of {total}',
    'tour.part1.intro.title': 'Hi, I am Tindra',
    'tour.part1.intro.body': 'Let me show you in a few steps how to start your first adventure. If you do not need me, you can skip the tour at any time.',
    'tour.part1.nav.title': 'The bottom bar',
    'tour.part1.nav.body': "Use the bar at the bottom to switch between the areas of Lorath — your chats with companions, your adventures and Discover.",
    'tour.part1.new.title': 'Your new starting point',
    'tour.part1.new.body': "This is where you build your own story at any time: a short wizard asks for setting, rules and tone.",
    'tour.part1.open.title': 'Tap here',
    'tour.part1.open.body': "Now tap your adventure — or one of the stories if you don't have one yet. It starts right away.",
    'tour.part2.narrator.title': 'Narrator mode',
    'tour.part2.narrator.body': 'The „New adventure" button opens the narrator wizard. There you pick setting, rules and tone before the story starts. No coins are spent until you actually send a message.',
    'tour.part2.models.title': 'AI models & voices',
    'tour.part2.models.body': 'In „Models & Media" you choose the image model, TTS voice and reading speed. These defaults apply to new adventures and chats.',
    'tour.part2.profile.title': 'Your profile & account',
    'tour.part2.profile.body': 'Edit your display name, email and password here. You can also find your coin balance and subscription details later on.',
    // W7-B: tour by door — the chats leg (/chats) and the discover step.
    'tour.chats.list.title': 'Your conversations',
    'tour.chats.list.body': 'Every conversation lives here, the newest at the top. Tap a row to open it.',
    'tour.chats.new.title': 'New companion',
    'tour.chats.new.body': 'This button creates a new companion: name, behaviour, appearance, quirks. Afterwards they move in and write to you first.',
    'tour.chats.profile.title': 'To the profile',
    'tour.chats.profile.body': "This menu takes you to the character's profile, and lets you call or mute them.",
    'tour.discover.list.title': 'Discover',
    'tour.discover.list.body': 'Here you find characters other people have published. You can adopt them and start talking right away.',
    // W7-B: visible consent hint in the guest step.
    'onboarding.tree.guest.terms_hint': 'By continuing you accept the terms of use and the privacy policy.',
    'tour.part2.world.title': 'Your worlds',
    'tour.part2.world.body': 'The worlds area collects cosmos, beings, timelines and cultures. Plug those building blocks into any new adventure you create.',
    'tour.replay.part1_title': 'Replay tour part 1',
    'tour.replay.part1_btn': 'Tour part 1',
    'tour.replay.part2_title': 'Replay tour part 2',
    'tour.replay.part2_btn': 'Tour part 2',
    // Phase 6: Composer shows the count of remaining free messages when available.
    'composer.free_messages': '{count} free messages',
    // v1.1.0.42x — negative-balance lock (server 402 `account_negative`).
    'composer.account_locked_hint': 'Your account is in the red — please top up coins to keep playing.',
    'coins_global.balance_negative_aria': 'Coin balance negative — please top up',
    // Bug II + III.i: subtle hint while reply suggestions generate in the background
    // (NOT the narrator typing indicator).
    'chat.suggestions_generating': 'Generating reply suggestions …',
    // v1.2: new carousel UI for reply suggestions (centered heading + column
    // labels + aria-labels for the side scroll arrows).
    'chat.suggestions_from': 'Reply suggestions from',
    // R3 follow-up (C71): invisible role prefix — both roles are actions of
    // the player character, not of the narrator.
    'chat.suggestions_narrator': 'Your action',
    'chat.suggestions_companion': 'With companion',
    'chat.suggestions_scroll_left': 'Scroll suggestions left',
    'chat.suggestions_scroll_right': 'Scroll suggestions right',
    // Beginning chips (retention): three short suggestions right above the input
    // while the campaign has fewer than five user messages. Group label + blocked
    // hint when a chip would send while the AI is writing.
    'chat.beginning_chips_group': 'Suggestions for your next action',
    'chat.beginning_chips_blocked_hint': 'The narrator is still writing — hang on a moment.',
    // Coins page (web): honest hint instead of three disabled "coming_soon" buttons.
    'coins.web_only_native_hint': 'In the browser only native purchases (iOS/Android) are available right now — web payments are coming soon.',
    'coins.web_only_native_hint_aria': 'Notice: only native purchases available',
    // Native store prices: local fallback until the new server key is deployed.
    'coins.native_price_hint': 'The final price is confirmed by the store during purchase.',
    'coins.native_price_hint_currency': 'Prices are shown in {currency}. The final price is confirmed by the store during purchase.',
    // ─── Campaign wizard (4 steps, mobile-first) ─────────────────────
    // Mode dropdown (3 options) — local fallback until server i18n ships them.
    'wizard.mode_player_only': 'Player',
    'wizard.mode_coop': 'Player + Character (Co-op)',
    'wizard.mode_dm_only': 'Dungeon Master',
    'wizard.mode_coop_hint': 'You play alongside an AI companion as a team.',
    'wizard.mode_player_hint': 'The AI guides you as the game master through your adventure.',
    'wizard.mode_dm_hint': 'You lead the game — the AI plays the characters.',
    // Import stabilization: error/validation strings for the world-element cascade.
    'wizard.cascade_failed': 'Importing the world elements failed. Please try again.',
    'wizard.cascade_start_required': 'Please choose a starting element for the import.',
    // Step 2 (narrator) — pulled out of step 1.
    'wizard.step_narrator': 'Narrator',
    'wizard.step_narrator_short': 'Narrator',
    // Step 3 (character & world) — context-aware by wizardMode.
    'wizard.who_are_you': 'Who are you?',
    'wizard.who_are_you_hint': 'Pick your character or just play as yourself.',
    'wizard.simple_me': 'Just me',
    // Character wizard step labels (client-only, no server-i18n deploy needed).
    'character_new.step_basics': 'Basics',
    'character_new.step_personality': 'Personality & Alignment',
    'character_new.step_stats': 'Stats & Abilities',
    'character_new.step_finishing': 'Finishing',
    'wizard.simple_me_hint': 'Play without a character sheet — the AI guides you.',
    'wizard.companion_label': 'Companion',
    'wizard.companion_hint': 'Pick a character to accompany you on the adventure.',
    'wizard.companion_required': 'Please pick a companion.',
    'wizard.no_companion': 'You have no companions yet. The first available character will be chosen automatically.',
    // Step 4 (advanced settings) — optional path.
    'wizard.step_advanced': 'Advanced settings',
    'wizard.advanced_intro': 'Do you want to set advanced options?',
    'wizard.advanced_yes': 'Yes, I want to set more',
    'wizard.advanced_no': 'No → Let\'s go',
    'wizard.advanced_yes_hint': 'Rules, default view, special wishes and opening scene.',
    'wizard.advanced_no_hint': 'Start right away with sensible defaults.',
    'wizard.start_mode_label': 'Default view',
    // Phase 2 — Adventure pre-planning fine-tuning (blueprint + 7 dials).
    // Local fallback until server i18n ships. Server i18n is the canonical
    // source — see server/i18n/ui/en.json.
    'wizard.finetune_title': 'Story fine-tuning',
    'wizard.finetune_hint': 'Without a choice the narrator rolls something fitting for your world, USK level and storyteller.',
    'wizard.blueprint_label': 'Story arc',
    'wizard.surprise_me': 'Surprise me',
    'wizard.mood_label': 'Mood',
    'wizard.mood_duester': 'Dark',
    'wizard.mood_hoffnungsvoll': 'Hopeful',
    'wizard.mood_humorvoll': 'Humorous',
    'wizard.mood_bittersuess': 'Bittersweet',
    'wizard.mood_episch': 'Epic',
    'wizard.mood_gemuetlich': 'Cozy',
    'wizard.pacing_label': 'Pacing',
    'wizard.pacing_gemaechlich': 'Slow',
    'wizard.pacing_ausgewogen': 'Balanced',
    'wizard.pacing_rasant': 'Fast',
    'wizard.focus_label': 'Focus (max. 2)',
    'wizard.focus_action': 'Action',
    'wizard.focus_beziehungen': 'Relationships',
    'wizard.focus_erkundung': 'Exploration',
    'wizard.focus_raetsel': 'Puzzles',
    'wizard.focus_intrige': 'Intrigue',
    'wizard.length_label': 'Target length',
    'wizard.length_oneshot': 'One-shot',
    'wizard.length_kurz': 'Short',
    'wizard.length_mittel': 'Medium',
    'wizard.length_episch': 'Epic',
    'wizard.ending_label': 'Ending style',
    'wizard.ending_offen': 'Open',
    'wizard.ending_hoffnungsvoll': 'Hopeful',
    'wizard.ending_tragisch_moeglich': 'Possibly tragic',
    'wizard.ending_twist': 'Twist',
    'wizard.consequence_label': 'Consequence level',
    'wizard.consequence_wohlwollend': 'Lenient',
    'wizard.consequence_fair': 'Fair',
    'wizard.consequence_gnadenlos': 'Merciless',
    'wizard.npc_density_label': 'NPC density',
    'wizard.npc_density_fokussiert': 'Focused',
    'wizard.npc_density_ausgewogen': 'Balanced',
    'wizard.npc_density_breit': 'Broad',
    'wizard.price_badge_coins': '{coins} coins',
    'wizard.price_badge_free': 'Free',
    // 50 setting-neutral adventure names (EN) — generic, short, fit
    // Fantasy / SciFi / Horror / Mystery. Picked at mount of the wizard
    // by index (seed = Date.now() % 50, NOT Math.random at module level).
    'wizard.random_name_1': 'The Forgotten Path',
    'wizard.random_name_2': 'Shadows over the Valley',
    'wizard.random_name_3': 'The Last Echo',
    'wizard.random_name_4': 'Beyond the Threshold',
    'wizard.random_name_5': 'The Empty Map',
    'wizard.random_name_6': 'Call from the Deep',
    'wizard.random_name_7': 'The Seventh Tower',
    'wizard.random_name_8': 'Words in the Mist',
    'wizard.random_name_9': 'The Sleeping City',
    'wizard.random_name_10': 'Splinters of the Moon',
    'wizard.random_name_11': 'The Silent Harbor',
    'wizard.random_name_12': 'Ash and Memory',
    'wizard.random_name_13': 'The Distant Promise',
    'wizard.random_name_14': 'Track in the Snow',
    'wizard.random_name_15': 'The Hidden Spring',
    'wizard.random_name_16': 'A Night Without Stars',
    'wizard.random_name_17': 'The Broken Crown',
    'wizard.random_name_18': 'Salt and Silence',
    'wizard.random_name_19': 'The Wandering Stone',
    'wizard.random_name_20': 'Door Without a Key',
    'wizard.random_name_21': 'The Whispering Moor',
    'wizard.random_name_22': "Raven's Call",
    'wizard.random_name_23': 'In the Eye of the Storm',
    'wizard.random_name_24': 'The Lost Melody',
    'wizard.random_name_25': 'Black Tide',
    'wizard.random_name_26': 'The Burning Forest',
    'wizard.random_name_27': 'Cold Lanterns',
    'wizard.random_name_28': 'The Last Watch',
    'wizard.random_name_29': 'Echo in the Stone',
    'wizard.random_name_30': 'Footsteps in the Leaves',
    'wizard.random_name_31': 'The Grey Morning',
    'wizard.random_name_32': 'Ghosts in the Light',
    'wizard.random_name_33': 'The Open Wound',
    'wizard.random_name_34': 'Dust of the Old Ones',
    'wizard.random_name_35': 'The Second Sun',
    'wizard.random_name_36': 'Ruins of Hope',
    'wizard.random_name_37': 'The Foreign Guest',
    'wizard.random_name_38': 'Between the Times',
    'wizard.random_name_39': 'Voices in the Wind',
    'wizard.random_name_40': 'The Cold Throne',
    'wizard.random_name_41': 'Twilight Hour',
    'wizard.random_name_42': 'The Broken Oath',
    'wizard.random_name_43': 'The White Fortress',
    'wizard.random_name_44': 'At the Edge of Night',
    'wizard.random_name_45': 'The Empty Chair',
    'wizard.random_name_46': 'Signs in the Sky',
    'wizard.random_name_47': 'The Flickering Candle',
    'wizard.random_name_48': 'Deeper than the Roots',
    'wizard.random_name_49': 'The Nameless One',
    'wizard.random_name_50': 'Harbingers',
    // Characters page: live search (case-insensitive, substring) + favorites filter.
    // Local fallback until server i18n ships these keys.
    'chars.search_placeholder': 'Search characters & groups …',
    'chars.filter_all': 'All',
    'chars.filter_favorites': 'Favorites only',
    'chars.no_results': 'No matching entries.',
    // VII-a: cosmos dropdown for the worldbuilding import in the wizard.
    'campaign_new.import_kosmos_label': 'World source (Cosmos)',
    // VII-b.4: "Played Adventures" section in the world element editor.
    'world_edit.played_adventures_title': 'Played Adventures',
    'world_edit.played_adventures_empty': 'No adventures played in this cosmos yet.',
    // VI: group chat — one chat with multiple AI characters.
    'group_chat.title': 'Group chat',
    'group_chat.member_count': '{count} members',
    // II.d: group chat section in "Your Characters".
    'characters.group_chats_title': 'Group chats',
    'characters.group_chats_empty': 'No group chats yet.',
    // V: new push trigger "reminder about your ongoing adventure".
    'settings.notifications.toggle_adventure_reminder_label': 'Adventure reminder',
    'settings.notifications.toggle_adventure_reminder_desc': 'A gentle nudge when an ongoing adventure is waiting for you.',
    'settings.notifications.toggle_adventure_ready_label': 'Adventure is ready',
    'settings.notifications.toggle_adventure_ready_desc': 'Ping me as soon as a newly created adventure has finished preparing.',
    'settings.notifications.toggle_first_day_nudge_label': 'Your story is waiting',
    'settings.notifications.toggle_first_day_nudge_desc': 'A single note on your first day if you have not written a message yet.',
    'group_chat.members_aria': 'Group members',
    'group_chat.members_typing': 'The group',
    'group_chat.empty_state': 'Write a message — several characters reply one after another.',
    'group_chat.input_placeholder': 'Message the group …',
    'group_chat.cost_hint': 'Costs per replying character.',
    'group_chat.mention_aria': 'Mention a character',
    'group_chat.load_error': 'The group chat could not be loaded.',
    'group_chat.load_error_title': 'Loading failed',
    'group_chat.send_failed': 'The message could not be sent.',
    // VI.e + VI.f: entry points into the group chat feature (campaign menu + characters page).
    'group_chat.new_group': 'New group',
    'group_chat.menu_label': 'Group chat',
    'group_chat.menu_hint': 'Several characters reply one after another.',
    // GroupChatCreateSheet (CREATE + MANAGE) + group chat page — full labels.
    'group_chat.create_title': 'Create a new group chat',
    'group_chat.manage_title': 'Manage group',
    'group_chat.name_label': 'Name',
    'group_chat.name_placeholder': 'e.g. The Companions',
    'group_chat.name_required': 'Please give the group a name.',
    'group_chat.description_label': 'Description',
    'group_chat.description_placeholder': 'What is this group about? (optional)',
    'group_chat.members_label': 'Members',
    'group_chat.members_hint': 'Pick the characters that should reply in the group.',
    'group_chat.selected_count': '{count} selected',
    'group_chat.current_members': 'Current members',
    'group_chat.add_member': 'Add member',
    'group_chat.add_member_hint': 'Add more of your own characters to the group:',
    'group_chat.remove_member': 'Remove member',
    'group_chat.member_add_failed': 'Member could not be added.',
    'group_chat.member_remove_failed': 'Member could not be removed.',
    'group_chat.member_limit': 'A group can have at most {max} members.',
    'group_chat.image_label': 'Group image',
    'group_chat.image_prompt_placeholder': 'Describe the group image you want …',
    'group_chat.generate_image': 'Generate image',
    'group_chat.image_cost_hint': 'Generating an image costs coins (like a portrait).',
    'group_chat.image_generated': 'Group image created.',
    'group_chat.image_failed': 'The image could not be generated.',
    'group_chat.create': 'Create group',
    'group_chat.create_failed': 'The group could not be created.',
    'group_chat.create_offline': 'You need an internet connection to create a group.',
    'group_chat.save': 'Save',
    'group_chat.saved': 'Saved.',
    'group_chat.save_failed': 'Saving failed.',
    'group_chat.manage_offline': 'You need an internet connection to manage the group.',
    'group_chat.manage_load_error': 'The group could not be loaded.',
    // II.a: "Who are you?" picker in the group chat sheet.
    'group_chat.player_label': 'Who are you?',
    'group_chat.player_hint': 'Choose who you are in this group — the characters will address you accordingly.',
    'group_chat.player_self': 'Just me',
    // R4-02 d: coin balance moved into the menu when the header was slimmed down.
    'chat.menu_coins_balance': 'Coins: {balance}',
    // IV.e: "Change/import cosmos" in the campaign menu.
    'chat.menu_more_label': 'More actions',
    'chat.kosmos_menu_label': 'Change/import cosmos',
    'chat.kosmos_menu_hint': 'Pick a world source and import it into this adventure.',
    'chat.kosmos_sheet_hint': 'Pick the cosmos whose world you want to use in this adventure.',
    'chat.kosmos_import_btn': 'Import cosmos “{name}”',
    'chat.kosmos_import_hint': 'Imports the cosmos world hierarchy into this adventure. Elements already present are skipped.',
    'chat.kosmos_pick_first': 'Please pick a cosmos first.',
    'chat.kosmos_import_empty': 'No starting element was found in this cosmos.',
    'chat.kosmos_imported': 'Imported {count} elements.',
    'chat.kosmos_import_error': 'The import failed.',
    // V: Admin memory editor in adventure/table-round chat. Now lives in the
    // unified memories table (additive, with [timestamp] prefixes and \n---\n
    // separators, NO hard 1500-char limit). Auto-compressed server-side
    // (soft_limit grows by factor 1.2 per compression).
    'chat.memory_hint': 'Additive AI memory for this adventure (entries are timestamped and separated by “---”). Compressed automatically — no hard character limit. Visible to admins only.',
    'chat.memory_counter': 'characters',
    // ─── Settings / Notifications (own sub-page) ───────────────────────────
    'settings.notifications.menu_title': 'Notifications',
    'settings.notifications.card_label': 'Notifications',
    'settings.notifications.card_desc': 'Push, email and testing tools in one place.',
    'settings.notifications.group_play': 'Your adventure',
    'settings.notifications.group_rewards': 'Your rewards',
    'settings.notifications.group_reminders': 'Reminders',
    'settings.notifications.group_news': 'App news',
    'settings.notifications.group_email': 'Email',
    'settings.notifications.group_test': 'Test tools (internal)',
    'settings.notifications.transactional_always_on_label': 'Important account info',
    'settings.notifications.transactional_always_on_desc': 'Security and service messages about your account (login, purchases, password). Always on.',
    'settings.notifications.transactional_always_on': 'Always on',
    'settings.notifications.email_label': 'Allow email notifications',
    'settings.notifications.email_desc': 'Newsletter, promos and surveys. This setting is independent of the push toggle.',
    'settings.notifications.test_panel_title': 'Test tools (internal)',
    'settings.notifications.test_panel_hint': 'Triggers the matching push to yourself right now (bypasses time windows / limits). Only works in the app with permission granted.',
    'settings.notifications.trigger_success': 'Push triggered',
    'settings.notifications.trigger_failed': 'Push could not be triggered',
    // Mirror of server i18n keys that need to be available immediately for the
    // new sub-page (independent of server deploy status).
    'settings.notifications.toggle_character_message_label': 'A character reaches out',
    'settings.notifications.toggle_character_message_desc': 'Characters you chat with often will reach out on their own after you have been away for a while.',
    // B3 (Round 6): Native Google/Apple login — status/error strings for the
    // social-login buttons in LoginPage + OnboardingChat. Mirrored locally
    // until the server-i18n deploys (same mechanism as other auth keys).
    'auth.social_opening': 'Opening browser …',
    'auth.social_login_failed': 'Login failed. Please try again.',
    // F88 (22.10.2026): OAuth sign-in hits an existing account that is not linked automatically.
    'auth.oauth_link_login_first': 'There is already a Lorath account for this email address. Please sign in the usual way first (password, Google or Apple), then link Google or Apple in the settings.',
    'auth.social_login_timeout': 'Login took too long. Are you online? Please try again.',
    // K1-III: SectionErrorBoundary — subtle inline hint when a section of the
    // page (character grid, group-chat grid, …) catches a render throw.
    'common.section_error': 'This section could not be loaded.',
    // K1-III: RouteErrorBoundary — hard-reload button + collapsible details
    // block exposing error.message/stack (for triage via Safari Web Inspector
    // / adb logcat).
    'common.reload': 'Reload',
    'common.error_details': 'Details',
    'common.close': 'Close',
    // Announcement banner on the adventure overview (single-line, scrolling).
    // v7.0.1.55: price cut announced. Once live → swap to promo_banner_live text AND
    // bump BANNER_ID in PromoBanner.tsx.
    'dashboard.promo_banner': "Cheaper coins are coming! We're lowering our coin prices — check back regularly to grab the new deals.",
    'dashboard.promo_banner_live': 'Prices are down! New: the “Spark” starter pack — take a look in the coin shop.',
    // ─── Round 6: new feature keys (local fallback until server i18n pipeline) ───
    'chat.suggestions_heading': 'Reply suggestions',
    'legal_reaccept.status_fetch_error': 'Could not load the legal status.',
    'legal_reaccept.accept_failed': 'Accepting failed. Please try again.',
    'legal_reaccept.postpone_failed': 'Postponing failed. Please try again.',
    'legal_reaccept.postpone_blocked': 'You can no longer postpone — please accept the updated documents.',
    'legal_reaccept.session_expired': 'Your session has expired.',
    'legal_reaccept.session_expired_hint': 'Log in again to accept the updated documents.',
    'legal_reaccept.login_again': 'Log in again',
    'coins.flat_status_active': 'Active flat: {tier}',
    'coins.flat_status_subscription': 'Subscription: {tier}',
    'coins.flat_native_managed': 'Your subscription is managed by {store} — it can only be cancelled there.',
    'coins.flat_native_manage_ios': 'Manage in App Store',
    'coins.flat_native_manage_android': 'Manage in {store}',
    'coins.flat_cancel_btn': 'Cancel subscription',
    'coins.flat_cancel_confirm': 'Your subscription stays active until {expires_at} and then ends. Cancel now?',
    'coins.flat_cancel_deadline': 'The cancellation window has expired — your subscription runs for another {hours} h.',
    'coins.flat_cancel_error': 'Cancellation failed.',
    'coins.flat_cancel_success': 'Subscription cancelled.',
    'coins.flat_subscriptions_title': 'Flat subscriptions',
    'coins.flat_subscriptions_coming_soon': 'Flat subscriptions (weekly/monthly) will be available soon.',
    'coins.flat_remaining_hours': '{hours} h remaining',
    'coins.flat_expires_at': 'until {date}',
    'coins.flat_legacy_tier_budget': 'Budget',
    'coins.flat_legacy_tier_normal': 'Normal',
    'coins.flat_legacy_tier_premium': 'Premium',
    'coins.flat_legacy_tier_legendary': 'Legendary',
    // App Review 2.1b: subscription purchase UI (subscribe to flat rate) —
    // visible native IAP purchase. Local fallback until server-i18n ships.
    'coins.sub_title': 'Subscribe to a flat rate',
    'coins.sub_weekly': 'Weekly',
    'coins.sub_monthly': 'Monthly',
    'coins.sub_tier_budget': 'Budget',
    'coins.sub_tier_normal': 'Normal',
    'coins.sub_tier_premium': 'Premium',
    'coins.sub_tier_legendary': 'Legendary',
    'coins.sub_benefit_budget': 'Unlimited messages with the fast standard models.',
    'coins.sub_benefit_legendary': 'Unlimited messages with every model, including GPT Standard.',
    'coins.sub_per_week': '/ week',
    'coins.sub_per_month': '/ month',
    'coins.sub_subscribe_btn': 'Subscribe',
    'coins.sub_restore_btn': 'Restore purchases',
    'coins.sub_renew_hint': 'Subscription auto-renews; cancel anytime in the Store.',
    'coins.sub_purchase_success': 'Subscription active. Enjoy!',
    'coins.sub_restore_done': 'Purchases restored.',
    // W7-A: web payment paths (subscribe in the browser, pay a flat with coins,
    // donation amount). Local fallback until the server i18n bundle is deployed.
    'coins.sub_buy_stripe': 'Subscribe with card',
    'coins.sub_buy_paypal': 'Subscribe with PayPal',
    'coins.flat_confirm_coins_amount': 'Spend {coins} coins on the flat?',
    'coins.donate_amount_label': 'Choose your own amount ({min} – {max} €)',
    'help.dialog_title': 'You are not alone',
    'help.dialog_intro': 'If you are not okay right now or feel unsafe, you can reach out to one of these services. They are confidential and free of charge.',
    'help.close': 'Close',
    'help.call_now': 'Call now',
    'help.visit_site': 'Open website',
    'help.hours_label': 'Hours:',
    'help.eu_emergency_name': 'EU Emergency',
    'help.error': 'We could not load the help list right now. Please try again later — in an emergency, dial 112.',
    'help.disclaimer': 'Lorath is not an emergency or counseling service. If you are in immediate danger, please call your local emergency number.',
    // Feature #36B: free-text fields for non-human characters in the character
    // editor (scales, fur, horns, wings, tail …). Local fallback until the
    // server-i18n deploys these keys.
    'character_edit.intimate.skin_tone_text': 'Skin/fur/scale color',
    'character_edit.intimate.skin_tone_text_placeholder': 'e.g. blue-green scales, silver fur',
    'character_edit.intimate.appearance_features': 'Appearance features',
    'character_edit.intimate.appearance_features_placeholder': 'Head, face, hair and special features like horns, wings, tail …',
    // v7.1.0.74: theme redesign — group labels + new theme names as local
    // fallback (must stay in sync with server/i18n/ui/en.json).
    'settings.theme_group_light': 'Light designs',
    'settings.theme_group_dark': 'Dark designs',
    'theme.light': 'Soft Light Gray',
    'theme.sage': 'Soft Green',
    'theme.coral': 'Soft Yellow',
    'theme.rose': 'Powder Rose',
    'theme.blue': 'Royal Blue',
    'theme.fantasy': 'Dark Purple',
    'theme.dark': 'Dark Forest Green',
    'theme.gray': 'Dark Slate',
    // M6 Kosmetik: thematische Parallele zu den deutschen Bezeichnungen oben.
    'theme.starlight': 'Starlight',
    'theme.founders': 'Founders Edition',
    // Phase 2: planning overlay in the campaign chat. Local fallback until
    // server i18n ships these keys (same mechanism as other chat keys).
    'chat.planning_title': 'Your adventure is being forged…',
    'chat.planning_phase_material': 'The narrator is sorting your world…',
    'chat.planning_phase_core': 'Forging destinies…',
    'chat.planning_phase_core_done': 'The core is set…',
    'chat.planning_phase_expand': 'Crafting places and faces…',
    'chat.planning_phase_finish': 'Final touches…',
    'chat.planning_phase_generic': 'Your adventure is taking shape…',
    'chat.planning_retry': 'Restart planning',
    'chat.planning_retry_hint': 'Planning is taking unusually long — you can restart it.',
    'chat.planning_wait_hint': 'Forging your adventure can take up to 10 minutes. You\'ll get a push notification as soon as it\'s ready — feel free to close the app.',
    'chat.planning_push_settings': 'Push notifications enabled? Open settings',
    'chat.planning_input_locked': 'Playable once your adventure is fully planned.',
    // (P42: free tier toggle/status keys removed — Free-Modus gestrichen.)
    'settings.push.free_reply_ready': 'Free reply ready',
    'settings.push.free_reply_ready_hint': 'Notify me when a queued free reply has arrived.',
    // ─── TTS / audio-first (local fallback until server i18n ships these keys) ───
    'chat.tts_pause': 'Pause',
    'chat.tts_seek': 'Seek to position',
    'chat.audio_mode_toggle_label': 'Audio messages',
    // ─── Feedback dialog (bug/idea reports from settings) ─────────────────
    // Local fallback until the server i18n ships these keys. Server contract
    // lives in server/feedback.js.
    'feedback.title': 'Send feedback',
    'feedback.message_label': 'Your message',
    'feedback.message_placeholder': 'What happened? What should we improve?',
    'feedback.attach_screenshot': 'Attach screenshot',
    'feedback.remove_screenshot': 'Remove',
    'feedback.send': 'Send',
    'feedback.sending': 'Sending …',
    'feedback.sent_success': "Thank you, your feedback has been sent.",
    'feedback.help_action': 'Send feedback',
    'feedback.help_action_desc': 'Found a bug or have an idea? Tell us — a screenshot is welcome.',
    // Contact page: direct in-app report path for signed-in users (the chat
    // menus link to /kontakt). Opens the FeedbackDialog.
    'feedback.inapp_heading': 'Report from the app',
    'feedback.inapp_desc': 'You are signed in: send your report straight to us — a screenshot is welcome. It lands directly in our report inbox.',
    // ─── Live talk (live-audio rebuild, local fallback until server i18n ships) ───
    'chat.live_talk_button': 'Campfire',
    'chat.live_talk_menu_label': 'Campfire',
    'chat.live_talk_menu_hint': 'Talk live with your narrator',
    'live_talk.confirm_title': "Campfire: start a live voice conversation?",
    'live_talk.confirm_body':
      '15 coins per minute — billed as 1 coin per started 4 seconds.\n\nBilling starts as soon as the connection is established.\n\nThe conversation is saved as text in your chat history, so you can continue it anytime later.',
    'live_talk.confirm_balance': 'Your balance: {balance} coins',
    'live_talk.start': 'Start',
    'live_talk.cancel': 'Cancel',
    'live_talk.connecting': 'Connecting …',
    'live_talk.listening': "I'm listening …",
    'live_talk.speaking': 'Narrator is speaking …',
    'live_talk.muted_status': 'Microphone off',
    'live_talk.mute': 'Mute',
    'live_talk.unmute': 'Unmute',
    'live_talk.end': 'End',
    'live_talk.warning_low_coins': 'Your coins are running low — the talk will end soon.',
    'live_talk.ended_title': 'Campfire ended',
    'live_talk.ended_duration': 'Duration: {duration}',
    'live_talk.close': 'Close',
    'live_talk.error_connect': 'Connection failed. Please try again later.',
    'live_talk.error_unavailable': 'Campfire is currently unavailable.',
    'live_talk.error_insufficient': 'Not enough coins for a campfire (at least 15 required).',
    'live_talk.error_session_active': 'A campfire is already running on your account.',
    'live_talk.error_mic': 'Microphone access was denied. Allow access in your device settings.',
    "live_talk.error_mic_busy": "The microphone is currently in use. If your Bluetooth headphones are paired with two devices, the other device often holds the microphone: disconnect it there for a moment, or pair the headphones with this device only, then call again.",
    'live_talk.error_generic': 'Something went wrong during the campfire.',
    // ─── R3-05 (D5/D7): Verbindungsfortschritt + ehrliche Fehlertexte ───
    'live_talk.stage_audio': 'Preparing audio …',
    'live_talk.stage_mic': 'Requesting microphone …',
    'live_talk.stage_session': 'Registering the conversation …',
    'live_talk.stage_socket': 'Establishing the connection …',
    'live_talk.stage_voice': 'Preparing the voice …',
    'live_talk.stage_ready': 'Ready',
    'live_talk.connect_elapsed': '{seconds} s',
    'live_talk.connect_hint_slow': 'This can take up to 35 seconds. You can cancel at any time.',
    'live_talk.error_stage': 'Stopped at: {stage}',
    'live_talk.error_audio_setup':
      'The microphone or audio processing could not be started. Close other apps using your microphone and try again.',
    'live_talk.error_ws_unreachable': 'The voice connection is currently unreachable. Please try again in a moment.',
    'live_talk.error_timeout': 'The server did not respond in time. Please try again shortly.',
    'live_talk.error_not_openable': 'This conversation cannot be opened right now.',
    'live_talk.error_age_blocked': 'This conversation is not available for your age level.',
    // ─── Live-Gespräch 7.1.1: Kulanz/Mikro-Hinweise, Banner, Tour, Stimmen-Einstellungen ───
    'composer.suggestions_toggle': 'Reply suggestions',
    'live_talk.refunded_notice':
      'Looks like there was a technical problem — your coins for this conversation have been refunded automatically.',
    'live_talk.mic_silent_hint': "We can't hear you — check your microphone or close other audio apps.",
    'dashboard.live_audio_banner':
      'Live audio mode is back! Finally just chat with your narrator — no tedious typing. Start it in the chat, up top next to your coins.',
    'dashboard.live_audio_update_banner': 'New: live conversations with your narrator! Update the app to join in.',
    'tour.live_talk_title': 'Talk to your narrator',
    'tour.live_talk_body':
      'New: tap here and chat live with your narrator — no typing needed. 15 coins per minute, your conversation is saved as text in the chat history.',
    'profile.live_voice_mode': 'Narrator and read aloud',
    'profile.live_voice_mode_system': 'System recommendation (per narrator)',
    'profile.live_voice_mode_custom': 'Custom',
    'profile.live_voice_choice': 'Your custom voice',
    'profile.live_voice_hint':
      'The system recommendation suits the narrator. Your custom choice applies to the narrator and read aloud.',
    // ─── Live-Gespräch v3 (7.1.1.02): Gesprächs-Stile, Sprach-Wizard, Musik ───
    'live_talk.style_gespraech': 'Conversation',
    'live_talk.style_gespraech_hint': 'You talk with each other — short, lively rounds.',
    'live_talk.style_hoerbuch': 'Audiobook',
    'live_talk.style_hoerbuch_hint': 'Your narrator tells the story in detail — you listen and steer.',
    'live_talk.wizard_title': 'Your narrator plans with you',
    'live_talk.wizard_listening': 'Just start talking …',
    'live_talk.music_playing': 'Music: {title}',
    // Wizard-eigener Kauf-Text beschreibt nur Loraths lokale Chatablage.
    // Vorübergehende Speicherung beim Sprachdienst wird im i-Dialog erklärt.
    'live_talk.wizard_confirm_body':
      "Plan your adventure in a live voice conversation with your narrator.\n\n15 coins per minute — billed as 1 coin per started 4 seconds from when the connection is established.\n\nYour narrator asks you a few questions; at the end your adventure is created as usual (free quota or coins). Lorath does not create a chat history for this interview.",
    'live_talk.style_group': 'Conversation style',
    'campaign.voice_wizard_title': 'Create your adventure in a conversation',
    'campaign.voice_wizard_desc':
      "Tell your narrator what you feel like — they'll ask you a few questions and take care of the rest.",
    'campaign.voice_wizard_price': '15 coins per minute',
    'campaign.voice_wizard_confirm_hint':
      'At the end of the conversation, your adventure is created as usual (free quota or coins).',
    // ─── Live-Gespräch: Hintergrund-Call-Modus (Call-Notification/Sperrbildschirm) ───
    'live_talk.call_notification_title': 'Campfire running',
    'live_talk.call_notification_text': 'Tap to return.',
    'live_talk.call_notification_channel': 'Campfire',
    'live_talk.call_notification_end': 'End',
    // ─── Character call (LiveCall plugin, F-C) — confirm/status strings ─────────
    'live_call.button': 'Call',
    'live_call.menu_label': 'Call',
    'live_call.menu_hint': 'Talk to your character live — like on the phone.',
    'live_call.confirm_title': 'Start call?',
    'live_call.confirm_body': 'You call your character and talk live. Cost: 15 coins per minute (1 coin per started 4 seconds), billed from when the connection is established.',
    'live_call.ringing': 'Ringing …',
    'live_call.ended_title': 'Call ended',
    'live_call.end': 'Hang up',
    'live_call.notification_title': 'Call in progress',
    'live_call.notification_text': 'Call in progress — tap to return.',
    // R4-06a: provider switch in the call dialog (testers/admins on beta only).
    // ─── Chat backgrounds v2 (color/crop/per-chat) + central crop UI + profile picture ───
    // Hint for the chat-bg menu row in character-chat and table-round-chat citizen menu.
    'settings.chat_bg.menu_hint': 'Pick an image, color or gallery for this chat.',
    'settings.chat_bg.mode_color': 'Color',
    'settings.chat_bg.color_hint': 'A calm solid color as your chat background.',
    'settings.chat_bg.color_custom': 'Custom color',
    'settings.chat_bg.summary_color': 'Color',
    'settings.chat_bg.invalid_color': 'Invalid color.',
    'settings.chat_bg.apply_title': 'Apply to',
    'settings.chat_bg.apply_this_chat': 'Only this chat',
    'settings.chat_bg.apply_type_campaign': 'All adventure chats',
    'settings.chat_bg.apply_type_character': 'All character chats',
    'settings.chat_bg.apply_type_tableround': 'All table rounds',
    'settings.chat_bg.apply_global': 'Everywhere',
    'settings.chat_bg.chat_not_found': 'This chat could not be found.',
    'settings.chat_bg.recrop_btn': 'Adjust crop',
    'settings.chat_bg.recropped': 'Crop updated.',
    'settings.chat_bg.invalid_crop': 'Please provide at least one valid crop area.',
    'settings.chat_bg.no_original': 'The original of this image is no longer available — please upload it again.',
    'settings.chat_bg.scrim_title': 'Readability dimming',
    'settings.chat_bg.scrim_hint': 'How strongly background images are dimmed behind the chat.',
    'settings.chat_bg.scrim_auto': 'Automatic',
    'settings.chat_bg.scrim_light': 'Light',
    'settings.chat_bg.scrim_medium': 'Medium',
    'settings.chat_bg.scrim_strong': 'Strong',
    'settings.chat_bg.scrim_off': 'Off',
    'settings.chat_bg.section_uploaded': 'Uploaded',
    'settings.chat_bg.section_ai': 'AI-generated',
    'settings.chat_bg.ai_cost_hint': 'Cost: {cost} coins',
    'settings.chat_bg.prompt_ideas': 'Ideas',
    'settings.chat_bg.this_chat_active': 'This chat uses its own background.',
    'media.crop.title': 'Crop image',
    'media.crop.step_landscape': 'Landscape',
    'media.crop.step_portrait': 'Portrait',
    'media.crop.step_square': 'Square',
    'media.crop.zoom': 'Zoom',
    'media.crop.back': 'Back',
    'media.crop.next': 'Next',
    'media.crop.apply': 'Apply',
    'media.crop.cancel': 'Cancel',
    'media.crop.loading': 'Loading image …',
    'settings.profile.portrait_title': 'Profile picture',
    'settings.profile.portrait_hint': 'Cropped square and shown round.',
    'settings.profile.portrait_upload': 'Choose image',
    'settings.profile.portrait_generate': 'Generate with AI',
    'settings.profile.portrait_delete': 'Remove',
    'settings.profile.portrait_uploaded': 'Profile picture updated.',
    'settings.profile.portrait_deleted': 'Profile picture removed.',
    'settings.profile.portrait_delete_confirm_title': 'Remove profile picture?',
    'settings.profile.portrait_delete_confirm_body': 'Your current profile picture will be permanently deleted.',
    // ─── Message editing (branching) + report AI message (2026-07-19) ───
    // Send/cancel reuse the generic existing keys chat.send/common.cancel.
    'chat.edit.button': 'Edit message',
    'chat.edit.invalid_target': 'This message can no longer be edited.',
    'chat.branch.prev': 'Previous variant',
    'chat.branch.next': 'Next variant',
    'chat.branch.position': 'Variant {current} of {total}',
    'chat.report.button': 'Report message',
    'chat.report.title': 'Report AI message',
    'chat.report.body': 'The message is immediately re-checked by our AI moderation with high priority. If the verdict stays the same, our team will review the message personally.',
    'chat.report.submit': 'Report',
    'chat.report.success': 'Thanks for your report! The message is being re-checked now.',
    'chat.report.exists': 'This message has already been reported and is being reviewed.',
    'chat.report.error': 'The report could not be sent. Please try again later.',
    'chat.report.limit': 'You have reached your report limit for today. Please try again tomorrow.',
    'character_chat.message_not_found': 'Message not found.',
    'character_chat.not_user_message': 'You can only edit your own messages.',
    'character_chat.invalid_edit_of_ts': 'This message cannot be edited.',
    'character_chat.no_sibling': 'No other variant available.',
    // R2-FixN: fallback if the server sends no `message` text.
    'character_chat.usk_hint_blocked': 'This character is approved for a higher age level than the one you currently have set. You can chat with them again once your content level matches.',
    // ─── Tafelrunde-Revival Block 1 (2026-07-20) ───
    'pwa.table_rounds': 'Table Round',
    'settings.game_settings.card_desc': 'Narrator · Setting · Content compliance',
    'dashboard.table_rounds_back_banner': 'The table round is back! Play together at the table again — with characters, NPCs and a chronicler.',
    'tr.kosmos_select_label': 'Kosmos',
    'tr.kosmos_select_hint': 'Choose the kosmos this table round takes place in.',
    'tr.import_campaign': 'Import from campaign',
    'tr.campaign_import_select': 'Campaign',
    'tr.campaign_import_loading': 'Loading campaigns …',
    'tr.campaign_import_hint': 'Imports world elements, characters, narrator, setting, rules and the story so far from the selected campaign.',
    'world.kosmos_favorite_add': 'Mark {name} as favorite',
    'world.kosmos_favorite_remove': 'Remove {name} from favorites',
    'world.kosmos_favorite_hint': 'Your favorite is the default pre-selection in campaigns, table rounds, and when moving/copying elements.',
    // ─── Tafelrunde Block 2 (Dice/Impro/Events) ───
    'table_rounds.event_invalid_type': 'Unknown event type.',
    'table_rounds.event_empty': 'Event cannot be empty.',
    'table_rounds.event_saved': 'Event saved.',
    'table_rounds.event_error': 'Could not save the event.',
    'dice.menu_label': 'Dice',
    'dice.menu_hint': 'Roll real dice for your session',
    'dice.modal_title': 'Roll dice',
    'dice.select_die': 'Choose die',
    'dice.mode_normal': 'Normal',
    'dice.mode_advantage': 'Advantage',
    'dice.mode_disadvantage': 'Disadvantage',
    'dice.modifier_label': 'Modifier',
    'dice.roll_button': 'Roll',
    'dice.result_label': 'Result',
    'dice.journal_title': 'Roll journal',
    'dice.journal_empty': 'No rolls yet',
    'dice.crit_success': 'Critical success!',
    'dice.crit_fail': 'Critical fail!',
    'dice.insert_to_chat': 'Log to chat',
    'dice.roll_prefix': 'Dice roll',
    'tr.qa_card_keep': 'Keep in kosmos',
    'tr.qa_card_kept': 'Saved ✓',
    'tr.qa_card_keep_error': 'Could not be saved',
    'tr.qa_card_type_begegnung': 'Encounter',
    'tr.qa_card_type_npc': 'NPC',
    'tr.qa_card_type_ort': 'Place',
    'tr.qa_card_type_loot': 'Loot',
    'tr.qa_card_type_raetsel': 'Riddle',
    'tr.qa_card_type_wendepunkt': 'Plot twist',
    // ─── Tafelrunde Block 2 Wave 2 (Cockpit/Timer/Soundboard) ───
    'tr_chat.cockpit_title': 'Session cockpit',
    'tr_chat.cockpit_open': 'Session cockpit',
    'tr_chat.cockpit_close': 'Back to chat',
    'tr_chat.timers_title': 'Timers',
    'tr_chat.timer_add': '+ Timer',
    'tr_chat.timer_doom_clock': '+ Doom clock',
    'tr_chat.timer_label': 'Label',
    'tr_chat.timer_start': 'Start',
    'tr_chat.timer_pause': 'Pause',
    'tr_chat.timer_reset': 'Reset',
    'tr_chat.timer_delete': 'Delete',
    'tr_chat.timer_none': 'No active timers',
    'soundboard.title': 'Soundboard',
    'soundboard.empty': 'No scenes found',
    'soundboard.empty_title': 'The soundboard belongs to a table round',
    'soundboard.empty_desc': "Create or open a table round to choose music and background sounds here.",
    'soundboard.load_error': 'Could not load music',
    'soundboard.call_notification_title': 'Music playing in background',
    'soundboard.call_notification_text': "Lorath soundboard",
    'soundboard.call_notification_channel': 'Soundboard',
    'soundboard.call_notification_end': 'Stop music',
    'soundboard.now_playing': 'Now playing',
    'soundboard.open': 'Open the soundboard',
    'soundboard.play': 'Resume playback',
    'soundboard.pause': 'Pause',
    'soundboard.stop': 'Stop',
    'soundboard.volume': 'Volume',
    'soundboard.last_played': 'Last played',
    // ─── Tafelrunde Block 3 Wave 1 (Session-Protokoll Server) ───
    'session_recordings.not_found': 'Recording not found.',
    'session_recordings.consent_required': 'Please confirm that all participants consent first.',
    'session_recordings.unsupported_format': 'This audio format is not supported.',
    'session_recordings.disk_full': 'Server storage currently full — please try again later.',
    'session_recordings.audio_expired': 'The original audio was automatically deleted after 30 days.',
    'session_recordings.purchase_insufficient': 'Not enough coins for the analysis.',
    'session_recordings.recording_not_ready': 'This recording is not ready yet.',
    'pricing_card.session_transcript.transcript.description': 'Raw transcript with speaker labels',
    'pricing_card.session_transcript.protocol.description': 'Session protocol (requires transcript)',
    'pricing_card.session_transcript.kosmos.description': 'Kosmos sync (requires protocol)',
    // Tafelrunde Block 3 Wave 4b (Session-Protokoll UI)
    'tr_session.title': 'Session log',
    'tr_session.intro': 'Upload a session and turn it into a transcript, protocol and cosmos sync.',
    'tr_session.upload_button': 'Upload recording',
    'tr_session.upload_success': 'Recording uploaded',
    'tr_session.upload_error': 'Upload failed',
    'tr_session.auto_delete_hint': 'The audio file is deleted automatically after 30 days.',
    'tr_session.consent_title': 'Consent',
    'tr_session.consent_body': 'You confirm that everyone present has consented to recording this session. The audio is stored securely and deleted after 30 days.',
    'tr_session.consent_confirm': 'Understood & choose file',
    'tr_session.recordings_empty': 'No recordings yet',
    'tr_session.recordings_empty_hint': 'Upload a session recording to evaluate it.',
    'tr_session.load_error': 'Recordings could not be loaded.',
    'tr_session.status_uploading': 'Uploading',
    'tr_session.status_stored': 'Ready',
    'tr_session.status_transcribing': 'Transcribing',
    'tr_session.status_transcribed': 'Transcribed',
    'tr_session.status_analyzing': 'Analyzing',
    'tr_session.status_done': 'Done',
    'tr_session.status_failed': 'Failed',
    'tr_session.tab_recording': 'Recording',
    'tr_session.tab_protocol': 'Protocol',
    'tr_session.tab_speakers': 'Speakers',
    'tr_session.tab_changes': 'World changes',
    'tr_session.audio_loading': 'Loading audio …',
    'tr_session.audio_load_error': 'Audio could not be loaded.',
    'tr_session.audio_expired': 'The audio file is no longer available.',
    'tr_session.purchase_kit_title': 'Evaluate',
    'tr_session.component_transcript': 'Transcript',
    'tr_session.component_transcript_hint': 'Verbatim transcript (25 coins/hr)',
    'tr_session.component_protocol': 'Protocol',
    'tr_session.component_protocol_hint': 'AI summary of the session (+10 coins/hr)',
    'tr_session.component_kosmos': 'Cosmos sync',
    'tr_session.component_kosmos_hint': 'Apply changes to your cosmos (+5 coins/hr)',
    'tr_session.component_owned': 'Purchased',
    'tr_session.price_estimate': 'up to {coins} coins',
    'tr_session.price_free_hint': 'First 60 min free — final price after your free allowance is applied.',
    'tr_session.purchase_button': 'Buy ({coins} coins)',
    'tr_session.purchase_success': '{coins} coins charged',
    'tr_session.purchase_free': 'Unlocked for free',
    'tr_session.purchase_error': 'Purchase failed',
    'tr_session.delete': 'Delete',
    'tr_session.delete_title': 'Delete recording?',
    'tr_session.delete_body': 'The recording and its evaluation will be removed.',
    'tr_session.delete_warning_no_transcript': 'This recording has not been evaluated yet. Deleting it loses the audio permanently.',
    'tr_session.delete_success': 'Recording deleted',
    'tr_session.delete_error': 'Delete failed',
    'tr_session.protocol_empty': 'No protocol yet',
    'tr_session.protocol_empty_hint': 'Buy the protocol to get a summary.',
    'tr_session.speakers_empty': 'No speakers detected',
    'tr_session.speakers_empty_hint': 'Speakers appear here once the transcript is ready.',
    'tr_session.speakers_intro': 'Name the detected speakers and assign a role.',
    'tr_session.speaker_name_label': 'Name',
    'tr_session.speaker_kind_unset': 'Choose role',
    'tr_session.speaker_kind_dm': 'Game master',
    'tr_session.speaker_kind_player': 'Player',
    'tr_session.speakers_confirm': 'Confirm assignment',
    'tr_session.speakers_saved': 'Speakers saved',
    'tr_session.speakers_error': 'Saving failed',
    'tr_session.changes_empty': 'No world changes',
    'tr_session.changes_empty_hint': 'Cosmos sync records its changes here.',
    'tr_session.changes_error': 'Changes could not be loaded.',
    'tr_session.change_created': 'Created',
    'tr_session.change_updated': 'Updated',
    'tr_session.change_deleted': 'Deleted',
    'tr_session.change_deleted_note': 'This element was removed.',
    'tr_session.change_no_fields': 'No field changes.',
    'tr_session.change_undo': 'Undo',
    'tr_session.change_undo_success': 'Change reverted',
    'tr_session.change_undo_error': 'Undo failed',
    'tr_session.change_already_reverted': 'Already reverted',
    'tr_session.change_reverted': 'Reverted',
    'tr_session.menu_label': 'Session log',
    'tr_session.menu_hint': 'Record & evaluate a session',
    'settings.notifications.toggle_session_protocol_ready_label': 'Session log ready',
    'settings.notifications.toggle_session_protocol_ready_desc': 'When your transcript or protocol has been evaluated.',
    // Tafelrunde Block 2 Rest (Poster/Portrait-Batch)
    'tr.session_poster_generate': 'Create poster',
    'tr.session_poster_regenerate': 'Recreate poster',
    'tr.session_poster_share': 'Share',
    'tr.session_poster_done': 'Poster created',
    'tr.session_poster_error': 'Poster could not be created.',
    'tr.session_poster_no_coins': 'Not enough coins for the poster.',
    'tr.session_poster_share_error': 'Sharing failed.',
    'tr.session_poster_alt': 'Poster for session {n}',
    'tr.portraits_batch_title': 'Portrait pack',
    'tr.portraits_batch_hint': '{count} characters/NPCs without a portrait. Images are generated one by one.',
    'tr.portraits_batch_start': 'Create portrait pack ({cost} coins)',
    'tr.portraits_batch_result': '{done} of {total} portraits created.',
    'tr.portraits_batch_skipped': '{count} intimate characters skipped.',
    'tr.portraits_batch_error': 'Portrait pack could not be created.',
    'tr.portraits_batch_no_coins': 'Not enough coins for the portrait pack.',
    // Tafelrunde Block 4: Recap-Hoerbuch
    'tr_recap.play_button': 'Previously on…',
    'tr_recap.title': 'Previously on…',
    'tr_recap.generating': 'Creating your recap…',
    'tr_recap.playing': 'Playing…',
    'tr_recap.replay': 'Play again',
    'tr.call_npc': 'Call',
    'tr.push_to_talk': 'Hold to talk',
    // Tafelrunde Block 5: In-App-Recorder
    'tr_rec.tile': 'Recording',
    'tr_rec.start': 'Start recording',
    'tr_rec.stop': 'Stop recording',
    'tr_rec.pause': 'Pause',
    'tr_rec.resume': 'Resume',
    'tr_rec.recording': 'Recording',
    'tr_rec.consent_title': 'Start recording?',
    'tr_rec.consent_body': 'The session will be recorded as audio and uploaded. Make sure everyone at the table agrees first.',
    'tr_rec.consent_confirm': 'Agree and record',
    'tr_rec.error_permission': 'No microphone access. Allow access in your settings and try again.',
    'tr_rec.error_generic': 'The recording could not be started.',
    'tr_rec.hint': 'Recording keeps running in the background. Afterwards you can review it in the session log.',
    'tr_rec.uploading': 'Uploading…',
    'tr_rec.finalizing': 'Saving…',
    'tr_rec.notification_title': 'Recording in progress',
    'tr_rec.notification_text': 'Your session is being recorded.',
    'tr_rec.notification_channel': 'Session recording',
    'tr_rec.notification_end': 'Stop',
    'tr_rec.started': 'Recording started.',
    'tr_rec.saved': 'Recording saved. Find it in the session log.',
    'tr_recap.no_coins': 'Not enough coins for the recap.',
    'tr_recap.error': 'Couldn\'t create the recap.',
    'tr_recap.no_history': 'There\'s no session history to recap for this round yet.',
    // ─── OpenRouter migration: TTS tiers + STT (local fallback until server i18n) ───
    // R4-03b: the six `profile.image_tier_krea_*` keys are gone — picture
    // quality is no longer a profile setting but chosen per image
    // (images.tier_* further down).
    'stt.recording_seconds': 'Recording… {seconds}s',
    'stt.transcribing_hint': 'Your recording is being converted to text.',
    'ai_transparency.open': 'AI: What happens to your input?',
    'ai_transparency.title': 'What AI does with your input',
    'ai_transparency.intro': 'You are using AI here. It creates text, images or speech from your input. Results can be wrong. Check important information yourself.',
    'ai_transparency.intro_child': 'An AI answers here. It is a computer program. It can make things up and get things wrong. To answer, Lorath sends your message to a data center that runs the AI.',
    'ai_transparency.gate_hint': '“Confirm and continue” runs the AI feature you chose. “Cancel – send nothing” takes you back; Lorath does not send your input.',
    'ai_transparency.details': 'Where does your data go?',
    'ai_transparency.loading': 'Loading the current data paths …',
    'ai_transparency.load_error': 'We could not load the current data paths. The AI can still make mistakes.',
    'ai_transparency.operator_fallback': 'an external AI service',
    'ai_transparency.zdr_verified': 'For this path, we require OpenRouter and the data center not to store your request (Zero Data Retention).',
    'ai_transparency.zdr_neutral': "The participating service’s storage rules apply to this path; we cannot rule out storage.",
    'ai_transparency.provider_definition': 'Your message goes through our server to a provider. Providers are data centers that run the AI for us.',
    'ai_transparency.chat_target': 'Your answer is created at {operator}.',
    'ai_transparency.chat_fallback': 'If {operator} cannot be reached, {fallbacks} takes over.',
    'ai_transparency.chat_fallback_multiple': 'If {operator} cannot be reached, we try {fallbacks} in that order.',
    'ai_transparency.moderation_heading': 'Safety check',
    'ai_transparency.moderation_precheck': 'A quick pre-check at {operator} checks your message for safety risks.',
    'ai_transparency.moderation_deep_local': 'The thorough check runs on our own servers.',
    'ai_transparency.moderation_deep_fallback': 'Only when our servers are overloaded does {operator} run this check.',
    'ai_transparency.moderation_no_enrichment': 'Lorath does not add your real name or personal profile data for this check.',
    'ai_transparency.voice_mic': "For direct speech input, your microphone audio is sent to {operator} and turned into text during recording.",
    'ai_transparency.voice_live': 'Your campfire runs through {operator}.',
    'ai_transparency.voice_storage': "The services' storage rules apply.",
    'ai_transparency.tts_steps': 'The text to be read aloud is prepared at {preparation} and turned into speech at {speech}.',
    'ai_transparency.tts_single': 'The text to be read aloud is turned into speech at {operator}.',
    'ai_transparency.images': 'Your AI image is created at {operator}.',
    'ai_transparency.adult': 'The content needed for the adults-only area is processed at {operator}.',
    'ai_transparency.links_heading': 'Privacy and terms',
    'ai_transparency.links_intro': "Here you can find Lorath's legal texts and the rules of every service currently involved, including the moderation pre-check provider.",
    'ai_transparency.external_privacy': 'Privacy at {operator}',
    'ai_transparency.external_terms': 'Terms at {operator}',
    'ai_transparency.external_link': 'external link',
    'ai_transparency.cancel': 'Cancel – send nothing',
    'ai_transparency.confirm_send': 'Confirm and continue',
    // ─── Context menu (Package C / E4a): right-click, long-press, ⋯ twin ───
    'ctxmenu.menu_label': 'Actions',
    'ctxmenu.open_chat': 'Open chat',
    'ctxmenu.duplicate': 'Duplicate',
    'ctxmenu.continue': 'Continue playing',
    'ctxmenu.select': 'Select',
    'ctxmenu.open': 'Open',
    // ─── Command layer (E4b): palette (⌘K) + shortcut help (?) ───
    'command.open': 'Open command palette',
    'command.placeholder': 'Search or type a command …',
    'command.section.commands': 'Commands',
    'command.section.characters': 'Characters',
    'command.section.world': 'World',
    'command.section.campaigns': 'Campaigns',
    'command.section.rounds': 'Table rounds',
    'command.empty': 'No matches',
    'shortcut.key.ctrl': 'Ctrl',
    'shortcut.key.alt': 'Alt',
    'shortcut.key.win': 'Win',
    'shortcut.title': 'Keyboard shortcuts',
    'shortcut.empty': 'No keyboard shortcuts available.',
    'shortcut.group.global': 'General',
    'shortcut.group.navigation': 'Navigation',
    'shortcut.group.ansicht': 'View',
    'shortcut.group.spiel': 'Play',
    'shortcut.group.konto': 'Account',
    // ─── W7-E: narrator switch, world context, unlinking world elements ───
    'narrators.load_error': 'The narrator list could not be loaded right now.',
    'narrators.none_available': 'No other narrator is available for this adventure right now.',
    'narrators.switch_menu_hint': 'Tap to switch',
    'chat.world_context_menu_hint': 'View, edit or regenerate the world context',
    'chat.world_context_regen_free': 'Regenerating is free: the context is rebuilt from your linked world elements without AI.',
    'chat.world_elements_unlink_hint': 'The narrator knows these elements in this adventure. Removing one only unlinks it — the element itself stays in your worldbuilding.',
    'chat.world_element_remove': 'Unlink',
    'chat.world_element_remove_error': 'The element could not be removed right now.',
    'chat.world_element_remove_unsupported': 'Can only be unlinked in worldbuilding',
    // ─── W7-D: world-tree canvas ───
    'tree.view_switcher': 'World tree view',
    'tree.view_canvas': 'Canvas',
    'tree.view_list': 'Hierarchy list',
    'tree.canvas_toolbar': 'Canvas tools',
    'tree.canvas_gesture_hint': 'Drag cards to arrange them. Drag the empty canvas to pan; use the mouse wheel or two fingers to zoom.',
    'tree.line_routing': 'Line routing',
    'tree.minimap': 'World tree minimap',
    'tree.timeline_range_invalid': 'The end year must be greater than the start year.',
    // ─── W7-H: Formular-Entwuerfe, Cache-Karte, Umgebungswechsel ───
    'form_draft.restore_prompt_minutes': 'Restore unsaved draft from {minutes} min ago?',
    'form_draft.restore_prompt_hours': 'Restore unsaved draft from {hours} h ago?',
    'settings.native.clear_cache_body': 'Clears the cache and local copies on this device. You stay signed in and your data on the server is untouched.',
    'settings.native.clear_cache_body_web': 'Clears the copies of your content stored in this browser. You stay signed in and your data on the server is untouched.',
    'settings.native.clear_cache_confirm_body': 'The cache and local copies will be cleared, then the app restarts and loads your content again. You stay signed in.',
    'settings.native.clear_cache_confirm_body_web': 'The copies stored in this browser will be cleared, then the page reloads. You stay signed in.',
    'settings.native.clear_cache_done': 'Cache cleared.',
    'settings.beta.section_title': 'Environment',
    'settings.beta.current_label': 'Current environment',
    'settings.beta.env_beta': 'Beta',
    'settings.beta.env_production': 'Production',
    'settings.beta.switch_desc': 'Switches to the other environment while keeping you signed in. Admin and tester accounts only.',
    'settings.beta.switch_to_beta': 'Switch to beta',
    'settings.beta.switch_to_production': 'Switch to production',
    'settings.beta.switch_error': 'Switching environments failed.',
    // ─── R6-02: beta environment inside the native app ───
    'beta.watermark': 'BETA version',
    'beta.purchase_blocked': 'Purchases are disabled in the beta environment. They would use real payment data but credit a test account. Buy in production instead.',
    'settings.beta.env_warning_intro': 'The beta environment is a separate world. Whatever you do there stays there.',
    'settings.beta.env_warning_db': 'Its own database: your production content is not there.',
    'settings.beta.env_warning_login': 'Its own login: you have to sign in again or create a test account.',
    'settings.beta.env_warning_purchases': 'No purchases: coins and subscriptions are disabled in beta.',
    'settings.beta.env_warning_data_loss': 'Data can disappear at any time — the beta is rebuilt regularly.',
    'settings.beta.activate_beta': 'Activate beta environment',
    'settings.beta.return_production': 'Back to production',
    'settings.beta.open_beta_browser': 'Open beta in browser',
    'settings.beta.open_production_browser': 'Open production in browser',
    'settings.beta.switching': 'Switching environment, the app will restart in a moment.',
    'settings.beta.activate_no_update': 'The beta environment is not offering anything right now. Either it is unreachable or your installed app version is too old.',
    'settings.beta.activate_not_native': 'Switching inside the app only works in the installed app. In the browser, use the link instead.',
    // ─── W7-F: user-editable AI memory (local fallback until server i18n ships) ───
    'chat.memory_menu_hint': 'See what the AI remembers — edit, delete or add entries.',
    'chat.memory_sheet_hint': 'The AI reads these entries before every reply. Changes take effect immediately.',
    'chat.memory_add_label': 'Add a memory',
    'chat.memory_add_placeholder': 'What should the AI remember?',
    'chat.memory_delete_confirm': 'Delete this memory? The AI will no longer know it.',
    'chat.memory_conflict': 'The memory changed in the meantime — the list was reloaded.',
    'chat.memory_too_long': 'This entry is too long.',
    'chat.memory_scope_adventure': 'This adventure',
    'chat.memory_scope_tableround': 'This table round',
    'chat.memory_scope_user': 'About you',
    'chat.memory_user_hint': 'What the AI remembers about you — this applies across all your chats.',
    'chat.memory_tableround_hint': "The AI's memory of this table round so far.",
    'chat.memory_scope_character': 'What {name} knows about you',
    'chat.memory_character_hint':
      'What {name} kept from your conversations — shared moments, plans, promises. It holds only between the two of you.',
    // ─── W7-C: image/video generation in chat (local fallback until server i18n) ───
    'chat.media_menu_label': 'Images and videos',
    'chat.media_price_short': '{coins} coins',
    'chat.media_menu_hint': 'Capture the scene as an image or create a video — costs coins.',
    'chat.media_none_available': 'No image or video generation is available for this chat right now.',
    'chat.media_flat_covered': 'Covered by your flat rate',
    'chat.media_nsfw_hint': 'Unlocked for this adventure only. You describe the image yourself.',
    // ─── W7-G: linked accounts (local fallback until server i18n) ───
    'settings.linked_accounts.title': 'Linked accounts',
    'settings.linked_accounts.desc': 'Sign in with Google or Apple in addition to your password. Your password stays active.',
    'settings.linked_accounts.unlink': 'Disconnect',
    'settings.linked_accounts.unlink_confirm_title': 'Disconnect this account?',
    'settings.linked_accounts.unlink_confirm_body': 'You will no longer be able to sign in with {provider}. Your other sign-in methods stay active.',
    'settings.linked_accounts.unlink_blocked': 'This is currently your only way to sign in. Set a password first, or link the other provider.',
    'settings.linked_accounts.unlinked': 'Account disconnected.',
    'settings.linked_accounts.unlink_error': 'The account could not be disconnected.',
    'settings.linked_accounts.linking': 'Finish signing in in your browser. We are waiting for the result here.',
    'settings.linked_accounts.link_timeout': 'Linking took too long. Please try again.',
    'auth.unlink_not_linked': 'This account is not linked to that provider.',
    'auth.unlink_last_method': 'That is your only way to sign in. Set a password first, or link another provider.',
    'auth.unlink_error': 'The account could not be disconnected.',
    // ─── W1-B: door frontend (local fallback until server i18n deploys) ───
    "onboarding.tree.start.option_create_account": "I would like to create an account right away",
    "onboarding.tree.guest.purpose_intro": "Good to have you here! What brings you to Lorath?",
    "onboarding.tree.guest.purpose_companion": "Get to know a companion",
    "onboarding.tree.guest.purpose_adventure": "Experience an adventure",
    "onboarding.tree.guest.age_intro": "So I can show you suitable content: how old are you?",
    "onboarding.tree.guest.age_under12": "I am under 12",
    "onboarding.tree.guest.age_12to15": "I am 12 to 15",
    "onboarding.tree.guest.age_16plus": "I am 16 or older",
    "onboarding.tree.guest.failed": "That did not work just now: {error}",
    "onboarding.tree.guest.retry": "Try again",
    "onboarding.tree.guest.register_instead": "Create an account instead",
    "onboarding.tree.guest.error_rate_limited": "There are too many attempts right now. Please try again later.",
    "onboarding.tree.guest.error_beta_restricted": "New sign-ups are closed on this test environment. Please sign in with an existing account.",
    "account.secure.title": "Secure your account",
    "account.secure.intro": "You are playing without an account. With an account everything stays safe:",
    "account.secure.reason_age": "Unlock content rated 16 and over",
    "account.secure.reason_sync": "Keep playing on all your devices",
    "account.secure.reason_safety": "Protect your characters and coins from loss",
    "account.secure.reason_status": "Daily status from your companions",
    "account.secure.username_label": "Username",
    "account.secure.password_label": "Password",
    "account.secure.password_hint": "At least 8 characters.",
    "account.secure.password_confirm_label": "Repeat password",
    "account.secure.email_label": "Email (optional)",
    "account.secure.email_hint": "Without an email address you cannot reset your password.",
    "account.secure.terms_checkbox": "I agree to the terms of use, the general terms and the privacy policy.",
    "account.secure.terms_required": "Please agree to the terms of use and the privacy policy.",
    "account.secure.submit": "Secure account",
    "account.secure.success_title": "Your account is secured.",
    "account.secure.success_bonus": "{coins} bonus coins credited.",
    "account.secure.social_intro": "Or secure your account with an existing provider:",
    "account.secure.link_google": "Secure with Google",
    "account.secure.link_apple": "Secure with Apple",
    "auth.guest_logout.title": "Sign out without an account?",
    "auth.guest_logout.body": "Without an account you lose your characters and coins. They cannot be restored afterwards.",
    "auth.guest_logout.secure_account": "Secure account",
    "auth.guest_logout.logout_anyway": "Sign out anyway",
    // ─── W3-A: wizard step 0 + adventure tab (local fallback until server i18n) ───
    'campaign_new.step0.label': 'Play style',
    'campaign_new.step0.title': 'With rules and a character sheet, or simply a story?',
    'campaign_new.step0.hint':
      'This decides whether your narrator uses dice and skill checks. You choose how much rulebook you want.',
    'campaign_new.step0.story_title': 'Simply a story',
    'campaign_new.step0.story_desc':
      'No dice, no checks, no character sheet. You tell the story together — you say what you do, and it happens.',
    'campaign_new.step0.rules_title': 'With rules and a character sheet',
    'campaign_new.step0.rules_desc':
      'Dice rolls decide success and failure, and your character brings their own stats along.',
    'campaign_new.step0.change_later':
      'You can start a new adventure with the other play style at any time.',
    'wizard.who_are_you_details': 'In detail',
    'dashboard.continue.empty_title': 'Your first adventure',
    'dashboard.continue.empty_body': 'No story started yet. A few questions, and you are right in the middle of it.',
    'dashboard.continue.empty_btn': 'Start your first adventure',
    'dashboard.tools.title': 'Tools',
    'tour.continue_title': 'Pick up right here',
    'tour.continue_body':
      'One tap on this tile takes you back into your most recent adventure — exactly where you left off.',
    // ─── W2-C: companion sheet (local fallback until server i18n deploys) ───
    "character_edit.sheet_companion": "Companion",
    "character_edit.sheet_hint_companion": "A friend to chat with. Four fields, done.",
    "character_edit.companion_preview_hint": "You are using AI here. It creates text, images or speech from your input. Results can be wrong. Check important information yourself.",
    "character_edit.companion.step_who": "Who is your companion?",
    "character_edit.companion.step_details": "Fine-tune the details",
    "character_edit.companion.name_placeholder": "e.g. Mira",
    "character_edit.companion.verhalten": "Behaviour",
    "character_edit.companion.verhalten_help": "What are they like in conversation?",
    "character_edit.companion.verhalten_placeholder": "e.g. listens calmly, asks questions, likes small jokes",
    "character_edit.companion.aussehen": "Appearance",
    "character_edit.companion.aussehen_help": "What do they look like?",
    "character_edit.companion.aussehen_placeholder": "e.g. short dark curls, warm brown eyes, a worn jacket",
    "character_edit.companion.eigenheiten": "Quirks",
    "character_edit.companion.eigenheiten_help": "Small things that make them unmistakable. Every line has its own die, and you can add more lines.",
    "character_edit.companion.eigenheit_1": "Quirk 1",
    "character_edit.companion.eigenheit_2": "Quirk 2",
    "character_edit.companion.eigenheit_3": "Quirk 3",
    "character_edit.companion.eigenheit_placeholder": "e.g. drinks tea only from one particular mug",
    "character_edit.companion.quirk_suggestions.1": "collects a stone from every place",
    "character_edit.companion.quirk_suggestions.2": "hums quietly while thinking",
    "character_edit.companion.quirk_suggestions.3": "constantly forgets names",
    "character_edit.companion.quirk_suggestions.4": "drinks coffee only cold",
    "character_edit.companion.quirk_suggestions.5": "talks to plants",
    "character_edit.companion.quirk_suggestions.6": "pauses briefly on every bridge",
    "character_edit.companion.quirk_suggestions.7": "has a proverb for everything",
    "character_edit.companion.quirk_suggestions.8": "writes everything on little notes",
    "character_edit.companion.preview_toggle": "Enable preview?",
    "character_edit.companion.preview_bubble_title": "This is how {name} would greet you",
    "character_edit.companion.preview_needs": "Add a name and a behaviour — then a greeting appears here.",
    "character_edit.companion.preview_error_rate": "One moment – this continues shortly.",
    "character_edit.companion.preview_error_unavailable": "Preview not possible right now.",
    "character_edit.companion.wuerfel": "Fill in at random",
    "character_edit.companion.wuerfel_failed": "That did not work. Please try again in a moment.",
    "character_edit.companion.preview_loading": "Writing …",
    "character_edit.companion.first_portrait_hint": "Your first portrait is created for free after saving.",
    "character_edit.companion.details_hint": "Everything here is optional. Whatever you leave blank, your companion makes up on their own.",
    "character_edit.companion.alter": "Age",
    "character_edit.companion.geschlechtsidentitaet": "Gender identity",
    "character_edit.companion.groesse": "Height",
    "character_edit.companion.gewicht": "Weight",
    "character_edit.companion.kleidungsstil": "Clothing style",
    "character_edit.companion.vorlieben": "Likes",
    "character_edit.companion.charakterzuege": "Character traits",
    "character_edit.companion.beziehungsstart": "How you met",
    "character_edit.companion.beziehungsstart_help": "How do you know each other when the first conversation starts?",
    "character_edit.companion.kommunikation": "Communication",
    "character_edit.companion.kommunikation_hint": "This is how your companion writes to you.",
    "character_edit.companion.length_label": "Message length",
    "character_edit.companion.length_short": "short",
    "character_edit.companion.length_standard": "medium",
    "character_edit.companion.length_long": "long",
    "character_edit.companion.initiative_label": "Initiative",
    "character_edit.companion.initiative_low": "low",
    "character_edit.companion.initiative_medium": "medium",
    "character_edit.companion.initiative_high": "high",
    "character_edit.companion.style_label": "Conversation style",
    "character_edit.companion.style_listen": "listen",
    "character_edit.companion.style_balanced": "balanced",
    "character_edit.companion.style_discuss": "discuss",
    "character_edit.companion.verhalten_required": "Please describe what your companion is like in conversation.",
    "character_edit.companion.aussehen_required": "Please describe what your companion looks like.",
    "character_edit.companion.eigenheiten_required": "Please fill in all three quirks.",
    "character_edit.companion.voice": "Voice",
    "character_edit.companion.voice_hint": 'Your character uses this voice for calls and voice messages. Changes apply to the next conversation and newly generated messages.',
    "character_edit.companion.voice_traits_label": "Voice qualities",
    "character_edit.companion.voice_traits_help": "Up to three. The die suggests some; tap the cross to remove one.",
    "character_edit.companion.voice_traits_empty": "No quality chosen yet.",
    "character_edit.companion.voice_trait_remove": "Remove {trait}",
    // ─── R3-03: page 2 random databases, preview card, quirk lines ───
    "character_edit.companion.preview_card_title": "Preview of the greeting",
    "character_edit.companion.preview_below": "You will find a preview of the greeting right at the bottom.",
    "character_edit.companion.eigenheit_n": "Quirk {n}",
    "character_edit.companion.quirk_add": "Add a line",
    "character_edit.companion.quirk_remove": "Remove line",
    "character_edit.companion.wuerfel_for": "Fill in {field} at random",
    "character_edit.companion.gender_male": "male",
    "character_edit.companion.gender_female": "female",
    "character_edit.companion.gender_nonbinary": "non-binary",
    "character_edit.companion.alter_hint": "Images are only created for adult characters.",
    "character_edit.companion.alter_placeholder": "e.g. 34",
    "character_edit.companion.groesse_placeholder": "e.g. 173 cm",
    "character_edit.companion.gewicht_placeholder": "e.g. 68 kg",
    "character_edit.companion.kleidungsstil_placeholder": "e.g. a worn jacket, sturdy boots",
    "character_new.badge_new": "New",
    "chars.sheet_companion": "Companion",
    // ─── W4-B: chat list + profile (local fallback until server i18n is deployed) ───
    'chats.title': 'Chats',
    'chats.profile_title': 'Profile',
    'chats.search_placeholder': 'Search chats',
    'chats.new_companion': 'New companion',
    'chats.manage_characters': 'Manage my characters',
    'chats.unnamed': 'Unnamed',
    'chats.no_messages_yet': 'No message yet',
    'chats.no_results': 'No chat matches your search.',
    'chats.load_error': 'The chats could not be loaded.',
    'chats.empty_title': 'No chats yet',
    'chats.empty_body':
      'Create a companion — someone you can simply write to. Your chat will appear here afterwards.',
    'chats.none_selected_title': 'No profile selected',
    'chats.none_selected_body': 'Pick a chat on the left — or create a new companion.',
    'chats.back_to_list': 'Back to chats',
    'chats.you_prefix': 'You: {text}',
    'chats.yesterday': 'Yesterday',
    'chats.unread_hint': 'Unread message from {name}',
    'chats.muted_hint': '{name} is muted',
    'chats.menu_open': 'Open',
    'chats.menu_profile': 'Profile',
    "chats.menu_profile_named": "Profile: {name}",
    'chats.menu_call': 'Call',
    'chats.menu_mute': 'Mute',
    'chats.menu_unmute': 'Unmute',
    // R2-09: pinning in the conversation list.
    'chats.menu_pin': 'Pin',
    'chats.menu_unpin': 'Unpin',
    'chats.pinned_hint': '{name} is pinned',
    'chats.pin_error': 'Pinning did not work.',
    'chats.pin_cap': 'You can pin at most {count} conversations. Unpin one first.',
    'chats.pin_archived': 'Archived chats cannot be pinned.',
    'chats.badge_companion': 'Companion',
    'chats.gallery_title': 'Images',
    'chats.highlights_title': 'Highlights',
    'chats.highlights_empty': 'No status images yet.',
    'chats.section_behaviour': 'Behaviour',
    'chats.section_appearance': 'Appearance',
    'chats.section_traits': 'Character traits',
    'chats.section_quirks': 'Quirks',
    'chats.section_memories': 'Memories',
    'chats.memories_hint':
      'Two areas: what this character kept from your conversations, and what the AI remembers about you. You can change or delete either at any time.',
    'chats.open_memories': 'Open memories',
    'chats.action_open_chat': 'Open chat',
    'chats.action_publish': 'Publish',
    'chats.publish_soon': 'Publishing is being built right now.',
    'chats.delete_blocked': 'This character is still tied to adventures. Delete it under “My characters”.',
    // ─── W6-C: messages + scheduled messages (local fallback until server i18n is deployed) ───
    'proactivity.title': 'Messages',
    'proactivity.open': 'Set up messages',
    'proactivity.explainer': 'Decide whether and when this character reaches out on its own.',
    'proactivity.enabled_label': 'May reach out',
    'proactivity.enabled_hint': 'Off means: only what you start yourself.',
    'proactivity.on': 'On',
    'proactivity.off': 'Off',
    'proactivity.per_day_label': 'How often per day',
    'proactivity.per_day_cap_hint': 'At most {max}, even if you want more.',
    'proactivity.per_day_zero_hint': 'At zero nobody reaches out on their own — scheduled messages still run.',
    'proactivity.hours_label': 'When',
    'proactivity.hours_default': 'The app\'s quiet hours',
    'proactivity.hours_custom': 'Own time window',
    'proactivity.hours_default_hint': 'Between 10 pm and 9 am it stays quiet; everything else arrives during the day.',
    'proactivity.hours_from': 'From',
    'proactivity.hours_to': 'Until',
    'proactivity.hours_night_hint': 'Then it will also ring at two in the morning.',
    'proactivity.delivery_label': 'Where it arrives',
    'proactivity.in_app_label': 'In the app',
    'proactivity.in_app_hint': 'The message waits in the chat until you open it.',
    'proactivity.push_label': 'As a notification',
    'proactivity.push_hint': 'Your device alerts you as soon as something arrives.',
    'proactivity.push_needs_in_app': 'Only works together with “In the app” — otherwise you tap a notification and find nothing.',
    'proactivity.voice_label': 'As a voice message',
    'proactivity.voice_hint': '1 coin per started 100 characters, at least 2 coins per voice message. If you do not have enough coins, the text message is kept.',
    'proactivity.rituals_label': 'Rituals',
    'proactivity.rituals_hint': 'Small recurring occasions. Pick as many as you like.',
    'proactivity.ritual_riddle': 'Riddle',
    'proactivity.ritual_evening_question': 'Evening question',
    'proactivity.ritual_continuation': 'Continuing story',
    'proactivity.summary_off': 'Does not reach out on its own.',
    'proactivity.summary_on': '{count} per day, {when}.',
    'proactivity.summary_quiet_hours': 'outside the quiet hours',
    'proactivity.summary_window': 'between {from} and {to} o\'clock',
    'proactivity.error_save': 'The setting could not be saved.',
    'proactivity.error_push_needs_in_app': 'Notifications only work together with “In the app”.',
    'schedules.title': 'Scheduled messages',
    'schedules.explainer': 'Messages you planned for this character. They also apply outside the settings above.',
    'schedules.empty': 'Nothing scheduled yet.',
    'schedules.new': 'New scheduled message',
    'schedules.create': 'Schedule it',
    'schedules.kind_label': 'Type',
    'schedules.kind_daily': 'Daily',
    'schedules.kind_weekdays': 'Weekdays',
    'schedules.kind_once': 'Once',
    'schedules.time_label': 'Time',
    'schedules.date_label': 'Date',
    'schedules.weekdays_label': 'On which days',
    'schedules.weekdays_required': 'Pick at least one weekday.',
    // W8-C (MINOR 7 der Nachschau): leeres Zeitfeld VOR dem POST abfangen.
    'schedules.time_required': 'Pick a time.',
    'schedules.weekday_mon': 'Mon',
    'schedules.weekday_tue': 'Tue',
    'schedules.weekday_wed': 'Wed',
    'schedules.weekday_thu': 'Thu',
    'schedules.weekday_fri': 'Fri',
    'schedules.weekday_sat': 'Sat',
    'schedules.weekday_sun': 'Sun',
    'schedules.intent_label': 'What should {name} write?',
    'schedules.intent_placeholder': 'e.g. remind me about training',
    'schedules.intent_required': 'Write briefly what it should be about.',
    'schedules.intent_rejected': 'This text is not allowed for a scheduled message.',
    'schedules.price_recurring': "Recurring request: each delivered message costs 1 coin while the request is active. You can pause or delete it at any time.",
    'schedules.price_once': '1 coin now.',
    'schedules.timezone_hint': 'Time zone: {zone}',
    'schedules.desc_daily': 'daily {time}',
    'schedules.desc_weekdays': '{days} {time}',
    'schedules.desc_once': 'on {date} at {time}',
    'schedules.next_run': 'Next message: {when}',
    'schedules.state_paused': 'Paused',
    'schedules.state_done': 'Done',
    'schedules.pause': 'Pause',
    'schedules.resume': 'Resume',
    'schedules.delete': 'Delete scheduled message',
    'schedules.deleted': 'Scheduled message deleted.',
    'schedules.created': 'Scheduled message created.',
    'schedules.created_paid': 'Scheduled message created, 1 coin charged.',
    'schedules.cap_reached_client': 'At most {max} scheduled messages per companion.',
    'schedules.insufficient_coins_client': 'Your coins are not enough for that.',
    'schedules.date_in_past': 'That date is in the past.',
    'schedules.invalid_timezone': 'Your device time zone could not be read.',
    'schedules.error_generic': 'The scheduled message could not be saved.',
    'schedules.chip_label': 'Schedule it: {when}',
    'schedules.chip_dismiss': 'Dismiss suggestion',
    'schedules.confirm_title': 'Schedule this message?',
    // ─── W5-D: images, status, voice (local fallback until server i18n is deployed) ───
    "images.tabs_aria": "Images or album",
    "images.tab_images": "Images",
    "images.tab_album": "Album",
    "images.empty": "No images yet.",
    "images.album_empty": "No scene images from your adventures yet.",
    "images.tile_aria": "Open image",
    "images.tile_primary_aria": "Open profile picture",
    "images.badge_primary": "Profile picture",
    "images.soon": "New images are switched off right now. Available again soon.",
    "images.action_series": "Create image set ({cost} coins)",
    "images.action_single": "Another image ({cost} coins)",
    "images.action_reference": "Create first portrait ({cost} coins)",
    "images.action_primary": "Set as profile picture",
    "images.action_replace": "Replace ({cost} coins)",
    "images.reference_needed": "Create a first portrait ({cost} coins) — every further image follows it.",
    "images.reference_hint": "This is the first portrait. It stays the template for every further image.",
    "images.menu_title": "Image",
    "images.confirm_pay": "Create",
    "images.series_confirm_title": "Create image set?",
    "images.series_confirm_body": "Four new images of this character for {cost} coins. It takes a moment — you can keep reading.",
    "images.single_confirm_title": "Create another image?",
    "images.single_confirm_body": "One new image of this character for {cost} coins.",
    "images.reference_confirm_title": "Create first portrait?",
    "images.reference_confirm_body": "The first image of this character for {cost} coins. Every further image follows it.",
    "images.replace_confirm_title": "Replace image?",
    "images.replace_confirm_body": "The old image is replaced by a new one. Cost: {cost} coins.",
    "images.delete_confirm_title": "Delete image?",
    "images.delete_confirm_body": "The image is removed for good.",
    "images.series_progress": "{done} of {total}",
    "images.series_done": "The image set is ready.",
    "images.series_partial": "Not every image made it. The rest was refunded to you.",
    "images.reference_done": "The first portrait is here.",
    "images.added": "The image is here.",
    "images.replaced": "The image was replaced.",
    "images.deleted": "The image was deleted.",
    "images.primary_done": "New profile picture set.",
    "images.not_enough_title": "Not enough coins",
    "images.not_enough_body": "This needs {cost} coins, you have {balance}.",
    "images.error_generic": "That did not work. Please try again in a moment.",
    "images.error_cap": "This character has reached the maximum number of images. Delete one first.",
    "images.error_series_failed": "The image set could not be created. Your coins are back.",
    "images.error_job_running": "An image set is already running for this character.",
    "images.error_reference_protected": "The first portrait cannot be replaced — it is the template for every further image.",
    "images.error_reference_in_use": "The first portrait can only be deleted once no other generated images are left.",
    "images.error_reference_exists": "This character already has a first portrait.",
    "images.error_reference_unreadable": "The first portrait cannot be read. Please create it again.",
    // ─── R4-03b: picture tiers (tier picker + series toggle) ───
    "images.tier_label": "Picture quality",
    "images.tier_price": "{cost} coins",
    "images.tier_good": "Good",
    "images.tier_good_desc": "Fast and affordable — great for everyday pictures.",
    "images.tier_premium": "Premium",
    "images.tier_premium_desc": "Runs as Standard at the Standard price.",
    "images.tier_ultra": "Ultra",
    "images.tier_ultra_desc": "Highest picture quality. Cannot follow an existing portrait.",
    "images.action_generate": "Create ({cost} coins)",
    "images.series_toggle": "Several pictures to flick through",
    "images.series_toggle_hint": "Four pictures instead of one, three times the price.",
    "images.series_needs_reference": "This needs a portrait of the character first.",
    "images.series_after_free_title": "Start the picture series afterwards?",
    "images.series_after_free_body": "The first portrait is free and arrives shortly. Right after it, four more pictures start for {cost} coins.",
    "images.series_after_free_pending": "The picture series starts as soon as the first portrait is there.",
    "status.title": "Status",
    "status.switch_label": "Daily status",
    "status.price_hint": "{day} coins per day, {month} coins per month, while switched on",
    "status.explainer": "Once a day your character tells you what happened — with a picture. You can switch it off at any time.",
    "status.on": "On",
    "status.off": "Off",
    "status.guest_hint": "You need an account for the status.",
    "status.guest_cta": "Secure account",
    "status.cap_hint": "At most {max} characters at the same time.",
    "status.error_generic": "The status could not be changed.",
    "status.soon": "The daily status is switched off right now. Available again soon.",
    "status.notice_off": "The status was switched off after three days without coins. Turn it back on whenever you like.",
    "status.highlight_expired": "This image expired after 90 days. The note stays.",
    "status.highlight_aria": "Status from {day}",
    "status.highlight_prev": "Previous day",
    "status.highlight_next": "Next day",
    "status.highlight_position": "{index} of {total}",
    "voice.listen": "Listen ({cost} coins)",
    "voice.play": "Play",
    "voice.pause": "Pause",
    "voice.seek": "Choose a position in the voice message",
    "voice.soon": "Voice messages are switched off right now. Available again soon.",
    "voice.error_failed": "The voice message could not be created. Your coins are back.",
    "voice.error_message_gone": "This message no longer exists.",
    "voice.error_too_short": "This message is too short to read aloud.",
    "publish.badge_pending": "In review",
    "publish.badge_approved": "Public",
    "publish.badge_rejected": "Rejected",
    "publish.badge_withdrawn": "Withdrawn",
    "publish.badge_blocked": "Blocked",
    // W8-A follow-up: new server keys mirrored into the local fallback.
    'publish.error_no_image': 'This character needs at least one image the guardian can check. Create or upload one, then submit it again.',
    // ─── W8-C (Liste B + MINOR 6): Nachzug in den lokalen Rueckfall ───────────
    // Diese Keys stehen laengst in server/i18n/ui/{de,en}.json, fehlten hier
    // aber. Der lokale Rueckfall greift beim Kaltstart ohne i18n-Cache und bei
    // einem OTA-Frontend, das dem Server-Buendel voraus ist — genau dort haetten
    // die Entdecken-Karten, der Veroeffentlichen-Dialog und die Galerie sonst
    // rohe Schluessel gezeigt.
    "character_chat.age_badge_tooltip": "Level from your profile. Changeable in the profile.",
    "character_chat.age_badge_age_0": "Ages 0+",
    "character_chat.age_badge_age_6": "Ages 6+",
    "character_chat.age_badge_age_12": "Ages 12+",
    "character_chat.age_badge_age_16": "Ages 16+",
    "character_chat.age_badge_age_18": "Ages 18+",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.error": "Error",
    "common.loading": "Loading...",
    "coins.insufficient": "Not enough coins.",
    "nav.coins_buy": "Buy Coins",
    "onboarding.tree.register.terms_link_use_terms": "Terms of Use",
    "onboarding.tree.register.terms_link_agb": "General Terms and Conditions",
    "onboarding.tree.register.terms_link_privacy": "Privacy Policy",
    "onboarding.tree.register.terms_link_privacy_sub": "Also written in plain language",
    "discover.adopt_own": "This is your own character — you already have it.",
    "discover.adopt_usk_blocked": "This character does not match your age level.",
    // ─── R2-10: discover filter bar (local fallback until server i18n deploys) ───
    "discover.filter_usk_label": "Age rating",
    "discover.filter_usk_all": "All ratings",
    "discover.usk_option_age_0": "Rated 0",
    "discover.usk_option_age_6": "Rated 6 and below",
    "discover.usk_option_age_12": "Rated 12 and below",
    "discover.usk_option_age_16": "Rated 16 and below",
    "discover.usk_option_age_18": "Rated 18 and below",
    "discover.usk_locked_guest_hint": "Available once you have an account.",
    "discover.usk_locked_age_hint": "Not unlocked for your age rating.",
    "discover.usk_locked_age": "This rating is not unlocked for your age. You can change it in the settings.",
    "discover.usk_locked_age_cta": "Go to age rating",
    "discover.usk_locked_max": "This rating is not available for your account.",
    "discover.usk_locked_max_hint": "Not available for your account.",
    "discover.filter_lang_label": "Language",
    "discover.filter_lang_all": "All languages",
    "discover.filter_reset": "Reset filters",
    "discover.adventures_soon": "Ready-made adventures are coming here. Check back soon.",
    // ─── R2-12: adventure templates (mirror of the de block, m5) ───
    "discover.adventures_title": "Adventures",
    "discover.adventures_intro": "Ready-made adventures by Lorath. Pick one and start right away.",
    "discover.adventures_search_placeholder": "Search adventures",
    "discover.adventures_empty_title": "No adventures yet",
    "discover.adventures_empty_body": "Ready-made adventures will appear here as soon as we have approved the first ones.",
    "discover.adventures_empty_filtered_title": "No matches",
    "discover.adventures_empty_filtered_body": "There is no adventure for this selection right now. Remove a filter or change your search.",
    "discover.adventures_load_error": "The adventures could not be loaded. Please try again later.",
    "discover.adventures_none_selected_body": "Choose an adventure on the left to take a look at it.",
    "discover.adventure_not_found_title": "Adventure not found",
    "discover.adventure_not_found_body": "This adventure no longer exists or is not available for you.",
    "discover.adventure_back_to_list": "Back to the adventures",
    "discover.adventure_play": "Play",
    "discover.adventure_play_free": "Free",
    "discover.adventure_play_cost": "{n} coins",
    "discover.adventure_play_error": "The adventure could not be started. Please try again later.",
    "discover.adventure_play_usk_blocked": "This adventure does not match your age level.",
    "discover.adventure_by_lorath": "By Lorath",
    "discover.adventures_filter_setting": "World",
    "discover.adventures_filter_usk": "Age level",
    "discover.adventures_filter_usk_all": "All levels",
    "discover.adventures_filter_usk_upto": "Up to {level}",
    // ─── R4-04: adult gate for image creation (local fallback until server i18n deploys) ───
    "character_images.age_below_adult": "No pictures can be created for this character: the sheet states an age under 18. Enter an age of 18 or over if you want pictures.",
    // ─── R4-01: character counter on capped form fields (local fallback until
    //     the next server-i18n batch run) ───
    'form.char_counter': '{n}/{max}',
    'form.char_counter_label': '{n} of {max} characters',
    "character_images.image_tier_invalid": "We do not know this picture quality. Please pick one of the offered levels.",
    "character_images.image_tier_unsupported": "This picture quality cannot use a reference picture — the character would look different. Pick one of the other two levels for pictures of this character.",
    // ─── R9-03: zentrale Einstellung „Erzählerstimme in Abenteuern" (neuer
    //     Kartentitel inklusive) — bis zum Pipeline-Nachlauf lokal ───
    "profile.adventure_voice": "Narrator voice in adventures",
    "profile.adventure_voice_auto": "Automatic (per narrator)",
    "profile.adventure_voice_hint": "This voice applies throughout an adventure: when reading aloud, for the narrator's voice messages and in campfire. \"Automatic\" picks the voice that fits the current narrator. Your characters keep their own voice.",
    "settings.media_models_title": "Audio & voice",
    // ─── R9-05: ergänzte Absätze der Datenschutz-Kurzfassung
    //     (Rechtsgrundlagen, Technikdaten, Sichtbarkeit, Cookies/Cache, Zahlung,
    //     Push, Stimme, Berechtigungen, Stores, Drittland, Zustimmungsnachweis,
    //     automatische Prüfung, Speicherdauer, Werbung, Support, Newsletter,
    //     Rechte) — bis zum Pipeline-Nachlauf lokal ───
  },
  ru: {
    // W2c/N3: Russisch braucht neben one insbesondere few und many.
    'world.overview_elements.one': '{count} элемент',
    'world.overview_elements.few': '{count} элемента',
    'world.overview_elements.many': '{count} элементов',
    'world.overview_elements.other': '{count} элемента',
  },
  ar: {
    // W2c/N3: Arabische CLDR-Kategorien statt einer festen Pluralform.
    'world.overview_elements.zero': '{count} عنصر',
    'world.overview_elements.one': '{count} عنصر',
    'world.overview_elements.two': '{count} عنصران',
    'world.overview_elements.few': '{count} عناصر',
    'world.overview_elements.many': '{count} عنصرًا',
    'world.overview_elements.other': '{count} عنصر',
  },
};

// Solange eine Quellversion ausdrücklich auf die Pipeline wartet, darf ein
// altes Sprachpaket aus Server oder Offline-Cache keine überholten Preise zeigen.
// Nach dem Nachlauf verschwinden die Manifest-Einträge und die Zieltexte greifen.
// Im Browser werden nur Keys gelesen; die Hashprüfung bleibt beim Node-Audit.
// W5: Soforttexte für offene Übersetzungsquellen; nach Übersetzung entfernen.
Object.assign(LOCAL_I18N_OVERRIDES.de!, {
  "settings.appearance_subtitle": "Konto und App-Einstellungen",
  "memories_book.unpin_toggle": "Nicht mehr anheften",
  "coins.reward_flat_24h": "24 Stunden Nachrichten-Flat",
  "coins.reward_flat_1w": "Eine Woche Nachrichten-Flat",
  "character_edit.discard_title": "Änderungen verwerfen?",
  "character_edit.discard_body": "Deine nicht gespeicherten Änderungen gehen verloren.",
  "character_edit.discard_confirm": "Verwerfen",
  "membership.quota_remaining": "{remaining} übrig",
  "settings.tools_title": "Werkzeuge",
  "coins.rewards_received": "Deine Kaufbelohnungen",
  "coins.reward_included": "Enthalten: {reward}",
  "coins.reward_until": "Noch {amount} bis {reward}",
  "coins.rewards_load_error": "Kaufbelohnungen konnten nicht geladen werden.",
  "coins.reward_push": "Zusätzlich erhalten: {rewards}.",
  "membership.daily_counter_label": "Gratis-Nachrichten heute",
  "membership.live_quota_label": "Lagerfeuer-Minuten je 28 Tage",
  "membership.background_quota_label": "Hintergründe diesen Monat",
  "intimate_video.feature_disabled": "Diese Funktion ist derzeit deaktiviert.",
  "legal_reaccept.decline_hint": "Du kannst dich auch jederzeit abmelden und die Änderungen später akzeptieren.",
  "legal_reaccept.logout_btn": "Abmelden"
});
Object.assign(LOCAL_I18N_OVERRIDES.en!, {
  "settings.appearance_subtitle": "Account and app settings",
  "memories_book.unpin_toggle": "Unpin",
  "coins.reward_flat_24h": "24-hour message flat rate",
  "coins.reward_flat_1w": "One-week message flat rate",
  "character_edit.discard_title": "Discard changes?",
  "character_edit.discard_body": "Your unsaved changes will be lost.",
  "character_edit.discard_confirm": "Discard",
  "membership.quota_remaining": "{remaining} left",
  "settings.tools_title": "Tools",
  "coins.rewards_received": "Your purchase rewards",
  "coins.reward_included": "Included: {reward}",
  "coins.reward_until": "{amount} more for {reward}",
  "coins.rewards_load_error": "Purchase rewards could not be loaded.",
  "coins.reward_push": "You also received: {rewards}.",
  "membership.daily_counter_label": "Free messages today",
  "membership.live_quota_label": "Campfire minutes per 28 days",
  "membership.background_quota_label": "Backgrounds this month",
  "intimate_video.feature_disabled": "This feature is currently disabled.",
  "legal_reaccept.decline_hint": "You can also log out at any time and accept the changes later.",
  "legal_reaccept.logout_btn": "Log out"
});

// 7.4 Warteschlange im Chat: Soforttexte fuer offene Uebersetzungsquellen; nach Uebersetzung entfernen.
Object.assign(LOCAL_I18N_OVERRIDES.de!, {
  "chat.queue.send": "Nachricht einreihen",
  "chat.queue.reason_review": "Die letzte Antwort wird noch geschrieben und geprüft. Du kannst trotzdem senden – deine Nachricht wartet und geht danach automatisch raus.",
  "chat.queue.reason_answer": "Die letzte Antwort wird noch geschrieben. Du kannst trotzdem senden – deine Nachricht wartet und geht danach automatisch raus.",
  "chat.queue.waiting_review": "Wartet – wird gesendet, sobald die letzte Antwort geprüft ist",
  "chat.queue.waiting_answer": "Wartet – wird gesendet, sobald die letzte Antwort da ist",
  "chat.queue.edit": "Wartende Nachricht bearbeiten",
  "chat.queue.remove": "Wartende Nachricht verwerfen",
  "chat.queue.full": "Es warten schon mehrere Nachrichten. Weitere kannst du einreihen, sobald die ersten gesendet sind.",
  "chat.queue.returned_withdrawn": "Die letzte Antwort wurde zurückgezogen. Deine wartenden Nachrichten wurden nicht gesendet und stehen wieder im Eingabefeld.",
  "chat.queue.returned_failed": "Deine wartenden Nachrichten wurden nicht gesendet und stehen wieder im Eingabefeld.",
  "chat.queue.returned_branch": "Der Verlauf hat sich geändert. Deine wartenden Nachrichten wurden nicht gesendet und stehen wieder im Eingabefeld.",
  "chat.queue.discarded_scope": "Du hast den Chat gewechselt. Deine wartenden Nachrichten aus dem vorherigen Chat wurden nicht gesendet und verworfen."
});
Object.assign(LOCAL_I18N_OVERRIDES.en!, {
  "chat.queue.send": "Queue message",
  "chat.queue.reason_review": "The last reply is still being written and checked. You can send anyway – your message waits and goes out automatically afterwards.",
  "chat.queue.reason_answer": "The last reply is still being written. You can send anyway – your message waits and goes out automatically afterwards.",
  "chat.queue.waiting_review": "Waiting – will be sent once the last reply has been checked",
  "chat.queue.waiting_answer": "Waiting – will be sent once the last reply has arrived",
  "chat.queue.edit": "Edit waiting message",
  "chat.queue.remove": "Discard waiting message",
  "chat.queue.full": "Several messages are already waiting. You can queue more once the first ones have been sent.",
  "chat.queue.returned_withdrawn": "The last reply was withdrawn. Your waiting messages were not sent and are back in the input field.",
  "chat.queue.returned_failed": "Your waiting messages were not sent and are back in the input field.",
  "chat.queue.returned_branch": "The conversation path changed. Your waiting messages were not sent and are back in the input field.",
  "chat.queue.discarded_scope": "You switched chats. Your waiting messages from the previous chat were not sent and have been discarded."
});

// Paket 75 (Geschenke): Soforttexte fuer offene Uebersetzungsquellen (Popups,
// Admin, Push/Mail-Spiegel fuer den Manifest-Test); nach Uebersetzung entfernen.
Object.assign(LOCAL_I18N_OVERRIDES.de!, {
  "gift.popup.tester_dank.title": "Danke für deine Hilfe",
  "gift.popup.tester_dank.body": "Das Tester-Programm gibt es nicht mehr – danke, dass du Lorath mitgestaltet hast! Als Dankeschön bekommst du Lorath Ultra dauerhaft. Wenn du Lorath unterstützen möchtest, kannst du jederzeit auf Founders wechseln.",
  "gift.popup.tester_dank.founders": "Founders ansehen",
  "gift.popup.coin_dank.title": "Danke für deine Unterstützung",
  "gift.popup.coin_dank.body": "Danke, dass du Lorath mit einem Coin-Kauf unterstützt hast – hier ist eine Woche Lorath Ultra, aktiv bis {date}.",
  "gift.popup.generic.title": "Ein Geschenk für dich",
  "gift.popup.generic.body_until": "Du hast Lorath {tier} geschenkt bekommen, aktiv bis {date}.",
  "gift.popup.generic.body_unlimited": "Du hast Lorath {tier} dauerhaft geschenkt bekommen.",
  "gift.popup.continue": "Danke, weiter",
  "admin.gifts.title": "Geschenke",
  "admin.gifts.reason_bestandsschutz": "Bestandsschutz",
  "admin.gifts.reason_tester_dank": "Dank für das Tester-Programm",
  "admin.gifts.reason_coin_dank": "Dank für einen Coin-Kauf",
  "admin.gifts.reason_other": "Geschenk",
  "admin.gifts.state_waiting": "Wartet auf erstes Öffnen",
  "admin.gifts.state_active": "Aktiv",
  "admin.gifts.state_ended": "Beendet",
  "admin.gifts.state_lapsed": "Einlösefrist verstrichen",
  "admin.gifts.redeem_until": "einlösbar bis {date}",
  "admin.gifts.activated": "aktiviert am {date}",
  "admin.gifts.days": "{days} Tage",
  "admin.gifts.popup_seen": "Hinweis gesehen",
  "admin.gifts.reminder_sent": "Erinnerung gesendet",
  "push.gift_expiry.title.0": "Dein Geschenk endet bald",
  "push.gift_expiry.body.0": "Dein geschenktes Lorath {tier} läuft am {date} aus.",
  "push.gift_expiry_bestand25.title.0": "Dein Plus endet bald",
  "push.gift_expiry_bestand25.body.0": "Dein geschenktes Lorath Plus läuft am {date} aus. Bis dahin sicherst du dir ein Jahresabo mit 25 % Rabatt.",
  "push.gift_announce_bestandsschutz.title.0": "30 Tage Plus warten auf dich",
  "push.gift_announce_bestandsschutz.body.0": "Danke für deine frühe Unterstützung: 30 Tage Lorath Plus starten, sobald du Lorath das nächste Mal öffnest.",
  "push.gift_announce_coin_dank.title.0": "Eine Woche Ultra wartet auf dich",
  "push.gift_announce_coin_dank.body.0": "Danke für deinen Coin-Kauf: Eine Woche Lorath Ultra startet, sobald du Lorath das nächste Mal öffnest.",
  "push.gift_announce_tester_dank.title.0": "Danke für deine Hilfe",
  "push.gift_announce_tester_dank.body.0": "Das Tester-Programm ist beendet. Als Dankeschön ist Lorath Ultra jetzt dauerhaft für dich freigeschaltet.",
  "email.gift.greeting": "Hallo {username},",
  "email.gift.cta": "Lorath öffnen",
  "email.gift.redeem_until": "Du kannst das Geschenk bis {date} einlösen – dafür genügt es, Lorath zu öffnen.",
  "email.gift_announce.bestandsschutz.subject": "30 Tage Lorath Plus für dich",
  "email.gift_announce.bestandsschutz.body": "danke für deine frühe Unterstützung! Wir schenken dir 30 Tage Lorath Plus. Die Zeit startet, sobald du Lorath das nächste Mal öffnest. Solange dein Plus läuft, kannst du dir außerdem einmalig ein Jahresabo mit 25 % Rabatt sichern.",
  "email.gift_announce.coin_dank.subject": "Eine Woche Lorath Ultra als Dankeschön",
  "email.gift_announce.coin_dank.body": "danke, dass du Lorath mit einem Coin-Kauf unterstützt hast! Als Dankeschön schenken wir dir eine Woche Lorath Ultra. Sie startet, sobald du Lorath das nächste Mal öffnest.",
  "email.gift_announce.tester_dank.subject": "Danke für deine Hilfe als Tester",
  "email.gift_announce.tester_dank.body": "das Tester-Programm gibt es nicht mehr – danke, dass du Lorath mitgestaltet hast! Als Dankeschön ist Lorath Ultra jetzt dauerhaft für dich freigeschaltet. Wenn du Lorath unterstützen möchtest, kannst du jederzeit auf Founders wechseln.",
  "email.gift_expiry.subject": "Dein geschenktes Lorath {tier} endet bald",
  "email.gift_expiry.body": "dein geschenktes Lorath {tier} läuft am {date} aus. Bis dahin kannst du alle Vorteile weiter nutzen.",
  "email.gift_expiry.offer_bestand25": "Solange dein Plus läuft, kannst du dir noch einmalig ein Jahresabo mit 25 % Rabatt sichern.",
  "email.gift_expiry.cta_offer": "Angebot ansehen"
});
Object.assign(LOCAL_I18N_OVERRIDES.en!, {
  "gift.popup.tester_dank.title": "Thank you for your help",
  "gift.popup.tester_dank.body": "The tester program has ended – thank you for helping to shape Lorath! As a thank-you, you get Lorath Ultra permanently. If you would like to support Lorath, you can switch to Founders at any time.",
  "gift.popup.tester_dank.founders": "View Founders",
  "gift.popup.coin_dank.title": "Thank you for your support",
  "gift.popup.coin_dank.body": "Thank you for supporting Lorath with a coin purchase – here is one week of Lorath Ultra, active until {date}.",
  "gift.popup.generic.title": "A gift for you",
  "gift.popup.generic.body_until": "You have received Lorath {tier} as a gift, active until {date}.",
  "gift.popup.generic.body_unlimited": "You have received Lorath {tier} as a permanent gift.",
  "gift.popup.continue": "Thanks, continue",
  "admin.gifts.title": "Gifts",
  "admin.gifts.reason_bestandsschutz": "Early-supporter protection",
  "admin.gifts.reason_tester_dank": "Tester program thank-you",
  "admin.gifts.reason_coin_dank": "Coin purchase thank-you",
  "admin.gifts.reason_other": "Gift",
  "admin.gifts.state_waiting": "Waiting for first app open",
  "admin.gifts.state_active": "Active",
  "admin.gifts.state_ended": "Ended",
  "admin.gifts.state_lapsed": "Redemption period expired",
  "admin.gifts.redeem_until": "redeemable until {date}",
  "admin.gifts.activated": "activated on {date}",
  "admin.gifts.days": "{days} days",
  "admin.gifts.popup_seen": "Notice seen",
  "admin.gifts.reminder_sent": "Reminder sent",
  "push.gift_expiry.title.0": "Your gift ends soon",
  "push.gift_expiry.body.0": "Your gifted Lorath {tier} ends on {date}.",
  "push.gift_expiry_bestand25.title.0": "Your Plus ends soon",
  "push.gift_expiry_bestand25.body.0": "Your gifted Lorath Plus ends on {date}. Until then, you can get an annual plan with 25% off.",
  "push.gift_announce_bestandsschutz.title.0": "30 days of Plus are waiting for you",
  "push.gift_announce_bestandsschutz.body.0": "Thank you for your early support: 30 days of Lorath Plus start the next time you open Lorath.",
  "push.gift_announce_coin_dank.title.0": "A week of Ultra is waiting for you",
  "push.gift_announce_coin_dank.body.0": "Thank you for your coin purchase: one week of Lorath Ultra starts the next time you open Lorath.",
  "push.gift_announce_tester_dank.title.0": "Thank you for your help",
  "push.gift_announce_tester_dank.body.0": "The tester program has ended. As a thank-you, Lorath Ultra is now permanently unlocked for you.",
  "email.gift.greeting": "Hi {username},",
  "email.gift.cta": "Open Lorath",
  "email.gift.redeem_until": "You can redeem the gift until {date} – simply open Lorath.",
  "email.gift_announce.bestandsschutz.subject": "30 days of Lorath Plus for you",
  "email.gift_announce.bestandsschutz.body": "Thank you for your early support! We are giving you 30 days of Lorath Plus. The time starts the next time you open Lorath. While your Plus is active, you can also get a one-time 25% discount on an annual plan.",
  "email.gift_announce.coin_dank.subject": "A week of Lorath Ultra as a thank-you",
  "email.gift_announce.coin_dank.body": "Thank you for supporting Lorath with a coin purchase! As a thank-you, we are giving you one week of Lorath Ultra. It starts the next time you open Lorath.",
  "email.gift_announce.tester_dank.subject": "Thank you for your help as a tester",
  "email.gift_announce.tester_dank.body": "The tester program has ended – thank you for helping to shape Lorath! As a thank-you, Lorath Ultra is now permanently unlocked for you. If you would like to support Lorath, you can switch to Founders at any time.",
  "email.gift_expiry.subject": "Your gifted Lorath {tier} ends soon",
  "email.gift_expiry.body": "Your gifted Lorath {tier} ends on {date}. Until then, you can keep using all of its benefits.",
  "email.gift_expiry.offer_bestand25": "While your Plus is active, you can still get a one-time 25% discount on an annual plan.",
  "email.gift_expiry.cta_offer": "View offer"
});

// Paket 75 Store-Abgleich (Admin): Soforttexte fuer offene Uebersetzungsquellen; nach Uebersetzung entfernen.
Object.assign(LOCAL_I18N_OVERRIDES.de!, {
  "admin.store_sync.title": "Store-Abos und Abgleich",
  "admin.store_sync.intro": "Mitgliedschaften aus App Store und Google Play mit dem letzten Abgleich gegen den Store. Testphasen und Abos kurz vor dem Periodenende werden stündlich geprüft, alle anderen alle drei Stunden.",
  "admin.store_sync.scope_open": "Laufend",
  "admin.store_sync.scope_all": "Alle",
  "admin.store_sync.empty": "Keine Store-Mitgliedschaften.",
  "admin.store_sync.loading_error": "Store-Abos konnten nicht geladen werden.",
  "admin.store_sync.provider_apple": "App Store",
  "admin.store_sync.provider_google": "Google Play",
  "admin.store_sync.store_state": "Store: {state}",
  "admin.store_sync.checked_at": "Abgeglichen {date}",
  "admin.store_sync.never_checked": "Noch nicht abgeglichen",
  "admin.store_sync.store_event_at": "Store-Nachricht {date}",
  "admin.store_sync.no_store_event": "Keine Store-Nachricht",
  "admin.store_sync.renews": "Verlängert sich",
  "admin.store_sync.renewal_off": "Verlängerung aus",
  "admin.store_sync.cancel_reason": "Grund: {reason}",
  "admin.store_sync.feedback": "Rückmeldung: {text}",
  "admin.store_sync.error": "Fehler beim Abgleich: {error}",
  "admin.store_sync.next_check": "Nächster Abgleich {date}",
  "admin.store_sync.hourly": "stündlich",
  "admin.store_sync.run_one": "Jetzt abgleichen",
  "admin.store_sync.run_success": "Abgleich ausgeführt.",
  "admin.store_sync.run_error": "Abgleich fehlgeschlagen.",
  "admin.store_sync.last_run": "Letzter Lauf {date}: {checked} geprüft, {corrections} korrigiert, {errors} Fehler",
  "admin.store_sync.no_run": "Noch kein Lauf protokolliert.",
  "admin.store_sync.webhook_google": "Google-Benachrichtigungen",
  "admin.store_sync.webhook_apple": "Apple-Benachrichtigungen",
  "admin.store_sync.webhook_last": "zuletzt {date} ({kind})",
  "admin.store_sync.webhook_none": "noch nie empfangen",
  "admin.store_sync.config_missing": "Nicht eingerichtet: {items}",
  "admin.store_sync.state_active": "aktiv",
  "admin.store_sync.state_canceled": "gekündigt",
  "admin.store_sync.state_in_grace_period": "Zahlungsfrist",
  "admin.store_sync.state_grace_period": "Zahlungsfrist",
  "admin.store_sync.state_on_hold": "Zahlung ausgesetzt",
  "admin.store_sync.state_paused": "pausiert",
  "admin.store_sync.state_expired": "abgelaufen",
  "admin.store_sync.state_pending": "Zahlung ausstehend",
  "admin.store_sync.state_billing_retry": "Zahlung wird wiederholt",
  "admin.store_sync.state_revoked": "erstattet",
  "admin.store_sync.state_pending_purchase_canceled": "Kauf abgebrochen"
});
Object.assign(LOCAL_I18N_OVERRIDES.en!, {
  "admin.store_sync.title": "Store subscriptions and sync",
  "admin.store_sync.intro": "App Store and Google Play memberships with their latest store check. Trials and subscriptions close to the end of their period are checked hourly, all others every three hours.",
  "admin.store_sync.scope_open": "Current",
  "admin.store_sync.scope_all": "All",
  "admin.store_sync.empty": "No store memberships.",
  "admin.store_sync.loading_error": "Store subscriptions could not be loaded.",
  "admin.store_sync.provider_apple": "App Store",
  "admin.store_sync.provider_google": "Google Play",
  "admin.store_sync.store_state": "Store: {state}",
  "admin.store_sync.checked_at": "Checked {date}",
  "admin.store_sync.never_checked": "Not checked yet",
  "admin.store_sync.store_event_at": "Store notification {date}",
  "admin.store_sync.no_store_event": "No store notification",
  "admin.store_sync.renews": "Renews",
  "admin.store_sync.renewal_off": "Renewal off",
  "admin.store_sync.cancel_reason": "Reason: {reason}",
  "admin.store_sync.feedback": "Feedback: {text}",
  "admin.store_sync.error": "Sync error: {error}",
  "admin.store_sync.next_check": "Next check {date}",
  "admin.store_sync.hourly": "hourly",
  "admin.store_sync.run_one": "Check now",
  "admin.store_sync.run_success": "Check completed.",
  "admin.store_sync.run_error": "Check failed.",
  "admin.store_sync.last_run": "Last run {date}: {checked} checked, {corrections} corrected, {errors} errors",
  "admin.store_sync.no_run": "No run logged yet.",
  "admin.store_sync.webhook_google": "Google notifications",
  "admin.store_sync.webhook_apple": "Apple notifications",
  "admin.store_sync.webhook_last": "last {date} ({kind})",
  "admin.store_sync.webhook_none": "never received",
  "admin.store_sync.config_missing": "Not configured: {items}",
  "admin.store_sync.state_active": "active",
  "admin.store_sync.state_canceled": "cancelled",
  "admin.store_sync.state_in_grace_period": "grace period",
  "admin.store_sync.state_grace_period": "grace period",
  "admin.store_sync.state_on_hold": "on hold",
  "admin.store_sync.state_paused": "paused",
  "admin.store_sync.state_expired": "expired",
  "admin.store_sync.state_pending": "payment pending",
  "admin.store_sync.state_billing_retry": "billing retry",
  "admin.store_sync.state_revoked": "refunded",
  "admin.store_sync.state_pending_purchase_canceled": "purchase cancelled"
});

Object.assign(LOCAL_I18N_OVERRIDES.de!, DAILY_RITUAL_DE);
Object.assign(LOCAL_I18N_OVERRIDES.en!, DAILY_RITUAL_EN);

// Paket 75-kauf/3+1: Wechsel-über-Store-Grenzen-Sperre + alte-Flats-
// Abschaltung — Quelltexte müssen exakt server/i18n/ui/{de,en}.json spiegeln
// (siehe scripts/i18n-pending-sources.json), bis der Übersetzungslauf läuft.
Object.assign(LOCAL_I18N_OVERRIDES.de!, {
  "paywall.cta.manage_in_store": "Bei {store} verwalten",
  "paywall.store.apple": "Apple",
  "paywall.store.google": "Google",
  "paywall.note.cross_store": "Dein Abo läuft über {store} — ändern kannst du es dort bzw. auf dem Gerät, auf dem du es abgeschlossen hast.",
  "paywall.note.cross_store_ending": "Dein {store}-Abo endet am {date}.",
  "flats.old_purchase_disabled": "Nachrichten-Flats werden nicht mehr neu verkauft. Bitte wähle stattdessen eine Mitgliedschaft (Plus, Ultra oder Founders).",
});
Object.assign(LOCAL_I18N_OVERRIDES.en!, {
  "paywall.cta.manage_in_store": "Manage at {store}",
  "paywall.store.apple": "Apple",
  "paywall.store.google": "Google",
  "paywall.note.cross_store": "Your subscription runs through {store} — you can change it there, or on the device where you took it out.",
  "paywall.note.cross_store_ending": "Your {store} subscription ends on {date}.",
  "flats.old_purchase_disabled": "Message flat rates are no longer sold. Please choose a membership instead (Plus, Ultra, or Founders).",
});

Object.assign(LOCAL_I18N_OVERRIDES.de!, {
  // F88 (24.10.2026): E-Mail-Bestätigung — gleiche Texte wie server/i18n/ui, bis der Server-i18n deployt ist.
  "verify_email.title": "E-Mail bestätigen",
  "verify_email.checking": "Dein Link wird geprüft …",
  "verify_email.success": "Deine E-Mail-Adresse ist bestätigt.",
  "verify_email.already": "Diese E-Mail-Adresse ist bereits bestätigt.",
  "verify_email.expired": "Dieser Link ist abgelaufen. Fordere in der App einen neuen Link an.",
  "verify_email.invalid": "Dieser Link ist ungültig oder wurde schon verwendet. Fordere in der App einen neuen Link an.",
  "verify_email.error": "Die Bestätigung hat gerade nicht geklappt. Bitte versuche es später noch einmal.",
  "verify_email.continue": "Weiter zu Lorath",
  "verify_email.to_login": "Zur Anmeldung",
  "verify_email.banner_text": "Bitte bestätige deine E-Mail-Adresse {email}. Schau in deinem Postfach und im Spam-Ordner nach unserer E-Mail und öffne den Bestätigungslink.",
  "verify_email.banner_resend": "Link erneut senden",
  "verify_email.banner_sending": "Wird gesendet …",
  "verify_email.banner_sent": "Link gesendet. Bitte prüfe auch den Spam-Ordner.",
  "verify_email.banner_limit": "Du hast gerade schon mehrere Links angefordert. Bitte warte etwa eine Stunde.",
  "verify_email.banner_failed": "Der Link konnte nicht gesendet werden. Bitte versuche es später noch einmal.",
  "verify_email.banner_dismiss": "Ausblenden",
  "verify_email.settings_verified": "E-Mail-Adresse bestätigt",
  "verify_email.settings_unverified": "E-Mail-Adresse noch nicht bestätigt",
});
Object.assign(LOCAL_I18N_OVERRIDES.en!, {
  // F88 (24.10.2026): E-Mail-Bestätigung — gleiche Texte wie server/i18n/ui, bis der Server-i18n deployt ist.
  "verify_email.title": "Confirm email",
  "verify_email.checking": "Checking your link …",
  "verify_email.success": "Your email address is confirmed.",
  "verify_email.already": "This email address is already confirmed.",
  "verify_email.expired": "This link has expired. Request a new link in the app.",
  "verify_email.invalid": "This link is invalid or has already been used. Request a new link in the app.",
  "verify_email.error": "The confirmation did not work just now. Please try again later.",
  "verify_email.continue": "Continue to Lorath",
  "verify_email.to_login": "Go to sign-in",
  "verify_email.banner_text": "Please confirm your email address {email}. Check your inbox and spam folder for our email and open the confirmation link.",
  "verify_email.banner_resend": "Resend link",
  "verify_email.banner_sending": "Sending …",
  "verify_email.banner_sent": "Link sent. Please also check your spam folder.",
  "verify_email.banner_limit": "You have already requested several links. Please wait about an hour.",
  "verify_email.banner_failed": "The link could not be sent. Please try again later.",
  "verify_email.banner_dismiss": "Dismiss",
  "verify_email.settings_verified": "Email address confirmed",
  "verify_email.settings_unverified": "Email address not confirmed yet",
});

export function localI18nOverridesFor(lang: SupportedLanguage): TranslationMap {
  const local = LOCAL_I18N_OVERRIDES[lang] ?? {};
  return { ...local, ...PENDING_SOURCE_TEXTS[lang === 'de' ? 'de' : 'en'] };
}
